webpackJsonp([6],{

/***/ "++TJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORAGE_KEY; });
var STORAGE_KEY = {
    TOKEN: 'token',
    MODEL_ID: 'modelId',
    MODEL_NAME: "modelName",
    RECORD_PERMISSION: 'recorder_permission',
    START_CHAT_TIME: "chatStartTime"
};

/***/ }),

/***/ "+8D2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+LB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/HB0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1/Ha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHAT_MSG_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHAT_EVNET; });
var CHAT_MSG_TYPE = {
    WORD: 1,
    VOICE_STREAM: 2,
    IMG: 3
};
var CHAT_EVNET = {
    PREPARE_AUDIO: 'prepare',
    START_AUDIO: 'start',
    END_AUDIO: 'end',
    ERROR_AUDIO: 'error',
    MUTED_PLAY: 'muted'
};

/***/ }),

/***/ "1NJS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2sLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_button = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("QlJb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_button,
  src_components_x_button,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3872a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Lqo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4WEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Tl+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jbP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5tr+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6ReU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ALGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7667bbe5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Mxix")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AlnM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXkM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BqjD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CEdf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ckmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DV3S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EJBL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F7vt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Fj5x":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "G6U3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HH82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hc/O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IM0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ics8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JvV8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KBZJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Kw3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EventBus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUS_EVENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

var BUS_EVENT = {
    ENABLE_INPUT: 'onEnableInput',
    ADD_LOG: 'onAddLog'
};

/***/ }),

/***/ "LWON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LYDH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M5Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mxix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/api/api.js
var api = __webpack_require__("P9l9");

// EXTERNAL MODULE: ./src/myComponents/ToneModel/ToneModel.less
var ToneModel = __webpack_require__("x/ze");
var ToneModel_default = /*#__PURE__*/__webpack_require__.n(ToneModel);

// EXTERNAL MODULE: ./node_modules/vux/src/components/selector/index.vue + 3 modules
var selector = __webpack_require__("wwIJ");

// EXTERNAL MODULE: ./src/utils/utils.js
var utils = __webpack_require__("oAV5");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/ToneModel/ToneModel.vue




var b = [];





/* harmony default export */ var ToneModel_ToneModel = ({
  name: "ToneModel",
  components: {
    Selector: selector["a" /* default */]
  },
  props: {
    type: Number,
    id: Number,
    disabldeChat: Boolean

  },
  data: function data() {
    return {
      list: [],
      list1: [],
      defaultValue: "",
      typeValue: "",
      oneState: false,
      disabldeChatActive: this.disabldeChat,
      idCount: this.id,
      dastles: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log('%c⧭', 'color: #731d1d', this.disabldeChat);
    this.appletPublicsType();
    setTimeout(function () {
      if (_this.type == 1) {
        Object(api["t" /* modelView */])(_this.id).then(function (res) {
          _this.defaultValue = res.data.image.audio_timbre;

          console.log('%c⧭', 'color: #1d3f73', res.data.image.audio_timbre);
          _this.typeValue = res.data.image.chat_type;
          var str = stringify_default()(res.data.audio_timbre_map);
          console.log('%c⧭', 'color: #997326', str);
          var obj = JSON.parse(str);

          console.log('%c⧭', 'color: #cc0088', obj);
          var data = [];
          data = obj[res.data.image.gender];

          console.log('%c⧭', 'color: #735656', data);
          data.forEach(function (item) {
            var num = {
              key: item.id,
              value: item.name
            };
            _this.list.push(num);
          });

          _this.oneState = true;
          setTimeout(function () {
            _this.oneState = false;
          }, 2000);
        });
      } else if (_this.type == 2) {
        Object(api["b" /* cardView */])(_this.id).then(function (res) {
          _this.defaultValue = res.data.card.chat_audio_timbre ? res.data.card.chat_audio_timbre : res.data.card.audio_timbre;

          _this.typeValue = res.data.card.chat_type;
          var data = [];
          data = res.data.audio_timbre_map[res.data.card.gender];

          console.log('%c⧭', 'color: #735656', data);
          data.forEach(function (item) {
            var num = {
              key: item.id,
              value: item.name
            };
            _this.list.push(num);
          });
          console.log('----------------list ', _this.list);
          _this.oneState = true;
          setTimeout(function () {
            _this.oneState = false;
          }, 2000);
        });
      }
    }, 2000);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onChange: function onChange() {},
    appletPublicsType: function appletPublicsType() {
      var _this2 = this;

      Object(api["a" /* appletPublicsType */])().then(function (res) {
        var data = res.data.chat_type;
        data.forEach(function (item) {
          var obj = {
            key: item.data,
            value: item.name
          };
          _this2.list1.push(obj);
        });
        console.log("%c⧭", "color: #00b300", res);
      });
    },
    onDefaultEvent: function onDefaultEvent(value) {
      var _this3 = this;

      if (this.oneState) return;
      this.$vux.loading.show({
        text: "设置中请等待"
      });
      if (this.type == 1) {
        Object(api["w" /* setImage */])({
          image_id: this.id,
          audio_timbre: value
        }).then(function (d) {}, function (e) {}).finally(function () {
          _this3.$vux.loading.hide();
        });
      } else {
        Object(api["v" /* setCard */])({
          card_id: this.id,
          chat_audio_timbre: value
        }).then(function (d) {}).finally(function () {
          _this3.$vux.loading.hide();
        });
      }
    },
    onTypeEvent: function onTypeEvent(value) {
      var _this4 = this;

      if (this.oneState) return;
      this.$vux.loading.show({
        text: "设置中请等待"
      });
      if (this.type == 1) {

        Object(api["w" /* setImage */])({
          image_id: this.id,
          chat_type: value
        }).then(function (d) {
          _this4.$vux.loading.hide();
          _this4.$emit("onPatternSetFinish", value);
        });
      } else {
        Object(utils["a" /* createRequest */])("post", "applet/webview/card/setting", {
          card_id: this.id,
          chat_type: value
        }, function (res) {
          _this4.$vux.loading.hide();
          _this4.$emit("onPatternSetFinish", value);
        }, function (err) {});
      }
    }
  },
  watch: {
    disabldeChat: function disabldeChat(value) {
      this.disabldeChatActive = value;
    },
    id: function id(value) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.idCount = value;
                console.log('%c⧭', 'color: #e57373', _this5.type);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/ToneModel/ToneModel.vue




var ToneModel_b = [];





/* harmony default export */ var myComponents_ToneModel_ToneModel = ({
  name: "ToneModel",
  components: {
    Selector: selector["a" /* default */]
  },
  props: {
    type: Number,
    id: Number,
    disabldeChat: Boolean

  },
  data: function data() {
    return {
      list: [],
      list1: [],
      defaultValue: "",
      typeValue: "",
      oneState: false,
      disabldeChatActive: this.disabldeChat,
      idCount: this.id,
      dastles: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log('%c⧭', 'color: #731d1d', this.disabldeChat);
    this.appletPublicsType();
    setTimeout(function () {
      if (_this.type == 1) {
        Object(api["t" /* modelView */])(_this.id).then(function (res) {
          _this.defaultValue = res.data.image.audio_timbre;

          console.log('%c⧭', 'color: #1d3f73', res.data.image.audio_timbre);
          _this.typeValue = res.data.image.chat_type;
          var str = stringify_default()(res.data.audio_timbre_map);
          console.log('%c⧭', 'color: #997326', str);
          var obj = JSON.parse(str);

          console.log('%c⧭', 'color: #cc0088', obj);
          var data = [];
          data = obj[res.data.image.gender];

          console.log('%c⧭', 'color: #735656', data);
          data.forEach(function (item) {
            var num = {
              key: item.id,
              value: item.name
            };
            _this.list.push(num);
          });

          _this.oneState = true;
          setTimeout(function () {
            _this.oneState = false;
          }, 2000);
        });
      } else if (_this.type == 2) {
        Object(api["b" /* cardView */])(_this.id).then(function (res) {
          _this.defaultValue = res.data.card.chat_audio_timbre ? res.data.card.chat_audio_timbre : res.data.card.audio_timbre;

          _this.typeValue = res.data.card.chat_type;
          var data = [];
          data = res.data.audio_timbre_map[res.data.card.gender];

          console.log('%c⧭', 'color: #735656', data);
          data.forEach(function (item) {
            var num = {
              key: item.id,
              value: item.name
            };
            _this.list.push(num);
          });
          console.log('----------------list ', _this.list);
          _this.oneState = true;
          setTimeout(function () {
            _this.oneState = false;
          }, 2000);
        });
      }
    }, 2000);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onChange: function onChange() {},
    appletPublicsType: function appletPublicsType() {
      var _this2 = this;

      Object(api["a" /* appletPublicsType */])().then(function (res) {
        var data = res.data.chat_type;
        data.forEach(function (item) {
          var obj = {
            key: item.data,
            value: item.name
          };
          _this2.list1.push(obj);
        });
        console.log("%c⧭", "color: #00b300", res);
      });
    },
    onDefaultEvent: function onDefaultEvent(value) {
      var _this3 = this;

      if (this.oneState) return;
      this.$vux.loading.show({
        text: "设置中请等待"
      });
      if (this.type == 1) {
        Object(api["w" /* setImage */])({
          image_id: this.id,
          audio_timbre: value
        }).then(function (d) {}, function (e) {}).finally(function () {
          _this3.$vux.loading.hide();
        });
      } else {
        Object(api["v" /* setCard */])({
          card_id: this.id,
          chat_audio_timbre: value
        }).then(function (d) {}).finally(function () {
          _this3.$vux.loading.hide();
        });
      }
    },
    onTypeEvent: function onTypeEvent(value) {
      var _this4 = this;

      if (this.oneState) return;
      this.$vux.loading.show({
        text: "设置中请等待"
      });
      if (this.type == 1) {

        Object(api["w" /* setImage */])({
          image_id: this.id,
          chat_type: value
        }).then(function (d) {
          _this4.$vux.loading.hide();
          _this4.$emit("onPatternSetFinish", value);
        });
      } else {
        Object(utils["a" /* createRequest */])("post", "applet/webview/card/setting", {
          card_id: this.id,
          chat_type: value
        }, function (res) {
          _this4.$vux.loading.hide();
          _this4.$emit("onPatternSetFinish", value);
        }, function (err) {});
      }
    }
  },
  watch: {
    disabldeChat: function disabldeChat(value) {
      this.disabldeChatActive = value;
    },
    id: function id(value) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.idCount = value;
                console.log('%c⧭', 'color: #e57373', _this5.type);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c7937de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/ToneModel/ToneModel.vue
var ToneModel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ToneModel"},[(_vm.list.length > 0)?_c('div',{staticClass:"ton-model-box"},[_c('div',{staticClass:"ton-text-select"},[_c('span',[_vm._v("对话音色")]),_vm._v(" "),_c('div',{staticClass:"icon-box"},[_c('selector',{ref:"defaultValueRef",attrs:{"options":_vm.list},on:{"on-change":_vm.onDefaultEvent},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}})],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: ToneModel_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_myComponents_ToneModel_ToneModel = (esExports);
// CONCATENATED MODULE: ./src/myComponents/ToneModel/ToneModel.vue
function injectStyle (ssrContext) {
  __webpack_require__("jTD2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c7937de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  myComponents_ToneModel_ToneModel,
  selectortype_template_index_0_src_myComponents_ToneModel_ToneModel,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_myComponents_ToneModel_ToneModel = (Component.exports);

// EXTERNAL MODULE: ./src/components/HelloFromVux.less
var HelloFromVux = __webpack_require__("1NJS");
var HelloFromVux_default = /*#__PURE__*/__webpack_require__.n(HelloFromVux);

// EXTERNAL MODULE: ./src/myComponents/Chatframe/Chatframe.vue + 14 modules
var Chatframe = __webpack_require__("t5lu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("uwyH")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["a" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["a" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65737ba9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-box/index.vue
var cell_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box weui-cell",class:_vm.className,style:(_vm.style),on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var cell_box_staticRenderFns = []
var cell_box_esExports = { render: cell_box_render, staticRenderFns: cell_box_staticRenderFns }
/* harmony default export */ var src_components_cell_box = (cell_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-box/index.vue
function cell_box_injectStyle (ssrContext) {
  __webpack_require__("tZYb")
}
var cell_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_box___vue_template_functional__ = false
/* styles */
var cell_box___vue_styles__ = cell_box_injectStyle
/* scopeId */
var cell_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_box___vue_module_identifier__ = null
var cell_box_Component = cell_box_normalizeComponent(
  components_cell_box,
  src_components_cell_box,
  cell_box___vue_template_functional__,
  cell_box___vue_styles__,
  cell_box___vue_scopeId__,
  cell_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_box = (cell_box_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-button/index.vue + 3 modules
var x_button = __webpack_require__("2sLL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-input/index.vue + 7 modules
var x_input = __webpack_require__("pDNl");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d4120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("gsj7")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var radio_props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0506500e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])]},{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("HH82")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = Object(props["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ var popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var popup_radio__cellProps = Object(props["a" /* default */])();
delete popup_radio__cellProps.value;

/* harmony default export */ var components_popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, popup_radio__cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f92ebd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-radio/index.vue
var popup_radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show.apply(null, arguments)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{"options":_vm.options,"value":_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])]},{"icon":props.icon,"label":props.label,"index":props.index})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var popup_radio_staticRenderFns = []
var popup_radio_esExports = { render: popup_radio_render, staticRenderFns: popup_radio_staticRenderFns }
/* harmony default export */ var src_components_popup_radio = (popup_radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-radio/index.vue
function popup_radio_injectStyle (ssrContext) {
  __webpack_require__("IM0P")
}
var popup_radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_radio___vue_template_functional__ = false
/* styles */
var popup_radio___vue_styles__ = popup_radio_injectStyle
/* scopeId */
var popup_radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_radio___vue_module_identifier__ = null
var popup_radio_Component = popup_radio_normalizeComponent(
  components_popup_radio,
  src_components_popup_radio,
  popup_radio___vue_template_functional__,
  popup_radio___vue_styles__,
  popup_radio___vue_scopeId__,
  popup_radio___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_radio = (popup_radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa2c7d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("Q7uw")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27223f69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",function(){return [_vm._v(_vm._s(_vm.leftText))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",function(){return [_vm._v(_vm._s(_vm.rightText))]})],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("XZOv")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413ccea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]},{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("5jbP")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-progress/index.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_progress = ({
  name: 'x-progress',
  mixins: [base["a" /* default */]],
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-progress/index.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_progress = ({
  name: 'x-progress',
  mixins: [base["a" /* default */]],
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01124028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-progress/index.vue
var x_progress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-progress"},[_c('div',{staticClass:"weui-progress__bar"},[_c('div',{staticClass:"weui-progress__inner-bar",style:({width: _vm.percent + '%'})})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCancel),expression:"showCancel"}],staticClass:"weui-progress_opr",attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"weui-icon-cancel",on:{"click":_vm.cancel}})])])}
var x_progress_staticRenderFns = []
var x_progress_esExports = { render: x_progress_render, staticRenderFns: x_progress_staticRenderFns }
/* harmony default export */ var src_components_x_progress = (x_progress_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-progress/index.vue
function x_progress_injectStyle (ssrContext) {
  __webpack_require__("n4IK")
}
var x_progress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_progress___vue_template_functional__ = false
/* styles */
var x_progress___vue_styles__ = x_progress_injectStyle
/* scopeId */
var x_progress___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_progress___vue_module_identifier__ = null
var x_progress_Component = x_progress_normalizeComponent(
  components_x_progress,
  src_components_x_progress,
  x_progress___vue_template_functional__,
  x_progress___vue_styles__,
  x_progress___vue_scopeId__,
  x_progress___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_progress = (x_progress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/oneInput/oneInput.vue




/* harmony default export */ var oneInput = ({
  name: "chatframe",
  components: {
    XInput: x_input["a" /* default */]
  },
  props: {
    values: String,
    itemValue: String

  },
  data: function data() {
    return {
      value: this.values
    };
  },
  mounted: function mounted() {
    this.$emit("onInput", this.value);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onDelOneInput: function onDelOneInput() {

      this.$emit("onDelOneInput", 0);
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit("onInput", _value);
    },
    values: function values(val) {

      console.log('%c⧭', 'color: #00736b', "val", "======");
    },
    itemValue: function itemValue(val) {
      console.log('%c⧭', 'color: #cc7033', val, "---");
      this.value = val;
      this.$emit("onInput", val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/oneInput/oneInput.vue




/* harmony default export */ var oneInput_oneInput = ({
  name: "chatframe",
  components: {
    XInput: x_input["a" /* default */]
  },
  props: {
    values: String,
    itemValue: String

  },
  data: function data() {
    return {
      value: this.values
    };
  },
  mounted: function mounted() {
    this.$emit("onInput", this.value);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onDelOneInput: function onDelOneInput() {

      this.$emit("onDelOneInput", 0);
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit("onInput", _value);
    },
    values: function values(val) {

      console.log('%c⧭', 'color: #00736b', "val", "======");
    },
    itemValue: function itemValue(val) {
      console.log('%c⧭', 'color: #cc7033', val, "---");
      this.value = val;
      this.$emit("onInput", val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef28114c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/oneInput/oneInput.vue
var oneInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-input",on:{"click":function($event){return _vm.$refs.issueInput.focus()}}},[_c('x-input',{ref:"issueInput",attrs:{"max":500,"placeholder":"请输入回复内容","show-clear":false},on:{"on-blur":function($event){return _vm.$emit('onBlur')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('img',{staticStyle:{"wifth":"14px","height":"14px","margin-left":"10%"},attrs:{"src":"/static/img/delect-icon.jpg","alt":""},on:{"click":_vm.onDelOneInput}})],1)}
var oneInput_staticRenderFns = []
var oneInput_esExports = { render: oneInput_render, staticRenderFns: oneInput_staticRenderFns }
/* harmony default export */ var myComponents_oneInput_oneInput = (oneInput_esExports);
// CONCATENATED MODULE: ./src/myComponents/oneInput/oneInput.vue
function oneInput_injectStyle (ssrContext) {
  __webpack_require__("Q5PW")
}
var oneInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var oneInput___vue_template_functional__ = false
/* styles */
var oneInput___vue_styles__ = oneInput_injectStyle
/* scopeId */
var oneInput___vue_scopeId__ = "data-v-ef28114c"
/* moduleIdentifier (server only) */
var oneInput___vue_module_identifier__ = null
var oneInput_Component = oneInput_normalizeComponent(
  oneInput_oneInput,
  myComponents_oneInput_oneInput,
  oneInput___vue_template_functional__,
  oneInput___vue_styles__,
  oneInput___vue_scopeId__,
  oneInput___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_oneInput_oneInput = (oneInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/twoInput/twoInput.vue




/* harmony default export */ var twoInput = ({
  name: "chatframe",
  components: {
    XInput: x_input["a" /* default */]
  },
  props: {
    values: String,
    itemValue: String

  },
  data: function data() {
    return {
      value: this.values
    };
  },
  mounted: function mounted() {
    this.$emit("onTwoInput", this.value);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onDelOneInput: function onDelOneInput() {
      this.$emit("onDelTwoInput", 1);
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit("onTwoInput", _value);
    },
    values: function values(val) {
      console.log(val, "val");
      this.value = val;
      this.$emit("onTwoInput", val);
    },
    itemValue: function itemValue(val) {
      console.log(val, "val");
      this.value = val;
      this.$emit("onTwoInput", val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/twoInput/twoInput.vue




/* harmony default export */ var twoInput_twoInput = ({
  name: "chatframe",
  components: {
    XInput: x_input["a" /* default */]
  },
  props: {
    values: String,
    itemValue: String

  },
  data: function data() {
    return {
      value: this.values
    };
  },
  mounted: function mounted() {
    this.$emit("onTwoInput", this.value);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onDelOneInput: function onDelOneInput() {
      this.$emit("onDelTwoInput", 1);
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit("onTwoInput", _value);
    },
    values: function values(val) {
      console.log(val, "val");
      this.value = val;
      this.$emit("onTwoInput", val);
    },
    itemValue: function itemValue(val) {
      console.log(val, "val");
      this.value = val;
      this.$emit("onTwoInput", val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-216916be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/twoInput/twoInput.vue
var twoInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-input",on:{"click":function($event){return _vm.$refs.issueInput.focus()}}},[_c('x-input',{ref:"issueInput",attrs:{"placeholder":"请输入回复内容","max":500,"show-clear":false},on:{"on-blur":function($event){return _vm.$emit('onBlur')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('img',{staticStyle:{"wifth":"14px","height":"14px","margin-left":"10%"},attrs:{"src":"/static/img/delect-icon.jpg","alt":""},on:{"click":_vm.onDelOneInput}})],1)}
var twoInput_staticRenderFns = []
var twoInput_esExports = { render: twoInput_render, staticRenderFns: twoInput_staticRenderFns }
/* harmony default export */ var myComponents_twoInput_twoInput = (twoInput_esExports);
// CONCATENATED MODULE: ./src/myComponents/twoInput/twoInput.vue
function twoInput_injectStyle (ssrContext) {
  __webpack_require__("l71h")
}
var twoInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var twoInput___vue_template_functional__ = false
/* styles */
var twoInput___vue_styles__ = twoInput_injectStyle
/* scopeId */
var twoInput___vue_scopeId__ = "data-v-216916be"
/* moduleIdentifier (server only) */
var twoInput___vue_module_identifier__ = null
var twoInput_Component = twoInput_normalizeComponent(
  twoInput_twoInput,
  myComponents_twoInput_twoInput,
  twoInput___vue_template_functional__,
  twoInput___vue_styles__,
  twoInput___vue_scopeId__,
  twoInput___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_twoInput_twoInput = (twoInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/theryInput/theryInput.vue




/* harmony default export */ var theryInput = ({
  name: "chatframe",
  components: {
    XInput: x_input["a" /* default */]
  },
  props: {
    values: String,
    itemValue: String

  },
  data: function data() {
    return {
      value: this.values
    };
  },
  mounted: function mounted() {
    this.$emit("onTheryInput", this.value);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onDelOneInput: function onDelOneInput() {
      this.$emit("onDelThrryInput", 2);
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit("onTheryInput", _value);
    },
    values: function values(val) {

      console.log('%c⧭', 'color: #00736b', val);
      this.value = val;
      this.$emit("onTheryInput", val);
    },
    itemValue: function itemValue(val) {

      console.log('%c⧭', 'color: #cc7033', val, "---");
      this.value = val;
      this.$emit("onTheryInput", val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/theryInput/theryInput.vue




/* harmony default export */ var theryInput_theryInput = ({
  name: "chatframe",
  components: {
    XInput: x_input["a" /* default */]
  },
  props: {
    values: String,
    itemValue: String

  },
  data: function data() {
    return {
      value: this.values
    };
  },
  mounted: function mounted() {
    this.$emit("onTheryInput", this.value);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onDelOneInput: function onDelOneInput() {
      this.$emit("onDelThrryInput", 2);
    }
  },
  watch: {
    value: function value(_value) {
      this.$emit("onTheryInput", _value);
    },
    values: function values(val) {

      console.log('%c⧭', 'color: #00736b', val);
      this.value = val;
      this.$emit("onTheryInput", val);
    },
    itemValue: function itemValue(val) {

      console.log('%c⧭', 'color: #cc7033', val, "---");
      this.value = val;
      this.$emit("onTheryInput", val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-470702da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/theryInput/theryInput.vue
var theryInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-input",on:{"click":function($event){return _vm.$refs.issueInput.focus()}}},[_c('x-input',{ref:"issueInput",attrs:{"max":500,"placeholder":"请输入回复内容","show-clear":false},on:{"on-blur":function($event){return _vm.$emit('onBlur')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('img',{staticStyle:{"wifth":"14px","height":"14px","margin-left":"10%"},attrs:{"src":"/static/img/delect-icon.jpg","alt":""},on:{"click":_vm.onDelOneInput}})],1)}
var theryInput_staticRenderFns = []
var theryInput_esExports = { render: theryInput_render, staticRenderFns: theryInput_staticRenderFns }
/* harmony default export */ var myComponents_theryInput_theryInput = (theryInput_esExports);
// CONCATENATED MODULE: ./src/myComponents/theryInput/theryInput.vue
function theryInput_injectStyle (ssrContext) {
  __webpack_require__("4Lqo")
}
var theryInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var theryInput___vue_template_functional__ = false
/* styles */
var theryInput___vue_styles__ = theryInput_injectStyle
/* scopeId */
var theryInput___vue_scopeId__ = "data-v-470702da"
/* moduleIdentifier (server only) */
var theryInput___vue_module_identifier__ = null
var theryInput_Component = theryInput_normalizeComponent(
  theryInput_theryInput,
  myComponents_theryInput_theryInput,
  theryInput___vue_template_functional__,
  theryInput___vue_styles__,
  theryInput___vue_scopeId__,
  theryInput___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_theryInput_theryInput = (theryInput_Component.exports);

// EXTERNAL MODULE: ./node_modules/qiniu-js/esm/index.js + 20 modules
var esm = __webpack_require__("sRRY");

// CONCATENATED MODULE: ./src/qiniu/index.js




/**
 * 七牛云上传
 * @param {*} file  二进制文件
 * @param {*} token  用户token
 * @param {*} format  文件格式 （后缀名）
 * @param {*} process  上传进度
 * @param {*} callback  上传结果(err,dat)
 */
function uploadQiniu(file, format, process, callback) {
    console.log('file', file);
    return new promise_default.a(function (resolve, reject) {
        Object(utils["a" /* createRequest */])('GET', 'applet/publics/qiniu/token', { format: format }, function (res) {
            console.log(res);
            if (res.code == 200) {
                var observable = esm["a" /* upload */](file, res.data.key, res.data.token);
                var subscription = observable.subscribe(function (next) {
                    process && process({
                        size: next.total.size,
                        loaded: next.total.loaded,
                        percent: next.total.percent
                    });
                }, function (error) {
                    callback && callback('上传失败');
                }, function (complete) {
                    callback && callback(null, res.data);
                });
                return resolve(subscription);
            } else {
                callback && callback('上传失败');
                reject('上传失败');
            }
        });
    });
}
function uploadQiniuSetKey(file, fileName, process, callback) {
    console.log('file', file);
    return new promise_default.a(function (resolve, reject) {
        if (fileName.length > 20) {
            callback && callback('文件名不能超20字符');
            return reject('文件名不能超20字符');
        }
        Object(utils["a" /* createRequest */])('GET', 'applet/publics/qiniu/token', { file_name: fileName }, function (res) {
            console.log(res);
            if (res.code == 200) {
                var observable = esm["a" /* upload */](file, res.data.key, res.data.token);
                var subscription = observable.subscribe(function (next) {
                    process && process({
                        size: next.total.size,
                        loaded: next.total.loaded,
                        percent: next.total.percent
                    });
                }, function (error) {
                    callback && callback('请重试');
                }, function (complete) {
                    callback && callback(null, res.data);
                });
                return resolve(subscription);
            } else {
                callback && callback('请重试');
                reject('请重试');
            }
        });
    });
}
// CONCATENATED MODULE: ./src/utils/encapsulationMethod.js

//去除数字里面的空值 
function trimSpace(array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == "" || array[i] == null || typeof array[i] == "undefined") {
      array.splice(i, 1);
      i = i - 1;
    }
  }
  return array;
}
// EXTERNAL MODULE: ./src/utils/define.js
var define = __webpack_require__("++TJ");

// EXTERNAL MODULE: ./src/myComponents/myVideo/myVideo.vue + 3 modules
var myVideo = __webpack_require__("qGz8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/AddQa/AddQa.vue
























/* harmony default export */ var AddQa = ({
  uploadingHandler: undefined,
  name: "chatframe",
  components: {
    Group: group["a" /* default */],
    Selector: selector["a" /* default */],
    Cell: vux_src_components_cell,
    CellBox: vux_src_components_cell_box,
    XButton: x_button["a" /* default */],
    XInput: x_input["a" /* default */],
    OnInput: src_myComponents_oneInput_oneInput,
    TwoInput: src_myComponents_twoInput_twoInput,
    TheryInput: src_myComponents_theryInput_theryInput,
    PopupRadio: vux_src_components_popup_radio,
    PopupPicker: vux_src_components_popup_picker,
    Toast: toast["a" /* default */],
    Popup: node_modules_vux_src_components_popup,
    XProgress: vux_src_components_x_progress,
    MyVideo: myVideo["a" /* default */]
  },
  props: {
    delValueIs: String,
    movementList: Array,
    spareName: String,
    typeIs: Number,
    modelID: Number,
    cardTypeIs: String
  },
  data: function data() {
    return {
      value2: "",
      inputList: [""],
      showPositionValue: false,
      position: "default",
      oneInputValue: "", //第一个input子集传值
      twoInputValue: "", //第2个input子集传值
      threeInputValue: "", //第3个input子集传值
      imageUrl: "",
      imageKey: "",
      list: [],
      issueValue: "",
      pdfNmae: "",
      videoUrl: "",
      videoCover: "",
      showVideo: false,
      setPreinstallState: false,
      gender: 0,
      activeSpareName: this.spareName,
      uploadProgress: 0
    };
  },
  mounted: function mounted() {
    this.getMovement();
    this.activeSpareName = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_NAME);

    console.log('%c⧭', 'color: #ffa280', localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_NAME));
    console.log("activeSpareName", this.activeSpareName);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onSetPreinstall: function onSetPreinstall() {
      this.setPreinstallState = !this.setPreinstallState;
    },
    getMovement: function getMovement() {
      var _this2 = this;

      if (this.cardTypeIs == '3d') {
        Object(utils["a" /* createRequest */])("get", "applet/webview/model_view", { image_id: localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) }, function (res) {
          console.log("%c⧭", "color: #bfffc8", res);
          if (res.code == 200) {
            _this2.gender = res.data.image.gender;
            Object(utils["a" /* createRequest */])("get", "applet/webview/config", { version: res.data.image.version }, function (reg) {
              console.log("%c⧭", "color: #bfffc8", res);
              if (reg.code == 200) {
                var list = reg.data.action_map[String(_this2.gender)];
                var data = [];
                list.forEach(function (item) {
                  var obj = {
                    value: ' ' + item.name,
                    key: item.id,
                    pic: item.pic,
                    video: item.video,
                    gender: item.gender
                  };
                  data.push(obj);
                });
                _this2.list = data;
                console.log(_this2.movementList);
              } else {
                console.error(reg.msg);
                _this2.$vux.toast.show({
                  type: "text",
                  text: reg.msg
                });
              }
            });
          } else {
            console.error(res.msg);
            _this2.$vux.toast.show({
              type: "text",
              text: res.msg
            });
          }
        });
      } else if (this.cardTypeIs == '2d') {
        var id = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
        Object(api["b" /* cardView */])(id).then(function (res) {
          if (res.code == 200) {
            _this2.gender = res.data.card.gender;
            Object(utils["a" /* createRequest */])("get", "applet/webview/config", { version: res.data.card.version }, function (reg) {
              console.log("%c⧭", "color: #bfffc8", res);
              if (reg.code == 200) {
                var list = reg.data.action_map[String(_this2.gender)];
                var data = [];
                list.forEach(function (item) {
                  var obj = {
                    value: ' ' + item.name,
                    key: item.id,
                    pic: item.pic,
                    video: item.video,
                    gender: item.gender
                  };
                  data.push(obj);
                });
                _this2.list = data;
                console.log(_this2.movementList);
              } else {
                console.error(reg.msg);
                _this2.$vux.toast.show({
                  type: "text",
                  text: reg.msg
                });
              }
            });
          } else {
            console.error(res.msg);
            _this2.$vux.toast.show({
              type: "text",
              text: res.msg
            });
          }
          console.log('%c⧭', 'color: #40fff2', res);
        });
      }
    },
    onLookVideo: function onLookVideo() {
      this.showVideo = true;
    },
    onSave: function onSave() {
      var _this3 = this;

      if (this.value2 == '') {
        this.$vux.toast.show({
          type: "text",
          text: '请选择动作'
        });
        return;
      }
      if (this.issueValue == '') {
        this.$vux.toast.show({
          type: "text",
          text: '请输入问题'
        });
        return;
      }
      if (this.inputList.length == 1) {
        this.inputList[0] = this.oneInputValue;
      } else if (this.inputList.length == 2) {
        this.inputList[0] = this.oneInputValue;
        this.inputList[1] = this.twoInputValue;
      } else if (this.inputList.length == 3) {
        this.inputList[0] = this.oneInputValue;
        this.inputList[1] = this.twoInputValue;
        this.inputList[2] = this.threeInputValue;
      }
      if (this.oneInputValue <= 0) {
        this.$vux.toast.show({
          type: "text",
          text: '请输入回复'
        });
        return;
      }

      console.log('%c⧭', 'color: #364cd9', localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID));
      var replyList = trimSpace(this.inputList);
      Object(utils["a" /* createRequest */])("post", "applet/webview/qa/add", {
        image_id: this.cardTypeIs == '3d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : '',
        card_id: this.cardTypeIs == '2d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : '',
        action_id: this.value2,
        question: this.issueValue,
        answer: replyList,
        file: this.imageKey,
        is_presets: this.setPreinstallState ? 1 : 2
      }, function (res) {
        console.log("%c⧭", "color: #d90000", res);
        if (res.code == 200) {
          _this3.$vux.toast.show({
            type: "text",
            text: "保存成功"
          });
          _this3.$emit("onAddSaveRouter", "costume", _this3.typeIs);
        } else {
          console.error(res.msg);
          _this3.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    getFile: function getFile(event) {
      var _this4 = this;

      console.log('get file event', event);
      var _this = this;
      var file = event.target.files[0];
      var chars = event.target.files[0].name.split(".");
      console.log("%c⧭", "color: #f200e2");
      var name = chars[chars.length - 1];
      if (["pdf", "png", "jpg", "mp4"].indexOf(name.toLowerCase()) < 0) {
        return this.$vux.toast.show({
          type: "text",
          text: "不支持的文件格式"
        });
      }
      var fileName = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('/') + 1);
      var self = this;
      uploadQiniuSetKey(file, fileName, function (res) {
        console.log("%c⧭", "color: #00e600", res);
        _this4.uploadProgress = res.percent;
      }, function (err, res) {
        _this4.uploadProgress = 0;
        if (err) {
          return _this4.$vux.toast.show({
            type: "text",
            text: "上传失败:" + err
          });
        }
        name = name.toLowerCase();
        if (name == "pdf") {
          var leng = event.target.files[0].name;
          var sp = leng.split('.');

          console.log('%c⧭', 'color: #006dcc', sp[0].length);
          if (sp[0].length < 6) {
            _this.pdfNmae = event.target.files[0].name;
          } else {

            var ont = sp[0].slice(0, 6);
            _this.pdfNmae = ont + '.' + sp[sp.length - 1];
          }
        } else if (name == "png" || name == "jpg") {
          _this.imageUrl = res.domain + res.key;
        } else if (name == "mp4") {
          _this.videoUrl = res.domain + res.key;
          _this.videoCover = res.domain + res.key + '?vframe/jpg/offset/2/w/480';
        }
        _this.imageKey = res.key;

        console.log("%c⧭", "color: #aa00ff", _this.imageUrl);
        console.log("%c⧭", "color: #00a3cc", reg, res);
      }).then(function (currentUploadHandler) {
        _this4.uploadingHandler = currentUploadHandler;
      });;
      console.log("%c⧭", "color: #ff0000");
    },
    onDelImageUrlKey: function onDelImageUrlKey() {
      this.imageKey = "";
      this.imageUrl = "";
      this.videoUrl = "";
      this.pdfNmae = "";
    },
    onAddInput: function onAddInput() {
      this.inputList.push("");
    },
    onDelOneInput: function onDelOneInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 0) {
        this.inputList.splice(event, 1);
        this.oneInputValue = this.twoInputValue;

        console.log("%c⧭", "color: #cc0036", this.oneInputValue, this.twoInputValue);
        this.twoInputValue = this.threeInputValue;
        this.threeInputValue = "";
      }
    },
    onInput: function onInput(event) {
      this.oneInputValue = event;
      console.log("%c⧭", "color: #ff6600", event);
    },
    onDelTwoInput: function onDelTwoInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 1) {
        this.inputList.splice(event, 1);
        this.twoInputValue = this.threeInputValue;
        this.threeInputValue = "";
      }
    },
    onTwoInput: function onTwoInput(event) {
      this.twoInputValue = event;

      console.log("%c⧭", "color: #ff6600", event);
    },
    onDelThrryInput: function onDelThrryInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 2) {
        this.inputList.splice(event, 1);
        this.threeInputValue = "";
      }
    },
    onTheryInput: function onTheryInput(event) {
      this.threeInputValue = event;
      console.log("%c⧭", "color: #ff6600", event);
    },
    onCancel: function onCancel() {
      console.log('----QA back');
      this.$emit('onBack', '', this.typeIs);
    },
    onClone: function onClone() {
      console.log('----QA back');
      this.$emit('onBackClone', '', this.typeIs);
    },
    cancelUpload: function cancelUpload() {
      console.log("cancel upload");
      this.uploadingHandler && this.uploadingHandler.unsubscribe();
      this.uploadProgress = 0;
    }
  },
  watch: {
    value2: function value2(value) {
      this.value2 = value;
    },
    issueValue: function issueValue(value) {
      this.issueValue = value;

      console.log('%c⧭', 'color: #cc0088', value.length);
    },
    modelID: function modelID(value) {
      this.activeSpareName = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_NAME);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/AddQa/AddQa.vue
























/* harmony default export */ var AddQa_AddQa = ({
  uploadingHandler: undefined,
  name: "chatframe",
  components: {
    Group: group["a" /* default */],
    Selector: selector["a" /* default */],
    Cell: vux_src_components_cell,
    CellBox: vux_src_components_cell_box,
    XButton: x_button["a" /* default */],
    XInput: x_input["a" /* default */],
    OnInput: src_myComponents_oneInput_oneInput,
    TwoInput: src_myComponents_twoInput_twoInput,
    TheryInput: src_myComponents_theryInput_theryInput,
    PopupRadio: vux_src_components_popup_radio,
    PopupPicker: vux_src_components_popup_picker,
    Toast: toast["a" /* default */],
    Popup: node_modules_vux_src_components_popup,
    XProgress: vux_src_components_x_progress,
    MyVideo: myVideo["a" /* default */]
  },
  props: {
    delValueIs: String,
    movementList: Array,
    spareName: String,
    typeIs: Number,
    modelID: Number,
    cardTypeIs: String
  },
  data: function data() {
    return {
      value2: "",
      inputList: [""],
      showPositionValue: false,
      position: "default",
      oneInputValue: "", //第一个input子集传值
      twoInputValue: "", //第2个input子集传值
      threeInputValue: "", //第3个input子集传值
      imageUrl: "",
      imageKey: "",
      list: [],
      issueValue: "",
      pdfNmae: "",
      videoUrl: "",
      videoCover: "",
      showVideo: false,
      setPreinstallState: false,
      gender: 0,
      activeSpareName: this.spareName,
      uploadProgress: 0
    };
  },
  mounted: function mounted() {
    this.getMovement();
    this.activeSpareName = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_NAME);

    console.log('%c⧭', 'color: #ffa280', localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_NAME));
    console.log("activeSpareName", this.activeSpareName);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onSetPreinstall: function onSetPreinstall() {
      this.setPreinstallState = !this.setPreinstallState;
    },
    getMovement: function getMovement() {
      var _this2 = this;

      if (this.cardTypeIs == '3d') {
        Object(utils["a" /* createRequest */])("get", "applet/webview/model_view", { image_id: localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) }, function (res) {
          console.log("%c⧭", "color: #bfffc8", res);
          if (res.code == 200) {
            _this2.gender = res.data.image.gender;
            Object(utils["a" /* createRequest */])("get", "applet/webview/config", { version: res.data.image.version }, function (reg) {
              console.log("%c⧭", "color: #bfffc8", res);
              if (reg.code == 200) {
                var list = reg.data.action_map[String(_this2.gender)];
                var data = [];
                list.forEach(function (item) {
                  var obj = {
                    value: ' ' + item.name,
                    key: item.id,
                    pic: item.pic,
                    video: item.video,
                    gender: item.gender
                  };
                  data.push(obj);
                });
                _this2.list = data;
                console.log(_this2.movementList);
              } else {
                console.error(reg.msg);
                _this2.$vux.toast.show({
                  type: "text",
                  text: reg.msg
                });
              }
            });
          } else {
            console.error(res.msg);
            _this2.$vux.toast.show({
              type: "text",
              text: res.msg
            });
          }
        });
      } else if (this.cardTypeIs == '2d') {
        var id = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
        Object(api["b" /* cardView */])(id).then(function (res) {
          if (res.code == 200) {
            _this2.gender = res.data.card.gender;
            Object(utils["a" /* createRequest */])("get", "applet/webview/config", { version: res.data.card.version }, function (reg) {
              console.log("%c⧭", "color: #bfffc8", res);
              if (reg.code == 200) {
                var list = reg.data.action_map[String(_this2.gender)];
                var data = [];
                list.forEach(function (item) {
                  var obj = {
                    value: ' ' + item.name,
                    key: item.id,
                    pic: item.pic,
                    video: item.video,
                    gender: item.gender
                  };
                  data.push(obj);
                });
                _this2.list = data;
                console.log(_this2.movementList);
              } else {
                console.error(reg.msg);
                _this2.$vux.toast.show({
                  type: "text",
                  text: reg.msg
                });
              }
            });
          } else {
            console.error(res.msg);
            _this2.$vux.toast.show({
              type: "text",
              text: res.msg
            });
          }
          console.log('%c⧭', 'color: #40fff2', res);
        });
      }
    },
    onLookVideo: function onLookVideo() {
      this.showVideo = true;
    },
    onSave: function onSave() {
      var _this3 = this;

      if (this.value2 == '') {
        this.$vux.toast.show({
          type: "text",
          text: '请选择动作'
        });
        return;
      }
      if (this.issueValue == '') {
        this.$vux.toast.show({
          type: "text",
          text: '请输入问题'
        });
        return;
      }
      if (this.inputList.length == 1) {
        this.inputList[0] = this.oneInputValue;
      } else if (this.inputList.length == 2) {
        this.inputList[0] = this.oneInputValue;
        this.inputList[1] = this.twoInputValue;
      } else if (this.inputList.length == 3) {
        this.inputList[0] = this.oneInputValue;
        this.inputList[1] = this.twoInputValue;
        this.inputList[2] = this.threeInputValue;
      }
      if (this.oneInputValue <= 0) {
        this.$vux.toast.show({
          type: "text",
          text: '请输入回复'
        });
        return;
      }

      console.log('%c⧭', 'color: #364cd9', localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID));
      var replyList = trimSpace(this.inputList);
      Object(utils["a" /* createRequest */])("post", "applet/webview/qa/add", {
        image_id: this.cardTypeIs == '3d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : '',
        card_id: this.cardTypeIs == '2d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : '',
        action_id: this.value2,
        question: this.issueValue,
        answer: replyList,
        file: this.imageKey,
        is_presets: this.setPreinstallState ? 1 : 2
      }, function (res) {
        console.log("%c⧭", "color: #d90000", res);
        if (res.code == 200) {
          _this3.$vux.toast.show({
            type: "text",
            text: "保存成功"
          });
          _this3.$emit("onAddSaveRouter", "costume", _this3.typeIs);
        } else {
          console.error(res.msg);
          _this3.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    getFile: function getFile(event) {
      var _this4 = this;

      console.log('get file event', event);
      var _this = this;
      var file = event.target.files[0];
      var chars = event.target.files[0].name.split(".");
      console.log("%c⧭", "color: #f200e2");
      var name = chars[chars.length - 1];
      if (["pdf", "png", "jpg", "mp4"].indexOf(name.toLowerCase()) < 0) {
        return this.$vux.toast.show({
          type: "text",
          text: "不支持的文件格式"
        });
      }
      var fileName = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('/') + 1);
      var self = this;
      uploadQiniuSetKey(file, fileName, function (res) {
        console.log("%c⧭", "color: #00e600", res);
        _this4.uploadProgress = res.percent;
      }, function (err, res) {
        _this4.uploadProgress = 0;
        if (err) {
          return _this4.$vux.toast.show({
            type: "text",
            text: "上传失败:" + err
          });
        }
        name = name.toLowerCase();
        if (name == "pdf") {
          var leng = event.target.files[0].name;
          var sp = leng.split('.');

          console.log('%c⧭', 'color: #006dcc', sp[0].length);
          if (sp[0].length < 6) {
            _this.pdfNmae = event.target.files[0].name;
          } else {

            var ont = sp[0].slice(0, 6);
            _this.pdfNmae = ont + '.' + sp[sp.length - 1];
          }
        } else if (name == "png" || name == "jpg") {
          _this.imageUrl = res.domain + res.key;
        } else if (name == "mp4") {
          _this.videoUrl = res.domain + res.key;
          _this.videoCover = res.domain + res.key + '?vframe/jpg/offset/2/w/480';
        }
        _this.imageKey = res.key;

        console.log("%c⧭", "color: #aa00ff", _this.imageUrl);
        console.log("%c⧭", "color: #00a3cc", reg, res);
      }).then(function (currentUploadHandler) {
        _this4.uploadingHandler = currentUploadHandler;
      });;
      console.log("%c⧭", "color: #ff0000");
    },
    onDelImageUrlKey: function onDelImageUrlKey() {
      this.imageKey = "";
      this.imageUrl = "";
      this.videoUrl = "";
      this.pdfNmae = "";
    },
    onAddInput: function onAddInput() {
      this.inputList.push("");
    },
    onDelOneInput: function onDelOneInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 0) {
        this.inputList.splice(event, 1);
        this.oneInputValue = this.twoInputValue;

        console.log("%c⧭", "color: #cc0036", this.oneInputValue, this.twoInputValue);
        this.twoInputValue = this.threeInputValue;
        this.threeInputValue = "";
      }
    },
    onInput: function onInput(event) {
      this.oneInputValue = event;
      console.log("%c⧭", "color: #ff6600", event);
    },
    onDelTwoInput: function onDelTwoInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 1) {
        this.inputList.splice(event, 1);
        this.twoInputValue = this.threeInputValue;
        this.threeInputValue = "";
      }
    },
    onTwoInput: function onTwoInput(event) {
      this.twoInputValue = event;

      console.log("%c⧭", "color: #ff6600", event);
    },
    onDelThrryInput: function onDelThrryInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 2) {
        this.inputList.splice(event, 1);
        this.threeInputValue = "";
      }
    },
    onTheryInput: function onTheryInput(event) {
      this.threeInputValue = event;
      console.log("%c⧭", "color: #ff6600", event);
    },
    onCancel: function onCancel() {
      console.log('----QA back');
      this.$emit('onBack', '', this.typeIs);
    },
    onClone: function onClone() {
      console.log('----QA back');
      this.$emit('onBackClone', '', this.typeIs);
    },
    cancelUpload: function cancelUpload() {
      console.log("cancel upload");
      this.uploadingHandler && this.uploadingHandler.unsubscribe();
      this.uploadProgress = 0;
    }
  },
  watch: {
    value2: function value2(value) {
      this.value2 = value;
    },
    issueValue: function issueValue(value) {
      this.issueValue = value;

      console.log('%c⧭', 'color: #cc0088', value.length);
    },
    modelID: function modelID(value) {
      this.activeSpareName = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_NAME);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be5f561","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/AddQa/AddQa.vue
var AddQa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-add-qa_zgq"},[_c('div',{staticClass:"spare-name"},[_c('div',{staticClass:"spare-text"}),_vm._v(" "),_c('div',{staticClass:"name-text"},[_vm._v("\n      "+_vm._s(_vm.activeSpareName)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"movement-issue-reply-button-image"},[_c('div',{staticClass:"movement-text-input"},[_c('div',{staticClass:"movement-text"},[_vm._v("身体动作：")]),_vm._v(" "),_c('div',{staticClass:"movement-input"},[_c('selector',{attrs:{"placeholder":"请选择动作","options":_vm.list},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"movement-text-input"},[_c('div',{staticClass:"movement-text"},[_vm._v("问题：")]),_vm._v(" "),_c('div',{staticClass:"movement-input-zgq",on:{"click":function($event){return _vm.$refs.issueInput.focus()}}},[_c('x-input',{ref:"issueInput",attrs:{"placeholder":"请输入问题","value":_vm.issueValue,"max":50,"show-clear":false},model:{value:(_vm.issueValue),callback:function ($$v) {_vm.issueValue=$$v},expression:"issueValue"}})],1),_vm._v(" "),_c('div',{staticClass:"preinstall-issue-box"},[_c('span',{class:_vm.setPreinstallState ? 'outer-circle-active' : 'outer-circle',on:{"click":_vm.onSetPreinstall}},[_c('span',{staticClass:"inner-circle"})]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("预设为快捷问题")])])]),_vm._v(" "),_c('div',{staticClass:"reply-movement-text-input"},[_c('div',{staticClass:"movement-text",staticStyle:{"color":"rgba(0, 237, 180, 1)"}},[_vm._v("回复：")]),_vm._v(" "),_c('div',{staticClass:"reply-movement-input"},_vm._l((_vm.inputList),function(item,index){return _c('div',{key:index},[(index == 0)?_c('OnInput',{staticStyle:{"border-bottom":"1px solid rgba(39, 154, 136, 1)"},attrs:{"itemValue":_vm.oneInputValue,"values":_vm.oneInputValue},on:{"onDelOneInput":_vm.onDelOneInput,"onInput":_vm.onInput}}):_vm._e(),_vm._v(" "),(index == 1)?_c('TwoInput',{staticStyle:{"border-bottom":"1px solid rgba(39, 154, 136, 1)"},attrs:{"itemValue":_vm.twoInputValue,"values":_vm.twoInputValue},on:{"onDelTwoInput":_vm.onDelTwoInput,"onTwoInput":_vm.onTwoInput}}):_vm._e(),_vm._v(" "),(index == 2)?_c('TheryInput',{staticStyle:{"border-bottom":"1px solid rgba(39, 154, 136, 1)"},attrs:{"itemValue":_vm.threeInputValue,"values":_vm.threeInputValue},on:{"onTheryInput":_vm.onTheryInput,"onDelThrryInput":_vm.onDelThrryInput}}):_vm._e()],1)}),0)]),_vm._v(" "),(_vm.inputList.length < 3)?_c('div',{staticClass:"movement-add-input-text"},[_c('div',{staticClass:"movement-button",on:{"click":_vm.onAddInput}},[_vm._v("更多回复")]),_vm._v(" "),_c('div',{staticClass:"movement-text"},[_vm._v("\n        可设置3个回复，分身将随机挑选其一进行回答.\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"file-image-delect-icon"},[_c('div',{staticClass:"movement-text"},[_vm._v("文件：")]),_vm._v(" "),_c('div',{staticClass:"image-url-text"},[(_vm.imageUrl != '' || _vm.pdfNmae != '' || _vm.videoUrl != '')?_c('div',{staticClass:"img"},[(_vm.imageUrl != '')?_c('img',{staticClass:"image-url",attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.pdfNmae != '')?_c('span',{staticClass:"pdf-text"},[_vm._v(_vm._s(_vm.pdfNmae))]):_vm._e(),_vm._v(" "),(_vm.videoUrl != '')?_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showVideo),expression:"!showVideo"}],staticStyle:{"object-fit":"cover","width":"100px","height":"45px"},attrs:{"src":_vm.videoCover},on:{"click":_vm.onLookVideo}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"del-cion"},[_c('img',{attrs:{"src":"/static/img/audioDelete.png","alt":""},on:{"click":_vm.onDelImageUrlKey}})])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadProgress == 0 && _vm.imageUrl == '' && _vm.pdfNmae == '' && _vm.videoUrl == ''),expression:"uploadProgress == 0 && imageUrl == '' && pdfNmae == '' && videoUrl == ''"}],staticClass:"button-uploading"},[_vm._v("\n          +点击上传文件\n          "),_c('div',{staticClass:"box_img_bottom"},[_c('form',{attrs:{"id":"form1","target":"frame1","method":"post","enctype":"multipart/form-data"}},[_c('input',{staticClass:"notFormFile",attrs:{"type":"file","name":"file","id":"file1","accept":"image/jpeg,image/jpg,image/png,.pdf,video/mp4"},on:{"change":function($event){return _vm.getFile($event)}}})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadProgress>0),expression:"uploadProgress>0"}],staticClass:"upload-progress"},[_c('x-progress',{attrs:{"show-cancel":_vm.uploadProgress < 100,"percent":_vm.uploadProgress},on:{"on-cancel":_vm.cancelUpload}})],1),_vm._v(" "),_c('div',{staticClass:"file-hint-text"},[_vm._v("\n      (请上传PDF、JPG、PNG格式图片及MP4格式视频)\n    ")])]),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":"不可全部删除","position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}},[_vm._v("1111")]),_vm._v(" "),(_vm.showVideo)?_c('MyVideo',{attrs:{"videoUrl":_vm.videoUrl},on:{"onHideMyVideo":function($event){_vm.showVideo=false}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"save-set-button-zgq-com"},[_c('div',{staticClass:"save-set-button",on:{"click":_vm.onCancel}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"cancel-set-button",on:{"click":_vm.onSave}},[_vm._v("保存")])])],1)}
var AddQa_staticRenderFns = []
var AddQa_esExports = { render: AddQa_render, staticRenderFns: AddQa_staticRenderFns }
/* harmony default export */ var myComponents_AddQa_AddQa = (AddQa_esExports);
// CONCATENATED MODULE: ./src/myComponents/AddQa/AddQa.vue
function AddQa_injectStyle (ssrContext) {
  __webpack_require__("EJBL")
}
var AddQa_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AddQa___vue_template_functional__ = false
/* styles */
var AddQa___vue_styles__ = AddQa_injectStyle
/* scopeId */
var AddQa___vue_scopeId__ = "data-v-7be5f561"
/* moduleIdentifier (server only) */
var AddQa___vue_module_identifier__ = null
var AddQa_Component = AddQa_normalizeComponent(
  AddQa_AddQa,
  myComponents_AddQa_AddQa,
  AddQa___vue_template_functional__,
  AddQa___vue_styles__,
  AddQa___vue_scopeId__,
  AddQa___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_AddQa_AddQa = (AddQa_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue + 3 modules
var flexbox_flexbox = __webpack_require__("YxJB");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue + 3 modules
var flexbox_item = __webpack_require__("3Lt7");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263730af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/divider/index.vue
var divider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var divider_staticRenderFns = []
var divider_esExports = { render: divider_render, staticRenderFns: divider_staticRenderFns }
/* harmony default export */ var src_components_divider = (divider_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/divider/index.vue
function divider_injectStyle (ssrContext) {
  __webpack_require__("LWON")
}
var divider_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var divider___vue_template_functional__ = false
/* styles */
var divider___vue_styles__ = divider_injectStyle
/* scopeId */
var divider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var divider___vue_module_identifier__ = null
var divider_Component = divider_normalizeComponent(
  components_divider,
  src_components_divider,
  divider___vue_template_functional__,
  divider___vue_styles__,
  divider___vue_scopeId__,
  divider___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_divider = (divider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a8526d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("JvV8")
}
var grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f818f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":_vm.icon,"alt":""}})]})],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]})],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("Ckmr")
}
var grid_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3c88812","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group-title/index.vue
var group_title_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells__title"},[_vm._t("default")],2)}
var group_title_staticRenderFns = []
var group_title_esExports = { render: group_title_render, staticRenderFns: group_title_staticRenderFns }
/* harmony default export */ var src_components_group_title = (group_title_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group-title/index.vue
function group_title_injectStyle (ssrContext) {
  __webpack_require__("4WEX")
}
var group_title_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group_title___vue_template_functional__ = false
/* styles */
var group_title___vue_styles__ = group_title_injectStyle
/* scopeId */
var group_title___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group_title___vue_module_identifier__ = null
var group_title_Component = group_title_normalizeComponent(
  components_group_title,
  src_components_group_title,
  group_title___vue_template_functional__,
  group_title___vue_styles__,
  group_title___vue_scopeId__,
  group_title___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group_title = (group_title_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-textarea/index.vue + 3 modules
var x_textarea = __webpack_require__("ALGc");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/HumanList/HumanList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var HumanList = ({
  name: "HumanList",
  components: {},
  props: {
    list: Array,
    isAddSpare: Boolean,
    modelID: Number,
    backGround: String,
    width: String,
    disable: Boolean
  },

  data: function data() {
    return {
      data: [],
      spareList: this.list,
      addSpare: false, // this.isAddSpare || false,
      modelViewId: this.modelID,
      comBackGround: this.backGround,
      activeBackGround: this.backGround,
      activeWidth: this.width

    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      console.log('----------move 1');
      var firtLeft = document.getElementById("spareObj_" + _this.spareList[0].id).getBoundingClientRect().left;
      if (_this.spareList.length > 0 && _this.spareList[0].id != _this.modelViewId) {
        document.getElementById("spareObj_" + _this.modelViewId) && document.getElementById("boxListScroll") && document.getElementById("boxListScroll").scrollTo({
          left: document.getElementById("spareObj_" + _this.modelViewId).getBoundingClientRect().left - firtLeft,
          behavior: "smooth"
        });
      }
    }, 2000);
    var localModelID = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
    if (localModelID && (!this.modelViewId || this.modelViewId == "")) {
      this.modelViewId = localModelID;
    }
    console.log("===this modelID", this.modelViewId, this.spareList);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onAddSpare: function onAddSpare() {
      this.$emit("onAddSpare");
    },
    selectSpare: function selectSpare(data) {
      console.log("------select spareID", data);
      if (this.disable) {
        return;
      }
      if (this.modelViewId == data.id) {
        return;
      }
      this.$emit("selectSpare", {
        id: data.id
      });

      this.modelViewId = data.id;
      localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_ID, data.id);
      localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, data.name);
    }
  },
  watch: {
    list: function list(_list) {
      console.log('----------move 2');
      this.spareList = _list;
      // if (
      //   this.spareList.length > 0 &&
      //   this.spareList[0].id != this.modelViewId
      // ) {
      //   //第一个不需要移动
      //   //列表初始化之后，定位到默认选择的分身上
      //   this.$nextTick(() => {
      //     document.getElementById(`spareObj_${this.modelViewId}`) &&
      //       document.getElementById("boxListScroll") &&
      //       document.getElementById("boxListScroll").scrollTo({
      //         left:
      //           document
      //             .getElementById(`spareObj_${this.modelViewId}`)
      //             .getBoundingClientRect().left,
      //         behavior: "smooth",
      //       });
      //   });
      // }
    },
    isAddSpare: function isAddSpare(data) {
      this.addSpare = data;
    },
    modelID: function modelID(data) {
      this.modelViewId = data;
    },
    backGround: function backGround(data) {
      console.log("change background", data);
      this.comBackGround = data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/HumanList/HumanList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var HumanList_HumanList = ({
  name: "HumanList",
  components: {},
  props: {
    list: Array,
    isAddSpare: Boolean,
    modelID: Number,
    backGround: String,
    width: String,
    disable: Boolean
  },

  data: function data() {
    return {
      data: [],
      spareList: this.list,
      addSpare: false, // this.isAddSpare || false,
      modelViewId: this.modelID,
      comBackGround: this.backGround,
      activeBackGround: this.backGround,
      activeWidth: this.width

    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      console.log('----------move 1');
      var firtLeft = document.getElementById("spareObj_" + _this.spareList[0].id).getBoundingClientRect().left;
      if (_this.spareList.length > 0 && _this.spareList[0].id != _this.modelViewId) {
        document.getElementById("spareObj_" + _this.modelViewId) && document.getElementById("boxListScroll") && document.getElementById("boxListScroll").scrollTo({
          left: document.getElementById("spareObj_" + _this.modelViewId).getBoundingClientRect().left - firtLeft,
          behavior: "smooth"
        });
      }
    }, 2000);
    var localModelID = localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
    if (localModelID && (!this.modelViewId || this.modelViewId == "")) {
      this.modelViewId = localModelID;
    }
    console.log("===this modelID", this.modelViewId, this.spareList);
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onAddSpare: function onAddSpare() {
      this.$emit("onAddSpare");
    },
    selectSpare: function selectSpare(data) {
      console.log("------select spareID", data);
      if (this.disable) {
        return;
      }
      if (this.modelViewId == data.id) {
        return;
      }
      this.$emit("selectSpare", {
        id: data.id
      });

      this.modelViewId = data.id;
      localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_ID, data.id);
      localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, data.name);
    }
  },
  watch: {
    list: function list(_list) {
      console.log('----------move 2');
      this.spareList = _list;
      // if (
      //   this.spareList.length > 0 &&
      //   this.spareList[0].id != this.modelViewId
      // ) {
      //   //第一个不需要移动
      //   //列表初始化之后，定位到默认选择的分身上
      //   this.$nextTick(() => {
      //     document.getElementById(`spareObj_${this.modelViewId}`) &&
      //       document.getElementById("boxListScroll") &&
      //       document.getElementById("boxListScroll").scrollTo({
      //         left:
      //           document
      //             .getElementById(`spareObj_${this.modelViewId}`)
      //             .getBoundingClientRect().left,
      //         behavior: "smooth",
      //       });
      //   });
      // }
    },
    isAddSpare: function isAddSpare(data) {
      this.addSpare = data;
    },
    modelID: function modelID(data) {
      this.modelViewId = data;
    },
    backGround: function backGround(data) {
      console.log("change background", data);
      this.comBackGround = data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c53716","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/HumanList/HumanList.vue
var HumanList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"human-list",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"default-top-administration-spare",style:({ background: _vm.activeBackGround, width: _vm.activeWidth })},[_c('div',{staticClass:"default-left-name-type-text"},[_c('div',{staticClass:"default-left-text"},[_vm._v("管理分身")]),_vm._v(" "),_c('div',{staticClass:"default-type-box-list",style:({ width: _vm.addSpare ? '60%' : '80%' }),attrs:{"id":"boxListScroll"}},_vm._l((_vm.spareList),function(item,index){return _c('div',{key:index,class:_vm.modelViewId == item.id
              ? 'type-text type-select'
              : 'type-text type-normal',attrs:{"id":'spareObj_' + item.id},on:{"click":function($event){return _vm.selectSpare(item)}}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])}),0),_vm._v(" "),(_vm.addSpare)?_c('div',{staticClass:"add-human-text",on:{"click":_vm.onAddSpare}},[_vm._v("＋")]):_vm._e()])])])}
var HumanList_staticRenderFns = []
var HumanList_esExports = { render: HumanList_render, staticRenderFns: HumanList_staticRenderFns }
/* harmony default export */ var myComponents_HumanList_HumanList = (HumanList_esExports);
// CONCATENATED MODULE: ./src/myComponents/HumanList/HumanList.vue
function HumanList_injectStyle (ssrContext) {
  __webpack_require__("CEdf")
}
var HumanList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HumanList___vue_template_functional__ = false
/* styles */
var HumanList___vue_styles__ = HumanList_injectStyle
/* scopeId */
var HumanList___vue_scopeId__ = "data-v-22c53716"
/* moduleIdentifier (server only) */
var HumanList___vue_module_identifier__ = null
var HumanList_Component = HumanList_normalizeComponent(
  HumanList_HumanList,
  myComponents_HumanList_HumanList,
  HumanList___vue_template_functional__,
  HumanList___vue_styles__,
  HumanList___vue_scopeId__,
  HumanList___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_HumanList_HumanList = (HumanList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/PaymentModel/PaymentModel.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };

var setTimeHandler = undefined;
var payMoneyStatus = 0;
/* harmony default export */ var PaymentModel = ({
  name: "PaymentModel",
  props: {
    purchaseModelOpen: Boolean,
    stateIs: Number
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data: function data() {
    return {
      purchaseList: [],
      purchaseModelIsopen: false,
      selectPurchaseIndex: 0,
      balanceCount: 0,
      starNoteEnough: []
    };
  },
  mounted: function mounted() {
    this.getPurchaseConfing();
    this.getWalletStat();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    //获取余额
    getWalletStat: function getWalletStat() {
      var _this = this;

      Object(api["q" /* getWalletStat */])().then(function (res) {
        _this.balanceCount = res.data.balance;
        _this.purchaseList.forEach(function (item) {
          if (item.star_coin <= res.data.balance) {

            console.log('%c⧭', 'color: #00ff88', item);
            _this.starNoteEnough.push(item);
          }
        });
        console.log('%c⧭', 'color: #f279ca', _this.starNoteEnough);
      });
    },

    //选择支付选项
    onSelectPurchase: function onSelectPurchase(index, item) {
      this.selectPurchaseIndex = index;
    },

    //获取充值配置
    getPurchaseConfing: function getPurchaseConfing() {
      var _this2 = this;

      Object(utils["a" /* createRequest */])("get", "applet/chat/recharge/config", {}, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.purchaseList = res.data.recharge_config;
          console.log('%c⧭', 'color: #7f7700', res);
        } else {
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },

    //取消支付model
    onCancelPurchaseModel: function onCancelPurchaseModel() {
      this.selectPurchaseIndex = 0;
      this.purchaseModelIsopen = false;
      this.$emit("informCancelPurchase", false);
      this.starNoteEnough = [];
      this.getWalletStat();
    },

    //立即支付
    onImmediatelyPurchase: function onImmediatelyPurchase() {
      var _this3 = this;

      if (this.payTime && Date.now() - this.payTime < 1000) {
        return;
      }
      this.payTime = Date.now();
      var that = this;
      //支付成功通知 false===> 关闭父级的model状态
      if (this.purchaseList[this.selectPurchaseIndex]) {
        Object(api["c" /* chatRecharge */])(this.purchaseList[this.selectPurchaseIndex].star_coin).then(function (res) {
          if (res.data.type == 0) {
            //支付成功
            _this3.$emit('informImmediatelyPurchase', true);
          } else if (res.data.type == 2) {
            //跳转微信支付
            var query = "?order_id=" + encodeURIComponent(res.data.order_id) + ("&appId=" + encodeURIComponent(res.data.wx_jspay_params.appId)) + ("&timeStamp=" + encodeURIComponent(res.data.wx_jspay_params.timeStamp)) + ("&nonceStr=" + encodeURIComponent(res.data.wx_jspay_params.nonceStr)) + ("&package=" + encodeURIComponent(res.data.wx_jspay_params.package)) + ("&signType=" + encodeURIComponent(res.data.wx_jspay_params.signType)) + ("&paySign=" + encodeURIComponent(res.data.wx_jspay_params.paySign));

            _this3.$wechat.miniProgram.navigateTo({
              url: '/walletPage/pages/commonRecharge/commonRecharge' + query,
              success: function success() {
                console.log('跳转成功');
                //定时监控订单支付状态
                if (setTimeHandler) {
                  clearInterval(setTimeHandler);
                }
                setTimeHandler = setInterval(function () {
                  Object(api["p" /* getWalletRecharge */])(res.data.order_id).then(function (res) {
                    payMoneyStatus = res.data.status;

                    if (payMoneyStatus == 2) {
                      //充值成功
                      clearInterval(setTimeHandler);

                      that.$emit('informImmediatelyPurchase', true);
                    }
                  });
                }, 1000);
              }
            });
          }
        });
        setTimeout(function () {
          _this3.starNoteEnough = [];
          _this3.getWalletStat();
        }, 1000);
      }
    }
  },
  watch: {
    purchaseModelOpen: function purchaseModelOpen(value) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.getWalletStat();

              case 2:
                _this4.purchaseModelIsopen = value;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/PaymentModel/PaymentModel.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };

var PaymentModel_setTimeHandler = undefined;
var PaymentModel_payMoneyStatus = 0;
/* harmony default export */ var PaymentModel_PaymentModel = ({
  name: "PaymentModel",
  props: {
    purchaseModelOpen: Boolean,
    stateIs: Number
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data: function data() {
    return {
      purchaseList: [],
      purchaseModelIsopen: false,
      selectPurchaseIndex: 0,
      balanceCount: 0,
      starNoteEnough: []
    };
  },
  mounted: function mounted() {
    this.getPurchaseConfing();
    this.getWalletStat();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    //获取余额
    getWalletStat: function getWalletStat() {
      var _this = this;

      Object(api["q" /* getWalletStat */])().then(function (res) {
        _this.balanceCount = res.data.balance;
        _this.purchaseList.forEach(function (item) {
          if (item.star_coin <= res.data.balance) {

            console.log('%c⧭', 'color: #00ff88', item);
            _this.starNoteEnough.push(item);
          }
        });
        console.log('%c⧭', 'color: #f279ca', _this.starNoteEnough);
      });
    },

    //选择支付选项
    onSelectPurchase: function onSelectPurchase(index, item) {
      this.selectPurchaseIndex = index;
    },

    //获取充值配置
    getPurchaseConfing: function getPurchaseConfing() {
      var _this2 = this;

      Object(utils["a" /* createRequest */])("get", "applet/chat/recharge/config", {}, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.purchaseList = res.data.recharge_config;
          console.log('%c⧭', 'color: #7f7700', res);
        } else {
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },

    //取消支付model
    onCancelPurchaseModel: function onCancelPurchaseModel() {
      this.selectPurchaseIndex = 0;
      this.purchaseModelIsopen = false;
      this.$emit("informCancelPurchase", false);
      this.starNoteEnough = [];
      this.getWalletStat();
    },

    //立即支付
    onImmediatelyPurchase: function onImmediatelyPurchase() {
      var _this3 = this;

      if (this.payTime && Date.now() - this.payTime < 1000) {
        return;
      }
      this.payTime = Date.now();
      var that = this;
      //支付成功通知 false===> 关闭父级的model状态
      if (this.purchaseList[this.selectPurchaseIndex]) {
        Object(api["c" /* chatRecharge */])(this.purchaseList[this.selectPurchaseIndex].star_coin).then(function (res) {
          if (res.data.type == 0) {
            //支付成功
            _this3.$emit('informImmediatelyPurchase', true);
          } else if (res.data.type == 2) {
            //跳转微信支付
            var query = "?order_id=" + encodeURIComponent(res.data.order_id) + ("&appId=" + encodeURIComponent(res.data.wx_jspay_params.appId)) + ("&timeStamp=" + encodeURIComponent(res.data.wx_jspay_params.timeStamp)) + ("&nonceStr=" + encodeURIComponent(res.data.wx_jspay_params.nonceStr)) + ("&package=" + encodeURIComponent(res.data.wx_jspay_params.package)) + ("&signType=" + encodeURIComponent(res.data.wx_jspay_params.signType)) + ("&paySign=" + encodeURIComponent(res.data.wx_jspay_params.paySign));

            _this3.$wechat.miniProgram.navigateTo({
              url: '/walletPage/pages/commonRecharge/commonRecharge' + query,
              success: function success() {
                console.log('跳转成功');
                //定时监控订单支付状态
                if (PaymentModel_setTimeHandler) {
                  clearInterval(PaymentModel_setTimeHandler);
                }
                PaymentModel_setTimeHandler = setInterval(function () {
                  Object(api["p" /* getWalletRecharge */])(res.data.order_id).then(function (res) {
                    PaymentModel_payMoneyStatus = res.data.status;

                    if (PaymentModel_payMoneyStatus == 2) {
                      //充值成功
                      clearInterval(PaymentModel_setTimeHandler);

                      that.$emit('informImmediatelyPurchase', true);
                    }
                  });
                }, 1000);
              }
            });
          }
        });
        setTimeout(function () {
          _this3.starNoteEnough = [];
          _this3.getWalletStat();
        }, 1000);
      }
    }
  },
  watch: {
    purchaseModelOpen: function purchaseModelOpen(value) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.getWalletStat();

              case 2:
                _this4.purchaseModelIsopen = value;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ec7a4e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/PaymentModel/PaymentModel.vue
var PaymentModel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PaymentModel"},[(_vm.purchaseModelIsopen)?_c('div',{staticClass:"purchase-character-model"},[_c('div',{staticClass:"purchase-character-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateIs == 2),expression:"stateIs == 2"}],staticClass:"star-note-moy"},[_c('span',{staticClass:"one-text-moy"},[_vm._v("请进行字符购买")])]),_vm._v(" "),(_vm.starNoteEnough.length > 0)?_c('div',{staticClass:"star-note-count"},[_c('span',{staticClass:"one-text"},[_vm._v("当前账户余额："),_c('span',{staticClass:"two-text"},[_vm._v(_vm._s(_vm.balanceCount))]),_vm._v("积分")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"two-box",style:(_vm.starNoteEnough.length <= 0 && _vm.stateIs == 1 ? 'margin-top:40px' : _vm.starNoteEnough.length <= 0 && _vm.stateIs == 2 ?'margin-top:20px' : '')},_vm._l((_vm.purchaseList),function(item,index){return _c('div',{key:index,class:_vm.selectPurchaseIndex == index ? 'left-right--purchase-one-active' : 'left-right--purchase-one',on:{"click":function($event){return _vm.onSelectPurchase(index,item)}}},[_c('div',{staticClass:"ont-two-top-text"},[_vm._v("\r\n                "+_vm._s(item.title)+"\r\n              ")]),_vm._v(" "),_c('div',{class:index == 1 ? 'about-number-issue-color' : 'about-number-issue'},[_vm._v("\r\n                （"+_vm._s(item.question)+"）\r\n              ")]),_vm._v(" "),_c('div',{class:index == 1 ? 'period-of-validity-text-color' : 'period-of-validity-text'},[_vm._v("\r\n                "+_vm._s(item.tip)+"\r\n              ")]),_vm._v(" "),_c('div',{staticClass:"studio-element-box"},[(_vm.starNoteEnough.length > 0)?_c('div',{staticClass:"studio-count"},[_c('span',{staticClass:"count-text"},[_vm._v(_vm._s(item.star_coin))]),_vm._v(" "),_c('span',{staticClass:"studio-text"},[_vm._v("积分")])]):_vm._e(),_vm._v(" "),(_vm.starNoteEnough.length <= 0)?_c('div',{staticClass:"studio-count"},[_c('span',{staticClass:"count-text"},[_vm._v(_vm._s(item.price / 100))]),_vm._v(" "),_c('span',{staticClass:"studio-text"},[_vm._v("元")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"purchase-character-position-absolute"},[_vm._v(_vm._s(item.icon))])])}),0),_vm._v(" "),_c('div',{staticClass:"purchase-character-cancel-payment"},[_c('div',{staticClass:"cancel-button",on:{"click":_vm.onCancelPurchaseModel}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"payment-button",on:{"click":_vm.onImmediatelyPurchase}},[_vm._v("立即支付")])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"0px","top":"0px","padding":"10px"}},[_c('img',{staticStyle:{"width":"15px","height":"15px"},attrs:{"src":"/static/img/audioDelete.png","alt":""},on:{"click":_vm.onCancelPurchaseModel}})])])]):_vm._e()])}
var PaymentModel_staticRenderFns = []
var PaymentModel_esExports = { render: PaymentModel_render, staticRenderFns: PaymentModel_staticRenderFns }
/* harmony default export */ var myComponents_PaymentModel_PaymentModel = (PaymentModel_esExports);
// CONCATENATED MODULE: ./src/myComponents/PaymentModel/PaymentModel.vue
function PaymentModel_injectStyle (ssrContext) {
  __webpack_require__("f+wq")
}
var PaymentModel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PaymentModel___vue_template_functional__ = false
/* styles */
var PaymentModel___vue_styles__ = PaymentModel_injectStyle
/* scopeId */
var PaymentModel___vue_scopeId__ = "data-v-9ec7a4e0"
/* moduleIdentifier (server only) */
var PaymentModel___vue_module_identifier__ = null
var PaymentModel_Component = PaymentModel_normalizeComponent(
  PaymentModel_PaymentModel,
  myComponents_PaymentModel_PaymentModel,
  PaymentModel___vue_template_functional__,
  PaymentModel___vue_styles__,
  PaymentModel___vue_scopeId__,
  PaymentModel___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_PaymentModel_PaymentModel = (PaymentModel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/edit/edit.vue















/* harmony default export */ var edit = ({
  uploadingHandler: undefined,
  name: "chatframe",
  components: {
    OnInput: src_myComponents_oneInput_oneInput,
    TwoInput: src_myComponents_twoInput_twoInput,
    TheryInput: src_myComponents_theryInput_theryInput,
    Toast: toast["a" /* default */],
    XInput: x_input["a" /* default */],
    Selector: selector["a" /* default */],
    XProgress: vux_src_components_x_progress,
    MyVideo: myVideo["a" /* default */]
  },
  props: {
    items: Object,
    indexIs: Number,
    actionList: Array,
    cardTypeIs: String

  },
  data: function data() {
    return {
      item: this.items,
      addState: false,
      inputList: this.items.answer_arr,

      oneValue: "",
      twoValue: "",
      theryValue: "",
      index: this.indexIs,
      editState: false,
      time: new Date(),
      showPositionValue: false,
      position: "default",
      imageUrl: "",
      imageKey: "",
      editID: 0,
      issueValue: "",
      list: this.actionList,
      value2: "",
      actionIdName: "",
      pdfNmae: "",
      videoUrl: "",
      videoCover: "",
      setPreinstallState: this.items.is_presets == 1 ? true : false,
      uploadProgress: 0,
      showVideo: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    console.log('%c⧭', 'color: #f27999', this.cardTypeIs, "this.cardTypeIs");
    this.getMovement();
    console.log(this.item, "-----items");
    if (this.item.file_key) {
      if (this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "pdf") {
        this.pdfNmae = "PDF文件";
      } else if (this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "png" || this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "jpg") {
        this.imageUrl = this.item.file == null || this.item.file == undefined || this.item.file == "" ? "" : this.item.file;
      } else if (this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "mp4") {
        this.videoUrl = this.item.file == null || this.item.file == undefined || this.item.file == "" ? "" : this.item.file;
        this.videoCover = this.videoUrl + '?vframe/jpg/offset/2/w/480';
      }
      this.setPreinstallState = this.item.is_presets == 1 ? true : false;
      this.imageKey = this.item.file_key == null || this.item.file_key == undefined || this.item.file_key == "" ? "" : this.item.file_key;
    }
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    autoSave: function autoSave() {
      console.log('自动保存');
      this.saveData();
    },
    onSetPreinstall: function onSetPreinstall() {
      this.setPreinstallState = !this.setPreinstallState;
      this.autoSave();
    },
    getMovement: function getMovement() {
      var _this2 = this;

      var list = this.actionList;

      console.log('%c⧭', 'color: #408059', list);
      var data = [];
      list.forEach(function (item) {
        var obj = {
          value: item.name,
          key: item.id,
          pic: item.pic,
          video: item.video,
          gender: item.gender
        };
        data.push(obj);
      });
      this.list = data;
      console.log('---list', list);
      this.list.forEach(function (val) {
        console.log("%c⧭", "color: #731d1d;font-size:50px", val.key);
        if (val.key == _this2.item.action_id) {
          _this2.actionIdName = val.value;
        }
      });
    },
    getFile: function getFile(event) {
      var _this3 = this;

      console.log("get file", event);
      var _this = this;
      var file = event.target.files[0];
      var chars = event.target.files[0].name.split(".");
      console.log("%c⧭", "color: #f200e2");
      var name = chars[chars.length - 1];
      if (["pdf", "png", "jpg", "mp4"].indexOf(name.toLowerCase()) < 0) {
        return this.$vux.toast.show({
          type: "text",
          text: "不支持的文件格式"
        });
      }
      var fileName = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('/') + 1);
      uploadQiniuSetKey(file, fileName, function (res) {
        console.log("%c⧭", "color: #00e600", res);
        _this3.uploadProgress = res.percent;
      }, function (err, res) {
        console.log('上传结束', err, res);
        _this3.uploadProgress = 0;
        if (err) {
          return _this3.$vux.toast.show({
            type: "text",
            text: "上传失败:" + err
          });
        }
        if (name == "pdf") {
          var leng = event.target.files[0].name;
          var sp = leng.split('.');

          console.log('%c⧭', 'color: #006dcc', sp[0].length);
          if (sp[0].length < 6) {
            _this.pdfNmae = event.target.files[0].name;
          } else {

            var ont = sp[0].slice(0, 6);
            _this.pdfNmae = ont + '.' + sp[sp.length - 1];
          }
        } else if (name == "png" || name == "jpg") {
          _this.imageUrl = res.domain + res.key;
        } else if (name == "mp4") {
          _this.videoUrl = res.domain + res.key;
          _this.videoCover = res.domain + res.key + '?vframe/jpg/offset/2/w/480';
        }
        _this.imageKey = res.key;
        _this.autoSave();
      }).then(function (currentUploadHandler) {
        _this3.uploadingHandler = currentUploadHandler;
      });
      console.log("%c⧭", "color: #ff0000");
    },
    onDelImageUrlKey: function onDelImageUrlKey() {
      this.imageKey = "";
      this.imageUrl = "";
      this.videoUrl = "";
      this.pdfNmae = "";
      this.autoSave();
    },
    onInput: function onInput(value) {
      console.log("%c⧭", "color: #997326", value);
      this.oneValue = value;
    },
    onDelOneInput: function onDelOneInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 0) {
        this.inputList.splice(event, 1);
        console.log("%c⧭", "color: #f27999", this.inputList);
        this.oneValue = this.twoValue;
        this.twoValue = this.theryValue;
        console.log("%c⧭", "color: #40fff2", this.twoValue);
        this.theryValue = "";
        this.autoSave();
      }
    },
    onTwoInput: function onTwoInput(value) {
      console.log("%c⧭", "color: #997326", value);
      this.twoValue = value;
    },
    onDelTwoInput: function onDelTwoInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 1) {
        this.inputList.splice(event, 1);
        this.twoValue = this.theryValue;
        this.theryValue = "";
        this.autoSave();
      }
    },
    onTheryInput: function onTheryInput(value) {
      console.log("%c⧭", "color: #997326", value);
      this.theryValue = value;
    },
    onDelThrryInput: function onDelThrryInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 2) {
        this.inputList.splice(event, 1);
        this.theryValue = "";
        this.autoSave();
      }
    },
    onEdit: function onEdit(val) {
      this.value2 = this.item.action_id;
      this.issueValue = this.item.question;
      this.editID = val;
      this.editState = true;
    },
    saveData: function saveData() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        var data = [];

        _this4.oneValu != "" && data.push(_this4.oneValue);
        _this4.twoValue != "" && data.push(_this4.twoValue);
        _this4.theryValue != "" && data.push(_this4.theryValue);
        _this4.inputList = data;
        Object(utils["a" /* createRequest */])("post", "applet/webview/qa/update", {
          image_id: _this4.cardTypeIs == '3d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : '',
          id: _this4.editID,
          action_id: _this4.value2,
          question: _this4.issueValue,
          answer: _this4.inputList,
          file: _this4.imageKey,
          is_presets: _this4.setPreinstallState ? 1 : 2,
          card_id: _this4.cardTypeIs == '2d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : ''
        }, function (res) {
          console.log("%c⧭", "color: #d90000", res);
          if (res.code == 200) {
            return resolve(res);
          } else {
            console.error(res.msg);
            return reject(res.msg);
          }
        });
      });
    },
    onSave: function onSave(val) {
      var _this5 = this;

      this.saveData().then(function (d) {
        _this5.$vux.toast.show({
          type: "text",
          text: "保存成功"
        });
        _this5.editState = false;
        _this5.list.forEach(function (val) {
          console.log("%c⧭", "color: #731d1d;font-size:50px", val.key);
          if (val.key == _this5.value2) {
            _this5.actionIdName = val.value;
          }
        });
        _this5.$emit("onSaveGetList", true);
      }, function (e) {
        _this5.$vux.toast.show({
          type: "text",
          text: e
        });
      });
    },
    onDelect: function onDelect(val, i) {
      console.log("%c⧭", "color: #cc0088", val, i);
      if (this.editState) {

        this.editState = false;
      } else {

        this.$emit("onDelectVal", val, i);
      }
    },
    addInput: function addInput(item) {
      this.inputList.push("");
    },
    cancelUpload: function cancelUpload() {
      console.log("cancel upload");
      this.uploadingHandler && this.uploadingHandler.unsubscribe();
      this.uploadProgress = 0;
    },
    onLookVideo: function onLookVideo() {
      console.log('look video');
      if (this.showVideo) {
        this.showVideo = false;
      }
      this.showVideo = true;
    },
    onHideMyVideo: function onHideMyVideo() {
      console.log('video 隐藏');
      this.showVideo = false;
    }
  },
  watch: {
    items: function items(value) {
      console.log("%c⧭", "color: #bfffc8", value);
      this.item = value;
    },
    issueValue: function issueValue(value) {
      this.issueValue = value;
    },
    actionList: function actionList(value) {
      this.actionList = value;
      this.getMovement();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/edit/edit.vue















/* harmony default export */ var edit_edit = ({
  uploadingHandler: undefined,
  name: "chatframe",
  components: {
    OnInput: src_myComponents_oneInput_oneInput,
    TwoInput: src_myComponents_twoInput_twoInput,
    TheryInput: src_myComponents_theryInput_theryInput,
    Toast: toast["a" /* default */],
    XInput: x_input["a" /* default */],
    Selector: selector["a" /* default */],
    XProgress: vux_src_components_x_progress,
    MyVideo: myVideo["a" /* default */]
  },
  props: {
    items: Object,
    indexIs: Number,
    actionList: Array,
    cardTypeIs: String

  },
  data: function data() {
    return {
      item: this.items,
      addState: false,
      inputList: this.items.answer_arr,

      oneValue: "",
      twoValue: "",
      theryValue: "",
      index: this.indexIs,
      editState: false,
      time: new Date(),
      showPositionValue: false,
      position: "default",
      imageUrl: "",
      imageKey: "",
      editID: 0,
      issueValue: "",
      list: this.actionList,
      value2: "",
      actionIdName: "",
      pdfNmae: "",
      videoUrl: "",
      videoCover: "",
      setPreinstallState: this.items.is_presets == 1 ? true : false,
      uploadProgress: 0,
      showVideo: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    console.log('%c⧭', 'color: #f27999', this.cardTypeIs, "this.cardTypeIs");
    this.getMovement();
    console.log(this.item, "-----items");
    if (this.item.file_key) {
      if (this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "pdf") {
        this.pdfNmae = "PDF文件";
      } else if (this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "png" || this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "jpg") {
        this.imageUrl = this.item.file == null || this.item.file == undefined || this.item.file == "" ? "" : this.item.file;
      } else if (this.item.file_key.split(".")[this.item.file_key.split(".").length - 1] == "mp4") {
        this.videoUrl = this.item.file == null || this.item.file == undefined || this.item.file == "" ? "" : this.item.file;
        this.videoCover = this.videoUrl + '?vframe/jpg/offset/2/w/480';
      }
      this.setPreinstallState = this.item.is_presets == 1 ? true : false;
      this.imageKey = this.item.file_key == null || this.item.file_key == undefined || this.item.file_key == "" ? "" : this.item.file_key;
    }
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    autoSave: function autoSave() {
      console.log('自动保存');
      this.saveData();
    },
    onSetPreinstall: function onSetPreinstall() {
      this.setPreinstallState = !this.setPreinstallState;
      this.autoSave();
    },
    getMovement: function getMovement() {
      var _this2 = this;

      var list = this.actionList;

      console.log('%c⧭', 'color: #408059', list);
      var data = [];
      list.forEach(function (item) {
        var obj = {
          value: item.name,
          key: item.id,
          pic: item.pic,
          video: item.video,
          gender: item.gender
        };
        data.push(obj);
      });
      this.list = data;
      console.log('---list', list);
      this.list.forEach(function (val) {
        console.log("%c⧭", "color: #731d1d;font-size:50px", val.key);
        if (val.key == _this2.item.action_id) {
          _this2.actionIdName = val.value;
        }
      });
    },
    getFile: function getFile(event) {
      var _this3 = this;

      console.log("get file", event);
      var _this = this;
      var file = event.target.files[0];
      var chars = event.target.files[0].name.split(".");
      console.log("%c⧭", "color: #f200e2");
      var name = chars[chars.length - 1];
      if (["pdf", "png", "jpg", "mp4"].indexOf(name.toLowerCase()) < 0) {
        return this.$vux.toast.show({
          type: "text",
          text: "不支持的文件格式"
        });
      }
      var fileName = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('/') + 1);
      uploadQiniuSetKey(file, fileName, function (res) {
        console.log("%c⧭", "color: #00e600", res);
        _this3.uploadProgress = res.percent;
      }, function (err, res) {
        console.log('上传结束', err, res);
        _this3.uploadProgress = 0;
        if (err) {
          return _this3.$vux.toast.show({
            type: "text",
            text: "上传失败:" + err
          });
        }
        if (name == "pdf") {
          var leng = event.target.files[0].name;
          var sp = leng.split('.');

          console.log('%c⧭', 'color: #006dcc', sp[0].length);
          if (sp[0].length < 6) {
            _this.pdfNmae = event.target.files[0].name;
          } else {

            var ont = sp[0].slice(0, 6);
            _this.pdfNmae = ont + '.' + sp[sp.length - 1];
          }
        } else if (name == "png" || name == "jpg") {
          _this.imageUrl = res.domain + res.key;
        } else if (name == "mp4") {
          _this.videoUrl = res.domain + res.key;
          _this.videoCover = res.domain + res.key + '?vframe/jpg/offset/2/w/480';
        }
        _this.imageKey = res.key;
        _this.autoSave();
      }).then(function (currentUploadHandler) {
        _this3.uploadingHandler = currentUploadHandler;
      });
      console.log("%c⧭", "color: #ff0000");
    },
    onDelImageUrlKey: function onDelImageUrlKey() {
      this.imageKey = "";
      this.imageUrl = "";
      this.videoUrl = "";
      this.pdfNmae = "";
      this.autoSave();
    },
    onInput: function onInput(value) {
      console.log("%c⧭", "color: #997326", value);
      this.oneValue = value;
    },
    onDelOneInput: function onDelOneInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 0) {
        this.inputList.splice(event, 1);
        console.log("%c⧭", "color: #f27999", this.inputList);
        this.oneValue = this.twoValue;
        this.twoValue = this.theryValue;
        console.log("%c⧭", "color: #40fff2", this.twoValue);
        this.theryValue = "";
        this.autoSave();
      }
    },
    onTwoInput: function onTwoInput(value) {
      console.log("%c⧭", "color: #997326", value);
      this.twoValue = value;
    },
    onDelTwoInput: function onDelTwoInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 1) {
        this.inputList.splice(event, 1);
        this.twoValue = this.theryValue;
        this.theryValue = "";
        this.autoSave();
      }
    },
    onTheryInput: function onTheryInput(value) {
      console.log("%c⧭", "color: #997326", value);
      this.theryValue = value;
    },
    onDelThrryInput: function onDelThrryInput(event) {
      if (this.inputList.length == 1) {
        this.showPositionValue = true;
      } else if (event == 2) {
        this.inputList.splice(event, 1);
        this.theryValue = "";
        this.autoSave();
      }
    },
    onEdit: function onEdit(val) {
      this.value2 = this.item.action_id;
      this.issueValue = this.item.question;
      this.editID = val;
      this.editState = true;
    },
    saveData: function saveData() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        var data = [];

        _this4.oneValu != "" && data.push(_this4.oneValue);
        _this4.twoValue != "" && data.push(_this4.twoValue);
        _this4.theryValue != "" && data.push(_this4.theryValue);
        _this4.inputList = data;
        Object(utils["a" /* createRequest */])("post", "applet/webview/qa/update", {
          image_id: _this4.cardTypeIs == '3d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : '',
          id: _this4.editID,
          action_id: _this4.value2,
          question: _this4.issueValue,
          answer: _this4.inputList,
          file: _this4.imageKey,
          is_presets: _this4.setPreinstallState ? 1 : 2,
          card_id: _this4.cardTypeIs == '2d' ? localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID) : ''
        }, function (res) {
          console.log("%c⧭", "color: #d90000", res);
          if (res.code == 200) {
            return resolve(res);
          } else {
            console.error(res.msg);
            return reject(res.msg);
          }
        });
      });
    },
    onSave: function onSave(val) {
      var _this5 = this;

      this.saveData().then(function (d) {
        _this5.$vux.toast.show({
          type: "text",
          text: "保存成功"
        });
        _this5.editState = false;
        _this5.list.forEach(function (val) {
          console.log("%c⧭", "color: #731d1d;font-size:50px", val.key);
          if (val.key == _this5.value2) {
            _this5.actionIdName = val.value;
          }
        });
        _this5.$emit("onSaveGetList", true);
      }, function (e) {
        _this5.$vux.toast.show({
          type: "text",
          text: e
        });
      });
    },
    onDelect: function onDelect(val, i) {
      console.log("%c⧭", "color: #cc0088", val, i);
      if (this.editState) {

        this.editState = false;
      } else {

        this.$emit("onDelectVal", val, i);
      }
    },
    addInput: function addInput(item) {
      this.inputList.push("");
    },
    cancelUpload: function cancelUpload() {
      console.log("cancel upload");
      this.uploadingHandler && this.uploadingHandler.unsubscribe();
      this.uploadProgress = 0;
    },
    onLookVideo: function onLookVideo() {
      console.log('look video');
      if (this.showVideo) {
        this.showVideo = false;
      }
      this.showVideo = true;
    },
    onHideMyVideo: function onHideMyVideo() {
      console.log('video 隐藏');
      this.showVideo = false;
    }
  },
  watch: {
    items: function items(value) {
      console.log("%c⧭", "color: #bfffc8", value);
      this.item = value;
    },
    issueValue: function issueValue(value) {
      this.issueValue = value;
    },
    actionList: function actionList(value) {
      this.actionList = value;
      this.getMovement();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1b2a9f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/edit/edit.vue
var edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{}),_vm._v(" "),(_vm.showVideo)?_c('my-video',{attrs:{"videoUrl":_vm.videoUrl},on:{"onHideMyVideo":_vm.onHideMyVideo}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"edit-icon-delect",style:(_vm.editState ? 'border-bottom: 1px solid rgba(0, 237, 180, 1)' : 'border-bottom: 1px solid #121325;')},[_c('div',{staticClass:"edit-icon-delect-zgq-issue-text"},[_c('span',{style:(_vm.editState ? 'color:rgba(0, 237, 180, 1)' : '')},[_vm._v("问题：")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.editState == false),expression:"editState == false"}],staticClass:"nnowrap"},[_vm._v(_vm._s(_vm.item.question))]),_vm._v(" "),_c('div',{staticClass:"movement-input-zgq",on:{"click":function($event){return _vm.$refs.issueInput.focus()}}},[_c('x-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.editState),expression:"editState"}],ref:"issueInput",attrs:{"placeholder":"请输入问题","value":_vm.issueValue,"show-clear":false,"max":50},on:{"on-blur":_vm.autoSave},model:{value:(_vm.issueValue),callback:function ($$v) {_vm.issueValue=$$v},expression:"issueValue"}})],1)]),_vm._v(" "),_c('div',{staticClass:"edit-save-del-button"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.editState == false),expression:"editState == false"}],staticClass:"edit-icon",on:{"click":function($event){return _vm.onEdit(_vm.item.id)}}},[_c('img',{staticStyle:{"width":"15px","height":"15px"},attrs:{"src":"/static/img/edit_icon.png","alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.editState),expression:"editState"}],staticClass:"edit-icon",on:{"click":function($event){return _vm.onSave(_vm.item.id)}}},[_c('img',{staticStyle:{"width":"15px","height":"15px"},attrs:{"src":"/static/img/save_icon.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"delect-icon",on:{"click":function($event){return _vm.onDelect(_vm.item.id, _vm.index)}}},[_c('img',{staticStyle:{"width":"15px","height":"15px"},attrs:{"src":"/static/img/audioDelete.png","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"movement-issue-reply-button-image"},[_c('div',{staticClass:"movement-text-input",style:(_vm.editState ? 'border-bottom: 1px solid rgba(0, 237, 180, 1)' : 'border-bottom: 1px solid #121325;')},[_c('div',{staticClass:"movement-text",style:(_vm.editState ? 'color:rgba(0, 237, 180, 1)' : '')},[_vm._v("身体动作：")]),_vm._v(" "),_c('div',{staticClass:"movement-input"},[(_vm.editState)?_c('selector',{attrs:{"placeholder":"请选择动作","options":_vm.list},on:{"on-change":_vm.autoSave},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}}):_vm._e(),_vm._v(" "),(_vm.editState == false)?_c('span',{staticStyle:{"font-size":"12px","font-weight":"bold","color":"#ffffff"}},[_vm._v(_vm._s(_vm.actionIdName))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"zgq-issue-content"},[_c('div',{staticClass:"zgq-issue-text",style:(_vm.editState ? '' : 'border-bottom: 1px solid #121325;padding-bottom:10px')},[_c('span',{style:(_vm.editState ? 'font-size: 14px;font-weight: bold;color:rgba(0, 237, 180, 1)' : 'font-size: 14px;font-weight: bold; color: rgba(255, 255, 255, 0.96);')},[_vm._v("回复：")]),_vm._v(" "),_c('div',{staticClass:"zgq-reply-text-content"},[_vm._l((_vm.inputList),function(val,index){return _c('div',{key:index},[(_vm.editState == false)?_c('span',[_vm._v(_vm._s(index + 1)+".")]):_vm._e(),_vm._v(" "),(_vm.editState == false)?_c('span',[_vm._v(_vm._s(val))]):_vm._e(),_vm._v(" "),(index == 0 && _vm.editState)?_c('OnInput',{style:(_vm.editState ? 'border-bottom: 1px solid rgba(0, 237, 180, 1)' : 'border-bottom: 1px solid #121325;'),attrs:{"itemValue":_vm.oneValue,"values":val},on:{"onInput":_vm.onInput,"onDelOneInput":_vm.onDelOneInput,"onBlur":_vm.autoSave}}):_vm._e(),_vm._v(" "),(index == 1 && _vm.editState)?_c('TwoInput',{style:(_vm.editState ? 'border-bottom: 1px solid rgba(0, 237, 180, 1)' : 'border-bottom: 1px solid #121325;'),attrs:{"itemValue":_vm.twoValue,"values":val},on:{"onTwoInput":_vm.onTwoInput,"onDelTwoInput":_vm.onDelTwoInput,"onBlur":_vm.autoSave}}):_vm._e(),_vm._v(" "),(index == 2 && _vm.editState)?_c('TheryInput',{style:(_vm.editState ? 'border-bottom: 1px solid rgba(0, 237, 180, 1)' : 'border-bottom: 1px solid #121325;'),attrs:{"itemValue":_vm.theryValue,"values":val},on:{"onDelThrryInput":_vm.onDelThrryInput,"onTheryInput":_vm.onTheryInput,"onBlur":_vm.autoSave}}):_vm._e()],1)}),_vm._v(" "),(_vm.editState && _vm.inputList.length < 3)?_c('div',{staticClass:"movement-button",on:{"click":function($event){return _vm.addInput(_vm.item)}}},[_vm._v("\n          更多回复\n        ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"file-image-delect-icon"},[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"movement-text"},[_vm._v("文件：")]),_vm._v(" "),_c('div',{staticClass:"image-url-text"},[(_vm.imageUrl != '' || _vm.pdfNmae != '' || _vm.videoUrl != '')?_c('div',{staticClass:"img"},[(_vm.imageUrl != '')?_c('img',{staticClass:"image-url",attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.pdfNmae != '')?_c('span',{staticClass:"pdf-text"},[_vm._v(_vm._s(_vm.pdfNmae))]):_vm._e(),_vm._v(" "),(_vm.videoUrl != '')?_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showVideo),expression:"!showVideo"}],staticStyle:{"object-fit":"cover","width":"100px","height":"45px"},attrs:{"src":_vm.videoCover},on:{"click":_vm.onLookVideo}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"del-cion"},[(_vm.editState)?_c('img',{attrs:{"src":"/static/img/audioDelete.png","alt":""},on:{"click":_vm.onDelImageUrlKey}}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
          _vm.uploadProgress == 0 &&
          _vm.editState &&
          _vm.imageUrl == '' &&
          _vm.pdfNmae == '' &&
          _vm.videoUrl == ''
        ),expression:"\n          uploadProgress == 0 &&\n          editState &&\n          imageUrl == '' &&\n          pdfNmae == '' &&\n          videoUrl == ''\n        "}],staticClass:"button-uploading"},[_vm._v("\n        +点击上传文件\n        "),_c('div',{staticClass:"box_img_bottom"},[_c('form',{attrs:{"id":"form1","target":"frame1","method":"post","enctype":"multipart/form-data"}},[_c('input',{staticClass:"notFormFile",attrs:{"type":"file","name":"file","id":"file1","accept":"image/jpeg,image/jpg,image/png,.pdf,video/mp4"},on:{"change":function($event){return _vm.getFile($event)}}})])])])])]),_vm._v(" "),(_vm.editState)?_c('div',{staticClass:"preinstall-issue-box"},[_c('span',{class:_vm.setPreinstallState ? 'outer-circle-active' : 'outer-circle',on:{"click":_vm.onSetPreinstall}},[_c('span',{staticClass:"inner-circle"})]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("预设为快捷问题")])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadProgress > 0),expression:"uploadProgress > 0"}],staticClass:"upload-progress"},[_c('x-progress',{attrs:{"show-cancel":_vm.uploadProgress < 100,"percent":_vm.uploadProgress},on:{"on-cancel":_vm.cancelUpload}})],1),_vm._v(" "),(_vm.imageUrl == '' && _vm.pdfNmae == '' && _vm.videoUrl == '')?_c('div',{staticClass:"file-hint-text"},[_vm._v("\n    (请上传PDF、JPG、PNG格式图片及MP4格式视频)\n  ")]):_vm._e(),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":"不可全部删除","position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}},[_vm._v("1111")])],1)}
var edit_staticRenderFns = []
var edit_esExports = { render: edit_render, staticRenderFns: edit_staticRenderFns }
/* harmony default export */ var myComponents_edit_edit = (edit_esExports);
// CONCATENATED MODULE: ./src/myComponents/edit/edit.vue
function edit_injectStyle (ssrContext) {
  __webpack_require__("5Tl+")
}
var edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var edit___vue_template_functional__ = false
/* styles */
var edit___vue_styles__ = edit_injectStyle
/* scopeId */
var edit___vue_scopeId__ = "data-v-2b1b2a9f"
/* moduleIdentifier (server only) */
var edit___vue_module_identifier__ = null
var edit_Component = edit_normalizeComponent(
  edit_edit,
  myComponents_edit_edit,
  edit___vue_template_functional__,
  edit___vue_styles__,
  edit___vue_scopeId__,
  edit___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_edit_edit = (edit_Component.exports);

// CONCATENATED MODULE: ./src/myComponents/myVideo/myVideo.js


/* harmony default export */ var myVideo_myVideo = (myVideo_myVideo);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/QAComponent/QAComponent.vue


var QAComponent_param = Object(utils["c" /* getUrlParams */])(window.location.href);








/* harmony default export */ var QAComponent = ({
  name: "QAComponent",
  components: {
    XButton: x_button["a" /* default */],
    Edit: src_myComponents_edit_edit,
    HumanList: src_myComponents_HumanList_HumanList,
    MyVideo: myVideo_myVideo
  },
  props: {
    addSaveRouterIs: Number,
    modelID: Number,
    cardTypeIs: String

  },
  data: function data() {
    return {
      data: [],
      spareList: [],
      total: 0,
      spareTotal: 0,
      modelViewId: 0,
      actionList: [],
      currentVideoUrl: '',
      showVideo: false,
      tabList: [{
        id: 1,
        name: '数字人形象',
        is_show: 1
      }, {
        id: 2,
        name: '互动设置',
        is_show: 2
      }, {
        id: 3,
        name: '互动问题',
        is_show: 0
      }]
    };
  },
  created: function created() {

    console.log('%c⧭', 'color: #8c0038;font-size:100px', this.cardTypeIs, "qa");
    this.modelViewId = this.modelID || localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
    this.getQAlist();
    this.getFigureList();
  },
  mounted: function mounted() {
    console.log('get qa list----------', this.cardTypeIs);
    document.title = '互动问题';
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onSaveGetList: function onSaveGetList() {
      this.getQAlist();
    },
    getQAlist: function getQAlist() {
      var _this = this;

      if (this.cardTypeIs == '3d') {

        Object(api["t" /* modelView */])(this.modelViewId).then(function (res) {
          console.log('model View', res);
          var gender = res.data.image.gender;
          _this.$emit('onSpareInfoChange', res.data);
          Object(api["j" /* config */])(res.data.image.version).then(function (res) {
            _this.actionList = res.data.action_map[String(gender)];
          });
          Object(api["u" /* qaList */])(_this.modelViewId, _this.cardTypeIs).then(function (res) {
            _this.data = res.data.data;
            _this.total = res.data.total;
          });
        });
      } else if (this.cardTypeIs == '2d') {
        Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
          console.log('model--- View', res);
          var gender = res.data.card.gender;
          _this.$emit('onSpareInfoChange', res.data);
          Object(api["j" /* config */])(res.data.card.version).then(function (res) {
            _this.actionList = res.data.action_map[String(gender)];
          });
          Object(api["u" /* qaList */])(_this.modelViewId, _this.cardTypeIs).then(function (res) {
            _this.data = res.data.data;
            _this.total = res.data.total;
          });
        });
      }
    },
    getFigureList: function getFigureList() {
      var _this2 = this;

      console.log('--------------------------set QA getFigureList');
      Object(utils["a" /* createRequest */])("get", "applet/user/image/list", { page: 1, num: 20, status: 3 }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.spareList = res.data.data;
          _this2.spareTotal = res.data.total;
        } else {
          console.error(res.msg);
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onDelectVal: function onDelectVal(e, i) {
      var _this3 = this;

      console.log("%c⧭", "color: #006dcc", e, i);
      this.data.splice(i, 1);
      console.log("%c⧭", "color: #1d3f73", this.data);
      Object(utils["a" /* createRequest */])("post", "applet/webview/qa/del", { id: e }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this3.$vux.toast.show({
            type: "text",
            text: "删除成功"
          });
          _this3.getQAlist();
        } else {
          console.error(res.msg);
          _this3.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onBack: function onBack() {
      console.log('----QA back');
      this.$emit("onBack", "preview");
    },
    selectSpare: function selectSpare(data) {
      console.log('user select spare', data);
      this.modelViewId = data.id;
      this.getQAlist();
    }
  },
  watch: {
    addSaveRouterIs: function addSaveRouterIs(value) {
      this.getQAlist();
    },
    modelID: function modelID(value) {
      if (this.modelViewId != value) {
        this.modelViewId = value;
        console.log('%c⧭', 'color: #7f2200', value);
        this.getQAlist();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/QAComponent/QAComponent.vue


var QAComponent_QAComponent_param = Object(utils["c" /* getUrlParams */])(window.location.href);








/* harmony default export */ var QAComponent_QAComponent = ({
  name: "QAComponent",
  components: {
    XButton: x_button["a" /* default */],
    Edit: src_myComponents_edit_edit,
    HumanList: src_myComponents_HumanList_HumanList,
    MyVideo: myVideo_myVideo
  },
  props: {
    addSaveRouterIs: Number,
    modelID: Number,
    cardTypeIs: String

  },
  data: function data() {
    return {
      data: [],
      spareList: [],
      total: 0,
      spareTotal: 0,
      modelViewId: 0,
      actionList: [],
      currentVideoUrl: '',
      showVideo: false,
      tabList: [{
        id: 1,
        name: '数字人形象',
        is_show: 1
      }, {
        id: 2,
        name: '互动设置',
        is_show: 2
      }, {
        id: 3,
        name: '互动问题',
        is_show: 0
      }]
    };
  },
  created: function created() {

    console.log('%c⧭', 'color: #8c0038;font-size:100px', this.cardTypeIs, "qa");
    this.modelViewId = this.modelID || localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
    this.getQAlist();
    this.getFigureList();
  },
  mounted: function mounted() {
    console.log('get qa list----------', this.cardTypeIs);
    document.title = '互动问题';
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onSaveGetList: function onSaveGetList() {
      this.getQAlist();
    },
    getQAlist: function getQAlist() {
      var _this = this;

      if (this.cardTypeIs == '3d') {

        Object(api["t" /* modelView */])(this.modelViewId).then(function (res) {
          console.log('model View', res);
          var gender = res.data.image.gender;
          _this.$emit('onSpareInfoChange', res.data);
          Object(api["j" /* config */])(res.data.image.version).then(function (res) {
            _this.actionList = res.data.action_map[String(gender)];
          });
          Object(api["u" /* qaList */])(_this.modelViewId, _this.cardTypeIs).then(function (res) {
            _this.data = res.data.data;
            _this.total = res.data.total;
          });
        });
      } else if (this.cardTypeIs == '2d') {
        Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
          console.log('model--- View', res);
          var gender = res.data.card.gender;
          _this.$emit('onSpareInfoChange', res.data);
          Object(api["j" /* config */])(res.data.card.version).then(function (res) {
            _this.actionList = res.data.action_map[String(gender)];
          });
          Object(api["u" /* qaList */])(_this.modelViewId, _this.cardTypeIs).then(function (res) {
            _this.data = res.data.data;
            _this.total = res.data.total;
          });
        });
      }
    },
    getFigureList: function getFigureList() {
      var _this2 = this;

      console.log('--------------------------set QA getFigureList');
      Object(utils["a" /* createRequest */])("get", "applet/user/image/list", { page: 1, num: 20, status: 3 }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.spareList = res.data.data;
          _this2.spareTotal = res.data.total;
        } else {
          console.error(res.msg);
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onDelectVal: function onDelectVal(e, i) {
      var _this3 = this;

      console.log("%c⧭", "color: #006dcc", e, i);
      this.data.splice(i, 1);
      console.log("%c⧭", "color: #1d3f73", this.data);
      Object(utils["a" /* createRequest */])("post", "applet/webview/qa/del", { id: e }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this3.$vux.toast.show({
            type: "text",
            text: "删除成功"
          });
          _this3.getQAlist();
        } else {
          console.error(res.msg);
          _this3.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onBack: function onBack() {
      console.log('----QA back');
      this.$emit("onBack", "preview");
    },
    selectSpare: function selectSpare(data) {
      console.log('user select spare', data);
      this.modelViewId = data.id;
      this.getQAlist();
    }
  },
  watch: {
    addSaveRouterIs: function addSaveRouterIs(value) {
      this.getQAlist();
    },
    modelID: function modelID(value) {
      if (this.modelViewId != value) {
        this.modelViewId = value;
        console.log('%c⧭', 'color: #7f2200', value);
        this.getQAlist();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6670a55a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/QAComponent/QAComponent.vue
var QAComponent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QAComponent"},[_c('div',{staticClass:"zgq-top-administration-spare-qa"}),_vm._v(" "),(_vm.data.length <= 0)?_c('div',{staticClass:"no-list"},[_vm._v("\n      请新建问答\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"zgq-bottom-add-list",style:({height:_vm.data.length>0?'90%':'70%'})},_vm._l((_vm.data),function(item,index){return _c('div',{key:item.id,staticClass:"zgq-add-list-edit"},[_c('Edit',{attrs:{"actionList":_vm.actionList,"items":item,"indexIs":index,"cardTypeIs":_vm.cardTypeIs},on:{"onSaveGetList":_vm.onSaveGetList,"onDelectVal":_vm.onDelectVal}})],1)}),0),_vm._v(" "),(_vm.data.length > 0)?_c('div',{staticClass:"back-button-box",on:{"click":_vm.onBack}},[_c('div',{staticClass:"back-button"},[_vm._v("预览")])]):_vm._e()])}
var QAComponent_staticRenderFns = []
var QAComponent_esExports = { render: QAComponent_render, staticRenderFns: QAComponent_staticRenderFns }
/* harmony default export */ var myComponents_QAComponent_QAComponent = (QAComponent_esExports);
// CONCATENATED MODULE: ./src/myComponents/QAComponent/QAComponent.vue
function QAComponent_injectStyle (ssrContext) {
  __webpack_require__("hZpC")
}
var QAComponent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var QAComponent___vue_template_functional__ = false
/* styles */
var QAComponent___vue_styles__ = QAComponent_injectStyle
/* scopeId */
var QAComponent___vue_scopeId__ = "data-v-6670a55a"
/* moduleIdentifier (server only) */
var QAComponent___vue_module_identifier__ = null
var QAComponent_Component = QAComponent_normalizeComponent(
  QAComponent_QAComponent,
  myComponents_QAComponent_QAComponent,
  QAComponent___vue_template_functional__,
  QAComponent___vue_styles__,
  QAComponent___vue_scopeId__,
  QAComponent___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_QAComponent_QAComponent = (QAComponent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/setThreeCom/setThreeCom.vue






var player = new Audio();
















/* harmony default export */ var setThreeCom = ({
  name: "chatframe",
  components: {
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Divider: vux_src_components_divider,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    XTextarea: x_textarea["a" /* default */],
    Group: group["a" /* default */],
    XInput: x_input["a" /* default */],
    HumanList: src_myComponents_HumanList_HumanList,
    QAComponent: src_myComponents_QAComponent_QAComponent,
    AddQa: src_myComponents_AddQa_AddQa,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel
  },
  props: {
    modelID: Number | String,
    cardTypeIs: String,
    firmIdBol: String | Number

  },
  data: function data() {
    return {
      spareList: [],
      spareTotal: 0,
      administrationSpareType: 0,
      preComponentsState: "",
      componentsState: "",
      textareaValueLength: 0,
      textareaValue: "",
      tagList: [],
      toneList: [],
      toneId: 0,
      toneState: 1,
      tagValue: "",
      addTagModelIsOpen: false,
      tagHeight: 0,
      modelViewId: 0,
      addSaveRouter: 1,
      movementList: [], //动作
      tabList: [{
        id: 1,
        name: "数字人形象",
        is_show: 1
      }, {
        id: 2,
        name: "互动设置",
        is_show: 2
      }, {
        id: 3,
        name: "互动问题",
        is_show: 0
      }],
      qaPageShow: 1,
      setCostType: 0,
      purchaseModelIsopen: false,
      purchaseList: [],
      hintIsopneModel: false,
      notYetSetQaState: false, // 尚未设置qa
      careObj: null,
      gender: 0,
      isHasConsume: false,
      firmIdBolActive: this.firmIdBol
    };
  },
  mounted: function mounted() {},
  created: function created() {
    var _this2 = this;

    this.modelViewId = this.modelID || localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
    this.initSpareInfo().then(function (data) {
      _this2.getMovementTone(data.version);
    });

    this.getPurchaseConfing();
    Object(api["l" /* getChatStat */])().then(function (res) {
      if (res.data.char_num_use > 0) _this2.isHasConsume = true;else _this2.isHasConsume = false;
    });
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onAuditionUrl: function onAuditionUrl() {
      var _this3 = this;

      player.pause();
      this.$vux.loading.show({
        text: "请等待"
      });
      Object(api["o" /* getPublicsAudio */])(this.textareaValue, this.toneId).then(function (res) {
        console.log('%c⧭', 'color: #f200e2');
        player.src = res.data.audio_url;
        _this3.$vux.loading.hide();
        player.play();
      });
    },
    inputClick: function inputClick() {
      console.log("input focus");
      this.$refs.messageInput.focus();
    },
    informCancelPurchase: function informCancelPurchase(e) {
      this.purchaseModelIsopen = e;
      this.setCostType = 1;
    },
    informImmediatelyPurchase: function informImmediatelyPurchase(e) {
      if (e) {

        this.purchaseModelIsopen = false;
        this.$vux.toast.show({
          type: "text",
          text: "充值成功"
        });
      }
    },
    onCloseHintModel: function onCloseHintModel() {
      this.hintIsopneModel = false;
    },
    onOpenHintModel: function onOpenHintModel() {
      this.hintIsopneModel = true;
    },
    getPurchaseConfing: function getPurchaseConfing() {
      var _this4 = this;

      Object(api["d" /* chatRechargeConfig */])().then(function (res) {
        _this4.purchaseList = res.data.recharge_config[0];

        console.log("%c⧭", "color: #33cc99;font-size:99px", _this4.purchaseList);
      });
    },
    onCostSelect: function onCostSelect(e) {
      var _this5 = this;

      this.setCostType = e;
      if (e == 2) {

        Object(api["l" /* getChatStat */])().then(function (res) {
          if (res.data.char_num < 10) {
            _this5.purchaseModelIsopen = true;
          }
        });
      }
    },
    onAQListChange: function onAQListChange(event) {
      if (event.modelViewId == this.modelViewId) {
        this.hasQAList == event.total > 0;
      }
    },
    getMovementTone: function getMovementTone(version) {
      var _this6 = this;

      Object(api["j" /* config */])(version).then(function (res) {
        _this6.toneList = res.data.audio_timbre_map[String(_this6.gender)];
      });
    },
    initSpareInfo: function initSpareInfo() {
      var _this7 = this;

      return new promise_default.a(function (resolve, reject) {
        console.log("initSpareInfo", _this7.modelViewId, _this7.cardTypeIs);
        if (_this7.cardTypeIs == "3d") {
          Object(api["t" /* modelView */])(_this7.modelViewId).then(function (res) {
            _this7.textareaValue = res.data.image.greet;

            _this7.toneId = res.data.image.audio_timbre;
            _this7.setCostType = res.data.image.chat_type || 1;
            _this7.gender = res.data.image.gender;
            _this7.$emit("onSpareInfoChange", res.data);
            localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.image.name);
            resolve(res.data.image);
          });
        } else if (_this7.cardTypeIs == "2d") {
          Object(api["b" /* cardView */])(_this7.modelViewId).then(function (res) {
            console.log("%c⧭", "color: #99614d;font-size:200px", res.data);
            _this7.textareaValue = res.data.card.greet;
            _this7.careObj = res.data;

            _this7.toneId = res.data.card.chat_audio_timbre ? res.data.card.chat_audio_timbre : res.data.card.audio_timbre;
            _this7.setCostType = res.data.card.chat_type || 1;
            _this7.gender = res.data.card.gender;
            localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.card.name);
            _this7.$emit("onSpareInfoChange", res.data);
            resolve(res.data.card);
          });
        }
      });
    },
    getFigureList: function getFigureList() {
      var _this8 = this;

      console.log("--------------------------set com getFigureList");
      Object(utils["a" /* createRequest */])("get", "applet/user/image/list", { page: 1, num: 100, status: 3 }, function (res) {
        console.log("%c⧭", "color: #d90000;font-size:300px", res.data.data);
        if (res.code == 200) {
          _this8.spareList = res.data.data;
          _this8.spareTotal = res.data.total;
        } else {
          console.error(res.msg);
          _this8.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onAdministrationSpare: function onAdministrationSpare(e) {
      this.administrationSpareType = e;

      console.log("%c⧭", "color: #ffa280", this.administrationSpareType);
    },
    onSetPerson: function onSetPerson(val) {
      this.tagList.forEach(function (item) {
        if (item.id == val.id) {
          item.dis = !item.dis;
        }
      });
    },
    onEvent: function onEvent(event) {
      console.log("on", event);
    },
    onToneActive: function onToneActive(item) {
      console.log('-----', this.toneId, this.toneState);
      var id = item.id;
      var _this = this;
      if (id != this.toneId) {
        this.toneId = id;
        this.toneState = 1;
        player.pause();
      } else if (this.toneId == id && this.toneState == 1) {
        this.toneState = 2;
        player.src = item.audio_url;
        player.play();
        player.addEventListener("ended", function () {
          console.log("播放结束");
          _this.toneState = 3;
          if (_this.toneState == 3) {
            _this.toneState = 1;
          }
        }, false);
      } else if (this.toneId == id && this.toneState == 2) {
        this.toneState = 3;
        player.pause();
        if (this.toneState == 3) {
          this.toneState = 1;
        }
      }
    },
    onSaveSet: function onSaveSet() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new promise_default.a(function (resolve, reject) {
                  if (_this9.textareaValueLength < 10) {
                    _this9.$vux.toast.show({
                      type: "text",
                      text: "请按要求设置打招呼内容,最少设置10个字符"
                    });
                    return reject();
                  }
                  if (_this9.toneId == 0) {
                    _this9.$vux.toast.show({
                      type: "text",
                      text: "请选择音色"
                    });
                    return reject();
                  }
                  if (_this9.setCostType == 0) {
                    _this9.$vux.toast.show({
                      type: "text",
                      text: "请选择对话机器人"
                    });
                    return reject();
                  }
                  _this9.$vux.loading.show({
                    text: "正在设置"
                  });
                  if (_this9.cardTypeIs == "3d") {
                    console.log(_this9.firmIdBolActive, 'this.firmIdBolActive');

                    Object(api["w" /* setImage */])({
                      image_id: _this9.modelViewId,
                      greet: _this9.textareaValue,
                      audio_timbre: _this9.toneId,
                      chat_type: _this9.firmIdBol <= 0 ? _this9.setCostType : undefined
                    }).then(function (d) {
                      _this9.$emit("onSpareInfoChange", {
                        clearSetting: true
                      });
                      _this9.$emit("onSaveSetRouter", {
                        modelViewId: _this9.modelViewId,
                        greet: _this9.textareaValue
                      });
                      _this9.$vux.loading.hide();
                      resolve();
                    }, function (e) {
                      console.error(e);
                      _this9.$vux.toast.show({
                        type: "text",
                        text: e
                      });
                      _this9.$vux.loading.hide();
                      reject();
                    });
                  } else if (_this9.cardTypeIs == "2d") {
                    var obj = {
                      card_id: _this9.modelViewId,
                      greet: _this9.textareaValue,
                      chat_audio_timbre: _this9.toneId,
                      chat_type: _this9.setCostType
                    };

                    Object(api["v" /* setCard */])(obj).then(function (res) {
                      if (res.code == 200) {
                        _this9.$emit("onSpareInfoChange", {
                          clearSetting: true
                        });
                        _this9.$emit("onSaveSetRouter", {
                          modelViewId: _this9.modelViewId,
                          greet: _this9.textareaValue
                        });
                        resolve();
                      } else {
                        console.error(res.msg);
                        _this9.$vux.toast.show({
                          type: "text",
                          text: res.msg
                        });
                        reject();
                      }
                      _this9.$vux.loading.hide();
                      console.log("%c⧭", "color: #40fff2", res);
                    });
                  }
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9);
      }))();
    },
    onGetFocus: function onGetFocus() {},
    onCloseModelIsOpen: function onCloseModelIsOpen() {
      this.addTagModelIsOpen = false;
      this.tagValue = "";
    },
    onAddTagModelIsOpen: function onAddTagModelIsOpen() {
      var _this10 = this;

      this.addTagModelIsOpen = true;
      setTimeout(function () {
        _this10.$refs.input.focus();
      }, 100);
      this.tagValue = "";
    },
    onBack: function onBack() {
      var _this11 = this;

      console.log("----QA back");
      this.onSaveSet().then(function () {
        _this11.$emit("onBack", "preview");
      }, function () {});
    },
    onGotoConsumeRecord: function onGotoConsumeRecord() {
      console.log("跳转消耗明细");
      this.$wechat.miniProgram.navigateTo({
        url: "/walletPage/pages/chatConsumeRecord/chatConsumeRecord",
        success: function success() {
          console.log("跳转成功");
        }
      });
    }
  },
  watch: {
    textareaValue: function textareaValue(value) {
      this.textareaValueLength = value.length;
      console.log("%c⧭", "color: #73998c", value);
      this.textareaValue = value;
    },
    modelID: function modelID(value) {
      var _this12 = this;

      console.log("%c⧭", "color: #7f2200", value);
      if (this.modelViewId != value) {
        this.modelViewId = value;
        this.toneState = 1;
        player.pause();
        this.initSpareInfo().then(function (data) {
          _this12.getMovementTone(data.version);
        });
      }
    },
    firmIdBol: function firmIdBol(v) {
      this.firmIdBolActive = v;
      console.log('%c⧭', 'color: #006dcc', v);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/setThreeCom/setThreeCom.vue






var setThreeCom_player = new Audio();
















/* harmony default export */ var setThreeCom_setThreeCom = ({
  name: "chatframe",
  components: {
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    Divider: vux_src_components_divider,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    XTextarea: x_textarea["a" /* default */],
    Group: group["a" /* default */],
    XInput: x_input["a" /* default */],
    HumanList: src_myComponents_HumanList_HumanList,
    QAComponent: src_myComponents_QAComponent_QAComponent,
    AddQa: src_myComponents_AddQa_AddQa,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel
  },
  props: {
    modelID: Number | String,
    cardTypeIs: String,
    firmIdBol: String | Number

  },
  data: function data() {
    return {
      spareList: [],
      spareTotal: 0,
      administrationSpareType: 0,
      preComponentsState: "",
      componentsState: "",
      textareaValueLength: 0,
      textareaValue: "",
      tagList: [],
      toneList: [],
      toneId: 0,
      toneState: 1,
      tagValue: "",
      addTagModelIsOpen: false,
      tagHeight: 0,
      modelViewId: 0,
      addSaveRouter: 1,
      movementList: [], //动作
      tabList: [{
        id: 1,
        name: "数字人形象",
        is_show: 1
      }, {
        id: 2,
        name: "互动设置",
        is_show: 2
      }, {
        id: 3,
        name: "互动问题",
        is_show: 0
      }],
      qaPageShow: 1,
      setCostType: 0,
      purchaseModelIsopen: false,
      purchaseList: [],
      hintIsopneModel: false,
      notYetSetQaState: false, // 尚未设置qa
      careObj: null,
      gender: 0,
      isHasConsume: false,
      firmIdBolActive: this.firmIdBol
    };
  },
  mounted: function mounted() {},
  created: function created() {
    var _this2 = this;

    this.modelViewId = this.modelID || localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID);
    this.initSpareInfo().then(function (data) {
      _this2.getMovementTone(data.version);
    });

    this.getPurchaseConfing();
    Object(api["l" /* getChatStat */])().then(function (res) {
      if (res.data.char_num_use > 0) _this2.isHasConsume = true;else _this2.isHasConsume = false;
    });
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onAuditionUrl: function onAuditionUrl() {
      var _this3 = this;

      setThreeCom_player.pause();
      this.$vux.loading.show({
        text: "请等待"
      });
      Object(api["o" /* getPublicsAudio */])(this.textareaValue, this.toneId).then(function (res) {
        console.log('%c⧭', 'color: #f200e2');
        setThreeCom_player.src = res.data.audio_url;
        _this3.$vux.loading.hide();
        setThreeCom_player.play();
      });
    },
    inputClick: function inputClick() {
      console.log("input focus");
      this.$refs.messageInput.focus();
    },
    informCancelPurchase: function informCancelPurchase(e) {
      this.purchaseModelIsopen = e;
      this.setCostType = 1;
    },
    informImmediatelyPurchase: function informImmediatelyPurchase(e) {
      if (e) {

        this.purchaseModelIsopen = false;
        this.$vux.toast.show({
          type: "text",
          text: "充值成功"
        });
      }
    },
    onCloseHintModel: function onCloseHintModel() {
      this.hintIsopneModel = false;
    },
    onOpenHintModel: function onOpenHintModel() {
      this.hintIsopneModel = true;
    },
    getPurchaseConfing: function getPurchaseConfing() {
      var _this4 = this;

      Object(api["d" /* chatRechargeConfig */])().then(function (res) {
        _this4.purchaseList = res.data.recharge_config[0];

        console.log("%c⧭", "color: #33cc99;font-size:99px", _this4.purchaseList);
      });
    },
    onCostSelect: function onCostSelect(e) {
      var _this5 = this;

      this.setCostType = e;
      if (e == 2) {

        Object(api["l" /* getChatStat */])().then(function (res) {
          if (res.data.char_num < 10) {
            _this5.purchaseModelIsopen = true;
          }
        });
      }
    },
    onAQListChange: function onAQListChange(event) {
      if (event.modelViewId == this.modelViewId) {
        this.hasQAList == event.total > 0;
      }
    },
    getMovementTone: function getMovementTone(version) {
      var _this6 = this;

      Object(api["j" /* config */])(version).then(function (res) {
        _this6.toneList = res.data.audio_timbre_map[String(_this6.gender)];
      });
    },
    initSpareInfo: function initSpareInfo() {
      var _this7 = this;

      return new promise_default.a(function (resolve, reject) {
        console.log("initSpareInfo", _this7.modelViewId, _this7.cardTypeIs);
        if (_this7.cardTypeIs == "3d") {
          Object(api["t" /* modelView */])(_this7.modelViewId).then(function (res) {
            _this7.textareaValue = res.data.image.greet;

            _this7.toneId = res.data.image.audio_timbre;
            _this7.setCostType = res.data.image.chat_type || 1;
            _this7.gender = res.data.image.gender;
            _this7.$emit("onSpareInfoChange", res.data);
            localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.image.name);
            resolve(res.data.image);
          });
        } else if (_this7.cardTypeIs == "2d") {
          Object(api["b" /* cardView */])(_this7.modelViewId).then(function (res) {
            console.log("%c⧭", "color: #99614d;font-size:200px", res.data);
            _this7.textareaValue = res.data.card.greet;
            _this7.careObj = res.data;

            _this7.toneId = res.data.card.chat_audio_timbre ? res.data.card.chat_audio_timbre : res.data.card.audio_timbre;
            _this7.setCostType = res.data.card.chat_type || 1;
            _this7.gender = res.data.card.gender;
            localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.card.name);
            _this7.$emit("onSpareInfoChange", res.data);
            resolve(res.data.card);
          });
        }
      });
    },
    getFigureList: function getFigureList() {
      var _this8 = this;

      console.log("--------------------------set com getFigureList");
      Object(utils["a" /* createRequest */])("get", "applet/user/image/list", { page: 1, num: 100, status: 3 }, function (res) {
        console.log("%c⧭", "color: #d90000;font-size:300px", res.data.data);
        if (res.code == 200) {
          _this8.spareList = res.data.data;
          _this8.spareTotal = res.data.total;
        } else {
          console.error(res.msg);
          _this8.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onAdministrationSpare: function onAdministrationSpare(e) {
      this.administrationSpareType = e;

      console.log("%c⧭", "color: #ffa280", this.administrationSpareType);
    },
    onSetPerson: function onSetPerson(val) {
      this.tagList.forEach(function (item) {
        if (item.id == val.id) {
          item.dis = !item.dis;
        }
      });
    },
    onEvent: function onEvent(event) {
      console.log("on", event);
    },
    onToneActive: function onToneActive(item) {
      console.log('-----', this.toneId, this.toneState);
      var id = item.id;
      var _this = this;
      if (id != this.toneId) {
        this.toneId = id;
        this.toneState = 1;
        setThreeCom_player.pause();
      } else if (this.toneId == id && this.toneState == 1) {
        this.toneState = 2;
        setThreeCom_player.src = item.audio_url;
        setThreeCom_player.play();
        setThreeCom_player.addEventListener("ended", function () {
          console.log("播放结束");
          _this.toneState = 3;
          if (_this.toneState == 3) {
            _this.toneState = 1;
          }
        }, false);
      } else if (this.toneId == id && this.toneState == 2) {
        this.toneState = 3;
        setThreeCom_player.pause();
        if (this.toneState == 3) {
          this.toneState = 1;
        }
      }
    },
    onSaveSet: function onSaveSet() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new promise_default.a(function (resolve, reject) {
                  if (_this9.textareaValueLength < 10) {
                    _this9.$vux.toast.show({
                      type: "text",
                      text: "请按要求设置打招呼内容,最少设置10个字符"
                    });
                    return reject();
                  }
                  if (_this9.toneId == 0) {
                    _this9.$vux.toast.show({
                      type: "text",
                      text: "请选择音色"
                    });
                    return reject();
                  }
                  if (_this9.setCostType == 0) {
                    _this9.$vux.toast.show({
                      type: "text",
                      text: "请选择对话机器人"
                    });
                    return reject();
                  }
                  _this9.$vux.loading.show({
                    text: "正在设置"
                  });
                  if (_this9.cardTypeIs == "3d") {
                    console.log(_this9.firmIdBolActive, 'this.firmIdBolActive');

                    Object(api["w" /* setImage */])({
                      image_id: _this9.modelViewId,
                      greet: _this9.textareaValue,
                      audio_timbre: _this9.toneId,
                      chat_type: _this9.firmIdBol <= 0 ? _this9.setCostType : undefined
                    }).then(function (d) {
                      _this9.$emit("onSpareInfoChange", {
                        clearSetting: true
                      });
                      _this9.$emit("onSaveSetRouter", {
                        modelViewId: _this9.modelViewId,
                        greet: _this9.textareaValue
                      });
                      _this9.$vux.loading.hide();
                      resolve();
                    }, function (e) {
                      console.error(e);
                      _this9.$vux.toast.show({
                        type: "text",
                        text: e
                      });
                      _this9.$vux.loading.hide();
                      reject();
                    });
                  } else if (_this9.cardTypeIs == "2d") {
                    var obj = {
                      card_id: _this9.modelViewId,
                      greet: _this9.textareaValue,
                      chat_audio_timbre: _this9.toneId,
                      chat_type: _this9.setCostType
                    };

                    Object(api["v" /* setCard */])(obj).then(function (res) {
                      if (res.code == 200) {
                        _this9.$emit("onSpareInfoChange", {
                          clearSetting: true
                        });
                        _this9.$emit("onSaveSetRouter", {
                          modelViewId: _this9.modelViewId,
                          greet: _this9.textareaValue
                        });
                        resolve();
                      } else {
                        console.error(res.msg);
                        _this9.$vux.toast.show({
                          type: "text",
                          text: res.msg
                        });
                        reject();
                      }
                      _this9.$vux.loading.hide();
                      console.log("%c⧭", "color: #40fff2", res);
                    });
                  }
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9);
      }))();
    },
    onGetFocus: function onGetFocus() {},
    onCloseModelIsOpen: function onCloseModelIsOpen() {
      this.addTagModelIsOpen = false;
      this.tagValue = "";
    },
    onAddTagModelIsOpen: function onAddTagModelIsOpen() {
      var _this10 = this;

      this.addTagModelIsOpen = true;
      setTimeout(function () {
        _this10.$refs.input.focus();
      }, 100);
      this.tagValue = "";
    },
    onBack: function onBack() {
      var _this11 = this;

      console.log("----QA back");
      this.onSaveSet().then(function () {
        _this11.$emit("onBack", "preview");
      }, function () {});
    },
    onGotoConsumeRecord: function onGotoConsumeRecord() {
      console.log("跳转消耗明细");
      this.$wechat.miniProgram.navigateTo({
        url: "/walletPage/pages/chatConsumeRecord/chatConsumeRecord",
        success: function success() {
          console.log("跳转成功");
        }
      });
    }
  },
  watch: {
    textareaValue: function textareaValue(value) {
      this.textareaValueLength = value.length;
      console.log("%c⧭", "color: #73998c", value);
      this.textareaValue = value;
    },
    modelID: function modelID(value) {
      var _this12 = this;

      console.log("%c⧭", "color: #7f2200", value);
      if (this.modelViewId != value) {
        this.modelViewId = value;
        this.toneState = 1;
        setThreeCom_player.pause();
        this.initSpareInfo().then(function (data) {
          _this12.getMovementTone(data.version);
        });
      }
    },
    firmIdBol: function firmIdBol(v) {
      this.firmIdBolActive = v;
      console.log('%c⧭', 'color: #006dcc', v);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d3ad75a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/setThreeCom/setThreeCom.vue
var setThreeCom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"content"},_vm._l((_vm.toneList),function(item){return _c('div',{key:item.id,class:_vm.toneId == item.id ? 'item-active' : 'item',on:{"click":function($event){return _vm.onToneActive(item)}}},[_c('div',{class:_vm.toneId == item.id && _vm.toneState == 2
              ? 'suspend-icon-active'
              : 'suspend-icon'},[_c('img',{class:_vm.toneId == item.id && _vm.toneState == 2
                ? 'suspend-image-active'
                : 'suspend-image',attrs:{"src":_vm.toneId == item.id && _vm.toneState == 2
                ? '/static/img/play_icon_active.png'
                : '/static/img/play_icon.png',"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"suspend-name"},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"gender-suspend"},[_vm._v("\n          "+_vm._s(item.gender == 1 ? "男声" : "女声")+"\n        ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"set-spare-content-input"},[_c('div',{staticClass:"input-box"},[_c('div',{staticClass:"greet-sb-audition"},[_c('div',{staticClass:"greet-sb-text-box"},[_vm._v("默认打招呼")]),_vm._v(" "),_c('div',{staticClass:"audition-box",on:{"click":_vm.onAuditionUrl}},[_vm._v("试听")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px"},on:{"click":_vm.inputClick}},[_c('div',{staticClass:"input"},[_c('x-textarea',{ref:"messageInput",attrs:{"max":200,"show-counter":false,"height":100,"placeholder":"大家好，我是XX公司的数字分身。很高兴与你对话"},on:{"on-focus":function($event){return _vm.onEvent('focus')},"on-blur":function($event){return _vm.onEvent('blur')}},model:{value:(_vm.textareaValue),callback:function ($$v) {_vm.textareaValue=$$v},expression:"textareaValue"}})],1),_vm._v(" "),_c('div',{staticClass:"input-value-length"},[_c('span',{class:_vm.textareaValueLength < 10 && _vm.textareaValueLength != 0
                ? 'red-hint-normal-active'
                : 'red-hint-normal'},[_vm._v(_vm._s(_vm.textareaValueLength))]),_vm._v(" "),_c('span',{staticClass:"normal"},[_vm._v(" /200 ")])])])])]),_vm._v(" "),_c('div',{staticClass:"save-set-button-zgq-com"},[_c('div',{staticClass:"save-set-button",on:{"click":_vm.onBack}},[_vm._v("预览")]),_vm._v(" "),_c('div',{staticClass:"cancel-set-button",on:{"click":_vm.onSaveSet}},[_vm._v("保存")])]),_vm._v(" "),_c('PaymentModel',{attrs:{"stateIs":2,"purchaseModelOpen":_vm.purchaseModelIsopen},on:{"informCancelPurchase":_vm.informCancelPurchase,"informImmediatelyPurchase":_vm.informImmediatelyPurchase}}),_vm._v(" "),(_vm.hintIsopneModel)?_c('div',{staticClass:"hint-purchase-message-model",on:{"click":_vm.onCloseHintModel}},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.notYetSetQaState)?_c('div',{staticClass:"hint-purchase-message-model"},[_vm._m(2)]):_vm._e()],1)}
var setThreeCom_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set-person-tag-box",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"set-person-tag"},[_c('span',{staticClass:"tag-radius"}),_vm._v(" 对话音色\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint-purchase-message-box"},[_c('div',{staticClass:"robot-divide-content"},[_c('div',{staticClass:"left-right-robot-introduce"},[_c('div',{staticClass:"left-robot-introduce"},[_vm._v("常规聊天机器人")]),_vm._v(" "),_c('div',{staticClass:"right-robot-introduce"},[_c('span',{staticClass:"Chinese"},[_vm._v(" 智能AI聊天机器人 ")])])]),_vm._v(" "),_c('div',{staticClass:"left-right-robot-tag-message"},[_c('div',{staticClass:"left"},[_vm._v("·能准确、流畅、自然的进行聊天对话及问题回答")]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"color-hint-text"},[_vm._v("·真正像人类一样聊天交流")]),_vm._v(" "),_c('div',{staticClass:"color-hint-text"},[_vm._v("\n              ·上知天文下至地理，能根据聊天的上下文进行互动\n            ")]),_vm._v(" "),_c('div',{staticClass:"color-hint-text"},[_vm._v("\n              ·能完成撰写邮件、视频脚本 文案、翻译、代码，写论文等.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"long-text"},[_c('div',{staticClass:"hint-color"}),_vm._v(" "),_c('div',{staticStyle:{"width":"99%"}},[_vm._v("\n            与您的数字人进行互动对话时，超出设置的互动问题，将由您选择的对话机器人进行接替回答\n          ")])]),_vm._v(" "),_c('div',{staticClass:"long-text"},[_c('div',{staticClass:"hint-color"}),_vm._v(" "),_c('div',{staticStyle:{"width":"99%"}},[_vm._v("\n            购买“智能AI聊天机器人”的对话字符，可在“体验”等同消耗使用。反之购买“”体验”对话字符，可在AI聊天机器人使用，无需单独购买。\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint-no-purchase-message-box"},[_c('div',{staticClass:"text-box"},[_c('div',{staticClass:"one-text"},[_vm._v("您尚未设置互动问题")]),_vm._v(" "),_c('div',{staticClass:"two-text"},[_vm._v("为保证更好的互动效果，建议您前去设置")])]),_vm._v(" "),_c('div',{staticClass:"no-button-two-zgq"},[_c('div',{staticClass:"no-zgq-left-button"},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"no-go-set-button"},[_vm._v("去设置")])])])}]
var setThreeCom_esExports = { render: setThreeCom_render, staticRenderFns: setThreeCom_staticRenderFns }
/* harmony default export */ var myComponents_setThreeCom_setThreeCom = (setThreeCom_esExports);
// CONCATENATED MODULE: ./src/myComponents/setThreeCom/setThreeCom.vue
function setThreeCom_injectStyle (ssrContext) {
  __webpack_require__("gnaN")
}
var setThreeCom_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var setThreeCom___vue_template_functional__ = false
/* styles */
var setThreeCom___vue_styles__ = setThreeCom_injectStyle
/* scopeId */
var setThreeCom___vue_scopeId__ = "data-v-6d3ad75a"
/* moduleIdentifier (server only) */
var setThreeCom___vue_module_identifier__ = null
var setThreeCom_Component = setThreeCom_normalizeComponent(
  setThreeCom_setThreeCom,
  myComponents_setThreeCom_setThreeCom,
  setThreeCom___vue_template_functional__,
  setThreeCom___vue_styles__,
  setThreeCom___vue_scopeId__,
  setThreeCom___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_setThreeCom_setThreeCom = (setThreeCom_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slick-carousel/dist/vue-slick-carousel.umd.js
var vue_slick_carousel_umd = __webpack_require__("Xlla");
var vue_slick_carousel_umd_default = /*#__PURE__*/__webpack_require__.n(vue_slick_carousel_umd);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/characterInsufficient/characterInsufficient.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };


/* harmony default export */ var characterInsufficient = ({
  name: "characterInsufficient",
  props: {
    modelViewId: Number,
    imageType: Number
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onFreeOfCharge: function onFreeOfCharge() {
      var _this = this;

      if (this.imageType == 1) {

        Object(api["w" /* setImage */])({
          image_id: this.modelViewId,
          chat_type: 1
        }).then(function (d) {
          _this.$emit("onFreeOfCharge", false);
        }, function (e) {});
      } else {
        Object(utils["a" /* createRequest */])("post", "applet/webview/card/setting", {
          card_id: this.modelViewId,
          chat_type: 1
        }, function (res) {
          _this.$emit("onFreeOfCharge", false);
          console.log("%c⧭", "color: #364cd9", res);
        }, function (err) {});
      }
    },
    onClones: function onClones() {
      this.$emit("onFreeOfCharge", false);
    },
    onCharge: function onCharge() {
      this.$emit("onCharge", true);
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/characterInsufficient/characterInsufficient.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };


/* harmony default export */ var characterInsufficient_characterInsufficient = ({
  name: "characterInsufficient",
  props: {
    modelViewId: Number,
    imageType: Number
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onFreeOfCharge: function onFreeOfCharge() {
      var _this = this;

      if (this.imageType == 1) {

        Object(api["w" /* setImage */])({
          image_id: this.modelViewId,
          chat_type: 1
        }).then(function (d) {
          _this.$emit("onFreeOfCharge", false);
        }, function (e) {});
      } else {
        Object(utils["a" /* createRequest */])("post", "applet/webview/card/setting", {
          card_id: this.modelViewId,
          chat_type: 1
        }, function (res) {
          _this.$emit("onFreeOfCharge", false);
          console.log("%c⧭", "color: #364cd9", res);
        }, function (err) {});
      }
    },
    onClones: function onClones() {
      this.$emit("onFreeOfCharge", false);
    },
    onCharge: function onCharge() {
      this.$emit("onCharge", true);
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111db89a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/characterInsufficient/characterInsufficient.vue
var characterInsufficient_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"character-insufficient"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"close-icon"},[_c('img',{attrs:{"src":"/static/img/audioDelete.png","alt":""},on:{"click":_vm.onClones}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"button-zgq-character"},[_c('div',{staticClass:"left",on:{"click":_vm.onFreeOfCharge}},[_vm._v("使用当前常规机器人")]),_vm._v(" "),_c('div',{staticClass:"right",on:{"click":_vm.onCharge}},[_vm._v("购买AI聊天机器人字符")])])])])}
var characterInsufficient_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-hint"},[_vm._v("\n      您购买的“智能AI聊天机器人”对话字符已消\n      "),_c('p',[_vm._v("耗尽，为您切换至常规聊天机器人")])])}]
var characterInsufficient_esExports = { render: characterInsufficient_render, staticRenderFns: characterInsufficient_staticRenderFns }
/* harmony default export */ var myComponents_characterInsufficient_characterInsufficient = (characterInsufficient_esExports);
// CONCATENATED MODULE: ./src/myComponents/characterInsufficient/characterInsufficient.vue
function characterInsufficient_injectStyle (ssrContext) {
  __webpack_require__("YcHL")
}
var characterInsufficient_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var characterInsufficient___vue_template_functional__ = false
/* styles */
var characterInsufficient___vue_styles__ = characterInsufficient_injectStyle
/* scopeId */
var characterInsufficient___vue_scopeId__ = "data-v-111db89a"
/* moduleIdentifier (server only) */
var characterInsufficient___vue_module_identifier__ = null
var characterInsufficient_Component = characterInsufficient_normalizeComponent(
  characterInsufficient_characterInsufficient,
  myComponents_characterInsufficient_characterInsufficient,
  characterInsufficient___vue_template_functional__,
  characterInsufficient___vue_styles__,
  characterInsufficient___vue_scopeId__,
  characterInsufficient___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_characterInsufficient_characterInsufficient = (characterInsufficient_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slick-carousel/dist/vue-slick-carousel.css
var vue_slick_carousel = __webpack_require__("liEy");
var vue_slick_carousel_default = /*#__PURE__*/__webpack_require__.n(vue_slick_carousel);

// EXTERNAL MODULE: ./node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css
var vue_slick_carousel_theme = __webpack_require__("AlnM");
var vue_slick_carousel_theme_default = /*#__PURE__*/__webpack_require__.n(vue_slick_carousel_theme);

// EXTERNAL MODULE: ./src/myComponents/awaitReplyModel/awaitReplyModel.less
var awaitReplyModel = __webpack_require__("+8D2");
var awaitReplyModel_default = /*#__PURE__*/__webpack_require__.n(awaitReplyModel);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/awaitReplyModel/awaitReplyModel.vue
//
//
//
//
//
//
//
//
//
//


// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };


/* harmony default export */ var awaitReplyModel_awaitReplyModel = ({
    name: "awaitReplyModel",
    props: {
        // src:String,
        // poster:String,
        // onPlayerReady:Function,
        // options: {
        //     type: Object,
        //     default() {
        //         return {};
        //     }
        // }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {},

    methods: {},
    watch: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/awaitReplyModel/awaitReplyModel.vue
//
//
//
//
//
//
//
//
//
//


// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };


/* harmony default export */ var myComponents_awaitReplyModel_awaitReplyModel = ({
    name: "awaitReplyModel",
    props: {
        // src:String,
        // poster:String,
        // onPlayerReady:Function,
        // options: {
        //     type: Object,
        //     default() {
        //         return {};
        //     }
        // }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {},

    methods: {},
    watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05424b8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/awaitReplyModel/awaitReplyModel.vue
var awaitReplyModel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var awaitReplyModel_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"awaitReplyModel"},[_c('div',{staticClass:"box"},[_vm._v("\r\n    正在回复中...\r\n  ")])])}]
var awaitReplyModel_esExports = { render: awaitReplyModel_render, staticRenderFns: awaitReplyModel_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_myComponents_awaitReplyModel_awaitReplyModel = (awaitReplyModel_esExports);
// CONCATENATED MODULE: ./src/myComponents/awaitReplyModel/awaitReplyModel.vue
function awaitReplyModel_injectStyle (ssrContext) {
  __webpack_require__("lT9M")
}
var awaitReplyModel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var awaitReplyModel___vue_template_functional__ = false
/* styles */
var awaitReplyModel___vue_styles__ = awaitReplyModel_injectStyle
/* scopeId */
var awaitReplyModel___vue_scopeId__ = "data-v-05424b8c"
/* moduleIdentifier (server only) */
var awaitReplyModel___vue_module_identifier__ = null
var awaitReplyModel_Component = awaitReplyModel_normalizeComponent(
  myComponents_awaitReplyModel_awaitReplyModel,
  selectortype_template_index_0_src_myComponents_awaitReplyModel_awaitReplyModel,
  awaitReplyModel___vue_template_functional__,
  awaitReplyModel___vue_styles__,
  awaitReplyModel___vue_scopeId__,
  awaitReplyModel___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_awaitReplyModel_awaitReplyModel = (awaitReplyModel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/EditTextModal/EditTextModal.vue




/* harmony default export */ var EditTextModal = ({
  name: "EditTextModal",
  components: {
    XTextarea: x_textarea["a" /* default */]
  },
  props: {
    textareaValue: String
  },
  data: function data() {
    return {
      textareaValueData: this.textareaValue,
      textareaValueLength: this.textareaValue.length
    };
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onCloseIcon: function onCloseIcon() {
      this.$emit("onCloseEditModal");
    },
    inputClick: function inputClick() {
      console.log("input focus");
      this.$refs.messageInput.focus();
    },
    onSave: function onSave() {
      if (this.textareaValueLength >= 10) {
        this.$emit("onSaveEditTextModal", this.textareaValueData);
      } else {
        this.$vux.toast.show({
          type: "text",
          text: '请按要求设置打招呼内容,最少设置10个字符'
        });
      }
    }
  },
  watch: {
    textareaValueData: function textareaValueData(value) {
      this.textareaValueLength = value.length;
      console.log("%c⧭", "color: #73998c", value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/EditTextModal/EditTextModal.vue




/* harmony default export */ var EditTextModal_EditTextModal = ({
  name: "EditTextModal",
  components: {
    XTextarea: x_textarea["a" /* default */]
  },
  props: {
    textareaValue: String
  },
  data: function data() {
    return {
      textareaValueData: this.textareaValue,
      textareaValueLength: this.textareaValue.length
    };
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onCloseIcon: function onCloseIcon() {
      this.$emit("onCloseEditModal");
    },
    inputClick: function inputClick() {
      console.log("input focus");
      this.$refs.messageInput.focus();
    },
    onSave: function onSave() {
      if (this.textareaValueLength >= 10) {
        this.$emit("onSaveEditTextModal", this.textareaValueData);
      } else {
        this.$vux.toast.show({
          type: "text",
          text: '请按要求设置打招呼内容,最少设置10个字符'
        });
      }
    }
  },
  watch: {
    textareaValueData: function textareaValueData(value) {
      this.textareaValueLength = value.length;
      console.log("%c⧭", "color: #73998c", value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c013cac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/EditTextModal/EditTextModal.vue
var EditTextModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-greet-box-modal"},[_c('div',{staticClass:"input-button-text-box"},[_c('div',{staticClass:"hint-text-close"},[_c('div',{staticClass:"hint-text"},[_vm._v("默认打招呼")]),_vm._v(" "),_c('div',{staticClass:"close-icon"},[_c('img',{attrs:{"src":"/static/img/audioDelete.png","alt":""},on:{"click":_vm.onCloseIcon}})])]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('div',{on:{"click":_vm.inputClick}},[_c('div',{staticClass:"input"},[_c('x-textarea',{ref:"messageInput",attrs:{"max":200,"show-counter":false,"height":100,"placeholder":"大家好，我是XX公司的数字分身。很高兴与你对话"},model:{value:(_vm.textareaValueData),callback:function ($$v) {_vm.textareaValueData=$$v},expression:"textareaValueData"}})],1),_vm._v(" "),_c('div',{staticClass:"input-value-length"},[_c('span',{class:_vm.textareaValueLength < 10 && _vm.textareaValueLength != 0
                ? 'red-hint-normal-active'
                : 'red-hint-normal'},[_vm._v(_vm._s(_vm.textareaValueLength))]),_vm._v(" "),_c('span',{staticClass:"normal"},[_vm._v(" /200 ")])])])]),_vm._v(" "),_c('div',{staticClass:"button-box-edit-text"},[_c('div',{staticClass:"button-edit-save",on:{"click":_vm.onSave}},[_vm._v("\n          保存\n      ")])])])])}
var EditTextModal_staticRenderFns = []
var EditTextModal_esExports = { render: EditTextModal_render, staticRenderFns: EditTextModal_staticRenderFns }
/* harmony default export */ var myComponents_EditTextModal_EditTextModal = (EditTextModal_esExports);
// CONCATENATED MODULE: ./src/myComponents/EditTextModal/EditTextModal.vue
function EditTextModal_injectStyle (ssrContext) {
  __webpack_require__("Ics8")
}
var EditTextModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditTextModal___vue_template_functional__ = false
/* styles */
var EditTextModal___vue_styles__ = EditTextModal_injectStyle
/* scopeId */
var EditTextModal___vue_scopeId__ = "data-v-4c013cac"
/* moduleIdentifier (server only) */
var EditTextModal___vue_module_identifier__ = null
var EditTextModal_Component = EditTextModal_normalizeComponent(
  EditTextModal_EditTextModal,
  myComponents_EditTextModal_EditTextModal,
  EditTextModal___vue_template_functional__,
  EditTextModal___vue_styles__,
  EditTextModal___vue_scopeId__,
  EditTextModal___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_EditTextModal_EditTextModal = (EditTextModal_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/loading/index.vue + 3 modules
var loading = __webpack_require__("Bfwr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/countdown/index.vue
//
//
//
//

/* harmony default export */ var countdown = ({
  name: 'countdown',
  props: {
    value: Number,
    start: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.currentTime = this.time;
    if (this.value) this.currentTime = this.value;
  },

  methods: {
    tick: function tick() {
      var _this = this;
      this.interval = setInterval(function () {
        if (_this.currentTime > 0) {
          _this.currentTime--;
        } else {
          _this.stop();
          _this.index++;
          _this.$emit('on-finish', _this.index);
        }
      }, 1000);
    },
    stop: function stop() {
      clearInterval(this.interval);
    }
  },
  watch: {
    value: function value(val) {
      this.currentTime = val;
    },
    currentTime: function currentTime(val) {
      this.$emit('input', val);
    },
    start: function start(newVal, oldVal) {
      if (newVal === true && oldVal === false && this.currentTime > 0) {
        this.tick();
      }
      if (newVal === false && oldVal === true) {
        this.stop();
      }
    }
  },
  mounted: function mounted() {
    if (this.start) {
      this.tick();
    }
  },
  data: function data() {
    return {
      interval: null,
      index: 0,
      currentTime: 60
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/countdown/index.vue
//
//
//
//

/* harmony default export */ var components_countdown = ({
  name: 'countdown',
  props: {
    value: Number,
    start: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.currentTime = this.time;
    if (this.value) this.currentTime = this.value;
  },

  methods: {
    tick: function tick() {
      var _this = this;
      this.interval = setInterval(function () {
        if (_this.currentTime > 0) {
          _this.currentTime--;
        } else {
          _this.stop();
          _this.index++;
          _this.$emit('on-finish', _this.index);
        }
      }, 1000);
    },
    stop: function stop() {
      clearInterval(this.interval);
    }
  },
  watch: {
    value: function value(val) {
      this.currentTime = val;
    },
    currentTime: function currentTime(val) {
      this.$emit('input', val);
    },
    start: function start(newVal, oldVal) {
      if (newVal === true && oldVal === false && this.currentTime > 0) {
        this.tick();
      }
      if (newVal === false && oldVal === true) {
        this.stop();
      }
    }
  },
  mounted: function mounted() {
    if (this.start) {
      this.tick();
    }
  },
  data: function data() {
    return {
      interval: null,
      index: 0,
      currentTime: 60
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690ffb0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/countdown/index.vue
var countdown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.currentTime))])}
var countdown_staticRenderFns = []
var countdown_esExports = { render: countdown_render, staticRenderFns: countdown_staticRenderFns }
/* harmony default export */ var src_components_countdown = (countdown_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/countdown/index.vue
var countdown_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var countdown___vue_template_functional__ = false
/* styles */
var countdown___vue_styles__ = null
/* scopeId */
var countdown___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var countdown___vue_module_identifier__ = null
var countdown_Component = countdown_normalizeComponent(
  components_countdown,
  src_components_countdown,
  countdown___vue_template_functional__,
  countdown___vue_styles__,
  countdown___vue_scopeId__,
  countdown___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_countdown = (countdown_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-loading/index.vue + 3 modules
var inline_loading = __webpack_require__("jijt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b138ba8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("cJYu")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// EXTERNAL MODULE: ./src/S51WebGLSDK/index.js + 5 modules
var src_S51WebGLSDK = __webpack_require__("WzIO");

// CONCATENATED MODULE: ./src/audio/js/record.js

(function (window) {
  window.URL = window.URL || window.webkitURL;
  navigator.getUserMedia = (navigator.mediaDevices ? navigator.mediaDevices.getUserMedia : navigator.getUserMedia) || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

  var Recorder_ = function Recorder_(stream, config) {
    var _this2 = this;

    var audioContext = window.AudioContext || window.webkitAudioContext;
    var context = new audioContext();

    config = config || {};
    config.channelCount = 1;
    config.numberOfInputChannels = config.channelCount;
    config.numberOfOutputChannels = config.channelCount;
    config.sampleBits = config.sampleBits || 16;
    config.sampleRate = config.sampleRate || 16000;
    config.bufferSize = 4096; //创建缓存，用来缓存声音
    this.mediaStream = stream;
    this.minDuration = 2; //时长
    this.maxDuration = 60;
    this.startRecord = 0; //开始录制时间
    this.analyserNode = null;

    var audioInput = context.createMediaStreamSource(stream); //将声音输入这个对像
    var volume = context.createGain(); //设置音量节点
    audioInput.connect(volume);

    // 创建声音的缓存节点，createScriptProcessor方法的第二个和第三个参数指的是输入和输出都是声道数

    var recorder = context.createScriptProcessor(config.bufferSize, config.channelCount, config.channelCount);

    // 判断录音状态
    var isRecording = false;
    // 定时器
    var timer = null;
    //
    var increament = 0;
    var self = this;
    //用来储存读出的麦克风数据，和压缩这些数据，将这些数据转换为WAV文件的格式
    var audioData = {
      size: 0, //录音文件长度
      buffer: [], //录音缓存
      inputSampleRate: context.sampleRate, //输入采样率
      inputSampleBits: 16, //输入采样数位 8, 16
      outputSampleRate: config.sampleRate, //输出采样率
      oututSampleBits: config.sampleBits, //输出采样数位 8, 16
      hasClose: false,
      input: function input(data) {
        // 实时存储录音的数据

        // 写音量判断
        var maxVal = Math.max.apply(Math, data);

        if (Math.round(maxVal * 100) > 1) {
          console.log('有声音');
          increament = 0;
          isRecording = true;
          this.buffer.push(new Float32Array(data));
          this.size += data.length;
        } else {
          console.log('没声音');
          increament++;
          console.log(increament);
          //有数据 且 已录音

          if (this.size > 0 && isRecording == true && increament > 4) {

            // recorder.disconnect()
            // let blob = audioData.getFullWavData()

            // console.log("现在停了")
            // this.buffer = []
            // this.size = 0
            // console.log('接着录')
            // if (isRecording) {
            //   audioInput.connect(recorder)
            //   recorder.connect(context.destination)
            // }
            // callBackSrc(blob)
          }
        }
        if (isRecording && Date.now() - self.startRecord >= self.maxDuration * 1000) {
          console.log('time out stop');
          self.stop();
        }
        /*
        this.buffer.push(new Float32Array(data))  //Float32Array
        this.size += data.length
         */
      },
      getBufferSize: function getBufferSize() {
        return this.size;
      },
      getRawData: function getRawData() {
        //合并压缩
        //合并
        var data = new Float32Array(this.size);
        var offset = 0;
        for (var i = 0; i < this.buffer.length; i++) {
          data.set(this.buffer[i], offset);
          offset += this.buffer[i].length;
        }
        // 压缩
        var getRawDataion = parseInt(this.inputSampleRate / this.outputSampleRate);
        var length = data.length / getRawDataion;
        var result = new Float32Array(length);

        var index = 0,
            j = 0;
        while (index < length) {
          result[index] = data[j];
          j += getRawDataion;
          index++;
        }
        return result;
      },
      covertWav: function covertWav() {
        // 转换成wav文件数据
        var sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate);
        var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);
        var bytes = this.getRawData();
        var dataLength = bytes.length * (sampleBits / 8);
        var buffer = new ArrayBuffer(44 + dataLength);
        var data = new DataView(buffer);
        var offset = 0;
        var writeString = function writeString(str) {
          for (var i = 0; i < str.length; i++) {
            data.setUint8(offset + i, str.charCodeAt(i));
          }
        };
        // 资源交换文件标识符
        writeString('RIFF');offset += 4;
        // 下个地址开始到文件尾总字节数,即文件大小-8
        data.setUint32(offset, 36 + dataLength, true);offset += 4;
        // WAV文件标志
        writeString('WAVE');offset += 4;
        // 波形格式标志
        writeString('fmt ');offset += 4;
        // 过滤字节,一般为 0x10 = 16
        data.setUint32(offset, 16, true);offset += 4;
        // 格式类别 (PCM形式采样数据)
        data.setUint16(offset, 1, true);offset += 2;
        // 通道数
        data.setUint16(offset, config.channelCount, true);offset += 2;
        // 采样率,每秒样本数,表示每个通道的播放速度
        data.setUint32(offset, sampleRate, true);offset += 4;
        // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8
        data.setUint32(offset, config.channelCount * sampleRate * (sampleBits / 8), true);offset += 4;
        // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8
        data.setUint16(offset, config.channelCount * (sampleBits / 8), true);offset += 2;
        // 每样本数据位数
        data.setUint16(offset, sampleBits, true);offset += 2;
        // 数据标识符
        writeString('data');offset += 4;
        // 采样数据总数,即数据总大小-44
        data.setUint32(offset, dataLength, true);offset += 4;
        // 写入采样数据
        data = this.reshapeWavData(sampleBits, offset, bytes, data);
        return data;
      },
      getFullWavData: function getFullWavData() {
        // 用blob生成文件
        var data = this.covertWav();
        return new Blob([data], { type: 'audio/wav' });
      },
      closeContext: function closeContext() {
        //关闭AudioContext否则录音多次会报错
        hasClose = true;
        context.close();
      },
      reshapeWavData: function reshapeWavData(sampleBits, offset, iBytes, oData) {
        // 8位采样数位
        if (sampleBits === 8) {
          for (var i = 0; i < iBytes.length; i++, offset++) {
            var s = Math.max(-1, Math.min(1, iBytes[i]));
            var val = s < 0 ? s * 0x8000 : s * 0x7FFF;
            val = parseInt(255 / (65535 / (val + 32768)));
            oData.setInt8(offset, val, true);
          }
        } else {
          for (var _i = 0; _i < iBytes.length; _i++, offset += 2) {
            var _s = Math.max(-1, Math.min(1, iBytes[_i]));
            oData.setInt16(offset, _s < 0 ? _s * 0x8000 : _s * 0x7FFF, true);
          }
        }
        return oData;
      },
      getWavBuffer: function getWavBuffer() {
        // 用于绘图wav格式的buffer数据
        var data = this.covertWav();
        return data.buffer;
      },
      getPcmBuffer: function getPcmBuffer() {
        // pcm buffer 数据
        var bytes = this.getRawData(),
            offset = 0,
            sampleBits = this.oututSampleBits,
            dataLength = bytes.length * (sampleBits / 8),
            buffer = new ArrayBuffer(dataLength),
            data = new DataView(buffer);
        for (var i = 0; i < bytes.length; i++, offset += 2) {
          var s = Math.max(-1, Math.min(1, bytes[i]));
          // 16位直接乘就行了
          data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
        return new Blob([data]);
      }

      // 获取音频文件
    };this.getBlob = function () {
      console.log('getBlob stop');
      _this2.stop();
      return audioData.getFullWavData();
    };
    this.getBuffer = function () {
      console.log('get buffer stop');
      _this2.stop();
      return audioData.getPcmBuffer();
    };
    // 播放
    this.play = function (audio) {
      audio.src = window.URL.createObjectURL(_this2.getBlob());
      audio.addEventListener("play", function () {
        // this.draw(ctx)
      });
    };
    this.getBufferSize = function () {
      return audioData.getBufferSize();
    };
    // // 播放
    // this.play = (audio, ctx) => {
    //   audio.src = window.URL.createObjectURL(this.getBlob())
    //   audio.addEventListener("play", () => {
    //     // this.draw(ctx)
    //   })
    // }
    // wav文件资源
    // this.wavSrc = () => {
    //   return window.URL.createObjectURL(this.getBlob())
    // }
    this.wavSrc = function () {
      return _this2.getBlob();
    };
    // pcm 文件
    this.pcmSrc = function () {
      _this2.stop();
      console.log('pcm src stop');
      return window.URL.createObjectURL(_this2.getBuffer());
    };

    // 开始录音
    this.start = function (minDuration, maxDuration, drawWaverCanvas) {
      //开始之前，先把正在录音停掉
      recorder.disconnect();
      audioInput.disconnect();
      _this2.analyserNode && _this2.analyserNode.disconnect();

      isRecording = true;
      _this2.minDuration = minDuration && minDuration > 0 ? minDuration : _this2.minDuration;
      _this2.maxDuration = maxDuration && maxDuration > 0 ? maxDuration : _this2.maxDuration;
      _this2.startRecord = Date.now();
      audioInput.connect(recorder);
      recorder.connect(context.destination);

      // 创建音频分析节点
      _this2.analyserNode = context.createAnalyser();
      // fftSize决定了能够获取到的音频数据的数量
      _this2.analyserNode.fftSize = 4096;
      // 音频源连接至analyserNode
      audioInput.connect(_this2.analyserNode);
      // analyserNode再连接至扬声器播放
      // this.analyserNode.connect(context.destination);
      if (drawWaverCanvas) {
        _this2.drawWaverCanvas = drawWaverCanvas;
        _this2.drawWaverInterval = setInterval(_this2.drawWaver.bind(_this2), 60);
      }
      // return srcCallback
    };

    // 停止
    this.stop = function (callBackSrc) {
      console.log('-------recorder stop');
      if (!isRecording) {
        return; //避免重复回调
      }
      isRecording = false;
      recorder.disconnect();
      audioInput.disconnect();
      _this2.analyserNode && _this2.analyserNode.disconnect();
      _this2.analyserNode = null;
      console.log('------------------stop recorder');
      var blob = audioData.getFullWavData();
      audioData.buffer = [];
      audioData.size = 0;
      recorder = null;
      if (_this2.drawWaverInterval) {
        clearInterval(_this2.drawWaverInterval);
      }
      callBackSrc && callBackSrc(blob, {
        duration: (Date.now() - _this2.startRecord) / 1000
      });
    };
    /**
     * 释放麦克风
     */
    this.close = function () {

      audioData.closeContext();
      if (this.mediaStream) {
        console.log('释放stream', this.mediaStream);
        this.mediaStream.getTracks().forEach(function (track) {
          track.stop();
        });
        this.mediaStream = null;
      }
    };
    this.drawWaver = function () {
      if (this.isRecording && (!this.analyserNode || this.drawWaverCanvas)) {
        console.log('-------stop draw waver');
        return;
      }
      var canvas = this.drawWaverCanvas;
      if (!this.originData) {
        this.originData = new Float32Array(this.analyserNode.fftSize);
      } else if (this.originData.length != this.analyserNode.fftSize) {
        delete this.originData;
        this.originData = new Float32Array(this.analyserNode.fftSize);
      }

      var positives = [];
      var negatives = [];
      // 获取当前的实时音频数据
      this.analyserNode.getFloatTimeDomainData(this.originData);

      // 每12位数据取一个最大值一个最小值 4096 / 12 = 341.3333

      var _canvas$getBoundingCl = canvas.getBoundingClientRect(),
          width = _canvas$getBoundingCl.width,
          height = _canvas$getBoundingCl.height;

      var rectCount = Math.floor(width / 4);
      var sliceCount = Math.floor(4096 / rectCount);
      for (var i = 0; i < rectCount; i++) {
        var temp = this.originData.slice(i * sliceCount, (i + 1) * sliceCount);
        positives.push(Math.max.apply(null, temp));
        negatives.push(Math.min.apply(null, temp));
      }
      // 创建canvas上下文
      if (canvas.getContext) {
        var ctx = canvas.getContext('2d');
        canvas.width = positives.length * 4;

        var x = 0;
        var midle = height / 2;
        var y = midle;

        ctx.fillStyle = '#fa541c';
        console.log(positives[0], negatives[0]);
        // canvas高度200，横坐标在canvas中点100px的位置，横坐标上方绘制正数据，下方绘制负数据
        for (var k = 0; k < positives.length; k++) {
          // 每个矩形宽3px，间隔1px，图形总长度即为 length * 4
          ctx.fillRect(x + 4 * k, y - midle * positives[k], 3, midle * positives[k]);
          ctx.fillRect(x + 4 * k, midle, 3, midle * Math.abs(negatives[k]));
        }
      }
    };
    // 音频采集
    recorder.onaudioprocess = function (e) {
      audioData.input(e.inputBuffer.getChannelData(0));
    };

    this.saveAsWavFile = function (pcmsrt) {
      //参数->（base64编码的pcm流，采样频率，声道数，采样位数）
      var header = {
        // OFFS SIZE NOTES
        chunkId: [0x52, 0x49, 0x46, 0x46], // 0    4    "RIFF" = 0x52494646
        chunkSize: 0, // 4    4    36+SubChunk2Size = 4+(8+SubChunk1Size)+(8+SubChunk2Size)
        format: [0x57, 0x41, 0x56, 0x45], // 8    4    "WAVE" = 0x57415645
        subChunk1Id: [0x66, 0x6d, 0x74, 0x20], // 12   4    "fmt " = 0x666d7420
        subChunk1Size: 16, // 16   4    16 for PCM
        audioFormat: 1, // 20   2    PCM = 1
        numChannels: config.channelCount || 1, // 22   2    Mono = 1, Stereo = 2...
        sampleRate: config.sampleRate || 16000, // 24   4    8000, 44100...
        byteRate: 0, // 28   4    SampleRate*NumChannels*BitsPerSample/8
        blockAlign: 0, // 32   2    NumChannels*BitsPerSample/8
        bitsPerSample: config.sampleBits || 16, // 34   2    8 bits = 8, 16 bits = 16
        subChunk2Id: [0x64, 0x61, 0x74, 0x61], // 36   4    "data" = 0x64617461
        subChunk2Size: 0 // 40   4    data size = NumSamples*NumChannels*BitsPerSample/8
      };
      function u32ToArray(i) {
        return [i & 0xff, i >> 8 & 0xff, i >> 16 & 0xff, i >> 24 & 0xff];
      }
      function u16ToArray(i) {
        return [i & 0xff, i >> 8 & 0xff];
      }
      // console.log(pcmsrt.length)
      // let pcm = Buffer.from(pcmsrt.split(',')[1],'base64')
      var bstr = window.atob(pcmsrt.split(',')[1]);
      var n = bstr.length;
      var pcm = new Uint8Array(n);
      while (n--) {
        pcm[n] = bstr.charCodeAt(n);
      }

      // let pcm = Uint8Array.from(pcmsrt)
      header.blockAlign = header.numChannels * header.bitsPerSample >> 3;
      header.byteRate = header.blockAlign * header.sampleRate;
      header.subChunk2Size = pcm.length * (header.bitsPerSample >> 3);
      header.chunkSize = 36 + header.subChunk2Size;

      var wavHeader = header.chunkId.concat(u32ToArray(header.chunkSize), header.format, header.subChunk1Id, u32ToArray(header.subChunk1Size), u16ToArray(header.audioFormat), u16ToArray(header.numChannels), u32ToArray(header.sampleRate), u32ToArray(header.byteRate), u16ToArray(header.blockAlign), u16ToArray(header.bitsPerSample), header.subChunk2Id, u32ToArray(header.subChunk2Size));
      var wavHeaderUnit8 = new Uint8Array(wavHeader);

      var mergedArray = new Uint8Array(wavHeaderUnit8.length + pcm.length);
      mergedArray.set(wavHeaderUnit8);
      mergedArray.set(pcm, wavHeaderUnit8.length);
      var blob = new Blob([mergedArray], { type: 'audio/wav' });
      return blob;
      // let blobUrl = window.URL.createObjectURL(blob)
      // return blobUrl
    };
  };

  /**********************************微信SDK */
  var MyWeChatRecorder = {};
  MyWeChatRecorder.get = function (callback, config, _this) {
    var wxRecord = {
      start: function start() {
        _this.$wechat.startRecord();
      },
      stop: function stop() {
        _this.$wechat.stopRecord({
          success: function success(res) {
            console.log('录音结束', res);
          }
        });
      },
      close: function close() {}
    };
    callback(wxRecord);
  };
  MyWeChatRecorder.gerPermission = function () {
    return new promise_default.a(function (resolve) {
      resolve();
    });
  };

  /**********************************普通SDK */
  // 获取麦克风
  var H5Recorder = {};
  H5Recorder.gerPermission = function () {
    return new promise_default.a(function (resolve, reject) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
          audio: true
          // audio: {
          //   echoCancellation: true,
          //   sampleRate: 16000,
          //   channelCount: 1,
          //   noiseSuppression: true
          // }
        }).then(function (stream) {
          console.log('获取到权限');
          if (stream) {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
            stream = null;
          }
          return resolve('获取权限成功');
        }).catch(function (err) {
          console.error('获取录音权限失败', err);
          return reject('未获取到录音权限');
        });
      } else {
        console.error('设备不支持录音功能');
        return reject('设备不支持录音功能');
      }
    });
  };
  var recorderRec = void 0;
  H5Recorder.get = function (callback, config, this_) {
    if (callback) {
      //兼容处理
      // navigator.getUserMedia || (navigator.getUserMedia = navigator.mozGetUserMedia || navigator.webkitGetUserMedia || navigator.msGetUserMedia);
      // console.log(navigator.getUserMedia)

      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
          audio: true
          // audio: {
          //   echoCancellation: true,
          //   sampleRate: 16000,
          //   channelCount: 1,
          //   noiseSuppression: true
          // }
        }, function (stream) {
          recorderRec = new Recorder_(stream, config);
          callback(recorderRec);
        }, function (error) {
          console.log(error);
        }).then(function (stream) {
          recorderRec = new Recorder_(stream, config);
          callback(recorderRec);
        }).catch(function (err) {
          console.log(err);
          callback(null, err);
        });
      } else {
        alert("麦克风获取失败");
      }
    }
  };

  window.MyRecorder = {
    get: function get(callback, config, this_) {
      console.log('-------------1');
      H5Recorder.get(callback, config, this_);
    },
    gerPermission: function gerPermission() {
      return H5Recorder.gerPermission();
    },
    reset: function reset() {
      recorderRec && recorderRec.stop();
      recorderRec && recorderRec.close();
      recorderRec = null;
    }
  };
})(window);
// EXTERNAL MODULE: ./src/S51WebGLSDK/utils/utils.js + 1 modules
var utils_utils = __webpack_require__("U3F8");

// EXTERNAL MODULE: ./src/assets/voice.png
var voice = __webpack_require__("TNon");
var voice_default = /*#__PURE__*/__webpack_require__.n(voice);

// EXTERNAL MODULE: ./src/assets/costume.png
var costume = __webpack_require__("BXkM");
var costume_default = /*#__PURE__*/__webpack_require__.n(costume);

// EXTERNAL MODULE: ./src/assets/mic.png
var mic = __webpack_require__("5tr+");
var mic_default = /*#__PURE__*/__webpack_require__.n(mic);

// EXTERNAL MODULE: ./src/assets/mic_load.png
var mic_load = __webpack_require__("F7vt");
var mic_load_default = /*#__PURE__*/__webpack_require__.n(mic_load);

// EXTERNAL MODULE: ./src/assets/recording.png
var recording = __webpack_require__("Fj5x");
var recording_default = /*#__PURE__*/__webpack_require__.n(recording);

// EXTERNAL MODULE: ./src/assets/play.png
var play = __webpack_require__("KBZJ");
var play_default = /*#__PURE__*/__webpack_require__.n(play);

// EXTERNAL MODULE: ./src/assets/play_active.png
var play_active = __webpack_require__("fT5a");
var play_active_default = /*#__PURE__*/__webpack_require__.n(play_active);

// EXTERNAL MODULE: ./src/S51WebGLSDK/define.js
var S51WebGLSDK_define = __webpack_require__("1/Ha");

// EXTERNAL MODULE: ./src/myComponents/Chatframe/index.js
var myComponents_Chatframe = __webpack_require__("dr2p");

// EXTERNAL MODULE: ./src/myComponents/ChatInput/Loading.less
var Loading = __webpack_require__("qhUK");
var Loading_default = /*#__PURE__*/__webpack_require__.n(Loading);

// EXTERNAL MODULE: ./src/eventBus/index.js
var eventBus = __webpack_require__("Kw3Y");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/ChatInput/ChatInput.vue











var recorder = null;
var TIME_COUNT = 60;
/* harmony default export */ var ChatInput = ({
  name: "ChatInput",
  components: {
    XInput: x_input["a" /* default */],
    Countdown: vux_src_components_countdown,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel
  },
  props: {
    disabled: Boolean,
    voiceShowIs: Number,
    isChatGPT: Boolean,
    isMyself: Boolean,
    preinstallListIs: Array,
    packUnfoldBloIs: Boolean,
    packUnfoldStateIs: Boolean,
    hasConsume: Boolean,
    packUnfoldShow: Number,
    voiceContentListIs: Array,
    companyID: Number
  },
  data: function data() {
    return {
      activeDisabled: this.disabled,
      cutRecordState: false,
      myChatVoiceBlob: undefined,
      value: "",
      time: TIME_COUNT,
      show: false,
      countHandler: undefined,
      isActiveChatGPT: this.isChatGPT,
      isActiveMyself: this.isMyself,
      isHasConsume: this.hasConsume || false,
      inputType: true,
      preinstallList: this.preinstallListIs || [],
      packUnfoldBlo: this.packUnfoldBloIs,
      packUnfoldState: this.packUnfoldStateIs,
      typeShow: this.packUnfoldShow,
      touchCancel: false,
      voiceContentList: this.voiceContentListIs,
      hasNotPermission: true,
      activeEnableInput: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log("ChatInput mouted 111", window.location);
    if (this.$refs.messageInput.$el.getElementsByTagName("input").length > 0) {

      this.$refs.messageInput.$el.getElementsByTagName("input")[0].enterKeyHint = "send";
    }

    if (this.isMyself) {
      Object(api["l" /* getChatStat */])().then(function (res) {
        if (res.data.char_num_use > 0) _this.isHasConsume = true;else _this.isHasConsume = false;
        console.log("is isMyself", _this.isHasConsume);
      });
    }
    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, function (param) {
      console.log('收到 enable input  消息', param);
      _this.activeEnableInput = param.enable;
    });
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onPackUnfold: function onPackUnfold() {
      this.$emit("onPackUnfold");
    },
    onGotoConsumeRecord: function onGotoConsumeRecord() {
      console.log("跳转消耗明细");
      this.$wechat.miniProgram.navigateTo({
        url: "/walletPage/pages/chatConsumeRecord/chatConsumeRecord",
        success: function success() {
          console.log("跳转成功");
        }
      });
    },
    onOpenChargeModel: function onOpenChargeModel() {
      console.log("----充值购买");
      this.$emit("onOpenChargeModel");
    },
    onTouchstart: function onTouchstart(e) {
      console.log("ontouch start");

      if (this.activeDisabled) {
        return;
      }
      e.preventDefault();

      if (this.cutRecordState) {
        //正在录音
        return;
      }
      if (this.startRecord > 0 && Date.now() - this.startRecord < 500) {
        return;
      }
      this.touchCancel = false;
      this.touchStop = false;
      this.cutRecordState = true;

      this.startRecord = Date.now();
      var self = this;
      window.MyRecorder.get(function (res, err) {
        self.$refs.voiceInputBtn.focus();
        document.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: 1, // 鼠标点击位置的x坐标
          clientY: 1
        }));

        if (err) {
          console.error(err);
          self.cutRecordState = false;
          return self.$vux.toast.show({
            type: 'text',
            text: '获取录音权限失败'
          });
        }

        setTimeout(function () {

          if (self.touchCancel || self.touchStop) {
            //超过300毫秒认为用户点击了授权
            return self.cutRecordState = false;
          }
          recorder = res;
          self.time = TIME_COUNT;
          self.show = true;
          self.$emit("onInputStartRecordAudio", true);
          recorder.start();

          if (self.countHandler) clearInterval(self.countHandler);
          self.countHandler = setInterval(function () {
            if (self.time >= 1) {
              self.time--;
            }
            if (self.time <= 0) {
              self.stopRecord();
            }
          }, 1000);
          console.log("%c⧭", "color: #1d5673", res);
        }, 300);
      }, null, self);
    },
    onTouchmove: function onTouchmove(e) {
      console.log("%c⧭", "color: #00bf00", e);
    },
    resetRecord: function resetRecord() {

      window.MyRecorder.reset();
    },
    stopRecord: function stopRecord() {
      var self = this;
      self.time = 0;
      self.show = false;
      self.cutRecordState = false;
      if (self.countHandler) clearInterval(self.countHandler);

      if (recorder) {
        recorder.stop(function (src, option) {
          console.log("main ========================================= ", option);

          if (option.duration < 1) {
            self.resetRecord();
            return self.$vux.toast.show({
              type: 'text',
              text: '说话时间太短'
            });
          }
          if (self.touchCancel) {
            self.resetRecord();
            return;
          }
          if (self.myChatVoiceBlob) {
            delete self.myChatVoiceBlob;
            self.myChatVoiceBlob = undefined;
          }
          self.myChatVoiceBlob = window.URL.createObjectURL(src);

          var a = new FileReader();
          a.readAsDataURL(src);
          a.onload = function (e) {
            var getRes = e.target.result;

            var file = new File([recorder.saveAsWavFile(getRes)], 'chataudio.wav', { type: 'audio/wav' });
            self.$vux.loading.show({
              text: '正在发送...'
            });
            uploadQiniu(file, 'wav', function (process) {
              console.log(process);
            }, function (err, res) {
              self.$vux.loading.hide();
              if (err) {
                return self.$vux.toast.show({
                  type: 'text',
                  text: '音频发送失败'
                });
              }
              self.$emit("onInputEndRecordAudio", {
                voiceUrl: self.myChatVoiceBlob, //voice url数据，可用于播放
                voiceSendData: res.key, //voice base64数据，用于聊天发送
                voiceHttpUrl: res.domain + res.key,
                duration: option.duration
              });
            });
          };
          self.resetRecord();
        });
      } else {
        this.resetRecord();
      }
    },
    onTouchCancel: function onTouchCancel(e) {
      console.log('被取消');

      this.touchCancel = true;
      this.stopRecord();
    },
    onTouchend: function onTouchend(e) {
      this.touchStop = true;
      this.stopRecord();
    },
    onSend: function onSend() {
      var _this2 = this;

      if (this.activeDisabled) {
        return;
      }
      if (!this.value || this.value.length == 0) {
        return;
      }
      this.$emit("onInputWordSend", this.value);
      setTimeout(function () {
        _this2.$refs.messageInput.blur();
      }, 200); //延时200毫秒失去焦点
      this.value = "";
      if (this.myChatVoiceBlob) {

        delete this.myChatVoiceBlob;
        this.myChatVoiceBlob = undefined;
      }
    },
    sendComment: function sendComment(e) {
      this.onSend();
    },
    inputClick: function inputClick() {
      this.$refs.messageInput.focus();
    },
    finish: function finish(index) {
      this.onTouchend();

      console.log("current index", index);
    },
    upChat: function upChat() {
      console.log('升级chatgpt');
      this.$emit("onUpChat");
    },
    sendPreQuestion: function sendPreQuestion(item) {
      if (!this.activeEnableInput) {
        return;
      }
      this.$emit("onSendPreQuestion", item);
    }
  },
  watch: {
    disabled: function disabled(val) {

      console.log('%c⧭', 'color: #99adcc', val);
      this.activeDisabled = val;
    },
    voiceContentListIs: function voiceContentListIs(value) {
      this.voiceContentList = value;
    },
    isChatGPT: function isChatGPT(val) {
      console.log("is chat gpt", val);
      this.isActiveChatGPT = val;
    },
    packUnfoldShow: function packUnfoldShow(value) {
      this.typeShow = value;

      console.log('%c⧭', 'color: #408059;font-size:90px', value);
    },
    preinstallList: function preinstallList(value) {

      console.log('%c⧭', 'color: #ffcc00;font-size:90px', value);
    },
    isMyself: function isMyself(val) {
      var _this3 = this;

      console.log('---ChatInput mouted');
      this.isActiveMyself = val;
      if (this.isMyself) {
        Object(api["l" /* getChatStat */])().then(function (res) {
          if (res.data.char_num_use > 0) _this3.isHasConsume = true;else _this3.isHasConsume = false;
          console.log("is isMyself", _this3.isHasConsume);
        });
      }
    },
    packUnfoldBloIs: function packUnfoldBloIs(value) {
      this.packUnfoldBlo = value;
    },
    packUnfoldStateIs: function packUnfoldStateIs(value) {
      this.packUnfoldState = value;
    },
    hasConsume: function hasConsume(val) {
      this.isHasConsume = val;
    },
    preinstallListIs: function preinstallListIs(val) {
      this.preinstallList = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/ChatInput/ChatInput.vue











var ChatInput_recorder = null;
var ChatInput_TIME_COUNT = 60;
/* harmony default export */ var ChatInput_ChatInput = ({
  name: "ChatInput",
  components: {
    XInput: x_input["a" /* default */],
    Countdown: vux_src_components_countdown,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel
  },
  props: {
    disabled: Boolean,
    voiceShowIs: Number,
    isChatGPT: Boolean,
    isMyself: Boolean,
    preinstallListIs: Array,
    packUnfoldBloIs: Boolean,
    packUnfoldStateIs: Boolean,
    hasConsume: Boolean,
    packUnfoldShow: Number,
    voiceContentListIs: Array,
    companyID: Number
  },
  data: function data() {
    return {
      activeDisabled: this.disabled,
      cutRecordState: false,
      myChatVoiceBlob: undefined,
      value: "",
      time: ChatInput_TIME_COUNT,
      show: false,
      countHandler: undefined,
      isActiveChatGPT: this.isChatGPT,
      isActiveMyself: this.isMyself,
      isHasConsume: this.hasConsume || false,
      inputType: true,
      preinstallList: this.preinstallListIs || [],
      packUnfoldBlo: this.packUnfoldBloIs,
      packUnfoldState: this.packUnfoldStateIs,
      typeShow: this.packUnfoldShow,
      touchCancel: false,
      voiceContentList: this.voiceContentListIs,
      hasNotPermission: true,
      activeEnableInput: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log("ChatInput mouted 111", window.location);
    if (this.$refs.messageInput.$el.getElementsByTagName("input").length > 0) {

      this.$refs.messageInput.$el.getElementsByTagName("input")[0].enterKeyHint = "send";
    }

    if (this.isMyself) {
      Object(api["l" /* getChatStat */])().then(function (res) {
        if (res.data.char_num_use > 0) _this.isHasConsume = true;else _this.isHasConsume = false;
        console.log("is isMyself", _this.isHasConsume);
      });
    }
    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, function (param) {
      console.log('收到 enable input  消息', param);
      _this.activeEnableInput = param.enable;
    });
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onPackUnfold: function onPackUnfold() {
      this.$emit("onPackUnfold");
    },
    onGotoConsumeRecord: function onGotoConsumeRecord() {
      console.log("跳转消耗明细");
      this.$wechat.miniProgram.navigateTo({
        url: "/walletPage/pages/chatConsumeRecord/chatConsumeRecord",
        success: function success() {
          console.log("跳转成功");
        }
      });
    },
    onOpenChargeModel: function onOpenChargeModel() {
      console.log("----充值购买");
      this.$emit("onOpenChargeModel");
    },
    onTouchstart: function onTouchstart(e) {
      console.log("ontouch start");

      if (this.activeDisabled) {
        return;
      }
      e.preventDefault();

      if (this.cutRecordState) {
        //正在录音
        return;
      }
      if (this.startRecord > 0 && Date.now() - this.startRecord < 500) {
        return;
      }
      this.touchCancel = false;
      this.touchStop = false;
      this.cutRecordState = true;

      this.startRecord = Date.now();
      var self = this;
      window.MyRecorder.get(function (res, err) {
        self.$refs.voiceInputBtn.focus();
        document.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          clientX: 1, // 鼠标点击位置的x坐标
          clientY: 1
        }));

        if (err) {
          console.error(err);
          self.cutRecordState = false;
          return self.$vux.toast.show({
            type: 'text',
            text: '获取录音权限失败'
          });
        }

        setTimeout(function () {

          if (self.touchCancel || self.touchStop) {
            //超过300毫秒认为用户点击了授权
            return self.cutRecordState = false;
          }
          ChatInput_recorder = res;
          self.time = ChatInput_TIME_COUNT;
          self.show = true;
          self.$emit("onInputStartRecordAudio", true);
          ChatInput_recorder.start();

          if (self.countHandler) clearInterval(self.countHandler);
          self.countHandler = setInterval(function () {
            if (self.time >= 1) {
              self.time--;
            }
            if (self.time <= 0) {
              self.stopRecord();
            }
          }, 1000);
          console.log("%c⧭", "color: #1d5673", res);
        }, 300);
      }, null, self);
    },
    onTouchmove: function onTouchmove(e) {
      console.log("%c⧭", "color: #00bf00", e);
    },
    resetRecord: function resetRecord() {

      window.MyRecorder.reset();
    },
    stopRecord: function stopRecord() {
      var self = this;
      self.time = 0;
      self.show = false;
      self.cutRecordState = false;
      if (self.countHandler) clearInterval(self.countHandler);

      if (ChatInput_recorder) {
        ChatInput_recorder.stop(function (src, option) {
          console.log("main ========================================= ", option);

          if (option.duration < 1) {
            self.resetRecord();
            return self.$vux.toast.show({
              type: 'text',
              text: '说话时间太短'
            });
          }
          if (self.touchCancel) {
            self.resetRecord();
            return;
          }
          if (self.myChatVoiceBlob) {
            delete self.myChatVoiceBlob;
            self.myChatVoiceBlob = undefined;
          }
          self.myChatVoiceBlob = window.URL.createObjectURL(src);

          var a = new FileReader();
          a.readAsDataURL(src);
          a.onload = function (e) {
            var getRes = e.target.result;

            var file = new File([ChatInput_recorder.saveAsWavFile(getRes)], 'chataudio.wav', { type: 'audio/wav' });
            self.$vux.loading.show({
              text: '正在发送...'
            });
            uploadQiniu(file, 'wav', function (process) {
              console.log(process);
            }, function (err, res) {
              self.$vux.loading.hide();
              if (err) {
                return self.$vux.toast.show({
                  type: 'text',
                  text: '音频发送失败'
                });
              }
              self.$emit("onInputEndRecordAudio", {
                voiceUrl: self.myChatVoiceBlob, //voice url数据，可用于播放
                voiceSendData: res.key, //voice base64数据，用于聊天发送
                voiceHttpUrl: res.domain + res.key,
                duration: option.duration
              });
            });
          };
          self.resetRecord();
        });
      } else {
        this.resetRecord();
      }
    },
    onTouchCancel: function onTouchCancel(e) {
      console.log('被取消');

      this.touchCancel = true;
      this.stopRecord();
    },
    onTouchend: function onTouchend(e) {
      this.touchStop = true;
      this.stopRecord();
    },
    onSend: function onSend() {
      var _this2 = this;

      if (this.activeDisabled) {
        return;
      }
      if (!this.value || this.value.length == 0) {
        return;
      }
      this.$emit("onInputWordSend", this.value);
      setTimeout(function () {
        _this2.$refs.messageInput.blur();
      }, 200); //延时200毫秒失去焦点
      this.value = "";
      if (this.myChatVoiceBlob) {

        delete this.myChatVoiceBlob;
        this.myChatVoiceBlob = undefined;
      }
    },
    sendComment: function sendComment(e) {
      this.onSend();
    },
    inputClick: function inputClick() {
      this.$refs.messageInput.focus();
    },
    finish: function finish(index) {
      this.onTouchend();

      console.log("current index", index);
    },
    upChat: function upChat() {
      console.log('升级chatgpt');
      this.$emit("onUpChat");
    },
    sendPreQuestion: function sendPreQuestion(item) {
      if (!this.activeEnableInput) {
        return;
      }
      this.$emit("onSendPreQuestion", item);
    }
  },
  watch: {
    disabled: function disabled(val) {

      console.log('%c⧭', 'color: #99adcc', val);
      this.activeDisabled = val;
    },
    voiceContentListIs: function voiceContentListIs(value) {
      this.voiceContentList = value;
    },
    isChatGPT: function isChatGPT(val) {
      console.log("is chat gpt", val);
      this.isActiveChatGPT = val;
    },
    packUnfoldShow: function packUnfoldShow(value) {
      this.typeShow = value;

      console.log('%c⧭', 'color: #408059;font-size:90px', value);
    },
    preinstallList: function preinstallList(value) {

      console.log('%c⧭', 'color: #ffcc00;font-size:90px', value);
    },
    isMyself: function isMyself(val) {
      var _this3 = this;

      console.log('---ChatInput mouted');
      this.isActiveMyself = val;
      if (this.isMyself) {
        Object(api["l" /* getChatStat */])().then(function (res) {
          if (res.data.char_num_use > 0) _this3.isHasConsume = true;else _this3.isHasConsume = false;
          console.log("is isMyself", _this3.isHasConsume);
        });
      }
    },
    packUnfoldBloIs: function packUnfoldBloIs(value) {
      this.packUnfoldBlo = value;
    },
    packUnfoldStateIs: function packUnfoldStateIs(value) {
      this.packUnfoldState = value;
    },
    hasConsume: function hasConsume(val) {
      this.isHasConsume = val;
    },
    preinstallListIs: function preinstallListIs(val) {
      this.preinstallList = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a268c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/ChatInput/ChatInput.vue
var ChatInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isActiveMyself)?_c('div',{class:_vm.packUnfoldShow == 1 && _vm.packUnfoldState == false ? 'consume-recharge-upgrade-active' : 'consume-recharge-upgrade'},[_c('div',{staticStyle:{"display":"flex","align-items":"center","position":"absolute","right":"5px","margin-bottom":"15px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.packUnfoldShow == 1 && _vm.voiceContentList.length > 0 && _vm.activeDisabled == false),expression:"packUnfoldShow == 1 && voiceContentList.length > 0 && activeDisabled == false"}],staticClass:"right-icon-pack-unfold-text",on:{"click":_vm.onPackUnfold}},[_c('img',{attrs:{"src":_vm.packUnfoldState == false
            ? '/static/img/unfold_icon.png'
            : '/static/img/pack_icon.png',"alt":""}}),_vm._v("\n        "+_vm._s(_vm.packUnfoldState == false ? "展开对话" : "收起对话")+"\n        ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"preinstall-box-chat-box"},[_c('div',{staticClass:"pack-unfold-preinstall"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preinstallList.length > 0),expression:"preinstallList.length > 0"}],staticClass:"left-preinstall-issue-box",style:({ width: '100%' })},_vm._l((_vm.preinstallList),function(item,index){return _c('div',{key:index,staticClass:"preinstall-issue-name-php",on:{"click":function($event){return _vm.sendPreQuestion(item)}}},[_c('span',{staticClass:"preinstall-issue-php"},[_vm._v("\n            #"+_vm._s(item.question)+"\n          ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"chatInput"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"model-time"},[_c('img',{attrs:{"src":"/static/img/recording.png"}}),_vm._v(" "),_c('countdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"value":_vm.time,"start":false},on:{"on-finish":_vm.finish}})],1),_vm._v(" "),_c('div',{staticClass:"zgq-chat-send-input"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.activeEnableInput),expression:"!activeEnableInput"}],staticClass:"box"},[_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeEnableInput),expression:"activeEnableInput"}],staticClass:"box"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","width":"100%"}},[(_vm.voiceShowIs != 1)?_c('div',{staticClass:"left-voice-icon"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputType),expression:"inputType"}],staticClass:"send-img",staticStyle:{"background-image":"url(/static/img/record_icon.png)"},attrs:{"disabled":_vm.activeDisabled,"alt":""},on:{"click":function($event){_vm.inputType = !_vm.inputType}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inputType),expression:"!inputType"}],staticClass:"send-img",staticStyle:{"background-image":"url(/static/img/text_icon.png)"},attrs:{"disabled":_vm.activeDisabled,"alt":""},on:{"click":function($event){_vm.inputType = !_vm.inputType}}})]):_vm._e(),_vm._v(" "),(_vm.voiceShowIs != 1)?_c('span',{staticClass:"transverse"}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputType),expression:"inputType"}],staticClass:"input-text-content",attrs:{"disabled":_vm.activeDisabled},on:{"click":_vm.inputClick}},[_c('x-input',{ref:"messageInput",attrs:{"disabled":_vm.activeDisabled,"show-clear":false,"placeholder":"请输入","value":_vm.value},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendComment.apply(null, arguments)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inputType),expression:"!inputType"}],ref:"voiceInputBtn",staticClass:"hegiht-back",attrs:{"disabled":_vm.activeDisabled},on:{"touchstart":_vm.onTouchstart,"touchmove":_vm.onTouchmove,"touchend":_vm.onTouchend,"touchcancel":_vm.onTouchCancel}},[_c('div',{class:_vm.cutRecordState == false ? 'back' : 'back-active'})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputType),expression:"inputType"}],staticClass:"right-button-icon-send"},[_c('img',{attrs:{"disabled":_vm.activeDisabled,"src":"/static/img/send_icon.png","alt":""},on:{"click":_vm.onSend}})])])])])])])}
var ChatInput_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-answer"},[_c('div',{staticClass:"loading-input"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])}]
var ChatInput_esExports = { render: ChatInput_render, staticRenderFns: ChatInput_staticRenderFns }
/* harmony default export */ var myComponents_ChatInput_ChatInput = (ChatInput_esExports);
// CONCATENATED MODULE: ./src/myComponents/ChatInput/ChatInput.vue
function ChatInput_injectStyle (ssrContext) {
  __webpack_require__("hnPy")
}
var ChatInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatInput___vue_template_functional__ = false
/* styles */
var ChatInput___vue_styles__ = ChatInput_injectStyle
/* scopeId */
var ChatInput___vue_scopeId__ = "data-v-69a268c6"
/* moduleIdentifier (server only) */
var ChatInput___vue_module_identifier__ = null
var ChatInput_Component = ChatInput_normalizeComponent(
  ChatInput_ChatInput,
  myComponents_ChatInput_ChatInput,
  ChatInput___vue_template_functional__,
  ChatInput___vue_styles__,
  ChatInput___vue_scopeId__,
  ChatInput___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_ChatInput_ChatInput = (ChatInput_Component.exports);

// EXTERNAL MODULE: ./src/components/SetQaPage.less
var SetQaPage = __webpack_require__("vy6r");
var SetQaPage_default = /*#__PURE__*/__webpack_require__.n(SetQaPage);

// EXTERNAL MODULE: ./src/myComponents/myImage/myImage.vue + 3 modules
var myImage = __webpack_require__("SRZQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/Firm/FirmData.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };



/* harmony default export */ var FirmData = ({
  components: {
    myImage: myImage["a" /* default */],
    myVideo: myVideo["a" /* default */]
  },
  name: "FirmData",
  props: {
    companyID: Number | String
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data: function data() {
    return {
      list: [],
      imageIsOpen: false,
      videoIsOpen: false,
      videoImageUrl: ''
    };
  },
  mounted: function mounted() {
    this.companyCorpusList();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onBack: function onBack() {
      console.log("----QA back");
      this.$emit("onBack", "preview");
    },
    companyCorpusList: function companyCorpusList() {
      var _this = this;

      if (this.companyID <= 0) {
        return; //非企业账号
      }
      Object(api["i" /* companyCorpusList */])(this.companyID, 1, 100).then(function (res) {
        _this.list = res.data.data;
        console.log("%c⧭", "color: #007300", res);
      });
    },
    onLookModal: function onLookModal(type, item) {
      if (type == "image") {
        this.imageIsOpen = true;
        this.videoImageUrl = item.file;
      } else if (type == 'video') {
        this.videoIsOpen = true;
        this.videoImageUrl = item.file;
      } else {
        this.$wechat.miniProgram.navigateTo({
          url: "../documentView/documentView?url=" + encodeURIComponent(item.file),
          success: function success() {
            console.log("跳转成功");
          }
        });
      }
    },
    onHideMyImage: function onHideMyImage() {
      this.imageIsOpen = false;
    },
    onHideMyVideo: function onHideMyVideo() {
      this.videoIsOpen = false;
    }
  },
  watch: {
    companyID: function companyID(val) {
      this.companyCorpusList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/Firm/FirmData.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };



/* harmony default export */ var Firm_FirmData = ({
  components: {
    myImage: myImage["a" /* default */],
    myVideo: myVideo["a" /* default */]
  },
  name: "FirmData",
  props: {
    companyID: Number | String
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data: function data() {
    return {
      list: [],
      imageIsOpen: false,
      videoIsOpen: false,
      videoImageUrl: ''
    };
  },
  mounted: function mounted() {
    this.companyCorpusList();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onBack: function onBack() {
      console.log("----QA back");
      this.$emit("onBack", "preview");
    },
    companyCorpusList: function companyCorpusList() {
      var _this = this;

      if (this.companyID <= 0) {
        return; //非企业账号
      }
      Object(api["i" /* companyCorpusList */])(this.companyID, 1, 100).then(function (res) {
        _this.list = res.data.data;
        console.log("%c⧭", "color: #007300", res);
      });
    },
    onLookModal: function onLookModal(type, item) {
      if (type == "image") {
        this.imageIsOpen = true;
        this.videoImageUrl = item.file;
      } else if (type == 'video') {
        this.videoIsOpen = true;
        this.videoImageUrl = item.file;
      } else {
        this.$wechat.miniProgram.navigateTo({
          url: "../documentView/documentView?url=" + encodeURIComponent(item.file),
          success: function success() {
            console.log("跳转成功");
          }
        });
      }
    },
    onHideMyImage: function onHideMyImage() {
      this.imageIsOpen = false;
    },
    onHideMyVideo: function onHideMyVideo() {
      this.videoIsOpen = false;
    }
  },
  watch: {
    companyID: function companyID(val) {
      this.companyCorpusList();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18388866","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/Firm/FirmData.vue
var FirmData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.list.length <= 0),expression:"list.length <= 0"}],staticStyle:{"color":"#fff","font-size":"15px","display":"flex","justify-content":"center","margin-top":"100px"}},[_vm._v("\n    暂无数据\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.list.length > 0),expression:"list.length > 0"}],staticStyle:{"min-height":"90%","max-height":"90%","overflow-y":"scroll","direction":"unset"}},[_c('div',{staticClass:"firm-data-box"},_vm._l((_vm.list),function(item,index){return _c('div',{key:item.id,staticClass:"box-zgq"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(index + 1)+"."+_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"image-video-pdf"},[(item.file_type == 'image')?_c('div',{staticClass:"box",on:{"click":function($event){return _vm.onLookModal(item.file_type,item)}}},[_c('img',{attrs:{"src":item.file,"alt":""}})]):(item.file_type == 'pdf')?_c('div',{staticClass:"box",on:{"click":function($event){return _vm.onLookModal(item.file_type,item)}}},[_c('div',{staticClass:"box-1"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"pdf-text"},[_vm._v("\n                "+_vm._s(item.file_name)+"\n              ")])])]):(item.file_type == 'zip')?_c('div',{staticClass:"box",on:{"click":function($event){return _vm.onLookModal(item.file_type,item)}}},[_c('div',{staticClass:"box-1"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"pdf-text"},[_vm._v("\n                "+_vm._s(item.file_name)+"\n              ")])])]):(item.file_type == 'video')?_c('div',{staticClass:"box",on:{"click":function($event){return _vm.onLookModal(item.file_type,item)}}},[_c('div',{staticClass:"box-1"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"pdf-text"},[_vm._v("\n                "+_vm._s(item.file_name)+"\n              ")])])]):(item.file_type == 'docx')?_c('div',{staticClass:"box",on:{"click":function($event){return _vm.onLookModal(item.file_type,item)}}},[_c('div',{staticClass:"box-1"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"pdf-text"},[_vm._v("\n                "+_vm._s(item.file_name)+"\n              ")])])]):_c('div',{staticClass:"box",on:{"click":function($event){return _vm.onLookModal(item.file_type,item)}}},[_c('div',{staticClass:"box-1"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"pdf-text"},[_vm._v("\n                "+_vm._s(item.file_name)+"\n              ")])])])])])}),0)]),_vm._v(" "),(_vm.list.length > 0)?_c('div',{staticClass:"back-button-box",on:{"click":_vm.onBack}},[_c('div',{staticClass:"back-button"},[_vm._v("预览")])]):_vm._e(),_vm._v(" "),(_vm.imageIsOpen)?_c('myImage',{attrs:{"imageUrl":_vm.videoImageUrl},on:{"onHideMyImage":_vm.onHideMyImage}}):_vm._e(),_vm._v(" "),(_vm.videoIsOpen)?_c('myVideo',{attrs:{"videoUrl":_vm.videoImageUrl},on:{"onHideMyVideo":_vm.onHideMyVideo}}):_vm._e()],1)}
var FirmData_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-type"},[_c('img',{attrs:{"src":"/static/img/pdf.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-type"},[_c('img',{attrs:{"src":"/static/img/file_icon.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-type"},[_c('img',{attrs:{"src":"/static/img/file_icon.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-type"},[_c('img',{attrs:{"src":"/static/img/word.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-type"},[_c('img',{attrs:{"src":"/static/img/file_icon.png"}})])}]
var FirmData_esExports = { render: FirmData_render, staticRenderFns: FirmData_staticRenderFns }
/* harmony default export */ var myComponents_Firm_FirmData = (FirmData_esExports);
// CONCATENATED MODULE: ./src/myComponents/Firm/FirmData.vue
function FirmData_injectStyle (ssrContext) {
  __webpack_require__("aXSi")
}
var FirmData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FirmData___vue_template_functional__ = false
/* styles */
var FirmData___vue_styles__ = FirmData_injectStyle
/* scopeId */
var FirmData___vue_scopeId__ = "data-v-18388866"
/* moduleIdentifier (server only) */
var FirmData___vue_module_identifier__ = null
var FirmData_Component = FirmData_normalizeComponent(
  Firm_FirmData,
  myComponents_Firm_FirmData,
  FirmData___vue_template_functional__,
  FirmData___vue_styles__,
  FirmData___vue_scopeId__,
  FirmData___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_Firm_FirmData = (FirmData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SetQaPage.vue













/* harmony default export */ var components_SetQaPage = ({
  name: 'SetQaPage',
  components: {
    ThreeSet: src_myComponents_setThreeCom_setThreeCom,
    QAComponent: src_myComponents_QAComponent_QAComponent,
    AddQa: src_myComponents_AddQa_AddQa,
    HumanList: src_myComponents_HumanList_HumanList,
    Badge: vux_src_components_badge,
    FirmData: src_myComponents_Firm_FirmData
  },
  props: {},
  data: function data() {
    return {
      preComponentsState: "",
      componentsState: "", //页面 ''-主页 costume-问答库 qa-新建问答 set-设置
      imageShow: "0",
      addSaveRouter: 1,
      spareList: [],
      modelViewId: 0,
      spareTotal: 0,
      setSucceedState: false,
      notYetSetQaState: false,
      hasSetting: false,
      hasQAList: false,
      backmini: null,
      cardType: '3d',
      firmId: 0
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    document.title = '设置智能对话';
    console.log('%c⧭', 'color: #917399;font-size:100px', document.title);
    console.log('%c⧭', 'color: #994d75;font-size:90px', this.modelViewId);
    console.log('route history', this.$router);
    this.getFigureList();
    this.getFirmId();
  },
  destroyed: function destroyed() {},
  created: function created() {
    var item = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.backmini = item.backmini;
    this.imageShow = item.image_show;
    this.cardType = item.type;
    this.modelViewId = Number(item.id);
    this.componentsState = item.startPage || 'set';
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      console.log('-----------before router enter');
      console.log(to);
      console.log(from);
    });
  },

  methods: {
    getFirmId: function getFirmId() {
      var _this = this;

      if (this.cardType == '3d') {

        Object(api["t" /* modelView */])(this.modelViewId).then(function (res) {
          _this.firmId = res.data.image.company_id;
        });
      } else if (this.cardType == '2d') {

        Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
          _this.firmId = res.data.card.company_id;
        });
      }
    },
    backShare: function backShare() {
      this.$wechat.miniProgram.navigateBack();
    },
    backPreview: function backPreview() {
      this.notYetSetQaState = false;
      localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_ID, this.modelViewId);

      if (this.cardType == '2d') {
        this.$router.push({ path: '/TwoD',
          query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), image_show: this.imageShow, type: '2d' } });
      } else if (this.cardType == '3d') {
        this.$router.push({ path: '/ThreeD',
          query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), image_show: this.imageShow, type: '3d' } });
      }
    },
    getFigureList: function getFigureList() {
      var _this2 = this;

      console.log("--------------------------set com getFigureList");
      Object(utils["a" /* createRequest */])("get", "applet/user/image/list", { page: 1, num: 100, status: 3 }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.spareList = res.data.data;
          _this2.spareTotal = res.data.total;
        } else {
          console.error(res.msg);
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    selectSpare: function selectSpare(data) {
      console.log("select spare", data);
      this.modelViewId = data.id;
      this.getFirmId();
    },
    getMovementTone: function getMovementTone() {
      var _this3 = this;

      var spare = this.spareList.find(function (spare) {
        return spare.id == _this3.modelViewId;
      });
      console.log("当前分身:", spare);
      spare && config(spare.version).then(function (res) {
        _this3.toneList = res.data.audio_timbre_map[String(spare.gender)];
      });
    },
    onInteractionSet: function onInteractionSet(e) {
      this.componentsState = e;
    },
    onAQListChange: function onAQListChange(event) {
      console.log('qa list change', event);
    },
    onSpareInfoChange: function onSpareInfoChange(e) {
      console.log('onSpareInfoChange', e);
      if (e.clearSetting) {
        this.hasSetting = true;
        return;
      } else if (e.clearQA) {
        this.hasQAList = true;
        return;
      } else {
        if (this.cardType == '3d') {
          this.hasSetting = e.image.greet.length > 0 && e.image.audio_timbre > 0;
          this.hasQAList = e.qa_count > 0;
        } else if (this.cardType == '2d') {
          this.hasSetting = e.card.greet.length > 0 && e.card.chat_audio_timbre > 0;
          this.hasQAList = e.qa_count > 0;
        }
      }
    },
    onSaveSetRouter: function onSaveSetRouter(e) {
      var _this4 = this;

      if (e.modelViewId == this.modelViewId) {
        this.hasSet = e.greet && e.greet.length;
      }
      if (this.cardType == '3d') {

        Object(api["t" /* modelView */])(this.modelViewId).then(function (res) {
          if (res.data.qa_count == 0) {
            _this4.notYetSetQaState = true;
          } else {
            _this4.setSucceedState = true;
          }
        });
      } else if (this.cardType == '2d') {

        Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
          if (res.data.qa_count == 0) {
            _this4.notYetSetQaState = true;
          } else {
            _this4.setSucceedState = true;
          }
        });
      }
    },
    onAddQuestions: function onAddQuestions(event) {
      this.switchPage('qa');
      console.log("%c⧭", "color: #ffa640", this.componentsState);
    },
    onAddSaveRouter: function onAddSaveRouter(event) {
      this.switchPage(event);
      this.addSaveRouter = this.addSaveRouter + 1;
      console.log("%c⧭", "color: #ffa640", this.componentsState);
    },
    switchPage: function switchPage(page) {
      this.preComponentsState = this.componentsState;
      this.componentsState = page;
      console.log('switch page', page);
      switch (page) {
        case '':
          document.title = this.currentHumanName;
          break;
        case 'costume':
        case 'qa':
          document.title = '问答';
          break;
        case 'set':
          document.title = '设置';
          break;

      }
    },
    onBack: function onBack(event) {

      console.log('----back', this.componentsState);
      if (event == 'preview') {
        this.backPreview();
      } else if (this.componentsState == 'qa') {
        //当前是新建QA页面，返回QA列表
        this.switchPage('costume');
      } else if (this.backmini) {
        //返回微信
        this.$wechat.miniProgram.navigateBack();
      } else {
        this.$router.back();
      }
    },
    onCloseSetModel: function onCloseSetModel(e) {
      this.switchPage("");
      this.componentsState = '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SetQaPage.vue













/* harmony default export */ var selectortype_script_index_0_src_components_SetQaPage = ({
  name: 'SetQaPage',
  components: {
    ThreeSet: src_myComponents_setThreeCom_setThreeCom,
    QAComponent: src_myComponents_QAComponent_QAComponent,
    AddQa: src_myComponents_AddQa_AddQa,
    HumanList: src_myComponents_HumanList_HumanList,
    Badge: vux_src_components_badge,
    FirmData: src_myComponents_Firm_FirmData
  },
  props: {},
  data: function data() {
    return {
      preComponentsState: "",
      componentsState: "", //页面 ''-主页 costume-问答库 qa-新建问答 set-设置
      imageShow: "0",
      addSaveRouter: 1,
      spareList: [],
      modelViewId: 0,
      spareTotal: 0,
      setSucceedState: false,
      notYetSetQaState: false,
      hasSetting: false,
      hasQAList: false,
      backmini: null,
      cardType: '3d',
      firmId: 0
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    document.title = '设置智能对话';
    console.log('%c⧭', 'color: #917399;font-size:100px', document.title);
    console.log('%c⧭', 'color: #994d75;font-size:90px', this.modelViewId);
    console.log('route history', this.$router);
    this.getFigureList();
    this.getFirmId();
  },
  destroyed: function destroyed() {},
  created: function created() {
    var item = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.backmini = item.backmini;
    this.imageShow = item.image_show;
    this.cardType = item.type;
    this.modelViewId = Number(item.id);
    this.componentsState = item.startPage || 'set';
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      console.log('-----------before router enter');
      console.log(to);
      console.log(from);
    });
  },

  methods: {
    getFirmId: function getFirmId() {
      var _this = this;

      if (this.cardType == '3d') {

        Object(api["t" /* modelView */])(this.modelViewId).then(function (res) {
          _this.firmId = res.data.image.company_id;
        });
      } else if (this.cardType == '2d') {

        Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
          _this.firmId = res.data.card.company_id;
        });
      }
    },
    backShare: function backShare() {
      this.$wechat.miniProgram.navigateBack();
    },
    backPreview: function backPreview() {
      this.notYetSetQaState = false;
      localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_ID, this.modelViewId);

      if (this.cardType == '2d') {
        this.$router.push({ path: '/TwoD',
          query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), image_show: this.imageShow, type: '2d' } });
      } else if (this.cardType == '3d') {
        this.$router.push({ path: '/ThreeD',
          query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), image_show: this.imageShow, type: '3d' } });
      }
    },
    getFigureList: function getFigureList() {
      var _this2 = this;

      console.log("--------------------------set com getFigureList");
      Object(utils["a" /* createRequest */])("get", "applet/user/image/list", { page: 1, num: 100, status: 3 }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.spareList = res.data.data;
          _this2.spareTotal = res.data.total;
        } else {
          console.error(res.msg);
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    selectSpare: function selectSpare(data) {
      console.log("select spare", data);
      this.modelViewId = data.id;
      this.getFirmId();
    },
    getMovementTone: function getMovementTone() {
      var _this3 = this;

      var spare = this.spareList.find(function (spare) {
        return spare.id == _this3.modelViewId;
      });
      console.log("当前分身:", spare);
      spare && config(spare.version).then(function (res) {
        _this3.toneList = res.data.audio_timbre_map[String(spare.gender)];
      });
    },
    onInteractionSet: function onInteractionSet(e) {
      this.componentsState = e;
    },
    onAQListChange: function onAQListChange(event) {
      console.log('qa list change', event);
    },
    onSpareInfoChange: function onSpareInfoChange(e) {
      console.log('onSpareInfoChange', e);
      if (e.clearSetting) {
        this.hasSetting = true;
        return;
      } else if (e.clearQA) {
        this.hasQAList = true;
        return;
      } else {
        if (this.cardType == '3d') {
          this.hasSetting = e.image.greet.length > 0 && e.image.audio_timbre > 0;
          this.hasQAList = e.qa_count > 0;
        } else if (this.cardType == '2d') {
          this.hasSetting = e.card.greet.length > 0 && e.card.chat_audio_timbre > 0;
          this.hasQAList = e.qa_count > 0;
        }
      }
    },
    onSaveSetRouter: function onSaveSetRouter(e) {
      var _this4 = this;

      if (e.modelViewId == this.modelViewId) {
        this.hasSet = e.greet && e.greet.length;
      }
      if (this.cardType == '3d') {

        Object(api["t" /* modelView */])(this.modelViewId).then(function (res) {
          if (res.data.qa_count == 0) {
            _this4.notYetSetQaState = true;
          } else {
            _this4.setSucceedState = true;
          }
        });
      } else if (this.cardType == '2d') {

        Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
          if (res.data.qa_count == 0) {
            _this4.notYetSetQaState = true;
          } else {
            _this4.setSucceedState = true;
          }
        });
      }
    },
    onAddQuestions: function onAddQuestions(event) {
      this.switchPage('qa');
      console.log("%c⧭", "color: #ffa640", this.componentsState);
    },
    onAddSaveRouter: function onAddSaveRouter(event) {
      this.switchPage(event);
      this.addSaveRouter = this.addSaveRouter + 1;
      console.log("%c⧭", "color: #ffa640", this.componentsState);
    },
    switchPage: function switchPage(page) {
      this.preComponentsState = this.componentsState;
      this.componentsState = page;
      console.log('switch page', page);
      switch (page) {
        case '':
          document.title = this.currentHumanName;
          break;
        case 'costume':
        case 'qa':
          document.title = '问答';
          break;
        case 'set':
          document.title = '设置';
          break;

      }
    },
    onBack: function onBack(event) {

      console.log('----back', this.componentsState);
      if (event == 'preview') {
        this.backPreview();
      } else if (this.componentsState == 'qa') {
        //当前是新建QA页面，返回QA列表
        this.switchPage('costume');
      } else if (this.backmini) {
        //返回微信
        this.$wechat.miniProgram.navigateBack();
      } else {
        this.$router.back();
      }
    },
    onCloseSetModel: function onCloseSetModel(e) {
      this.switchPage("");
      this.componentsState = '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9bd7c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SetQaPage.vue
var SetQaPage_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SetQaPage"},[(_vm.imageShow == 1 && _vm.componentsState != 'qa')?_c('div',[_c('human-list',{attrs:{"backGround":'#2c2d42',"list":_vm.spareList,"isAddSpare":false,"modelID":_vm.modelViewId},on:{"selectSpare":_vm.selectSpare}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.componentsState != 'qa'),expression:"componentsState != 'qa'"}],staticClass:"set-qa-three-page-top-tab"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","width":"100%"}},[_c('div',{class:_vm.componentsState == 'set' ? 'active' : 'tab-name-hint-active',on:{"click":function($event){return _vm.onInteractionSet('set')}}},[_vm._v("\n          对话\n            "),_c('badge',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasSetting),expression:"!hasSetting"}],staticClass:"my-badge"})],1),_vm._v(" "),_c('div',{class:_vm.componentsState == 'costume' || _vm.componentsState == 'firm' ? 'active' : 'tab-name-hint-active',on:{"click":function($event){return _vm.onInteractionSet('costume')}}},[_vm._v("\n            问答\n            "),_c('badge',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasQAList),expression:"!hasQAList"}],staticClass:"my-badge"})],1)]),_vm._v(" "),(_vm.componentsState == 'costume' || _vm.componentsState == 'firm')?_c('div',{staticClass:"personage-firm-add-qa-box"},[_c('div',{staticClass:"personage-firm-box"},[_c('div',{class:_vm.componentsState == 'costume' ? 'personage-text-active' : 'personage-text',on:{"click":function($event){return _vm.onInteractionSet('costume')}}},[_vm._v("个人资料库")]),_vm._v(" "),(_vm.firmId > 0)?_c('div',{class:_vm.componentsState == 'firm' ? 'personage-text-active' : 'personage-text',on:{"click":function($event){return _vm.onInteractionSet('firm')}}},[_vm._v("企业资料库")]):_vm._e()]),_vm._v(" "),(_vm.componentsState == 'costume')?_c('div',{staticClass:"zgq-add-qa-button",on:{"click":_vm.onAddQuestions}},[_vm._v("新建问答")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"set-qa-three-page-implant"},[_c('ThreeSet',{directives:[{name:"show",rawName:"v-show",value:(_vm.componentsState == 'set'),expression:"componentsState == 'set'"}],staticStyle:{"margin-top":"10px"},attrs:{"modelID":_vm.modelViewId,"cardTypeIs":_vm.cardType,"firmIdBol":_vm.firmId},on:{"onSaveSetRouter":_vm.onSaveSetRouter,"onBack":_vm.onBack,"onCloseSetModel":_vm.onCloseSetModel,"onSpareInfoChange":_vm.onSpareInfoChange}}),_vm._v(" "),_c('QAComponent',{directives:[{name:"show",rawName:"v-show",value:(_vm.componentsState == 'costume'),expression:"componentsState == 'costume'"}],attrs:{"addSaveRouterIs":_vm.addSaveRouter,"modelID":_vm.modelViewId,"cardTypeIs":_vm.cardType},on:{"onAddQuestions":_vm.onAddQuestions,"onBack":_vm.onBack,"onSpareInfoChange":_vm.onSpareInfoChange}}),_vm._v(" "),(_vm.componentsState == 'qa')?_c('AddQa',{attrs:{"modelID":_vm.modelViewId,"cardTypeIs":_vm.cardType},on:{"onAddSaveRouter":_vm.onAddSaveRouter,"onBack":_vm.onBack}}):_vm._e(),_vm._v(" "),_c('FirmData',{directives:[{name:"show",rawName:"v-show",value:(_vm.componentsState == 'firm' && _vm.firmId > 0),expression:"componentsState == 'firm' && firmId > 0"}],attrs:{"companyID":_vm.firmId},on:{"onBack":_vm.onBack}})],1),_vm._v(" "),(_vm.setSucceedState)?_c('div',{staticClass:"hint-purchase-message-model"},[_c('div',{staticClass:"hint-no-purchase-message-box"},[_c('div',{staticClass:"set-succeed-text-zgq"},[_vm._v("设置成功")]),_vm._v(" "),_c('div',{staticClass:"no-button-two-zgq"},[_c('div',{staticClass:"no-go-set-button-yulan",on:{"click":_vm.backPreview}},[_vm._v("\n            预览效果\n          ")]),_vm._v(" "),_c('div',{staticClass:"no-go-set-button",staticStyle:{"margin-left":"10px"},on:{"click":_vm.backShare}},[_vm._v("\n            返回分享\n          ")])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"0px","top":"0px","padding":"10px"}},[_c('img',{staticStyle:{"width":"15px","height":"15px"},attrs:{"src":"/static/img/audioDelete.png","alt":""},on:{"click":function (){this$1.setSucceedState = false}}})])])]):_vm._e(),_vm._v(" "),(_vm.notYetSetQaState)?_c('div',{staticClass:"hint-purchase-message-model"},[_c('div',{staticClass:"hint-no-purchase-message-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"no-button-two-zgq"},[_c('div',{staticClass:"no-zgq-left-button",on:{"click":_vm.backPreview}},[_vm._v("\n            预览效果\n          ")]),_vm._v(" "),_c('div',{staticClass:"no-go-set-button",on:{"click":function($event){_vm.switchPage('costume');_vm.notYetSetQaState=false}}},[_vm._v("\n            去设置\n          ")])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"0px","top":"0px","padding":"10px"}},[_c('img',{staticStyle:{"width":"15px","height":"15px"},attrs:{"src":"/static/img/audioDelete.png","alt":""},on:{"click":function($event){_vm.notYetSetQaState=false}}})])])]):_vm._e()])}
var SetQaPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-box"},[_c('div',{staticClass:"one-text"},[_vm._v("\n        您尚未设置互动问题 \n        ")]),_vm._v(" "),_c('div',{staticClass:"two-text"},[_vm._v("\n          为保证更好的互动效果，建议您前去设置\n        ")])])}]
var SetQaPage_esExports = { render: SetQaPage_render, staticRenderFns: SetQaPage_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_SetQaPage = (SetQaPage_esExports);
// CONCATENATED MODULE: ./src/components/SetQaPage.vue
function SetQaPage_injectStyle (ssrContext) {
  __webpack_require__("k3w1")
}
var SetQaPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SetQaPage___vue_template_functional__ = false
/* styles */
var SetQaPage___vue_styles__ = SetQaPage_injectStyle
/* scopeId */
var SetQaPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SetQaPage___vue_module_identifier__ = null
var SetQaPage_Component = SetQaPage_normalizeComponent(
  selectortype_script_index_0_src_components_SetQaPage,
  selectortype_template_index_0_src_components_SetQaPage,
  SetQaPage___vue_template_functional__,
  SetQaPage___vue_styles__,
  SetQaPage___vue_scopeId__,
  SetQaPage___vue_module_identifier__
)

/* harmony default export */ var src_components_SetQaPage = (SetQaPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/PageVisible/PageVisible.vue



/* harmony default export */ var PageVisible = ({
  name: "PageVisible",
  components: {},
  props: {
    AppID: String
  },
  data: function data() {
    return {
      lastStartTime: 0
    };
  },
  mounted: function mounted() {
    document.addEventListener('visibilitychange', this.handleVisiable);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisiable);
  },

  methods: {
    handleVisiable: function handleVisiable(e) {
      if (e.target.visibilityState === 'visible') {

        console.log('visible', Date.now(), this.AppID);
        if (this.AppID && this.AppID.length > 0 && Date.now() - this.lastStartTime >= 15 * 60000) {
          //超过20分钟重新启动服务
          Object(api["e" /* chatServiceStart */])(this.AppID).then(function (prce) {
            console.log('%c⧭', 'color: #ace2e6', prce);
            if (prce.code == 500) {
              Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (val) {
                console.log('%c⧭', 'color: #ace2e6', val);
              });
            }
          });
        }
        this.lastStartTime = Date.now();
      }
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/PageVisible/PageVisible.vue



/* harmony default export */ var PageVisible_PageVisible = ({
  name: "PageVisible",
  components: {},
  props: {
    AppID: String
  },
  data: function data() {
    return {
      lastStartTime: 0
    };
  },
  mounted: function mounted() {
    document.addEventListener('visibilitychange', this.handleVisiable);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisiable);
  },

  methods: {
    handleVisiable: function handleVisiable(e) {
      if (e.target.visibilityState === 'visible') {

        console.log('visible', Date.now(), this.AppID);
        if (this.AppID && this.AppID.length > 0 && Date.now() - this.lastStartTime >= 15 * 60000) {
          //超过20分钟重新启动服务
          Object(api["e" /* chatServiceStart */])(this.AppID).then(function (prce) {
            console.log('%c⧭', 'color: #ace2e6', prce);
            if (prce.code == 500) {
              Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (val) {
                console.log('%c⧭', 'color: #ace2e6', val);
              });
            }
          });
        }
        this.lastStartTime = Date.now();
      }
    }
  },
  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b870a40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/PageVisible/PageVisible.vue
var PageVisible_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageVisible"})}
var PageVisible_staticRenderFns = []
var PageVisible_esExports = { render: PageVisible_render, staticRenderFns: PageVisible_staticRenderFns }
/* harmony default export */ var myComponents_PageVisible_PageVisible = (PageVisible_esExports);
// CONCATENATED MODULE: ./src/myComponents/PageVisible/PageVisible.vue
function PageVisible_injectStyle (ssrContext) {
  __webpack_require__("lU6p")
}
var PageVisible_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageVisible___vue_template_functional__ = false
/* styles */
var PageVisible___vue_styles__ = PageVisible_injectStyle
/* scopeId */
var PageVisible___vue_scopeId__ = "data-v-3b870a40"
/* moduleIdentifier (server only) */
var PageVisible___vue_module_identifier__ = null
var PageVisible_Component = PageVisible_normalizeComponent(
  PageVisible_PageVisible,
  myComponents_PageVisible_PageVisible,
  PageVisible___vue_template_functional__,
  PageVisible___vue_styles__,
  PageVisible___vue_scopeId__,
  PageVisible___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_PageVisible_PageVisible = (PageVisible_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloFromVux.vue






var _showWebglStats$compo;














































var HelloFromVux_recorder = null;
var HelloFromVux_param = Object(utils["c" /* getUrlParams */])(window.location.href);
/* harmony default export */ var components_HelloFromVux = (_showWebglStats$compo = {
  showWebglStats: false,
  components: {
    XButton: x_button["a" /* default */],
    VueSlickCarousel: vue_slick_carousel_umd_default.a,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    Loading: loading["a" /* default */],
    Countdown: vux_src_components_countdown,
    InlineLoading: inline_loading["a" /* default */],
    Chatframe: Chatframe["a" /* default */],
    QAComponent: src_myComponents_QAComponent_QAComponent,
    AddQa: src_myComponents_AddQa_AddQa,
    Popup: node_modules_vux_src_components_popup,
    HumanList: src_myComponents_HumanList_HumanList,
    Badge: vux_src_components_badge,
    ChatInput: src_myComponents_ChatInput_ChatInput,
    SetThreeCom: src_myComponents_setThreeCom_setThreeCom,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel,
    AwaitReplyModel: src_myComponents_awaitReplyModel_awaitReplyModel,
    PageVisible: src_myComponents_PageVisible_PageVisible,
    CharacterInsufficient: src_myComponents_characterInsufficient_characterInsufficient,
    ToneModel: src_myComponents_ToneModel_ToneModel,
    EditTextModal: src_myComponents_EditTextModal_EditTextModal
  },
  data: function data() {
    return {
      msg: "Hello World!",
      isLoading: false,
      loadPercent: "0%",
      settings: {
        focusOnSelect: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 120
      },
      list: [],
      clickCostumeId: 0,
      modelViewId: 0,
      value: "",
      inputCostumeShow: false,
      cutRecordState: false,
      myChatVoiceBlob: undefined,
      robotChatMessageType: "1", //内容类型
      imageUrl: "/static/img/play_icon.png", //机器人回复图片地址
      downloadUrl: "https://www.baidu.com/", //机器人回复下载查看地址
      linkUrl: "https://www.baidu.com/", //机器人回复超链接地址
      robotMessageTotal: "", //将要显示的所有聊天信息
      robotChatDisplayIndex: 0,
      chatTimeHandler: undefined, //聊天显示定时器
      robotVoiceDuration: 0,

      changeButtonText: "聊天",
      imgVoiceUrl: voice_default.a,
      imgCostumeUrl: costume_default.a,
      imgMicUrl: mic_default.a,
      imgMicLoadUrl: mic_load_default.a,
      imgRecordingUrl: recording_default.a,
      imgPlayUrl: play_default.a,
      imgPlayActiveUrl: play_active_default.a,
      playState: false,
      movementList: [], //动作
      voiceContentList: [],
      preComponentsState: "",
      componentsState: "", //页面 ''-主页 costume-问答库 qa-新建问答 set-设置
      fixationHeight: 1,
      packUnfoldHeight: 0,
      isDisplayDebug: false,
      showDebug: false,
      packUnfoldBlo: true,
      packUnfoldState: true,
      preinstallList: [],
      virtualHumanGender: 0,
      clothingShow: false,
      clothingWhetherSelect: false,
      clothingList: [],
      debugInfo: {
        modelID: 1,
        errorMessage: "",
        appID: ""
      },
      lastClickType: "",
      addSaveRouter: 0,
      spareList: [],
      currentHumanName: '',
      hasQAList: true,
      hasSet: true,
      isMyself: false,
      curAppID: '',
      purchaseModelIsopen: false,
      isChatGPT: false,
      imageType: 0,
      awaitReply: false,
      actionMaps: {},
      defaultChatAction: '',
      isHasConsume: false,
      robberPurchase: false,
      editStateIsOpen: false,
      textareaValue: "",
      firmId: 0, // 企业id,
      closeShareImageState: false, //分享图的显示状态
      activeEnableInput: true
    };
  },

  watch: {
    value: function value(_value) {},
    voiceContentList: function voiceContentList(value) {
      if (this.packUnfoldState) {
        this.clothingShow = false;
      }

      console.log("%c⧭", "color: #e57373", value);
    },
    clothingShow: function clothingShow(val) {
      console.log('衣服选择隐藏:', val);
      if (!val) {
        //衣服模态框隐藏 隐藏保存按钮，显示聊天框
        this.packUnfoldBlo = true;
        this.clothingWhetherSelect = false;
        this.packUnfoldState = true;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      console.log('-----------before router enter');
      console.log(to);
      console.log(from);
    });
  },
  created: function created() {},
  mounted: function mounted() {
    var _this2 = this;

    console.log('route history', this.$router);
    var param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.imageType = param.type == '3d' ? 1 : '';
    console.log('%c⧭', 'color: #00a3cc', param);
    src_S51WebGLSDK["a" /* default */].initSDK(document.querySelector(".top-box"), 0x616e75, {
      token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN),
      helper: param.helper
    }, "development" == "production");

    this.curPage = 0;
    this.isDisplayDebug = "development" == "production";

    this.getCostume(localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID), true).then(function () {
      if (_this2.isMyself) _this2.getImageList();
      _this2.$forceUpdate();
    });
    Object(api["u" /* qaList */])(localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID), param.type).then(function (d) {
      _this2.hasQAList = d.data.total > 0;
    });

    window.addEventListener("popstate", function (e) {
      console.log('回退事件', e);
    }, false);

    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, function (param) {
      console.log('收到 enable input  消息', param);
      _this2.activeEnableInput = param.enable;
    });

    this.errorCount = 0;
    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ADD_LOG, function (param) {
      if (_this2.errorCount >= 10) {
        _this2.debugInfo.errorMessage = "";
      }
      _this2.debugInfo.errorMessage += '\r\n' + param;
      _this2.errorCount++;
    });
  },
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy ');
    src_S51WebGLSDK["a" /* default */].stopNowVoice();
    src_S51WebGLSDK["a" /* default */].clearCache();
  }
}, defineProperty_default()(_showWebglStats$compo, "created", function created() {}), defineProperty_default()(_showWebglStats$compo, "methods", {
  onCloseShareImage: function onCloseShareImage() {
    this.closeShareImageState = false;
  },
  onPatternSetFinish: function onPatternSetFinish(e) {
    this.isChatGPT = e;
  },
  informEditModal: function informEditModal(e) {
    this.editStateIsOpen = e.open;
    this.textareaValue = e.text;
  },
  onCloseEditModal: function onCloseEditModal() {
    this.editStateIsOpen = false;
  },
  onSaveEditTextModal: function onSaveEditTextModal(e) {
    var _this3 = this;

    Object(api["w" /* setImage */])({
      image_id: this.modelViewId,
      greet: e
    }).then(function (d) {
      _this3.$vux.toast.show({
        type: "text",
        text: "保存成功"
      });
      _this3.editStateIsOpen = false;
      _this3.$refs.myChatFrame.updateHelloWord(e);
    }, function (e) {
      console.error(e);
      _this3.$vux.toast.show({
        type: "text",
        text: e
      });
    });
  },
  onFreeOfCharge: function onFreeOfCharge(e) {
    this.robberPurchase = e;
  },
  onCharge: function onCharge(e) {
    this.robberPurchase = false;
    this.purchaseModelIsopen = true;
    this.awaitReply = false;
  },
  onChatLeftNotEnough: function onChatLeftNotEnough() {
    if (this.isMyself) {
      this.awaitReply = false;
      this.robberPurchase = true;
    }
  },
  debugClick: function debugClick() {
    console.log('---debug click');
    this.showWebglStats = !this.showWebglStats;
    src_S51WebGLSDK["a" /* default */].showStats(this.showWebglStats);

    if (false) {
      this.showDebug = !this.showDebug;
    }
  },
  getImageList: function getImageList() {
    var _this4 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(api["s" /* imageList */])();

            case 2:
              res = _context.sent;

              _this4.spareList = res.data.data;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  },
  onChatListChange: function onChatListChange(value) {
    this.voiceContentList = value;

    if (!this.packUnfoldBlo) {
      this.packUnfoldBlo = true;
      this.packUnfoldState = true;
      this.clothingShow = false;
      this.clothingWhetherSelect = false;
    }
  },
  onSaveVirtualHuman: function onSaveVirtualHuman() {
    var _this5 = this;

    if (this.isLoading || !this.activeEnableInput) {
      return;
    }

    this.$vux.loading.show({
      text: '正在保存形象'
    });
    src_S51WebGLSDK["a" /* default */].downloadCanvasImg(function (err, blobData) {
      console.log('----截图', blobData);
      if (err) {
        _this5.$vux.loading.hide();
        return _this5.$vux.toast.show({
          type: 'text',
          text: '形象保存失败，请重试'
        });
      }
      var file = new File([blobData], 'screenshot.png', { type: 'image/png' });
      uploadQiniu(file, 'png', function (process) {}, function (err, res) {
        console.log('上传', err, res);
        if (err) {
          _this5.$vux.loading.hide();
          return _this5.$vux.toast.show({
            type: 'text',
            text: '形象保存失败，请重试'
          });
        }
        Object(api["w" /* setImage */])({
          image_id: _this5.modelViewId,
          show_clothes_id: _this5.clickCostumeId,
          generate_cover: res.key
        }).then(function (d) {
          _this5.$vux.toast.show({
            type: "text",
            text: "保存成功"
          });
          _this5.$vux.loading.hide();
          _this5.clothingShow = false;
          _this5.clothingWhetherSelect = false;
        }, function (e) {
          console.error(e);
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: "text",
            text: e
          });
        });
      });
    });

    this.clothingWhetherSelect = false;
  },
  onPackUnfold: function onPackUnfold() {
    this.packUnfoldBlo = !this.packUnfoldBlo;
    this.packUnfoldState = !this.packUnfoldState;
    if (this.packUnfoldState) {
      //显示对话窗口则隐藏换装窗口
      this.clothingShow = false;
      this.clothingWhetherSelect = false;
    }
  },
  openPDF: function openPDF() {

    this.$wechat.miniProgram.navigateTo({
      url: "../documentView/documentView?url=" + encodeURIComponent('http://api.wangyi.talent666.top/assets/wangyi-tutorial.pdf'),
      success: function success() {
        console.log('跳转成功');
      }
    });
  },
  showLoading: function showLoading() {
    this.loadPercent = '0%';
    this.isLoading = true;
  },
  closeLoading: function closeLoading() {
    console.log('loading finished');

    this.loadPercent = "Loaded";
    this.isLoading = false;
  },
  onCutInputButton: function onCutInputButton() {
    if (this.isLoading) {
      return;
    }
    this.clickCostumeId = 0;
    this.inputCostumeShow = !this.inputCostumeShow;
    if (this.inputCostumeShow) {
      this.changeButtonText = "换装";
    } else {
      this.changeButtonText = "聊天";
    }
    src_S51WebGLSDK["a" /* default */].resetHumanPosition();
    console.log("%c⧭", "color: #ff0000", 111);
  },
  onSelectCostume: function onSelectCostume(item) {
    var _this6 = this;

    if (this.isLoading || !this.activeEnableInput) {
      return;
    }
    if (this.clickCostumeId == item.id) return;
    this.clickCostumeId = item.id;
    this.clothingWhetherSelect = true;
    this.packUnfoldBlo = false;
    console.log("%c⧭", "color: #00e600", item);
    this.showLoading();
    src_S51WebGLSDK["a" /* default */].loadAndCLoth(item.file_glb, function (process) {
      _this6.loadPercent = Math.floor(process.percent) + "%";
    }, function (err, result) {
      if (err) {
        console.error(err);
        _this6.closeLoading();
      } else {
        _this6.closeLoading();
      }
    });
  },
  sendWord2Human: function sendWord2Human(myChatMessage) {
    var _this7 = this;

    this.awaitReply = true;
    this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, myChatMessage, this.cardID).then(function (d) {
      _this7.debugInfo.chatType = d.data.chat_type;
      _this7.debugInfo.word = d.data.word;
      if (_this7.isChatGPT) _this7.isHasConsume = true;
    }, function (err) {
      _this7.debugInfo.errorMessage = err;
    }).finally(function () {
      _this7.awaitReply = false;
    });
  },
  onInputEndRecordAudio: function onInputEndRecordAudio(data) {
    var _this8 = this;

    console.log('结束录音', data);
    this.awaitReply = true;
    this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].VOICE, {
      voiceUrl: data.voiceUrl,
      voiceSendData: data.voiceSendData,
      voiceHttpUrl: data.voiceHttpUrl,
      duration: data.duration
    }, this.cardID).then(function (d) {}, function (err) {
      _this8.debugInfo.errorMessage = err;
    }).finally(function () {
      _this8.awaitReply = false;
    });
  },
  getCostume: function getCostume(modelID) {
    var _this9 = this;

    return new promise_default.a(function (resolve, reject) {
      _this9.modelViewId = Number(modelID);
      _this9.debugInfo.modelID = modelID;

      _this9.showLoading();
      Object(utils["a" /* createRequest */])("get", "applet/webview/model_view", { image_id: _this9.modelViewId }, function (res) {
        console.log("%c⧭", "color: #d90000", res);
        if (res.code == 200) {
          document.title = res.data.image.name;
          console.log("%c⧭", "color: #ffa640", res.data.clothes_map);
          _this9.preinstallList = res.data.qa_list.data;
          _this9.virtualHumanGender = res.data.app_info.gender;
          _this9.clothingList = res.data.clothes_map;
          _this9.clickCostumeId = res.data.image.show_clothes_id;
          _this9.debugInfo.appID = res.data.app_info.app_id;
          _this9.curAppID = res.data.app_info.app_id;
          localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.image.name);
          _this9.isMyself = res.data.image.uid == res.data.uid;
          _this9.firmId = res.data.image.company_id;
          var _param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
          _this9.cardID = _param.cardId;
          console.log('----------------------cardID', _this9.cardID);
          Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (prce) {
            console.log('%c⧭', 'color: #ace2e6', prce);
            if (prce.code == 500) {
              Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (val) {
                console.log('%c⧭', 'color: #ace2e6', val);
              });
            }
          });

          console.log("%c⧭", "color: #997326", res.data.image.action_id, _this9.clickCostumeId);
          src_S51WebGLSDK["a" /* default */].resetAppID(res.data.app_info.app_id);
          _this9.isChatGPT = res.data.image.chat_type == 2;

          _this9.currentHumanName = res.data.image.name;
          _this9.list = res.data.clothes_map;
          _this9.hasSet = res.data.image.greet && res.data.image.greet != '';
          var changeClothes = [];
          if (res.data.image.show_clothes_id) {
            var cloth = res.data.clothes_map.find(function (ele) {
              return ele.id == res.data.image.show_clothes_id;
            });
            changeClothes = cloth ? cloth.file_glb : [];
          }
          var actions = [];
          var chatActionMaps = new map_default.a();
          if (res.data.action_wait) {
            actions.push(res.data.action_wait.fbx_url_qa);
            chatActionMaps[res.data.action_wait.value] = res.data.action_wait.fbx_url_qa;
          }
          if (res.data.action_interact) {
            actions.push(res.data.action_interact.fbx_url_qa);
            chatActionMaps[res.data.action_interact.value] = res.data.action_interact.fbx_url_qa;
            _this9.defaultChatAction = res.data.action_interact.value;
          }
          var acionMap = res.data.action_map;

          console.log('acionMap', acionMap);
          acionMap && acionMap && acionMap.forEach(function (action) {
            actions.push(action.fbx_url);
            chatActionMaps[action.value] = action.fbx_url_qa;
          });
          _this9.actionMaps = chatActionMaps;
          var wordVoice = void 0;
          if (res.data.image.greet && res.data.image.greet.length > 0) {
            Object(api["g" /* chatWordToVoice */])(res.data.image.greet, _this9.curAppID).then(function (voiceRes) {
              if (res.code == 200) {
                wordVoice = voiceRes.data;
              }
            });
          }

          src_S51WebGLSDK["a" /* default */].loadHuman(res.data.image.model_url, res.data.image.clothes_name_list, res.data.hdr, changeClothes, //默认需要替换的服装
          actions, //所有需要提前加载的动作列表
          res.data.action_wait.fbx_url, // 'https://ad-qiniu-demo.studio51.com/F_HuXi_V2.0.10.fbx',//空闲动作
          {
            gender: res.data.image.gender
          }, function (process) {

            if (process.percent >= 100) {} else {
              _this9.loadPercent = Math.floor(process.percent) + '%';
            }
          }, function (err, result) {

            console.log(err, result, '123');
            if (err) {
              console.log('模型加载失败', err);
              _this9.debugInfo.errorMessage = '模型加载失败:' + err;
              _this9.closeLoading();
              _this9.$vux.toast.show({
                type: "text",
                text: '人物加载失败'
              });
            } else {

              if (res.data.image.greet && res.data.image.greet.length > 0) {

                var start_ = Date.now();
                var handler_ = setInterval(function () {
                  if (Date.now() - start_ > 5000) {
                    _this9.closeLoading();
                    return clearInterval(handler_);
                  }
                  if (wordVoice) {
                    _this9.closeLoading();
                    clearInterval(handler_);
                    _this9.sayHello(res.data.image.greet, wordVoice.audio, wordVoice.viseme, chatActionMaps[_this9.defaultChatAction], wordVoice.duration);
                  }
                }, 500);
              } else {
                _this9.closeLoading();
              }
            }
          });
        } else {

          _this9.closeLoading();
          console.error(res.msg);
          _this9.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
        resolve();
      });
    });
  },
  myMessagePlay: function myMessagePlay(e) {
    console.log("播放我的声音");
    var _this = this;
    if (this.myChatVoiceBlob) {
      var audio = new Audio(window.URL.createObjectURL(this.myChatVoiceBlob));
      audio.play();
      this.playState = true;
      audio.addEventListener("ended", function () {
        console.log("%c⧭", "color: #731d1d", 111111);
        _this.playState = false;
      }, false);
    }
  },
  finish: function finish(index) {
    this.onTouchend();

    console.log("current index", index);
  },
  onCostumeModel: function onCostumeModel(e) {
    if (this.isLoading || !this.activeEnableInput) {
      return;
    }
    this.clothingShow = !this.clothingShow;
    this.$refs.myChatFrame.stopNowVoice();
  },
  onQaModel: function onQaModel(e) {
    if (this.isLoading || !this.activeEnableInput) {
      return;
    }
    this.$router.push({
      path: '/setQaPage',
      query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), image_show: 1, startPage: 'costume', type: '3d' }
    });
  },
  onSetModel: function onSetModel(e) {
    this.closeShareImageState = true;
  },
  onUpChat: function onUpChat() {
    this.onSetModel();
  },
  onAddQuestions: function onAddQuestions(event) {
    this.switchPage('qa');
    console.log("%c⧭", "color: #ffa640", this.componentsState);
  },
  onAQListChange: function onAQListChange(event) {
    if (event.modelViewId == this.modelViewId) {
      this.hasQAList == event.total > 0;
    }
  },
  onAddSaveRouter: function onAddSaveRouter(event) {
    this.switchPage(event);
    this.addSaveRouter = this.addSaveRouter + 1;
    console.log("%c⧭", "color: #ffa640", this.componentsState);
  },
  onSaveSetRouter: function onSaveSetRouter(e) {
    this.switchPage("");
    if (e.modelViewId == this.modelViewId) {
      this.hasSet = e.greet && e.greet.length;
    }
  },
  onCloseSetModel: function onCloseSetModel(e) {
    this.switchPage("");
    this.componentsState = '';
  },
  switchPage: function switchPage(page) {
    var _this10 = this;

    this.preComponentsState = this.componentsState;
    this.componentsState = page;
    console.log('switch page', page);
    switch (page) {
      case '':
        document.title = this.currentHumanName;

        Object(api["u" /* qaList */])(this.modelViewId).then(function (d) {
          _this10.hasQAList = d.data.total > 0;
        });
        break;
      case 'costume':
      case 'qa':
        document.title = 'QA库';
        break;
      case 'set':
        document.title = '设置';
        break;

    }
  },
  selectSpare: function selectSpare(data) {
    var _this11 = this;

    if (this.isLoading) {
      return;
    }

    this.clothingShow = false;
    this.getCostume(data.id).then(function () {

      _this11.$refs.myChatFrame.clearChat();
    });
  },
  onAddSpare: function onAddSpare() {
    if (this.isLoading) {
      return;
    }
    this.$wechat.miniProgram.navigateTo({
      url: '../createFigure/createFigure',
      success: function success() {
        console.log('跳转成功');
      }
    });
  },
  onBack: function onBack(event) {
    console.log('----back', event);
    if (event == "home") {
      this.switchPage("");
    } else {
      this.switchPage(this.preComponentsState);
    }
  },
  sendPreQuestion: function sendPreQuestion(question) {
    var _this12 = this;

    console.log('发送预设问题:', question);

    if (this.isLoading) {
      return;
    }
    this.awaitReply = true;
    this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, question.question, this.cardID).then(function (d) {
      if (_this12.isChatGPT) _this12.isHasConsume = true;
    }, function (err) {
      _this12.debugInfo.errorMessage = err;
    }).finally(function () {
      _this12.awaitReply = false;
    });
  },
  sayHello: function sayHello(helloWord, helloAudio, helloVisem, action, duration) {
    this.$refs.myChatFrame.sayHello(helloWord, helloAudio, helloVisem, action, duration, this.isMyself);
  },
  onInputWordSend: function onInputWordSend(message) {
    console.log('send message', message);
    if (this.isLoading) {
      return;
    }
    if (!message || message.length == 0) {
      return;
    }
    this.sendWord2Human(message);
  },
  onInputStartRecordAudio: function onInputStartRecordAudio() {
    console.log('开始录音');
    src_S51WebGLSDK["a" /* default */].stopNowVoice();
  },
  informCancelPurchase: function informCancelPurchase(e) {
    this.purchaseModelIsopen = e;
  },
  informImmediatelyPurchase: function informImmediatelyPurchase(e) {
    if (e) {
      //充值成功
      this.purchaseModelIsopen = false;
      this.$vux.toast.show({
        type: "text",
        text: "充值成功"
      });
    }
  },
  onOpenChargeModel: function onOpenChargeModel() {
    this.purchaseModelIsopen = true;
    console.log('-----open charge');
  }
}), _showWebglStats$compo);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloFromVux.vue






var HelloFromVux__showWebglStats$compo;














































var components_HelloFromVux_recorder = null;
var components_HelloFromVux_param = Object(utils["c" /* getUrlParams */])(window.location.href);
/* harmony default export */ var selectortype_script_index_0_src_components_HelloFromVux = (HelloFromVux__showWebglStats$compo = {
  showWebglStats: false,
  components: {
    XButton: x_button["a" /* default */],
    VueSlickCarousel: vue_slick_carousel_umd_default.a,
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    XInput: x_input["a" /* default */],
    Group: group["a" /* default */],
    Loading: loading["a" /* default */],
    Countdown: vux_src_components_countdown,
    InlineLoading: inline_loading["a" /* default */],
    Chatframe: Chatframe["a" /* default */],
    QAComponent: src_myComponents_QAComponent_QAComponent,
    AddQa: src_myComponents_AddQa_AddQa,
    Popup: node_modules_vux_src_components_popup,
    HumanList: src_myComponents_HumanList_HumanList,
    Badge: vux_src_components_badge,
    ChatInput: src_myComponents_ChatInput_ChatInput,
    SetThreeCom: src_myComponents_setThreeCom_setThreeCom,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel,
    AwaitReplyModel: src_myComponents_awaitReplyModel_awaitReplyModel,
    PageVisible: src_myComponents_PageVisible_PageVisible,
    CharacterInsufficient: src_myComponents_characterInsufficient_characterInsufficient,
    ToneModel: src_myComponents_ToneModel_ToneModel,
    EditTextModal: src_myComponents_EditTextModal_EditTextModal
  },
  data: function data() {
    return {
      msg: "Hello World!",
      isLoading: false,
      loadPercent: "0%",
      settings: {
        focusOnSelect: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 120
      },
      list: [],
      clickCostumeId: 0,
      modelViewId: 0,
      value: "",
      inputCostumeShow: false,
      cutRecordState: false,
      myChatVoiceBlob: undefined,
      robotChatMessageType: "1", //内容类型
      imageUrl: "/static/img/play_icon.png", //机器人回复图片地址
      downloadUrl: "https://www.baidu.com/", //机器人回复下载查看地址
      linkUrl: "https://www.baidu.com/", //机器人回复超链接地址
      robotMessageTotal: "", //将要显示的所有聊天信息
      robotChatDisplayIndex: 0,
      chatTimeHandler: undefined, //聊天显示定时器
      robotVoiceDuration: 0,

      changeButtonText: "聊天",
      imgVoiceUrl: voice_default.a,
      imgCostumeUrl: costume_default.a,
      imgMicUrl: mic_default.a,
      imgMicLoadUrl: mic_load_default.a,
      imgRecordingUrl: recording_default.a,
      imgPlayUrl: play_default.a,
      imgPlayActiveUrl: play_active_default.a,
      playState: false,
      movementList: [], //动作
      voiceContentList: [],
      preComponentsState: "",
      componentsState: "", //页面 ''-主页 costume-问答库 qa-新建问答 set-设置
      fixationHeight: 1,
      packUnfoldHeight: 0,
      isDisplayDebug: false,
      showDebug: false,
      packUnfoldBlo: true,
      packUnfoldState: true,
      preinstallList: [],
      virtualHumanGender: 0,
      clothingShow: false,
      clothingWhetherSelect: false,
      clothingList: [],
      debugInfo: {
        modelID: 1,
        errorMessage: "",
        appID: ""
      },
      lastClickType: "",
      addSaveRouter: 0,
      spareList: [],
      currentHumanName: '',
      hasQAList: true,
      hasSet: true,
      isMyself: false,
      curAppID: '',
      purchaseModelIsopen: false,
      isChatGPT: false,
      imageType: 0,
      awaitReply: false,
      actionMaps: {},
      defaultChatAction: '',
      isHasConsume: false,
      robberPurchase: false,
      editStateIsOpen: false,
      textareaValue: "",
      firmId: 0, // 企业id,
      closeShareImageState: false, //分享图的显示状态
      activeEnableInput: true
    };
  },

  watch: {
    value: function value(_value) {},
    voiceContentList: function voiceContentList(value) {
      if (this.packUnfoldState) {
        this.clothingShow = false;
      }

      console.log("%c⧭", "color: #e57373", value);
    },
    clothingShow: function clothingShow(val) {
      console.log('衣服选择隐藏:', val);
      if (!val) {
        //衣服模态框隐藏 隐藏保存按钮，显示聊天框
        this.packUnfoldBlo = true;
        this.clothingWhetherSelect = false;
        this.packUnfoldState = true;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      console.log('-----------before router enter');
      console.log(to);
      console.log(from);
    });
  },
  created: function created() {},
  mounted: function mounted() {
    var _this2 = this;

    console.log('route history', this.$router);
    var param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.imageType = param.type == '3d' ? 1 : '';
    console.log('%c⧭', 'color: #00a3cc', param);
    src_S51WebGLSDK["a" /* default */].initSDK(document.querySelector(".top-box"), 0x616e75, {
      token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN),
      helper: param.helper
    }, "development" == "production");

    this.curPage = 0;
    this.isDisplayDebug = "development" == "production";

    this.getCostume(localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID), true).then(function () {
      if (_this2.isMyself) _this2.getImageList();
      _this2.$forceUpdate();
    });
    Object(api["u" /* qaList */])(localStorage.getItem(define["a" /* STORAGE_KEY */].MODEL_ID), param.type).then(function (d) {
      _this2.hasQAList = d.data.total > 0;
    });

    window.addEventListener("popstate", function (e) {
      console.log('回退事件', e);
    }, false);

    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, function (param) {
      console.log('收到 enable input  消息', param);
      _this2.activeEnableInput = param.enable;
    });

    this.errorCount = 0;
    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ADD_LOG, function (param) {
      if (_this2.errorCount >= 10) {
        _this2.debugInfo.errorMessage = "";
      }
      _this2.debugInfo.errorMessage += '\r\n' + param;
      _this2.errorCount++;
    });
  },
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy ');
    src_S51WebGLSDK["a" /* default */].stopNowVoice();
    src_S51WebGLSDK["a" /* default */].clearCache();
  }
}, defineProperty_default()(HelloFromVux__showWebglStats$compo, "created", function created() {}), defineProperty_default()(HelloFromVux__showWebglStats$compo, "methods", {
  onCloseShareImage: function onCloseShareImage() {
    this.closeShareImageState = false;
  },
  onPatternSetFinish: function onPatternSetFinish(e) {
    this.isChatGPT = e;
  },
  informEditModal: function informEditModal(e) {
    this.editStateIsOpen = e.open;
    this.textareaValue = e.text;
  },
  onCloseEditModal: function onCloseEditModal() {
    this.editStateIsOpen = false;
  },
  onSaveEditTextModal: function onSaveEditTextModal(e) {
    var _this3 = this;

    Object(api["w" /* setImage */])({
      image_id: this.modelViewId,
      greet: e
    }).then(function (d) {
      _this3.$vux.toast.show({
        type: "text",
        text: "保存成功"
      });
      _this3.editStateIsOpen = false;
      _this3.$refs.myChatFrame.updateHelloWord(e);
    }, function (e) {
      console.error(e);
      _this3.$vux.toast.show({
        type: "text",
        text: e
      });
    });
  },
  onFreeOfCharge: function onFreeOfCharge(e) {
    this.robberPurchase = e;
  },
  onCharge: function onCharge(e) {
    this.robberPurchase = false;
    this.purchaseModelIsopen = true;
    this.awaitReply = false;
  },
  onChatLeftNotEnough: function onChatLeftNotEnough() {
    if (this.isMyself) {
      this.awaitReply = false;
      this.robberPurchase = true;
    }
  },
  debugClick: function debugClick() {
    console.log('---debug click');
    this.showWebglStats = !this.showWebglStats;
    src_S51WebGLSDK["a" /* default */].showStats(this.showWebglStats);

    if (false) {
      this.showDebug = !this.showDebug;
    }
  },
  getImageList: function getImageList() {
    var _this4 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(api["s" /* imageList */])();

            case 2:
              res = _context.sent;

              _this4.spareList = res.data.data;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  },
  onChatListChange: function onChatListChange(value) {
    this.voiceContentList = value;

    if (!this.packUnfoldBlo) {
      this.packUnfoldBlo = true;
      this.packUnfoldState = true;
      this.clothingShow = false;
      this.clothingWhetherSelect = false;
    }
  },
  onSaveVirtualHuman: function onSaveVirtualHuman() {
    var _this5 = this;

    if (this.isLoading || !this.activeEnableInput) {
      return;
    }

    this.$vux.loading.show({
      text: '正在保存形象'
    });
    src_S51WebGLSDK["a" /* default */].downloadCanvasImg(function (err, blobData) {
      console.log('----截图', blobData);
      if (err) {
        _this5.$vux.loading.hide();
        return _this5.$vux.toast.show({
          type: 'text',
          text: '形象保存失败，请重试'
        });
      }
      var file = new File([blobData], 'screenshot.png', { type: 'image/png' });
      uploadQiniu(file, 'png', function (process) {}, function (err, res) {
        console.log('上传', err, res);
        if (err) {
          _this5.$vux.loading.hide();
          return _this5.$vux.toast.show({
            type: 'text',
            text: '形象保存失败，请重试'
          });
        }
        Object(api["w" /* setImage */])({
          image_id: _this5.modelViewId,
          show_clothes_id: _this5.clickCostumeId,
          generate_cover: res.key
        }).then(function (d) {
          _this5.$vux.toast.show({
            type: "text",
            text: "保存成功"
          });
          _this5.$vux.loading.hide();
          _this5.clothingShow = false;
          _this5.clothingWhetherSelect = false;
        }, function (e) {
          console.error(e);
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: "text",
            text: e
          });
        });
      });
    });

    this.clothingWhetherSelect = false;
  },
  onPackUnfold: function onPackUnfold() {
    this.packUnfoldBlo = !this.packUnfoldBlo;
    this.packUnfoldState = !this.packUnfoldState;
    if (this.packUnfoldState) {
      //显示对话窗口则隐藏换装窗口
      this.clothingShow = false;
      this.clothingWhetherSelect = false;
    }
  },
  openPDF: function openPDF() {

    this.$wechat.miniProgram.navigateTo({
      url: "../documentView/documentView?url=" + encodeURIComponent('http://api.wangyi.talent666.top/assets/wangyi-tutorial.pdf'),
      success: function success() {
        console.log('跳转成功');
      }
    });
  },
  showLoading: function showLoading() {
    this.loadPercent = '0%';
    this.isLoading = true;
  },
  closeLoading: function closeLoading() {
    console.log('loading finished');

    this.loadPercent = "Loaded";
    this.isLoading = false;
  },
  onCutInputButton: function onCutInputButton() {
    if (this.isLoading) {
      return;
    }
    this.clickCostumeId = 0;
    this.inputCostumeShow = !this.inputCostumeShow;
    if (this.inputCostumeShow) {
      this.changeButtonText = "换装";
    } else {
      this.changeButtonText = "聊天";
    }
    src_S51WebGLSDK["a" /* default */].resetHumanPosition();
    console.log("%c⧭", "color: #ff0000", 111);
  },
  onSelectCostume: function onSelectCostume(item) {
    var _this6 = this;

    if (this.isLoading || !this.activeEnableInput) {
      return;
    }
    if (this.clickCostumeId == item.id) return;
    this.clickCostumeId = item.id;
    this.clothingWhetherSelect = true;
    this.packUnfoldBlo = false;
    console.log("%c⧭", "color: #00e600", item);
    this.showLoading();
    src_S51WebGLSDK["a" /* default */].loadAndCLoth(item.file_glb, function (process) {
      _this6.loadPercent = Math.floor(process.percent) + "%";
    }, function (err, result) {
      if (err) {
        console.error(err);
        _this6.closeLoading();
      } else {
        _this6.closeLoading();
      }
    });
  },
  sendWord2Human: function sendWord2Human(myChatMessage) {
    var _this7 = this;

    this.awaitReply = true;
    this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, myChatMessage, this.cardID).then(function (d) {
      _this7.debugInfo.chatType = d.data.chat_type;
      _this7.debugInfo.word = d.data.word;
      if (_this7.isChatGPT) _this7.isHasConsume = true;
    }, function (err) {
      _this7.debugInfo.errorMessage = err;
    }).finally(function () {
      _this7.awaitReply = false;
    });
  },
  onInputEndRecordAudio: function onInputEndRecordAudio(data) {
    var _this8 = this;

    console.log('结束录音', data);
    this.awaitReply = true;
    this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].VOICE, {
      voiceUrl: data.voiceUrl,
      voiceSendData: data.voiceSendData,
      voiceHttpUrl: data.voiceHttpUrl,
      duration: data.duration
    }, this.cardID).then(function (d) {}, function (err) {
      _this8.debugInfo.errorMessage = err;
    }).finally(function () {
      _this8.awaitReply = false;
    });
  },
  getCostume: function getCostume(modelID) {
    var _this9 = this;

    return new promise_default.a(function (resolve, reject) {
      _this9.modelViewId = Number(modelID);
      _this9.debugInfo.modelID = modelID;

      _this9.showLoading();
      Object(utils["a" /* createRequest */])("get", "applet/webview/model_view", { image_id: _this9.modelViewId }, function (res) {
        console.log("%c⧭", "color: #d90000", res);
        if (res.code == 200) {
          document.title = res.data.image.name;
          console.log("%c⧭", "color: #ffa640", res.data.clothes_map);
          _this9.preinstallList = res.data.qa_list.data;
          _this9.virtualHumanGender = res.data.app_info.gender;
          _this9.clothingList = res.data.clothes_map;
          _this9.clickCostumeId = res.data.image.show_clothes_id;
          _this9.debugInfo.appID = res.data.app_info.app_id;
          _this9.curAppID = res.data.app_info.app_id;
          localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.image.name);
          _this9.isMyself = res.data.image.uid == res.data.uid;
          _this9.firmId = res.data.image.company_id;
          var _param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
          _this9.cardID = _param.cardId;
          console.log('----------------------cardID', _this9.cardID);
          Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (prce) {
            console.log('%c⧭', 'color: #ace2e6', prce);
            if (prce.code == 500) {
              Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (val) {
                console.log('%c⧭', 'color: #ace2e6', val);
              });
            }
          });

          console.log("%c⧭", "color: #997326", res.data.image.action_id, _this9.clickCostumeId);
          src_S51WebGLSDK["a" /* default */].resetAppID(res.data.app_info.app_id);
          _this9.isChatGPT = res.data.image.chat_type == 2;

          _this9.currentHumanName = res.data.image.name;
          _this9.list = res.data.clothes_map;
          _this9.hasSet = res.data.image.greet && res.data.image.greet != '';
          var changeClothes = [];
          if (res.data.image.show_clothes_id) {
            var cloth = res.data.clothes_map.find(function (ele) {
              return ele.id == res.data.image.show_clothes_id;
            });
            changeClothes = cloth ? cloth.file_glb : [];
          }
          var actions = [];
          var chatActionMaps = new map_default.a();
          if (res.data.action_wait) {
            actions.push(res.data.action_wait.fbx_url_qa);
            chatActionMaps[res.data.action_wait.value] = res.data.action_wait.fbx_url_qa;
          }
          if (res.data.action_interact) {
            actions.push(res.data.action_interact.fbx_url_qa);
            chatActionMaps[res.data.action_interact.value] = res.data.action_interact.fbx_url_qa;
            _this9.defaultChatAction = res.data.action_interact.value;
          }
          var acionMap = res.data.action_map;

          console.log('acionMap', acionMap);
          acionMap && acionMap && acionMap.forEach(function (action) {
            actions.push(action.fbx_url);
            chatActionMaps[action.value] = action.fbx_url_qa;
          });
          _this9.actionMaps = chatActionMaps;
          var wordVoice = void 0;
          if (res.data.image.greet && res.data.image.greet.length > 0) {
            Object(api["g" /* chatWordToVoice */])(res.data.image.greet, _this9.curAppID).then(function (voiceRes) {
              if (res.code == 200) {
                wordVoice = voiceRes.data;
              }
            });
          }

          src_S51WebGLSDK["a" /* default */].loadHuman(res.data.image.model_url, res.data.image.clothes_name_list, res.data.hdr, changeClothes, //默认需要替换的服装
          actions, //所有需要提前加载的动作列表
          res.data.action_wait.fbx_url, // 'https://ad-qiniu-demo.studio51.com/F_HuXi_V2.0.10.fbx',//空闲动作
          {
            gender: res.data.image.gender
          }, function (process) {

            if (process.percent >= 100) {} else {
              _this9.loadPercent = Math.floor(process.percent) + '%';
            }
          }, function (err, result) {

            console.log(err, result, '123');
            if (err) {
              console.log('模型加载失败', err);
              _this9.debugInfo.errorMessage = '模型加载失败:' + err;
              _this9.closeLoading();
              _this9.$vux.toast.show({
                type: "text",
                text: '人物加载失败'
              });
            } else {

              if (res.data.image.greet && res.data.image.greet.length > 0) {

                var start_ = Date.now();
                var handler_ = setInterval(function () {
                  if (Date.now() - start_ > 5000) {
                    _this9.closeLoading();
                    return clearInterval(handler_);
                  }
                  if (wordVoice) {
                    _this9.closeLoading();
                    clearInterval(handler_);
                    _this9.sayHello(res.data.image.greet, wordVoice.audio, wordVoice.viseme, chatActionMaps[_this9.defaultChatAction], wordVoice.duration);
                  }
                }, 500);
              } else {
                _this9.closeLoading();
              }
            }
          });
        } else {

          _this9.closeLoading();
          console.error(res.msg);
          _this9.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
        resolve();
      });
    });
  },
  myMessagePlay: function myMessagePlay(e) {
    console.log("播放我的声音");
    var _this = this;
    if (this.myChatVoiceBlob) {
      var audio = new Audio(window.URL.createObjectURL(this.myChatVoiceBlob));
      audio.play();
      this.playState = true;
      audio.addEventListener("ended", function () {
        console.log("%c⧭", "color: #731d1d", 111111);
        _this.playState = false;
      }, false);
    }
  },
  finish: function finish(index) {
    this.onTouchend();

    console.log("current index", index);
  },
  onCostumeModel: function onCostumeModel(e) {
    if (this.isLoading || !this.activeEnableInput) {
      return;
    }
    this.clothingShow = !this.clothingShow;
    this.$refs.myChatFrame.stopNowVoice();
  },
  onQaModel: function onQaModel(e) {
    if (this.isLoading || !this.activeEnableInput) {
      return;
    }
    this.$router.push({
      path: '/setQaPage',
      query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), image_show: 1, startPage: 'costume', type: '3d' }
    });
  },
  onSetModel: function onSetModel(e) {
    this.closeShareImageState = true;
  },
  onUpChat: function onUpChat() {
    this.onSetModel();
  },
  onAddQuestions: function onAddQuestions(event) {
    this.switchPage('qa');
    console.log("%c⧭", "color: #ffa640", this.componentsState);
  },
  onAQListChange: function onAQListChange(event) {
    if (event.modelViewId == this.modelViewId) {
      this.hasQAList == event.total > 0;
    }
  },
  onAddSaveRouter: function onAddSaveRouter(event) {
    this.switchPage(event);
    this.addSaveRouter = this.addSaveRouter + 1;
    console.log("%c⧭", "color: #ffa640", this.componentsState);
  },
  onSaveSetRouter: function onSaveSetRouter(e) {
    this.switchPage("");
    if (e.modelViewId == this.modelViewId) {
      this.hasSet = e.greet && e.greet.length;
    }
  },
  onCloseSetModel: function onCloseSetModel(e) {
    this.switchPage("");
    this.componentsState = '';
  },
  switchPage: function switchPage(page) {
    var _this10 = this;

    this.preComponentsState = this.componentsState;
    this.componentsState = page;
    console.log('switch page', page);
    switch (page) {
      case '':
        document.title = this.currentHumanName;

        Object(api["u" /* qaList */])(this.modelViewId).then(function (d) {
          _this10.hasQAList = d.data.total > 0;
        });
        break;
      case 'costume':
      case 'qa':
        document.title = 'QA库';
        break;
      case 'set':
        document.title = '设置';
        break;

    }
  },
  selectSpare: function selectSpare(data) {
    var _this11 = this;

    if (this.isLoading) {
      return;
    }

    this.clothingShow = false;
    this.getCostume(data.id).then(function () {

      _this11.$refs.myChatFrame.clearChat();
    });
  },
  onAddSpare: function onAddSpare() {
    if (this.isLoading) {
      return;
    }
    this.$wechat.miniProgram.navigateTo({
      url: '../createFigure/createFigure',
      success: function success() {
        console.log('跳转成功');
      }
    });
  },
  onBack: function onBack(event) {
    console.log('----back', event);
    if (event == "home") {
      this.switchPage("");
    } else {
      this.switchPage(this.preComponentsState);
    }
  },
  sendPreQuestion: function sendPreQuestion(question) {
    var _this12 = this;

    console.log('发送预设问题:', question);

    if (this.isLoading) {
      return;
    }
    this.awaitReply = true;
    this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, question.question, this.cardID).then(function (d) {
      if (_this12.isChatGPT) _this12.isHasConsume = true;
    }, function (err) {
      _this12.debugInfo.errorMessage = err;
    }).finally(function () {
      _this12.awaitReply = false;
    });
  },
  sayHello: function sayHello(helloWord, helloAudio, helloVisem, action, duration) {
    this.$refs.myChatFrame.sayHello(helloWord, helloAudio, helloVisem, action, duration, this.isMyself);
  },
  onInputWordSend: function onInputWordSend(message) {
    console.log('send message', message);
    if (this.isLoading) {
      return;
    }
    if (!message || message.length == 0) {
      return;
    }
    this.sendWord2Human(message);
  },
  onInputStartRecordAudio: function onInputStartRecordAudio() {
    console.log('开始录音');
    src_S51WebGLSDK["a" /* default */].stopNowVoice();
  },
  informCancelPurchase: function informCancelPurchase(e) {
    this.purchaseModelIsopen = e;
  },
  informImmediatelyPurchase: function informImmediatelyPurchase(e) {
    if (e) {
      //充值成功
      this.purchaseModelIsopen = false;
      this.$vux.toast.show({
        type: "text",
        text: "充值成功"
      });
    }
  },
  onOpenChargeModel: function onOpenChargeModel() {
    this.purchaseModelIsopen = true;
    console.log('-----open charge');
  }
}), HelloFromVux__showWebglStats$compo);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9ebe05","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloFromVux.vue
var HelloFromVux_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HelloFromVux"},[_c('div',{staticClass:"top-box"}),_vm._v(" "),_c('PaymentModel',{directives:[{name:"show",rawName:"v-show",value:(_vm.purchaseModelIsopen),expression:"purchaseModelIsopen"}],attrs:{"stateIs":1,"purchaseModelOpen":_vm.purchaseModelIsopen},on:{"informCancelPurchase":_vm.informCancelPurchase,"informImmediatelyPurchase":_vm.informImmediatelyPurchase}}),_vm._v(" "),(_vm.isMyself)?_c('div',{staticClass:"zgq-top-administration-spare"},[_c('human-list',{attrs:{"list":_vm.spareList,"isAddSpare":true,"modelID":_vm.modelViewId,"disable":!_vm.activeEnableInput},on:{"selectSpare":_vm.selectSpare,"onAddSpare":_vm.onAddSpare}})],1):_vm._e(),_vm._v(" "),(_vm.isMyself)?_c('div',{staticClass:"ton-model-position-absolute"},[_c('ToneModel',{attrs:{"disabldeChat":_vm.firmId > 0,"id":_vm.modelViewId,"type":_vm.imageType},on:{"onPatternSetFinish":_vm.onPatternSetFinish}})],1):_vm._e(),_vm._v(" "),(_vm.isDisplayDebug)?_c('div',{class:_vm.showDebug == true ? 'debug-container debug-display' : 'debug-container debug-hidden',on:{"click":_vm.debugClick}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDebug),expression:"showDebug"}]},[_c('div',[_vm._v("模型ID："+_vm._s(_vm.debugInfo.modelID))]),_vm._v(" "),_c('div',[_vm._v("APP_ID："+_vm._s(_vm.debugInfo.appID))]),_vm._v(" "),_c('div',[_vm._v("chatType："+_vm._s(_vm.debugInfo.chatType))]),_vm._v(" "),_c('div',[_vm._v("word:"+_vm._s(_vm.debugInfo.word ? _vm.debugInfo.word.substr(0, 50) : ''))]),_vm._v(" "),_c('div',{staticClass:"debug-error"},[_vm._v(_vm._s(_vm.debugInfo.errorMessage))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-button"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.packUnfoldBlo == true && !_vm.clothingShow),expression:"packUnfoldBlo == true && !clothingShow"}],ref:"mianscroll",staticClass:"chat-left-right",staticStyle:{"height":"192px"}},[_c('Chatframe',{ref:"myChatFrame",attrs:{"appId":_vm.curAppID,"imageType":_vm.imageType,"actionMap":_vm.actionMaps,"defaultChatAction":_vm.defaultChatAction},on:{"onChatListChange":_vm.onChatListChange,"onChatLeftNotEnough":_vm.onChatLeftNotEnough,"informEditModal":_vm.informEditModal}})],1),_vm._v(" "),_c('div',{staticClass:"zgq-chat-send-input"},[_c('chat-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.clothingWhetherSelect == false),expression:"clothingWhetherSelect == false"}],attrs:{"disabled":_vm.isLoading,"isChatGPT":_vm.isChatGPT,"isMyself":_vm.isMyself,"preinstallListIs":_vm.preinstallList,"hasConsume":_vm.isHasConsume,"packUnfoldShow":_vm.imageType,"companyID":_vm.firmId,"packUnfoldBloIs":_vm.packUnfoldBlo,"packUnfoldStateIs":_vm.packUnfoldState,"voiceContentListIs":_vm.voiceContentList},on:{"onInputWordSend":_vm.onInputWordSend,"onInputStartRecordAudio":_vm.onInputStartRecordAudio,"onInputEndRecordAudio":_vm.onInputEndRecordAudio,"onOpenChargeModel":_vm.onOpenChargeModel,"onUpChat":_vm.onUpChat,"onPackUnfold":_vm.onPackUnfold,"onSendPreQuestion":function (e) { return _vm.sendPreQuestion(e); }}})],1)]),_vm._v(" "),(_vm.isMyself)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading && (_vm.voiceContentList.length <= 0 || _vm.packUnfoldBlo == false)),expression:"!isLoading && (voiceContentList.length <= 0 || packUnfoldBlo == false)"}],staticClass:"right-button-position"},[_c('div',{staticClass:"one",on:{"click":function($event){return _vm.onCostumeModel()}}},[_c('img',{attrs:{"src":"/static/img/clothing_icon.png","alt":""}}),_vm._v("\n      换装\n    ")]),_vm._v(" "),_c('div',{staticClass:"three",on:{"click":function($event){return _vm.onQaModel('costume')}}},[_c('badge',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasQAList),expression:"!hasQAList"}],staticClass:"my-badge"}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/QA_icon.png","alt":""}}),_vm._v("\n      问答\n    ")],1),_vm._v(" "),_c('div',{staticClass:"four",on:{"click":function($event){return _vm.onSetModel('set')}}},[_c('badge',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasSet),expression:"!hasSet"}],staticClass:"my-badge"}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/share_icon.jpg","alt":""}}),_vm._v("\n      分享\n    ")],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.clothingShow),expression:"clothingShow"}],staticClass:"clothing-model-box"},[_c('div',{staticClass:"box"},_vm._l((_vm.clothingList),function(item){return _c('div',{key:item.id,class:_vm.clickCostumeId == item.id ? 'image-box-active' : 'image-box'},[_c('img',{attrs:{"src":item.pic,"alt":""},on:{"click":function($event){return _vm.onSelectCostume(item)}}})])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.clothingWhetherSelect && _vm.packUnfoldBlo == false),expression:"clothingWhetherSelect && packUnfoldBlo == false"}],staticClass:"save-virtual-human-box"},[_c('div',{staticClass:"save-button",on:{"click":_vm.onSaveVirtualHuman}},[_vm._v("保存形象")]),_vm._v(" "),_c('div',{staticClass:"cancel-button",on:{"click":function () { _vm.clothingWhetherSelect = false; this$1.clothingShow = false }}},[_vm._v("取消")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"containerLoading"},[_c('div',{attrs:{"id":"loadProcess"}},[_vm._v(_vm._s(_vm.loadPercent))]),_vm._v(" "),_c('div',{attrs:{"id":"circleLoading"}})]),_vm._v(" "),_c('AwaitReplyModel',{directives:[{name:"show",rawName:"v-show",value:(_vm.awaitReply),expression:"awaitReply"}]}),_vm._v(" "),_c('PageVisible',{attrs:{"AppID":_vm.curAppID}}),_vm._v(" "),(_vm.editStateIsOpen)?_c('EditTextModal',{attrs:{"textareaValue":_vm.textareaValue},on:{"onSaveEditTextModal":_vm.onSaveEditTextModal,"onCloseEditModal":_vm.onCloseEditModal}}):_vm._e(),_vm._v(" "),_c('CharacterInsufficient',{directives:[{name:"show",rawName:"v-show",value:(_vm.robberPurchase),expression:"robberPurchase"}],attrs:{"modelViewId":_vm.modelViewId,"imageType":_vm.imageType},on:{"onFreeOfCharge":_vm.onFreeOfCharge,"onCharge":_vm.onCharge}}),_vm._v(" "),(_vm.closeShareImageState)?_c('div',{staticClass:"share-image",on:{"click":_vm.onCloseShareImage}},[_c('img',{attrs:{"src":"/static/img/background_share_icon.jpg","alt":""}})]):_vm._e()],1)}
var HelloFromVux_staticRenderFns = []
var HelloFromVux_esExports = { render: HelloFromVux_render, staticRenderFns: HelloFromVux_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_HelloFromVux = (HelloFromVux_esExports);
// CONCATENATED MODULE: ./src/components/HelloFromVux.vue
function HelloFromVux_injectStyle (ssrContext) {
  __webpack_require__("DV3S")
}
var HelloFromVux_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HelloFromVux___vue_template_functional__ = false
/* styles */
var HelloFromVux___vue_styles__ = HelloFromVux_injectStyle
/* scopeId */
var HelloFromVux___vue_scopeId__ = "data-v-3a9ebe05"
/* moduleIdentifier (server only) */
var HelloFromVux___vue_module_identifier__ = null
var HelloFromVux_Component = HelloFromVux_normalizeComponent(
  selectortype_script_index_0_src_components_HelloFromVux,
  selectortype_template_index_0_src_components_HelloFromVux,
  HelloFromVux___vue_template_functional__,
  HelloFromVux___vue_styles__,
  HelloFromVux___vue_scopeId__,
  HelloFromVux___vue_module_identifier__
)

/* harmony default export */ var src_components_HelloFromVux = (HelloFromVux_Component.exports);

// EXTERNAL MODULE: ./src/components/TwoD.less
var TwoD = __webpack_require__("/HB0");
var TwoD_default = /*#__PURE__*/__webpack_require__.n(TwoD);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TwoD.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var components_TwoD = ({
  name: "TwoD",
  components: {
    ChatInput: src_myComponents_ChatInput_ChatInput,
    Chatframe: Chatframe["a" /* default */],
    AwaitReplyModel: src_myComponents_awaitReplyModel_awaitReplyModel,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel,
    PageVisible: src_myComponents_PageVisible_PageVisible,
    CharacterInsufficient: src_myComponents_characterInsufficient_characterInsufficient,
    EditTextModal: src_myComponents_EditTextModal_EditTextModal,
    ToneModel: src_myComponents_ToneModel_ToneModel
  },
  props: {},
  data: function data() {
    return {
      videoUrl: "",
      voiceContentList: [
        // {
        //   type:1, //1文字 2语音 3图片 4文件 5超链接
        //   name:'zgq', //内容
        //   differentiate:1, //1机器人 2用户
        //   id:1,
        //   imageUrl:'', //图片路径
        //   voiceUrl:'', //语音路径
        //   fileUrl:'', //文件下载地址
        //   linkUrl:'', //超链接地址
        //   videoUrl
        //   speed:,//文字显示速度 毫秒/字
        // },
      ],
      isLoading: false,
      packUnfoldState: true,
      clothingShow: false,
      clothingWhetherSelect: false,
      debugInfo: {
        modelID: 1,
        errorMessage: "",
        appID: ""
      },
      modelViewId: 0,
      curAppID: '',
      imageType: 2,
      awaitReply: false,
      height: 0,
      isMyself: false,
      isChatGPT: false,
      packUnfoldBlo: false,
      preinstallList: [],
      purchaseModelIsopen: false,
      isHasConsume: false,
      ImageUrl: '', //图片url
      playVideoSate: false, //点击图片切换video的状态
      imageLoadState: false, //图片是否加载完成的状态
      robberPurchase: false,
      editStateIsOpen: false,
      textareaValue: "",
      firmId: 0, // 企业id
      defaultHeight: '0', //默认屏幕高度
      nowHeight: '0', //实时屏幕高度
      upspringState: false
    };
  },

  computed: {},
  watch: {
    voiceContentList: function voiceContentList(value) {

      console.log('%c⧭', 'color: #514080', value);
      var getlos = localStorage.getItem("packUnfoldBlo_two");
      if (getlos == null || getlos == undefined || getlos == "") {
        localStorage.setItem("packUnfoldBlo_two", true);
        this.packUnfoldBlo = true;
      }
      if (this.packUnfoldState) {
        this.clothingShow = false;
      }

      console.log("%c⧭", "color: #e57373", value);
    },
    nowHeight: function nowHeight() {
      if (this.defaultHeight != this.nowHeight) {
        //键盘弹出操作
        this.upspringState = true;
      } else {
        //键盘不弹出操作
        this.upspringState = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    //获取默认高度
    this.defaultHeight = document.documentElement.clientHeight;
    window.onresize = function () {
      return function () {
        //实时屏幕高度
        _this.nowHeight = document.documentElement.clientHeight;
      }();
    };
    this.height = document.documentElement.clientHeight - 485;
    console.log('%c⧭', 'color: #f200e2', this.height);
    var param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.modelViewId = Number(param.id);
    this.initSpareInfo();
  },
  destroyed: function destroyed() {},
  created: function created() {
    localStorage.removeItem("packUnfoldBlo_two");
  },

  methods: {
    //模型设置成功
    onPatternSetFinish: function onPatternSetFinish(e) {
      this.isChatGPT = e;
    },

    //通知修改文案modal起
    informEditModal: function informEditModal(e) {
      this.editStateIsOpen = e.open;
      this.textareaValue = e.text;
    },
    onFreeOfCharge: function onFreeOfCharge(e) {
      this.robberPurchase = e;
    },
    onCloseEditModal: function onCloseEditModal() {
      this.editStateIsOpen = false;
    },
    onSaveEditTextModal: function onSaveEditTextModal(e) {
      var _this2 = this;

      Object(utils["a" /* createRequest */])("post", "applet/webview/card/setting", {
        card_id: this.modelViewId,
        greet: e
      }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.$vux.toast.show({
            type: "text",
            text: "保存成功"
          });
          _this2.editStateIsOpen = false;
          _this2.$refs.myChatFrame.updateHelloWord(e);
        } else {
          console.error(res.msg);
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onCharge: function onCharge(e) {
      this.robberPurchase = false;
      this.purchaseModelIsopen = true;
      this.awaitReply = false;
    },
    onChatLeftNotEnough: function onChatLeftNotEnough() {
      if (this.isMyself) {
        this.awaitReply = false;
        this.robberPurchase = true;
      }
    },

    //监听图片是否加载完成
    onImageLoad: function onImageLoad() {
      this.imageLoadState = true;
    },

    //播放视频
    onPlayVideo: function onPlayVideo() {
      this.playVideoSate = true;
      this.$refs.video_play.play();
    },
    sendPreQuestion: function sendPreQuestion(question) {
      var _this3 = this;

      console.log('发送预设问题:', question);
      // this.sendWord2Human(question.question)
      //测试阶段，返回固定应答
      if (this.isLoading) {
        return;
      }
      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, question.question, this.cardID).then(function (d) {
        if (_this3.isChatGPT) _this3.isHasConsume = true;
      }, function (err) {
        _this3.debugInfo.errorMessage = err;
      }).finally(function () {
        _this3.awaitReply = false;
      });
    },
    initSpareInfo: function initSpareInfo() {
      var _this4 = this;

      this.$vux.loading.show({
        text: '载入中...',
        position: 'absolute'
      });
      Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
        _this4.preinstallList = res.data.qa_list.data;
        _this4.curAppID = res.data.app_info.app_id;
        _this4.firmId = res.data.card.company_id;
        Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (prce) {});
        _this4.videoUrl = res.data.card.generate_video;
        _this4.ImageUrl = res.data.card.generate_cover;
        console.log('%c⧭', 'color: #73998c', res.data.card.generate_video);
        _this4.cardID = res.data.card.id;
        document.title = res.data.card.name + '的名片';
        _this4.isMyself = res.data.card.uid == res.data.uid;
        _this4.isChatGPT = res.data.card.chat_type == 2;
        if (res.data.card.greet && res.data.card.greet.length > 0) {
          Object(api["g" /* chatWordToVoice */])(res.data.card.greet, _this4.curAppID).then(function (voiceRes) {
            if (res.code == 200) {
              _this4.sayHello(res.data.card.greet, voiceRes.data.audio, null, null, voiceRes.data.duration);
            }
          }).finally(function () {
            _this4.$vux.loading.hide();
          });
        } else {
          _this4.$vux.loading.hide();
        }
        localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.card.name);
      }, function (e) {
        _this4.$vux.loading.hide();
      });
    },
    onChatListChange: function onChatListChange(value) {
      this.voiceContentList = value;
    },
    sayHello: function sayHello(helloWord, helloAudio, helloVisem, action, duration) {
      this.$refs.myChatFrame.sayHello(helloWord, helloAudio, helloVisem, action, duration, this.isMyself);
    },
    onInputWordSend: function onInputWordSend(message) {
      console.log('send message', message);
      if (this.isLoading) {
        return;
      }
      if (!message || message.length == 0) {
        return;
      }
      this.sendWord2Human(message);
    },
    onInputStartRecordAudio: function onInputStartRecordAudio() {
      console.log('开始录音');
      src_S51WebGLSDK["a" /* default */].stopNowVoice();
    },
    onInputEndRecordAudio: function onInputEndRecordAudio(data) {
      var _this5 = this;

      console.log('结束录音', data);
      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].VOICE, data, this.cardID).then(function () {
        if (_this5.isChatGPT) _this5.isHasConsume = true;
      }, //成功
      function (err) {
        _this5.debugInfo.errorMessage = err;
      }).finally(function () {
        _this5.awaitReply = false;
      });
    },
    sendWord2Human: function sendWord2Human(myChatMessage) {
      var _this6 = this;

      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, myChatMessage, this.cardID).then(function () {
        if (_this6.isChatGPT) _this6.isHasConsume = true;
      }, //成功
      function (err) {
        _this6.debugInfo.errorMessage = err;
      }).finally(function () {
        _this6.awaitReply = false;
      });
    },
    onUpChat: function onUpChat() {
      if (this.isLoading) {
        return;
      }
      // this.switchPage(e)
      this.$router.push({ path: '/setQaPage', query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), type: '2d' } });
    },
    informImmediatelyPurchase: function informImmediatelyPurchase(e) {
      if (e) {
        //充值成功
        this.purchaseModelIsopen = false;
        this.$vux.toast.show({
          type: "text",
          text: "充值成功"
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TwoD.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var selectortype_script_index_0_src_components_TwoD = ({
  name: "TwoD",
  components: {
    ChatInput: src_myComponents_ChatInput_ChatInput,
    Chatframe: Chatframe["a" /* default */],
    AwaitReplyModel: src_myComponents_awaitReplyModel_awaitReplyModel,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel,
    PageVisible: src_myComponents_PageVisible_PageVisible,
    CharacterInsufficient: src_myComponents_characterInsufficient_characterInsufficient,
    EditTextModal: src_myComponents_EditTextModal_EditTextModal,
    ToneModel: src_myComponents_ToneModel_ToneModel
  },
  props: {},
  data: function data() {
    return {
      videoUrl: "",
      voiceContentList: [
        // {
        //   type:1, //1文字 2语音 3图片 4文件 5超链接
        //   name:'zgq', //内容
        //   differentiate:1, //1机器人 2用户
        //   id:1,
        //   imageUrl:'', //图片路径
        //   voiceUrl:'', //语音路径
        //   fileUrl:'', //文件下载地址
        //   linkUrl:'', //超链接地址
        //   videoUrl
        //   speed:,//文字显示速度 毫秒/字
        // },
      ],
      isLoading: false,
      packUnfoldState: true,
      clothingShow: false,
      clothingWhetherSelect: false,
      debugInfo: {
        modelID: 1,
        errorMessage: "",
        appID: ""
      },
      modelViewId: 0,
      curAppID: '',
      imageType: 2,
      awaitReply: false,
      height: 0,
      isMyself: false,
      isChatGPT: false,
      packUnfoldBlo: false,
      preinstallList: [],
      purchaseModelIsopen: false,
      isHasConsume: false,
      ImageUrl: '', //图片url
      playVideoSate: false, //点击图片切换video的状态
      imageLoadState: false, //图片是否加载完成的状态
      robberPurchase: false,
      editStateIsOpen: false,
      textareaValue: "",
      firmId: 0, // 企业id
      defaultHeight: '0', //默认屏幕高度
      nowHeight: '0', //实时屏幕高度
      upspringState: false
    };
  },

  computed: {},
  watch: {
    voiceContentList: function voiceContentList(value) {

      console.log('%c⧭', 'color: #514080', value);
      var getlos = localStorage.getItem("packUnfoldBlo_two");
      if (getlos == null || getlos == undefined || getlos == "") {
        localStorage.setItem("packUnfoldBlo_two", true);
        this.packUnfoldBlo = true;
      }
      if (this.packUnfoldState) {
        this.clothingShow = false;
      }

      console.log("%c⧭", "color: #e57373", value);
    },
    nowHeight: function nowHeight() {
      if (this.defaultHeight != this.nowHeight) {
        //键盘弹出操作
        this.upspringState = true;
      } else {
        //键盘不弹出操作
        this.upspringState = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    //获取默认高度
    this.defaultHeight = document.documentElement.clientHeight;
    window.onresize = function () {
      return function () {
        //实时屏幕高度
        _this.nowHeight = document.documentElement.clientHeight;
      }();
    };
    this.height = document.documentElement.clientHeight - 485;
    console.log('%c⧭', 'color: #f200e2', this.height);
    var param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.modelViewId = Number(param.id);
    this.initSpareInfo();
  },
  destroyed: function destroyed() {},
  created: function created() {
    localStorage.removeItem("packUnfoldBlo_two");
  },

  methods: {
    //模型设置成功
    onPatternSetFinish: function onPatternSetFinish(e) {
      this.isChatGPT = e;
    },

    //通知修改文案modal起
    informEditModal: function informEditModal(e) {
      this.editStateIsOpen = e.open;
      this.textareaValue = e.text;
    },
    onFreeOfCharge: function onFreeOfCharge(e) {
      this.robberPurchase = e;
    },
    onCloseEditModal: function onCloseEditModal() {
      this.editStateIsOpen = false;
    },
    onSaveEditTextModal: function onSaveEditTextModal(e) {
      var _this2 = this;

      Object(utils["a" /* createRequest */])("post", "applet/webview/card/setting", {
        card_id: this.modelViewId,
        greet: e
      }, function (res) {
        console.log("%c⧭", "color: #d90000", res.data);
        if (res.code == 200) {
          _this2.$vux.toast.show({
            type: "text",
            text: "保存成功"
          });
          _this2.editStateIsOpen = false;
          _this2.$refs.myChatFrame.updateHelloWord(e);
        } else {
          console.error(res.msg);
          _this2.$vux.toast.show({
            type: "text",
            text: res.msg
          });
        }
      });
    },
    onCharge: function onCharge(e) {
      this.robberPurchase = false;
      this.purchaseModelIsopen = true;
      this.awaitReply = false;
    },
    onChatLeftNotEnough: function onChatLeftNotEnough() {
      if (this.isMyself) {
        this.awaitReply = false;
        this.robberPurchase = true;
      }
    },

    //监听图片是否加载完成
    onImageLoad: function onImageLoad() {
      this.imageLoadState = true;
    },

    //播放视频
    onPlayVideo: function onPlayVideo() {
      this.playVideoSate = true;
      this.$refs.video_play.play();
    },
    sendPreQuestion: function sendPreQuestion(question) {
      var _this3 = this;

      console.log('发送预设问题:', question);
      // this.sendWord2Human(question.question)
      //测试阶段，返回固定应答
      if (this.isLoading) {
        return;
      }
      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, question.question, this.cardID).then(function (d) {
        if (_this3.isChatGPT) _this3.isHasConsume = true;
      }, function (err) {
        _this3.debugInfo.errorMessage = err;
      }).finally(function () {
        _this3.awaitReply = false;
      });
    },
    initSpareInfo: function initSpareInfo() {
      var _this4 = this;

      this.$vux.loading.show({
        text: '载入中...',
        position: 'absolute'
      });
      Object(api["b" /* cardView */])(this.modelViewId).then(function (res) {
        _this4.preinstallList = res.data.qa_list.data;
        _this4.curAppID = res.data.app_info.app_id;
        _this4.firmId = res.data.card.company_id;
        Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (prce) {});
        _this4.videoUrl = res.data.card.generate_video;
        _this4.ImageUrl = res.data.card.generate_cover;
        console.log('%c⧭', 'color: #73998c', res.data.card.generate_video);
        _this4.cardID = res.data.card.id;
        document.title = res.data.card.name + '的名片';
        _this4.isMyself = res.data.card.uid == res.data.uid;
        _this4.isChatGPT = res.data.card.chat_type == 2;
        if (res.data.card.greet && res.data.card.greet.length > 0) {
          Object(api["g" /* chatWordToVoice */])(res.data.card.greet, _this4.curAppID).then(function (voiceRes) {
            if (res.code == 200) {
              _this4.sayHello(res.data.card.greet, voiceRes.data.audio, null, null, voiceRes.data.duration);
            }
          }).finally(function () {
            _this4.$vux.loading.hide();
          });
        } else {
          _this4.$vux.loading.hide();
        }
        localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_NAME, res.data.card.name);
      }, function (e) {
        _this4.$vux.loading.hide();
      });
    },
    onChatListChange: function onChatListChange(value) {
      this.voiceContentList = value;
    },
    sayHello: function sayHello(helloWord, helloAudio, helloVisem, action, duration) {
      this.$refs.myChatFrame.sayHello(helloWord, helloAudio, helloVisem, action, duration, this.isMyself);
    },
    onInputWordSend: function onInputWordSend(message) {
      console.log('send message', message);
      if (this.isLoading) {
        return;
      }
      if (!message || message.length == 0) {
        return;
      }
      this.sendWord2Human(message);
    },
    onInputStartRecordAudio: function onInputStartRecordAudio() {
      console.log('开始录音');
      src_S51WebGLSDK["a" /* default */].stopNowVoice();
    },
    onInputEndRecordAudio: function onInputEndRecordAudio(data) {
      var _this5 = this;

      console.log('结束录音', data);
      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].VOICE, data, this.cardID).then(function () {
        if (_this5.isChatGPT) _this5.isHasConsume = true;
      }, //成功
      function (err) {
        _this5.debugInfo.errorMessage = err;
      }).finally(function () {
        _this5.awaitReply = false;
      });
    },
    sendWord2Human: function sendWord2Human(myChatMessage) {
      var _this6 = this;

      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, myChatMessage, this.cardID).then(function () {
        if (_this6.isChatGPT) _this6.isHasConsume = true;
      }, //成功
      function (err) {
        _this6.debugInfo.errorMessage = err;
      }).finally(function () {
        _this6.awaitReply = false;
      });
    },
    onUpChat: function onUpChat() {
      if (this.isLoading) {
        return;
      }
      // this.switchPage(e)
      this.$router.push({ path: '/setQaPage', query: { id: this.modelViewId, token: localStorage.getItem(define["a" /* STORAGE_KEY */].TOKEN), type: '2d' } });
    },
    informImmediatelyPurchase: function informImmediatelyPurchase(e) {
      if (e) {
        //充值成功
        this.purchaseModelIsopen = false;
        this.$vux.toast.show({
          type: "text",
          text: "充值成功"
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-420fa7c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TwoD.vue
var TwoD_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TwoD"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"video_box"},[_c('div',{class:_vm.upspringState ? 'upspring' : 'withdraw'},[_c('div',{staticStyle:{"width":"100%","position":"relative","z-index":"2"}},[(_vm.playVideoSate == false)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.ImageUrl,"alt":""},on:{"load":_vm.onImageLoad}}):_vm._e()]),_vm._v(" "),(_vm.isMyself)?_c('div',{staticClass:"ton-model-position-absolute"},[_c('ToneModel',{attrs:{"disabldeChat":_vm.firmId>0,"id":_vm.modelViewId,"type":_vm.imageType},on:{"onPatternSetFinish":_vm.onPatternSetFinish}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-button"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],ref:"mianscroll",staticClass:"chat-left-right",style:({height: _vm.height + 'px'})},[_c('Chatframe',{ref:"myChatFrame",attrs:{"appId":_vm.curAppID,"imageType":_vm.imageType},on:{"onChatListChange":_vm.onChatListChange,"onChatLeftNotEnough":_vm.onChatLeftNotEnough,"informEditModal":_vm.informEditModal}})],1),_vm._v(" "),_c('div',{staticClass:"zgq-chat-send-input"},[_c('chat-input',{attrs:{"disabled":_vm.isLoading,"isMyself":_vm.isMyself,"isChatGPT":_vm.isChatGPT,"hasConsume":_vm.isHasConsume,"preinstallListIs":_vm.preinstallList},on:{"onInputWordSend":_vm.onInputWordSend,"onInputStartRecordAudio":_vm.onInputStartRecordAudio,"onInputEndRecordAudio":_vm.onInputEndRecordAudio,"onOpenChargeModel":function($event){_vm.purchaseModelIsopen=true},"onSendPreQuestion":function (e){ return _vm.sendPreQuestion(e); },"onUpChat":_vm.onUpChat}})],1)])]),_vm._v(" "),_c('AwaitReplyModel',{directives:[{name:"show",rawName:"v-show",value:(_vm.awaitReply),expression:"awaitReply"}]}),_vm._v(" "),_c('CharacterInsufficient',{directives:[{name:"show",rawName:"v-show",value:(_vm.robberPurchase),expression:"robberPurchase"}],attrs:{"modelViewId":_vm.modelViewId,"imageType":_vm.imageType},on:{"onFreeOfCharge":_vm.onFreeOfCharge,"onCharge":_vm.onCharge}}),_vm._v(" "),_c('PaymentModel',{directives:[{name:"show",rawName:"v-show",value:(_vm.purchaseModelIsopen),expression:"purchaseModelIsopen"}],attrs:{"stateIs":1,"purchaseModelOpen":_vm.purchaseModelIsopen},on:{"informCancelPurchase":function($event){_vm.purchaseModelIsopen=false},"informImmediatelyPurchase":_vm.informImmediatelyPurchase}}),_vm._v(" "),_c('PageVisible',{attrs:{"AppID":_vm.curAppID}}),_vm._v(" "),(_vm.editStateIsOpen)?_c('EditTextModal',{attrs:{"textareaValue":_vm.textareaValue},on:{"onSaveEditTextModal":_vm.onSaveEditTextModal,"onCloseEditModal":_vm.onCloseEditModal}}):_vm._e()],1)}
var TwoD_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send_card"},[_c('div',{staticClass:"character-hint-text"})])}]
var TwoD_esExports = { render: TwoD_render, staticRenderFns: TwoD_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_TwoD = (TwoD_esExports);
// CONCATENATED MODULE: ./src/components/TwoD.vue
function TwoD_injectStyle (ssrContext) {
  __webpack_require__("Hc/O")
}
var TwoD_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TwoD___vue_template_functional__ = false
/* styles */
var TwoD___vue_styles__ = TwoD_injectStyle
/* scopeId */
var TwoD___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TwoD___vue_module_identifier__ = null
var TwoD_Component = TwoD_normalizeComponent(
  selectortype_script_index_0_src_components_TwoD,
  selectortype_template_index_0_src_components_TwoD,
  TwoD___vue_template_functional__,
  TwoD___vue_styles__,
  TwoD___vue_scopeId__,
  TwoD___vue_module_identifier__
)

/* harmony default export */ var src_components_TwoD = (TwoD_Component.exports);

// EXTERNAL MODULE: ./src/components/ChatGPTpage/ChatGPTpage.less
var ChatGPTpage = __webpack_require__("BqjD");
var ChatGPTpage_default = /*#__PURE__*/__webpack_require__.n(ChatGPTpage);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChatGPTpage/ChatGPTpage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var ChatGPTpage_ChatGPTpage = ({
  name: 'ChatGPTpage',
  components: {
    Chatframe: Chatframe["a" /* default */],
    ChatInput: src_myComponents_ChatInput_ChatInput,
    AwaitReplyModel: src_myComponents_awaitReplyModel_awaitReplyModel,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel,
    PageVisible: src_myComponents_PageVisible_PageVisible
  },
  props: {},
  data: function data() {
    return {
      voiceContentList: [],
      packUnfoldBlo: false,
      isLoading: false,
      curAppID: '',
      chatType: 0,
      awaitReply: false,
      purchaseModelIsopen: false,
      isHasConsume: false
    };
  },

  computed: {},
  watch: {
    voiceContentList: function voiceContentList(value) {
      var getlos = localStorage.getItem("packUnfoldBlo_GPT");

      console.log('%c⧭', 'color: #514080', "xixixiixi");
      if (getlos == null || getlos == undefined || getlos == "") {
        console.log('%c⧭', 'color: #73998c', "SADFSAFAS");
        localStorage.setItem("packUnfoldBlo_GPT", true);
        this.packUnfoldBlo = true;
      }
      if (value.length <= 0) {
        this.packUnfoldBlo = false;
        localStorage.removeItem("packUnfoldBlo_GPT");
      }
      console.log("%c⧭", "color: #e57373", value);
    }
  },
  mounted: function mounted() {
    document.title = '智能AI聊天机器人';
  },
  destroyed: function destroyed() {},
  created: function created() {
    var _this = this;

    localStorage.removeItem("packUnfoldBlo_GPT");
    Object(api["l" /* getChatStat */])().then(function (res) {
      _this.curAppID = res.data.app_info.app_id;
      Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (prce) {

        console.log('%c⧭', 'color: #ace2e6', prce);
      });
    });
    var param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.chatType = param.type == 'GPT' ? 3 : 0;
    console.log('%c⧭', 'color: #86bf60', this.chatType);
  },

  methods: {
    //默认文案发送
    onSendText: function onSendText(e) {

      console.log('%c⧭', 'color: #eeff00', this.purchaseModelIsopen);
      this.sendWord2Human(e);
    },
    onInputWordSend: function onInputWordSend(message) {
      console.log('send message', message);
      if (this.isLoading) {
        return;
      }
      if (!message || message.length == 0) {
        return;
      }
      this.sendWord2Human(message);
    },
    onInputStartRecordAudio: function onInputStartRecordAudio() {
      console.log('开始录音');
      S51WebGLSDK.stopNowVoice();
    },
    onInputEndRecordAudio: function onInputEndRecordAudio(data) {
      var _this2 = this;

      console.log('结束录音', data);
      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].VOICE, data).then(function () {
        _this2.isHasConsume = true;
      }, //成功
      function (err) {
        console.error(err);
      }).finally(function () {
        _this2.awaitReply = false;
      });
    },
    sendWord2Human: function sendWord2Human(myChatMessage) {
      var _this3 = this;

      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, myChatMessage).then(function () {
        _this3.isHasConsume = true;
      }, //成功
      function (err) {
        console.error(err);
      }).finally(function () {
        _this3.awaitReply = false;
      });
    },
    informImmediatelyPurchase: function informImmediatelyPurchase(e) {
      if (e) {
        //充值成功
        this.purchaseModelIsopen = false;
        this.$vux.toast.show({
          type: "text",
          text: "充值成功"
        });
      }
    },
    onOpenChargeModel: function onOpenChargeModel() {
      this.purchaseModelIsopen = true;
      console.log('-----open charge');
    },
    onChatLeftNotEnough: function onChatLeftNotEnough() {

      this.purchaseModelIsopen = true;
      this.awaitReply = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChatGPTpage/ChatGPTpage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var components_ChatGPTpage_ChatGPTpage = ({
  name: 'ChatGPTpage',
  components: {
    Chatframe: Chatframe["a" /* default */],
    ChatInput: src_myComponents_ChatInput_ChatInput,
    AwaitReplyModel: src_myComponents_awaitReplyModel_awaitReplyModel,
    PaymentModel: src_myComponents_PaymentModel_PaymentModel,
    PageVisible: src_myComponents_PageVisible_PageVisible
  },
  props: {},
  data: function data() {
    return {
      voiceContentList: [],
      packUnfoldBlo: false,
      isLoading: false,
      curAppID: '',
      chatType: 0,
      awaitReply: false,
      purchaseModelIsopen: false,
      isHasConsume: false
    };
  },

  computed: {},
  watch: {
    voiceContentList: function voiceContentList(value) {
      var getlos = localStorage.getItem("packUnfoldBlo_GPT");

      console.log('%c⧭', 'color: #514080', "xixixiixi");
      if (getlos == null || getlos == undefined || getlos == "") {
        console.log('%c⧭', 'color: #73998c', "SADFSAFAS");
        localStorage.setItem("packUnfoldBlo_GPT", true);
        this.packUnfoldBlo = true;
      }
      if (value.length <= 0) {
        this.packUnfoldBlo = false;
        localStorage.removeItem("packUnfoldBlo_GPT");
      }
      console.log("%c⧭", "color: #e57373", value);
    }
  },
  mounted: function mounted() {
    document.title = '智能AI聊天机器人';
  },
  destroyed: function destroyed() {},
  created: function created() {
    var _this = this;

    localStorage.removeItem("packUnfoldBlo_GPT");
    Object(api["l" /* getChatStat */])().then(function (res) {
      _this.curAppID = res.data.app_info.app_id;
      Object(api["e" /* chatServiceStart */])(res.data.app_info.app_id).then(function (prce) {

        console.log('%c⧭', 'color: #ace2e6', prce);
      });
    });
    var param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
    this.chatType = param.type == 'GPT' ? 3 : 0;
    console.log('%c⧭', 'color: #86bf60', this.chatType);
  },

  methods: {
    //默认文案发送
    onSendText: function onSendText(e) {

      console.log('%c⧭', 'color: #eeff00', this.purchaseModelIsopen);
      this.sendWord2Human(e);
    },
    onInputWordSend: function onInputWordSend(message) {
      console.log('send message', message);
      if (this.isLoading) {
        return;
      }
      if (!message || message.length == 0) {
        return;
      }
      this.sendWord2Human(message);
    },
    onInputStartRecordAudio: function onInputStartRecordAudio() {
      console.log('开始录音');
      S51WebGLSDK.stopNowVoice();
    },
    onInputEndRecordAudio: function onInputEndRecordAudio(data) {
      var _this2 = this;

      console.log('结束录音', data);
      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].VOICE, data).then(function () {
        _this2.isHasConsume = true;
      }, //成功
      function (err) {
        console.error(err);
      }).finally(function () {
        _this2.awaitReply = false;
      });
    },
    sendWord2Human: function sendWord2Human(myChatMessage) {
      var _this3 = this;

      this.awaitReply = true;
      this.$refs.myChatFrame.chat(myComponents_Chatframe["b" /* CHAT_TYPE */].TEXT, myChatMessage).then(function () {
        _this3.isHasConsume = true;
      }, //成功
      function (err) {
        console.error(err);
      }).finally(function () {
        _this3.awaitReply = false;
      });
    },
    informImmediatelyPurchase: function informImmediatelyPurchase(e) {
      if (e) {
        //充值成功
        this.purchaseModelIsopen = false;
        this.$vux.toast.show({
          type: "text",
          text: "充值成功"
        });
      }
    },
    onOpenChargeModel: function onOpenChargeModel() {
      this.purchaseModelIsopen = true;
      console.log('-----open charge');
    },
    onChatLeftNotEnough: function onChatLeftNotEnough() {

      this.purchaseModelIsopen = true;
      this.awaitReply = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cdde836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatGPTpage/ChatGPTpage.vue
var ChatGPTpage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ChatGPTpage"},[(_vm.voiceContentList.length <= 0)?_c('div',{staticClass:"chat-GPT-page-box"},[_c('div',{staticClass:"ai-creation-amusing-qa-ai-encyclopedia-box"},[_c('div',{staticClass:"ai-creation-text"},[_vm._v("\n            AI创作\n        ")]),_vm._v(" "),_c('div',{staticClass:"click-send-chat-icon"},[_c('div',{staticClass:"click-name-icon-box",on:{"click":function($event){return _vm.onSendText('写一首情诗')}}},[_c('div',{staticClass:"name-text"},[_vm._v("写一首情诗")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"click-name-icon-box",on:{"click":function($event){return _vm.onSendText('面试时如何做自我介绍')}}},[_vm._m(1),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"ai-creation-amusing-qa-ai-encyclopedia-box"},[_c('div',{staticClass:"ai-creation-text"},[_vm._v("\n            有趣的问题\n        ")]),_vm._v(" "),_c('div',{staticClass:"click-send-chat-icon"},[_c('div',{staticClass:"click-name-icon-box",on:{"click":function($event){return _vm.onSendText('如何哄女朋友开心')}}},[_vm._m(3),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"click-name-icon-box",on:{"click":function($event){return _vm.onSendText('AI会替代人类工作吗？')}}},[_vm._m(5),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"ai-creation-amusing-qa-ai-encyclopedia-box"},[_c('div',{staticClass:"ai-creation-text"},[_vm._v("\n            AI百科\n        ")]),_vm._v(" "),_c('div',{staticClass:"click-send-chat-icon"},[_c('div',{staticClass:"click-name-icon-box",on:{"click":function($event){return _vm.onSendText('“我很讨厌你”用文言文怎么说？')}}},[_vm._m(7),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"click-name-icon-box",on:{"click":function($event){return _vm.onSendText('什么是“第一性原理”')}}},[_vm._m(9),_vm._v(" "),_vm._m(10)])])])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.packUnfoldBlo ? 'input-button-active' : 'input-button'},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.packUnfoldBlo == true),expression:"packUnfoldBlo == true"}],ref:"mianscroll",staticClass:"chat-left-right"},[_c('Chatframe',{ref:"myChatFrame",attrs:{"appId":_vm.curAppID,"imageType":_vm.chatType},on:{"onChatListChange":function (value){ return _vm.voiceContentList=value; },"onChatLeftNotEnough":_vm.onChatLeftNotEnough}})],1),_vm._v(" "),_c('div',{staticClass:"zgq-chat-send-input"},[_c('chat-input',{attrs:{"disabled":_vm.isLoading,"isMyself":true,"isChatGPT":true,"hasConsume":_vm.isHasConsume,"voiceShowIs":1},on:{"onInputWordSend":_vm.onInputWordSend,"onInputStartRecordAudio":_vm.onInputStartRecordAudio,"onInputEndRecordAudio":_vm.onInputEndRecordAudio,"onOpenChargeModel":_vm.onOpenChargeModel}})],1)]),_vm._v(" "),_c('AwaitReplyModel',{directives:[{name:"show",rawName:"v-show",value:(_vm.awaitReply),expression:"awaitReply"}]}),_vm._v(" "),_c('PaymentModel',{directives:[{name:"show",rawName:"v-show",value:(_vm.purchaseModelIsopen),expression:"purchaseModelIsopen"}],attrs:{"stateIs":1,"purchaseModelOpen":_vm.purchaseModelIsopen},on:{"informCancelPurchase":function($event){_vm.purchaseModelIsopen=false},"informImmediatelyPurchase":_vm.informImmediatelyPurchase}}),_vm._v(" "),_c('PageVisible',{attrs:{"AppID":_vm.curAppID}})],1)}
var ChatGPTpage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-icon-zgq"},[_c('div',{staticClass:"button-agq-send"},[_c('img',{attrs:{"src":"/static/img/add_lt_icon.jpg","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-text-two"},[_c('p',[_vm._v("面试时如何做")]),_vm._v(" "),_c('p',[_vm._v("自我介绍")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-icon-zgq-two"},[_c('div',{staticClass:"button-agq-send"},[_c('img',{attrs:{"src":"/static/img/add_lt_icon.jpg","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-text-two"},[_c('p',[_vm._v("如何哄女朋友")]),_vm._v(" "),_c('p',[_vm._v("开心")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-icon-zgq-two"},[_c('div',{staticClass:"button-agq-send"},[_c('img',{attrs:{"src":"/static/img/add_lt_icon.jpg","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-text-two"},[_c('p',[_vm._v("AI会替代人类")]),_vm._v(" "),_c('p',[_vm._v("工作吗？")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-icon-zgq-two"},[_c('div',{staticClass:"button-agq-send"},[_c('img',{attrs:{"src":"/static/img/add_lt_icon.jpg","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-text-two"},[_c('p',[_vm._v("“我很讨厌你”")]),_vm._v(" "),_c('p',[_vm._v("用文言文怎么说？")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-icon-zgq-two"},[_c('div',{staticClass:"button-agq-send"},[_c('img',{attrs:{"src":"/static/img/add_lt_icon.jpg","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-text-two"},[_c('p',[_vm._v("什么是")]),_vm._v(" "),_c('p',[_vm._v("“第一性原理”")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-icon-zgq-two"},[_c('div',{staticClass:"button-agq-send"},[_c('img',{attrs:{"src":"/static/img/add_lt_icon.jpg","alt":""}})])])}]
var ChatGPTpage_esExports = { render: ChatGPTpage_render, staticRenderFns: ChatGPTpage_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_ChatGPTpage_ChatGPTpage = (ChatGPTpage_esExports);
// CONCATENATED MODULE: ./src/components/ChatGPTpage/ChatGPTpage.vue
function ChatGPTpage_injectStyle (ssrContext) {
  __webpack_require__("sc21")
}
var ChatGPTpage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatGPTpage___vue_template_functional__ = false
/* styles */
var ChatGPTpage___vue_styles__ = ChatGPTpage_injectStyle
/* scopeId */
var ChatGPTpage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatGPTpage___vue_module_identifier__ = null
var ChatGPTpage_Component = ChatGPTpage_normalizeComponent(
  components_ChatGPTpage_ChatGPTpage,
  selectortype_template_index_0_src_components_ChatGPTpage_ChatGPTpage,
  ChatGPTpage___vue_template_functional__,
  ChatGPTpage___vue_styles__,
  ChatGPTpage___vue_scopeId__,
  ChatGPTpage___vue_module_identifier__
)

/* harmony default export */ var src_components_ChatGPTpage_ChatGPTpage = (ChatGPTpage_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/ThreeD',
    name: 'HelloWorld',
    component: src_components_HelloFromVux
  }, {
    path: '/ChatGPTpage',
    name: 'ChatGPTpage',
    component: src_components_ChatGPTpage_ChatGPTpage
  }, {
    path: '/TwoD',
    name: 'TwoD',
    component: src_components_TwoD
  }, {
    path: '/SetQaPage',
    name: 'SetQaPage',
    component: src_components_SetQaPage
  }, {
    path: '/webglframe',
    name: 'webglframe',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "9Zbg"));
    }
  }, {
    path: '/webglmaindemo',
    name: 'webglmaindemo',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "83Bt"));
    }
  }, {
    path: '/pdfview',
    name: 'pdfview',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Km7Z"));
    }
  }, {
    path: '/humanpreview',
    name: 'humanpreview',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "rzef"));
    }
  }, {
    path: '/subCompany',
    name: 'subCompany',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "wLNd"));
    }
  }]
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ada1b11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appis",attrs:{"id":"app","draggable":"false"}},[_c('router-view')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("eXW6")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var plugins_loading = __webpack_require__("Y+qm");

// CONCATENATED MODULE: ./src/main.js

















console.log('%c⧭', 'color: #00bf00', 22222, window.location);
var main_param = utils_utils["a" /* utils */].getUrlParams(window.location.href);
console.log('url', window.location.href, main_param);
main_param.token && (main_param.token = decodeURIComponent(main_param.token));
console.log('param', main_param);

localStorage.setItem(define["a" /* STORAGE_KEY */].TOKEN, main_param.token);
localStorage.setItem(define["a" /* STORAGE_KEY */].MODEL_ID, main_param.id);

vue_esm["a" /* default */].directive('transfer-dom', transfer_dom["a" /* default */]);
vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(plugins_toast["a" /* default */]);
vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].use(plugins_loading["a" /* default */]);

document.body.style.overflow = 'hidden';
document.body.style.position = 'fixed';
document.body.style.left = '0';
document.body.style.top = '0';

if (main_param.token) {

  if (main_param.type == '2d' && window.location.pathname == '/TwoD') {
    //2D分享名片
    Object(api["k" /* getCharShareInfo */])(main_param.id).then(function (data) {
      vue_esm["a" /* default */].wechat.miniProgram.postMessage({
        data: {
          name: 'setShareInfo',
          msg: {
            title: data.data.title,
            imageUrl: data.data.image_url,
            path: data.data.path
          }

        }
      });
    });
  } else if (main_param.type == '3d' && window.location.pathname == '/ThreeD') {
    //3D分享分身
    Object(api["x" /* shareHuman */])().then(function (data) {
      vue_esm["a" /* default */].wechat.miniProgram.postMessage({
        data: {
          name: 'setShareInfo',
          msg: {
            title: data.data.title,
            imageUrl: data.data.image_url,
            path: '/pages/webView/webView?route=ThreeD&id=' + main_param.id + '&type=3d'
          }

        }
      });
    });
  } else {
    //默认
    Object(api["m" /* getDefaultShareInfo */])().then(function (data) {
      vue_esm["a" /* default */].wechat.miniProgram.postMessage({
        data: {
          name: 'setShareInfo',
          msg: {
            title: data.data.title,
            imageUrl: data.data.image_url,
            path: data.data.path
          }
        }
      });
    });
  }
}

vue_esm["a" /* default */].wechat.miniProgram.getEnv(function (res) {
  if (res.miniprogram) {
    console.log('小程序环境：--------------');
    Object(api["n" /* getJSSDK */])(window.location.href.split('#')[0]).then(function (d) {
      vue_esm["a" /* default */].wechat.config(extends_default()({}, d.data.config));
      vue_esm["a" /* default */].wechat.ready(function (res) {
        console.log('jssdk注册成功', res);
      });
      vue_esm["a" /* default */].wechat.error(function (res) {
        console.log('jssdk注册失败', res);
      });
    });
  }
});

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "P9l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["t"] = modelView;
/* harmony export (immutable) */ __webpack_exports__["i"] = companyCorpusList;
/* harmony export (immutable) */ __webpack_exports__["b"] = cardView;
/* harmony export (immutable) */ __webpack_exports__["s"] = imageList;
/* harmony export (immutable) */ __webpack_exports__["q"] = getWalletStat;
/* harmony export (immutable) */ __webpack_exports__["j"] = config;
/* harmony export (immutable) */ __webpack_exports__["u"] = qaList;
/* harmony export (immutable) */ __webpack_exports__["r"] = headInfoSize;
/* unused harmony export agedDialog */
/* unused harmony export dialog */
/* harmony export (immutable) */ __webpack_exports__["c"] = chatRecharge;
/* harmony export (immutable) */ __webpack_exports__["e"] = chatServiceStart;
/* harmony export (immutable) */ __webpack_exports__["v"] = setCard;
/* harmony export (immutable) */ __webpack_exports__["w"] = setImage;
/* harmony export (immutable) */ __webpack_exports__["o"] = getPublicsAudio;
/* harmony export (immutable) */ __webpack_exports__["g"] = chatWordToVoice;
/* harmony export (immutable) */ __webpack_exports__["d"] = chatRechargeConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = appletPublicsType;
/* harmony export (immutable) */ __webpack_exports__["p"] = getWalletRecharge;
/* harmony export (immutable) */ __webpack_exports__["l"] = getChatStat;
/* harmony export (immutable) */ __webpack_exports__["k"] = getCharShareInfo;
/* harmony export (immutable) */ __webpack_exports__["m"] = getDefaultShareInfo;
/* harmony export (immutable) */ __webpack_exports__["n"] = getJSSDK;
/* harmony export (immutable) */ __webpack_exports__["x"] = shareHuman;
/* harmony export (immutable) */ __webpack_exports__["f"] = chatToken;
/* harmony export (immutable) */ __webpack_exports__["h"] = companyApply;
/* unused harmony export companyApplyInfo */
/* harmony export (immutable) */ __webpack_exports__["y"] = translateVoiceToText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__("oAV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_define__ = __webpack_require__("++TJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_toast_index_js__ = __webpack_require__("3BeM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__S51WebGLSDK_define__ = __webpack_require__("1/Ha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__S51WebGLSDK_utils_utils__ = __webpack_require__("U3F8");











__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_toast_index_js__["a" /* default */]);
var vm = new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]();

function modelView(modelID) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/webview/model_view", { image_id: modelID }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function companyCorpusList(modelID, page, num) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/company/corpus/list", {
      company_id: modelID,
      page: page,
      num: num
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function cardView(modelID) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/webview/card_view", {
      card_id: modelID
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function imageList() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/user/image/list", { page: 1, num: 20, status: 3 }, function (res) {
      console.log("%c⧭", "color: #d90000", res.data);
      if (res.code == 200) {
        resolve(res);
      } else {
        console.error(res.msg);
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function getWalletStat() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/wallet/stat", {}, function (res) {
      console.log("%c⧭", "color: #d90000", res.data);
      if (res.code == 200) {
        resolve(res);
      } else {
        console.error(res.msg);
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function config(version) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/webview/config", { version: version }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function qaList(modelViewId, type) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/webview/qa/list", {
      image_id: type == '3d' ? modelViewId : '',
      card_id: type == '2d' ? modelViewId : '',
      page: 1,
      num: 100
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function headInfoSize(url) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({
      type: 'HEAD',
      url: url,
      success: function success(res) {},
      complete: function complete(xhr, data) {
        resolve(xhr.getResponseHeader('Content-Length'));
      },
      error: function error(errorMsg) {

        console.log(errorMsg, '请求数据失败');

        reject({
          code: errorMsg.status,
          msg: errorMsg.statusText
        });
      }
    });
  });
}

function agedDialog(appId, word, voice) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var body = {
      app_id: appId
    };

    if (voice) {
      body['voice'] = voice;
    } else {
      body['word'] = "" + word;
    }
    console.log('请求聊天:', appId, word, voice);
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/webview/dialog", body, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        var _utils$parseRobotMess = __WEBPACK_IMPORTED_MODULE_9__S51WebGLSDK_utils_utils__["a" /* utils */].parseRobotMessage(res.data.resp),
            _utils$parseRobotMess2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_utils$parseRobotMess, 2),
            messageType = _utils$parseRobotMess2[0],
            message = _utils$parseRobotMess2[1];

        res.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, res.data, {
          messageType: messageType,
          message: message
        });

        resolve(res);
      } else {
        reject(res.msg);
      }
    });
  });
}

function dialog(appId, word, voice, type, cardID) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var body = {
      app_id: appId,
      type: type,
      start_time: Number(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__utils_define__["a" /* STORAGE_KEY */].START_CHAT_TIME)),
      card_id: cardID
    };

    if (voice) {
      body['voice'] = voice;
    } else {
      body['word'] = "" + word;
    }
    console.log('请求聊天:', appId, word, voice);
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/chat/dialog", body, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        var _utils$parseRobotMess3 = __WEBPACK_IMPORTED_MODULE_9__S51WebGLSDK_utils_utils__["a" /* utils */].parseRobotMessage(res.data.resp),
            _utils$parseRobotMess4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_utils$parseRobotMess3, 2),
            messageType = _utils$parseRobotMess4[0],
            message = _utils$parseRobotMess4[1];

        res.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, res.data, {
          messageType: messageType,
          message: message
        });

        resolve(res);
      } else if (res.code == 60001) {
        //余额不足
        resolve(res);
      } else {
        reject(res.msg);
      }
    });
  });
}

function chatRecharge(starCoin) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/chat/recharge", { star_coin: starCoin }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function chatServiceStart(starCoin) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/chat/service/start", {
      app_id: starCoin
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {

        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_4__utils_define__["a" /* STORAGE_KEY */].START_CHAT_TIME, Math.floor(Date.now() / 1000));
        resolve(res);
      } else if (res.code == 500) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function setCard(starCoin) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/webview/card/setting", {
      card_id: starCoin.card_id,
      greet: starCoin.greet,
      chat_audio_timbre: starCoin.chat_audio_timbre,
      chat_type: starCoin.chat_type
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function setImage(conf) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/webview/image/setting", {
      image_id: conf.image_id,
      greet: conf.greet,
      audio_timbre: conf.audio_timbre,
      chat_type: conf.chat_type,
      generate_cover: conf.generate_cover,
      show_clothes_id: conf.show_clothes_id
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function getPublicsAudio(text, id) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/publics/text2audio", {
      audio_text: text,
      audio_timbre: id
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function chatWordToVoice(name, id) {
  console.log('%c⧭', 'color: #00e600', name, id);
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("post", "applet/chat/word_to_voice", {
      app_id: id,
      word: name
    }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function chatRechargeConfig() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/chat/recharge/config", {}, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function appletPublicsType() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/publics/type", {}, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function getWalletRecharge(orderID) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/wallet/recharge_info", { recharge_id: orderID }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function getChatStat() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/chat/stat", {}, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function getCharShareInfo(cardID) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/share/card", { card_id: cardID }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function getDefaultShareInfo() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/share/default", {}, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function getJSSDK(url) {
  console.log('get jssdk', url);
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/webview/jssdk", { url: url }, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function shareHuman() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("get", "applet/share/virtual_human", {}, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function chatToken(param) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("POST", "applet/chat/token", param, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function companyApply(param) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("POST", "applet/company/apply", param, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}
function companyApplyInfo(param) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("POST", "applet/company/apply/info", param, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

function translateVoiceToText(param) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* createRequest */])("POST", "applet/chat/voice_to_word", param, function (res) {
      console.log("%c⧭", "color: #d90000", res);
      if (res.code == 200) {
        resolve(res);
      } else {
        vm.$vux.toast.show({
          type: "text",
          text: res.msg
        });
        reject(res.msg);
      }
    });
  });
}

/***/ }),

/***/ "Q5PW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q7uw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QlJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/myImage/myImage.vue



/* harmony default export */ var myImage = ({
  name: "myImage",
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    imageUrl: String
  },
  data: function data() {
    return {
      activeUrl: this.imageUrl,
      showHideOnBlur: true
    };
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onHide: function onHide() {
      console.log("隐藏视频窗口");
      this.$emit("onHideMyImage");
    }
  },
  watch: {
    imageUrl: function imageUrl(url) {
      this.activeUrl = url;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/myImage/myImage.vue



/* harmony default export */ var myImage_myImage = ({
  name: "myImage",
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    imageUrl: String
  },
  data: function data() {
    return {
      activeUrl: this.imageUrl,
      showHideOnBlur: true
    };
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onHide: function onHide() {
      console.log("隐藏视频窗口");
      this.$emit("onHideMyImage");
    }
  },
  watch: {
    imageUrl: function imageUrl(url) {
      this.activeUrl = url;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a434318","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/myImage/myImage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myImage"},[_c('x-dialog',{staticClass:"dialog-demo",attrs:{"hide-on-blur":""},on:{"on-hide":_vm.onHide},model:{value:(_vm.showHideOnBlur),callback:function ($$v) {_vm.showHideOnBlur=$$v},expression:"showHideOnBlur"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.activeUrl,"controls":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var myComponents_myImage_myImage = (esExports);
// CONCATENATED MODULE: ./src/myComponents/myImage/myImage.vue
function injectStyle (ssrContext) {
  __webpack_require__("h9JT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a434318"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  myImage_myImage,
  myComponents_myImage_myImage,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_myComponents_myImage_myImage = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TNon":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "U3F8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./src/S51WebGLSDK/define.js
var define = __webpack_require__("1/Ha");

// EXTERNAL MODULE: ./node_modules/axios/index.js + 37 modules
var axios = __webpack_require__("mtWM");

// CONCATENATED MODULE: ./src/S51WebGLSDK/utils/request.js


var request_createRequest = function createRequest(baseUrl) {
    console.log(baseUrl, "baseUrl");
    var r = axios["a" /* default */].create({
        // API 请求的默认前缀
        baseURL: baseUrl,
        timeout: 35000 // 请求超时时间
    });
    return r;
};


// EXTERNAL MODULE: ./node_modules/ua-device/index.js
var ua_device = __webpack_require__("rCgY");
var ua_device_default = /*#__PURE__*/__webpack_require__.n(ua_device);

// CONCATENATED MODULE: ./src/S51WebGLSDK/utils/utils.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utils_utils; });








var utils_utils = function () {
    function utils() {
        classCallCheck_default()(this, utils);
    }

    createClass_default()(utils, null, [{
        key: "getUrlParams",
        value: function getUrlParams(url) {

            var result = {};
            var arr_ = url.split('?');
            if (arr_.length <= 1) {
                return result;
            }
            var paramArr = arr_[1].split('&');
            for (var i = 0; i < paramArr.length; ++i) {
                var _arr = paramArr[i].split('=');
                if (_arr.length == 2) {
                    result[_arr[0]] = _arr[1];
                }
            }
            return result;
        }
    }, {
        key: "getModelNameRemoveVersion",
        value: function getModelNameRemoveVersion(name) {
            if (!name) {
                return;
            }
            var index = name.lastIndexOf("_V");
            if (index < 0) {
                //尝试区分下大小写
                index = name.lastIndexOf("_v");
            }
            if (index < 0) {
                //使用源字符串
                return name;
            }
            var nameNew = name.substring(0, index);
            nameNew = nameNew.toLowerCase();
            return nameNew;
        }
    }, {
        key: "postData",
        value: function postData(url, api, data) {
            return new promise_default.a(function (resolve, reject) {
                request_createRequest(url).request({
                    url: api,
                    method: 'post',
                    headers: {
                        // 'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data: data
                }).then(function (dat) {
                    console.log('----', dat);
                    if (dat.status != 200) {
                        reject(dat.status, '请求失败');
                    } else {
                        resolve(dat.data);
                    }
                }, function (err) {
                    reject(501, '请求失败');
                });
            });
        }
    }, {
        key: "getNavicatObj",
        value: function getNavicatObj() {

            var output = new ua_device_default.a(navigator.userAgent);
            return output;
        }
    }, {
        key: "parseRobotMessage",
        value: function parseRobotMessage(message) {
            var _parseRobotImgMessage = this.parseRobotImgMessage(message),
                _parseRobotImgMessage2 = slicedToArray_default()(_parseRobotImgMessage, 2),
                isImg = _parseRobotImgMessage2[0],
                url = _parseRobotImgMessage2[1];

            if (isImg) {
                return [define["b" /* CHAT_MSG_TYPE */].IMG, url];
            }
            return [define["b" /* CHAT_MSG_TYPE */].WORD, message];
        }
    }, {
        key: "parseRobotImgMessage",
        value: function parseRobotImgMessage(message) {
            var regex = /https?:\/\/[^\s]+/g;
            var matches = message.replace(/^!\[\]\((.*)\)$/, '$1');
            var url = matches.split("?")[0];
            var lastExt = url.substring(url.lastIndexOf('.') + 1);
            console.log('url', lastExt);
            var IMG_EXT = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'bmp', 'ico'];
            if (IMG_EXT.indexOf(lastExt.toLowerCase()) >= 0) {
                return [true, matches];
            } else {
                return [false, message];
            }
        }
    }, {
        key: "dataURLToBlob",
        value: function dataURLToBlob(dataurl) {
            var type = dataurl.match(/data:(.+);/)[1];
            var base64 = dataurl.split(',')[1];
            var binStr = atob(base64);
            var u8a = new Uint8Array(binStr.length);
            var p = binStr.length;
            while (p) {
                p--;
                u8a[p] = binStr.codePointAt(p);
            }
            return new Blob([u8a], { type: type });
        }
    }, {
        key: "dataURLtoFile",
        value: function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }
    }]);

    return utils;
}();



/***/ }),

/***/ "Uh5A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V+Qo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WzIO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./src/S51WebGLSDK/define.js
var define = __webpack_require__("1/Ha");

// EXTERNAL MODULE: ./src/S51WebGLSDK/utils/utils.js + 1 modules
var utils = __webpack_require__("U3F8");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__("Ml+6");

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/stats.module.js
var stats_module = __webpack_require__("QLyc");

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/controls/OrbitControls.js
var OrbitControls = __webpack_require__("BMSc");

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/loaders/GLTFLoader.js + 1 modules
var GLTFLoader = __webpack_require__("hV/q");

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/loaders/FBXLoader.js + 2 modules
var FBXLoader = __webpack_require__("T9FJ");

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/environments/RoomEnvironment.js
var RoomEnvironment = __webpack_require__("csbk");

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/loaders/exrloader.js
var exrloader = __webpack_require__("gg4D");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./src/eventBus/index.js
var eventBus = __webpack_require__("Kw3Y");

// CONCATENATED MODULE: ./src/S51WebGLSDK/audioPlayer.js











//启用缓存
three_module["l" /* Cache */].enabled = true;
var JAWOPEN = 'jawOpen';
var viseme_map = {
    'PP': 1,
    'FF': 1,
    'TH': 1,
    'DD': 1,
    'kk': 1,
    'CH': 1,
    'SS': 1,
    'nn': 1,
    'RR': 1,
    'aa': 1,
    'E': 1,
    'I': 1,
    'O': 1,
    'U': 1,
    'sil': 1,
    'jawOpen': 1

};

var STATE_PLAY = {
    FREE: 0,
    PLAYING: 1,
    ENDED: 2
};
var audioPlayer_AudioPlayer = function () {
    function AudioPlayer() {
        classCallCheck_default()(this, AudioPlayer);

        this.audioListener = undefined;
        this.audioSound = undefined;
        this.bodyModel = undefined;
        this.phonemeJasonData = undefined; //音素数据
        this.morphControl = undefined;
        this.morphDict = undefined;
        this.nextFrame = 0;
        this.currentFrame = -1;
        this.currentFrameStartTime = 0; //当前口型开始时间
        this.startlayTime = 0;
        this.endTime = 0;
        this.eventHandler = undefined;
        this.statePlay = 0; //STATE_PLAY 0-未开始 1-播放中 2-播放结束
        //口型驱动相关参数
        this.exponent = 5;
        this.intensity = 0.8, //口型变化强度
        this.dec = 10;
        this.defStep = 0.07, //口型变化步长 会在initDefStep方法中重新初始化
        this.currentFrameDelyaTime = 100; //当前口型持续时间 会在initDefStep方法中重新初始化
        this.endDelay = 1000; //结束之后延时（嘴型还原时间）
    }
    /**
     * 加载音素数据
     * @param {*} url 
     */


    createClass_default()(AudioPlayer, [{
        key: "loadPhonemeData",
        value: function loadPhonemeData(url) {
            return new promise_default.a(function (resolve, reject) {
                var fileLoader = new three_module["y" /* FileLoader */]();
                fileLoader.load(url, function (data) {
                    resolve(data);
                }, function (process) {}, function (err) {
                    reject(err);
                });
            });
        }
        /**
         * 设置监听回调
         * @param {} handler 
         */

    }, {
        key: "setEventListener",
        value: function setEventListener(handler) {
            this.eventHandler = handler;
        }
        /**
         * 发送事件
         * @param {*} event 
         * @param {*} data 
         */

    }, {
        key: "emitEvent",
        value: function emitEvent(event, data) {
            console.log('emit event', event, data);
            if (this.eventHandler) this.eventHandler(event, data);
        }

        /**
         * 计算步长信息
         */

    }, {
        key: "initDefStep",
        value: function initDefStep() {
            if (this.phonemeJasonData.length <= 1) {
                return;
            }
            var timeTotal = 0;
            for (var i = 1; i < this.phonemeJasonData.length; ++i) {
                timeTotal += this.phonemeJasonData[i].time - this.phonemeJasonData[i - 1].time;
            }
            this.currentFrameDelyaTime = timeTotal / this.phonemeJasonData.length - 1;
            this.defStep = 1.0 / (60.0 / 1000 * this.currentFrameDelyaTime); //形态键最大值/(fps/1000毫秒*每个口型持续时间平均值)
        }
    }, {
        key: "startAudioCtx",
        value: function startAudioCtx(startSec) {
            if (this._source && this.audioCtxPlaying) {
                this._source.stop();
            }
            this.audioCtxPlaying = true;
            this._source && this._source.start(0, startSec ? startSec : 0);
        }
        /**
         * 根据音频波形控制口行张合
         */

    }, {
        key: "initAudioCtx",
        value: function initAudioCtx(audioUrl, startSec) {

            var _sensitivityThreshold = .5;
            var samplingFrequency = 44100;
            var _voiceBoundingFrequencies = [0, 500, 700, 3000, 6000];
            var _audioSampleCount = { low: 256, med: 512, high: 1024 };
            var _smoothing = 0.5;
            var getstPSD = function getstPSD(spectrum) {

                var stPSD = new Float32Array(spectrum.length);

                for (var i = 0; i < spectrum.length; i++) {
                    stPSD[i] = _sensitivityThreshold + (spectrum[i] + 20) / 140;
                }

                return stPSD;
            };

            var _getData = function _getData(url) {
                var request = new XMLHttpRequest();

                request.open('GET', url, true);
                request.responseType = 'arraybuffer';

                return new promise_default.a(function (resolve, reject) {
                    request.onload = function () {
                        var audioData = request.response;
                        resolve(audioData);
                        console.log('audioData', audioData);
                    };

                    request.send();
                });
            };

            var _sampleCount = _audioSampleCount.high;
            var _indicesFrequencyMale = [];
            var _analyser = this.audioCtx.createAnalyser();
            this.audioCtxPlaying = false;
            var _this = this;
            _getData(audioUrl).then(function (audioData) {
                _this.audioCtx.decodeAudioData(audioData, function (_buffer) {
                    console.log('Buffer ready to play.');
                    for (var m = 0; m < _voiceBoundingFrequencies.length; m++) {
                        _indicesFrequencyMale[m] = Math.round(2 * _sampleCount / samplingFrequency * _voiceBoundingFrequencies[m]);
                        //console.log("IndicesFrequencyMale[",m,"]",_indicesFrequencyMale[m]);
                    }
                    _analyser.minDecibels = -160;
                    _analyser.maxDecibels = -25;
                    _analyser.smoothingTimeConstant = _smoothing;
                    _analyser.fftSize = _sampleCount;

                    _this._source = _this.audioCtx.createBufferSource();
                    _this._source.buffer = _buffer;
                    _this._source.connect(_analyser);
                    var gainNode = _this.audioCtx.createGain();
                    gainNode.connect(_this.audioCtx.destination);
                    gainNode.gain.value = 0; // 设置音量为0
                    _this._source.connect(gainNode);
                    if (_this._node) {
                        _this._node.onaudioprocess = null;
                        _this._node = null;
                    }
                    _this._node = _this.audioCtx.createScriptProcessor(_sampleCount * 2, 1, 1);
                    _analyser.connect(_this._node);
                    _this._node.onaudioprocess = function (_) {
                        if (!_this.audioCtxPlaying) return;
                        // console.log('=============== process')
                        var _spectrum = new Float32Array(_analyser.frequencyBinCount);
                        _analyser.getFloatFrequencyData(_spectrum);
                        var _stPSD = getstPSD(_spectrum);

                        var _blendShapeKiss = 0;
                        var _blendShapeLips = 0;
                        var _blendShapeMouth = 0;

                        var energyBinMale = new Float32Array(_voiceBoundingFrequencies.length);

                        for (var _m = 0; _m < _voiceBoundingFrequencies.length - 1; _m++) {
                            for (var j = _indicesFrequencyMale[_m]; j <= _indicesFrequencyMale[_m + 1]; j++) {
                                if (_stPSD[j] > 0) {
                                    energyBinMale[_m] += _stPSD[j];
                                }
                            }

                            energyBinMale[_m] /= _indicesFrequencyMale[_m + 1] - _indicesFrequencyMale[_m];
                        }

                        if (energyBinMale[1] > 0.2) {
                            _blendShapeKiss = 1 - 2 * energyBinMale[2];
                        } else {
                            _blendShapeKiss = (1 - 2 * energyBinMale[2]) * 5 * energyBinMale[1];
                        }

                        _blendShapeLips = 3 * energyBinMale[3];
                        _blendShapeMouth = 0.85 * (energyBinMale[1] - energyBinMale[3]);

                        var _blendShapes = {
                            blendShapeKiss: _blendShapeKiss,
                            blendShapeLips: _blendShapeLips,
                            blendShapeMouth: _blendShapeMouth
                        };
                        _this.morphControl[_this.morphDict[JAWOPEN]] = _blendShapeMouth;
                        //    EventBus.$emit(BUS_EVENT.ADD_LOG,_blendShapeMouth)
                    };

                    _this._node.connect(_this.audioCtx.destination);
                    _this.audioCtxPlaying = true;
                    _this._source.start(0, startSec ? startSec : 0);
                    _this._source.onended = function () {
                        console.log('播放结束');
                        _this.audioCtxPlaying = false;
                        _this.emitEvent(define["a" /* CHAT_EVNET */].END_AUDIO);
                        _this._node.onaudioprocess = null;
                    };
                }, function (err) {
                    console.log("Error with decoding audio data:" + err);
                    _this.emitEvent(define["a" /* CHAT_EVNET */].END_AUDIO);
                    reject(err);
                });
            }, function (err) {
                console.log("Error with decoding audio data:" + err);
                reject(err);
            });
        }
        /**
         * 播放音频文件，并驱动口型
         * @param {人物模型} bodyModel
         * @param {音频文件地址} audioUrl 
         * @param {音素文件地址} phonemeUrl 
         */

    }, {
        key: "playAudio",
        value: function playAudio(bodyModel, audioUrl, phonemeData, textData, duration, conf) {
            var _this2 = this;

            return new promise_default.a(function () {
                var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(resolve, reject) {
                    var startPlay;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    try {
                                        //停止正在播放的音频
                                        if (_this2.audioSound) {
                                            _this2.audioSound.pause();
                                        }
                                        _this2.nextFrame = 0;
                                        _this2.currentFrame = -1;
                                        _this2.statePlay = STATE_PLAY.FREE;
                                        bodyModel.scene.getObjectByName("Armature").traverse(function (o) {
                                            if (o.morphTargetInfluences) {

                                                _this2.morphControl = o.morphTargetInfluences;
                                                _this2.morphDict = o.morphTargetDictionary;
                                                console.log('找到形态键：', o.name, o.morphTargetDictionary);
                                            }
                                        });
                                        //加载音素数据
                                        // const jsonData = await this.loadPhonemeData(phonemeUrl)
                                        if (_this2.audioCtx) {
                                            _this2.audioCtx.close();
                                            delete _this2.audioCtx;
                                            _this2.audioCtx = null;
                                        }
                                        _this2.audioCtx = new (window.AudioContext || window.webkitAudioContext)();

                                        _this2.phonemeJasonData = phonemeData;
                                        _this2.textData = textData;
                                        console.log('音素数据：', _this2.phonemeJasonData);
                                        if (_this2.phonemeJasonData.length == 0 || _this2.phonemeJasonData[0].type != 'viseme') {
                                            _this2.emitEvent(define["a" /* CHAT_EVNET */].ERROR_AUDIO, '无法识别的音素数据:' + (_this2.phonemeJasonData.length == 0 ? '数组长度为0' : ''));
                                            reject("无法识别的音素数据");
                                        }
                                        _this2.initDefStep();
                                        console.log('计算出平均时长以及步长:', _this2.currentFrameDelyaTime, _this2.defStep);
                                        _this2.bodyModel = bodyModel;

                                        //加载音频文件
                                        if (!_this2.audioSound) {
                                            _this2.audioSound = new Audio();
                                        }

                                        _this2.audioSound.preload = 'none';
                                        _this2.audioSound.addEventListener('error', function (err) {
                                            //开始播放
                                            _this2.emitEvent(define["a" /* CHAT_EVNET */].ERROR_AUDIO, '语音加载失败:' + audioUrl);
                                            reject(err);
                                        });
                                        // this.audioSound.muted = true
                                        _this2.audioSound.src = audioUrl;
                                        _this2.playDuration = duration; //播放时长

                                        startPlay = function startPlay() {
                                            console.log('-------can start play');
                                            _this2.audioSound.removeEventListener('canplaythrough', startPlay);
                                            if (!_this2.isPlaying) {
                                                _this2.startPlayTime = Date.now() / 1000;
                                                _this2.isPlaying = true;
                                                _this2.isPlayMuted = false;
                                            }

                                            _this2.audioSound.currentTime = Date.now() / 1000 - _this2.startPlayTime;
                                            _this2.audioSound.addEventListener('seeked', function () {
                                                console.log('----------seeked');
                                                _this2.audioSound.muted = false;
                                                _this2.audioSound.play();
                                            });
                                            _this2.initAudioCtx(audioUrl, _this2.audioSound.currentTime + 0.1);
                                        };

                                        _this2.audioSound.removeEventListener('canplaythrough', startPlay);
                                        _this2.audioSound.addEventListener('canplaythrough', startPlay);

                                        _this2.startlayTime = 0;
                                        _this2.endTime = 0;

                                        if (conf.muted) {
                                            _this2.emitEvent(define["a" /* CHAT_EVNET */].MUTED_PLAY, '静音播放');
                                            _this2.startPlayTime = Date.now() / 1000;
                                            _this2.isPlaying = true;
                                            _this2.isPlayMuted = true;
                                        } else {
                                            //自动开始播放
                                            _this2.audioSound.muted = true; //开始播放前静音，等加载完成后再开始播放声音
                                            _this2.audioSound.load();
                                            _this2.audioCtx && _this2.audioCtx.resume(); //激活audioctx
                                        }
                                        _this2.emitEvent(define["a" /* CHAT_EVNET */].START_AUDIO, {
                                            message: _this2.textData,
                                            voiceDuration: _this2.phonemeJasonData.length > 0 ? _this2.phonemeJasonData[_this2.phonemeJasonData.length - 1].time : 0
                                        });
                                    } catch (e) {
                                        console.error(e);
                                        reject('加载音频失败');
                                    }

                                case 1:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this2);
                }));

                return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, {
        key: "setAudioMuted",
        value: function setAudioMuted(muted) {
            if (this.audioSound) {
                this.audioSound.muted = muted;
            }
            if (!muted && this.isPlayMuted && this.isPlaying) {
                //当前静音假播放，定位到时间点
                this.audioSound.muted = true; //开始播放前静音，等加载完成后再开始播放声音
                this.audioSound.play().then(function () {}, function (e) {
                    console.error('播放失败:', e);
                });
                this.audioCtx && this.audioCtx.resume(); //激活resume
            }
        }
    }, {
        key: "currentTime",
        value: function currentTime() {
            return Date.now() / 1000; //this.startPlayTime+ this.currentPlayTime
        }
        //取消所有形态键

    }, {
        key: "decreaseAllVisemes",
        value: function decreaseAllVisemes() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(keys_default()(this.morphDict)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var visemeName = _step.value;

                    this.morphControl[this.morphDict[visemeName]] = 0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: "nextViseme",
        value: function nextViseme() {
            // console.log('current frame',this.currentFrame)
            if (this.currentFrame > 0 && this.phonemeJasonData[this.currentFrame].value === this.phonemeJasonData[this.currentFrame - 1].value) {
                this.exponent -= 0.1;
            } else this.exponent = 10;
            // decrease all visemes
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = get_iterator_default()(keys_default()(this.morphDict)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var visemeName = _step2.value;


                    if (viseme_map[visemeName]) {
                        this.morphControl[this.morphDict[visemeName]] -= this.intensity / this.dec;
                        if (this.morphControl[this.morphDict[visemeName]] < 0) this.morphControl[this.morphDict[visemeName]] = 0;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (!this.isPlaying) {
                return;
            }
            if (this.currentFrame >= 0 && this.currentFrame < this.phonemeJasonData.length) {
                var visemeName = this.phonemeJasonData[this.currentFrame].value;
                var mapping = defineProperty_default()({}, visemeName, 1);
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = get_iterator_default()(keys_default()(mapping)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var currentVisemeName = _step3.value;

                        //   console.log('currentVisemeName pre',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
                        if (this.morphControl[this.morphDict[currentVisemeName]] == undefined) continue;
                        // calculate the added value
                        var inc = Math.pow(this.intensity, this.exponent);
                        // check if the visime is relative
                        if (mapping[currentVisemeName] > 1) inc /= 4;
                        //   console.log('inc ',inc)
                        //   console.log('increase 0',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
                        // add the value
                        this.morphControl[this.morphDict[currentVisemeName]] += this.intensity / this.dec;
                        // console.log('increase 1',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
                        this.morphControl[this.morphDict[currentVisemeName]] += inc;
                        //   console.log('increase 2',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
                        // check constraints
                        if (this.morphControl[this.morphDict[currentVisemeName]] > 1 && mapping[currentVisemeName] > 1) this.morphControl[this.morphDict[currentVisemeName]] = 1;
                        if (this.morphControl[this.morphDict[currentVisemeName]] > mapping[currentVisemeName] * this.intensity && !(mapping[currentVisemeName] > 1)) this.morphControl[this.morphDict[currentVisemeName]] = mapping[currentVisemeName] * this.intensity;
                        //   console.log('increase 3',currentVisemeName,this.morphControl[this.morphDict[currentVisemeName]])
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }

            var nextFrame = this.currentFrame + 1;
            //  console.log('----1',nextFrame)
            if (nextFrame < this.phonemeJasonData.length) {
                // console.log('----2')
                var nextVisemeData = this.phonemeJasonData[nextFrame];
                var nextTime = this.currentTime() * 1000 - this.startlayTime - 20; //-20为了提前驱动口型
                if (nextTime < 0) nextTime = 0;
                // console.log('----3 nextTime',nextTime,nextVisemeData.time)
                if (nextTime >= nextVisemeData.time) {
                    this.currentFrame = nextFrame;
                    this.currentFrameStartTime = this.currentTime() * 1000;
                }
            }
        }
    }, {
        key: "updateAudioDelta",
        value: function updateAudioDelta() {
            return;
            if (this.isPlaying) {
                if (this.statePlay == STATE_PLAY.FREE) {
                    this.startlayTime = this.currentTime() * 1000;

                    this.statePlay = STATE_PLAY.PLAYING;
                }
                this.nextViseme();
                //播放结束
                if (Date.now() / 1000 - this.startPlayTime > this.playDuration) {
                    this.isPlaying = false;
                }
            } else if (this.statePlay == STATE_PLAY.PLAYING) {
                if (this.startlayTime > 0) {
                    if (this.endTime == 0) this.endTime = Date.now();else if (Date.now() - this.endTime < this.endDelay) this.nextViseme();else {
                        this.statePlay = STATE_PLAY.ENDED;
                        this.emitEvent(define["a" /* CHAT_EVNET */].END_AUDIO);
                        this.eventHandler = undefined;
                    }
                }
            }
        }
    }, {
        key: "stopNowVoice",
        value: function stopNowVoice() {
            if (this.audioSound) this.audioSound.pause();
            this.audioCtxPlaying = false;
            this.isPlaying = false;
            this.emitEvent(define["a" /* CHAT_EVNET */].END_AUDIO);
        }
    }, {
        key: "initAudioDict",
        value: function initAudioDict(bodyModel) {
            var _this3 = this;

            bodyModel.scene.getObjectByName("Armature").traverse(function (o) {
                if (o.morphTargetInfluences) {

                    _this3.morphControl = o.morphTargetInfluences;
                    _this3.morphDict = o.morphTargetDictionary;
                    console.log('找到形态键：', o.name, o.morphTargetDictionary);
                }
            });
            this.bodyModel = bodyModel;
        }
    }, {
        key: "setJWAOpenValue",
        value: function setJWAOpenValue(value) {
            if (this.morphControl && this.morphDict) {
                this.morphControl[this.morphDict[JAWOPEN]] = value;
            }
        }
    }]);

    return AudioPlayer;
}();
// CONCATENATED MODULE: ./src/S51WebGLSDK/utils/config.js
var S51Config = {
    "dev": {
        HUMAN_URL: "https://xiaochengxu.studio51.com",
        HUMAN_SIGN: "studio51"
    },
    "pro": {
        HUMAN_URL: "https://xiaochengxu.studio51.com",
        HUMAN_SIGN: "studio51"
    }
};
// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("Av7u");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// CONCATENATED MODULE: ./src/S51WebGLSDK/action/actionItem.js



var actionItem_ActionItem = function () {
    function ActionItem(action, actionKey, isIdleAction, weight) {
        classCallCheck_default()(this, ActionItem);

        this.actionKey = actionKey;
        this.action = action;
        this.isIdleAction = isIdleAction ? isIdleAction : false;
        this.weight = weight | 0;
        this.playTime = 0;
    }

    createClass_default()(ActionItem, [{
        key: "pauseAction",
        value: function pauseAction() {
            if (this.action) {
                this.action.paused = true;
            }
        }
    }, {
        key: "unPauseAction",
        value: function unPauseAction() {
            if (this.action) {
                this.action.paused = false;
            }
        }
    }, {
        key: "updateWeight",
        value: function updateWeight() {
            if (this.action) {
                this.weight = this.action.getEffectiveWeight();
            }
        }
    }, {
        key: "updatePlayTime",
        value: function updatePlayTime(time) {
            this.playTime = time || Date.now();
        }
    }, {
        key: "release",
        value: function release() {}
    }]);

    return ActionItem;
}();

/* harmony default export */ var actionItem = (actionItem_ActionItem);
// CONCATENATED MODULE: ./src/S51WebGLSDK/action/actionMgr.js









var defaultCrossDuration = 0.1;
var START_FRAME = 1;

var actionMgr_ActionMgr = function () {
    function ActionMgr(modelScene) {
        classCallCheck_default()(this, ActionMgr);

        this.actionsMap = new map_default.a();
        this.currentActionKey = undefined;
        this.idleActionKey = undefined;
        this.modelScene = modelScene;
        if (modelScene.getObjectByName("Armature")) {
            this.rootBone = modelScene.getObjectByName("Armature").getObjectByName("RootNode").getObjectByName("Hips");
        }
        this.animationMixer = new three_module["c" /* AnimationMixer */](modelScene); //动作混合器
        // this.animationMixer.timeScale = 1.5;
        this.animationMixer.addEventListener('finished', this.actionFinished.bind(this));
        this.animationMixer.addEventListener('loop', this.onAnimationLoop.bind(this));
    }

    createClass_default()(ActionMgr, [{
        key: "updateMixerDelate",
        value: function updateMixerDelate(deltaTime) {
            if (this.animationMixer) {
                this.animationMixer.update(deltaTime);
            }
        }
        //加载动作文件

    }, {
        key: "loadAction",
        value: function loadAction(actionFile, processCall) {
            return new promise_default.a(function (resolve, reject) {
                if (actionFile) {
                    var fbxloader = new FBXLoader["a" /* FBXLoader */]();
                    fbxloader.load(actionFile, function (animation) {
                        // console.log('加载动作', animation)
                        if (animation.animations.length) {
                            animation = animation.animations[0];
                            console.log('动作时长度', animation.duration);
                            // 剪辑动画
                            var frameRate = animation.tracks[0].times.length / animation.duration; // 获取帧速率
                            var subclipAnimation = three_module["d" /* AnimationUtils */].subclip(animation, 'subclip', START_FRAME, animation.duration * frameRate, frameRate);
                            subclipAnimation.resetDuration(animation.duration);
                            // console.log('动作subclip', subclipAnimation)
                            return resolve(subclipAnimation);
                        } else {
                            return reject('未找到动作信息');
                        }
                    }, function (process) {
                        processCall && processCall(process);
                    });
                } else {
                    reject('没有找到动作，不绑定动作');
                }
            });
        }

        /**
         * 直接播放动作
         * @param {*} actionFile 
         * @returns 
         */

    }, {
        key: "playAction",
        value: function playAction(actionFile) {
            var _this = this;

            this.loadAction(actionFile).then(function (animation) {

                var action = _this.animationMixer.clipAction(animation, _this.rootBone);
                _this.setAction(actionFile, action);
                //从第一帧开始播放，播放一次
                action.setLoop(three_module["W" /* LoopOnce */], START_FRAME);
                //播放结束后停在最后一帧
                action.clampWhenFinished = true;
                action.play();
                console.log('播放动作', actionFile);
            }, function (err) {
                console.log('加载动作文件失败', err);
            });
        }
    }, {
        key: "loadFileToAction",
        value: function () {
            var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(actionFiles, idleActionFile, processCall) {
                var _this2 = this;

                var actionCount, _loop, i, action;

                return regenerator_default.a.wrap(function _callee$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                actionCount = actionFiles.length;
                                _loop = /*#__PURE__*/regenerator_default.a.mark(function _loop(i) {
                                    var actionFile, animation;
                                    return regenerator_default.a.wrap(function _loop$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    actionFile = actionFiles[i];

                                                    if (_this2.getAction(actionFile)) {
                                                        _context.next = 8;
                                                        break;
                                                    }

                                                    _context.next = 4;
                                                    return _this2.loadAction(actionFile, function (process) {
                                                        var percent = void 0;
                                                        if (process.loaded >= process.total && i == actionCount - 1) {
                                                            percent = 100;
                                                        } else {
                                                            var itemProcess = process.loaded / process.total; //将多个衣服的进度组成一个整体进度
                                                            var loadedProcess = ((1 / actionCount * itemProcess + i / actionCount) * 100).toFixed(2);
                                                            percent = loadedProcess;
                                                        }
                                                        if (processCall) {
                                                            processCall({
                                                                finished: percent == '100' ? true : false,
                                                                percent: percent
                                                            });
                                                        }
                                                    });

                                                case 4:
                                                    animation = _context.sent;
                                                    action = _this2.animationMixer.clipAction(animation, _this2.rootBone);

                                                    _this2.setAction(actionFile, action, actionFile == idleActionFile);
                                                    console.log('load acion success', actionFile);

                                                case 8:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }
                                    }, _loop, _this2);
                                });
                                i = 0;

                            case 3:
                                if (!(i < actionCount)) {
                                    _context2.next = 8;
                                    break;
                                }

                                return _context2.delegateYield(_loop(i), "t0", 5);

                            case 5:
                                ++i;
                                _context2.next = 3;
                                break;

                            case 8:
                                this.activateIdelActions();
                                return _context2.abrupt("return", [null]);

                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadFileToAction(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return loadFileToAction;
        }()
    }, {
        key: "setIdleActionKey",
        value: function setIdleActionKey(actionKey) {
            this.idleActionKey = actionKey;
        }
    }, {
        key: "getActionItem",
        value: function getActionItem(actionKey) {
            if (this.actionsMap.has(actionKey)) {
                return this.actionsMap.get(actionKey);
            } else {
                return null;
            }
        }
    }, {
        key: "setAction",
        value: function setAction(actionKey, action, isIdleAction) {
            console.log('set action', actionKey);

            action.clampWhenFinished = true;
            if (isIdleAction) {
                action.setLoop(three_module["X" /* LoopRepeat */]);
            } else action.setLoop(three_module["W" /* LoopOnce */]);

            this.actionsMap.set(actionKey, new actionItem(action, actionKey, isIdleAction));
            if (isIdleAction) {
                this.idleActionKey = actionKey;
            }
        }
    }, {
        key: "pauseAllActions",
        value: function pauseAllActions() {
            this.actionsMap.forEach(function (action, key) {
                action.pauseAction();
            });
        }
    }, {
        key: "unPauseAllActions",
        value: function unPauseAllActions() {
            this.actionsMap.forEach(function (action, key) {
                action.unPauseAction();
            });
        }
    }, {
        key: "activateIdelActions",
        value: function activateIdelActions() {
            this.idleActionKey && this.idleActionKey.length > 0 && this.fadeToAction(this.idleActionKey, 1);
        }
    }, {
        key: "getAction",
        value: function getAction(actionKey) {
            return this.actionsMap.get(actionKey);
        }
    }, {
        key: "actionFinished",
        value: function actionFinished() {
            var _this3 = this;

            console.log('动作结束', this.currentActionKey);
            //恢复默认动作 
            if (this.currentActionKey != this.idleActionKey) {
                if (Date.now() - this.getAction(this.currentActionKey).playTime < 2000) {
                    //动作播放小于3秒中，需要等待3秒再结束
                    setTimeout(function () {
                        _this3.fadeToAction(_this3.idleActionKey, 0.5);
                    }, 2000);
                } else {
                    this.fadeToAction(this.idleActionKey, 0.5);
                }
            }
        }
    }, {
        key: "onAnimationLoop",
        value: function onAnimationLoop(event) {}
    }, {
        key: "fadeToAction",
        value: function fadeToAction(actionKey, duration, ignoreListener) {
            console.log('渐进动作', actionKey, duration);
            if (!this.getAction(actionKey)) {
                console.error('动作不存在', actionKey);
                return;
            }

            var preActionKey = this.currentActionKey;

            if (preActionKey) {

                if (preActionKey != actionKey) //上一个动作淡出
                    this.getAction(preActionKey) && this.getAction(preActionKey).action.fadeOut(duration || defaultCrossDuration);else //动作没有变化
                    {
                        console.log('新动作与旧动作相同');
                        return;
                    }
            }
            this.getAction(actionKey).action.clampWhenFinished = true;
            this.getAction(actionKey).action.reset().setEffectiveTimeScale(1).setEffectiveWeight(1).fadeIn(duration || defaultCrossDuration).play();
            this.getAction(actionKey).updatePlayTime();
            this.currentActionKey = actionKey;
        }
        /**
         * 释放所有动作文件
         */

    }, {
        key: "release",
        value: function release() {
            this.actionsMap.forEach(function (action, key) {
                action.release();
            });
            this.actionsMap.clear();
        }
    }]);

    return ActionMgr;
}();

/* harmony default export */ var actionMgr = (actionMgr_ActionMgr);
// CONCATENATED MODULE: ./src/S51WebGLSDK/WebGlLoader.js









// 导入控制器





// core version + navigation, pagination modules:







var EYE_BLINK_LEFT = 'eyeBlinkLeft';
var EYE_BLINK_RIGHT = 'eyeBlinkRight';
var EYE_BLINK_STEP = 0.05; //眨眼步长
var g_removeDefaultFlag = false;
var isLoading = false;
var mainScene = void 0;
var renderer = void 0;
var mainCamera = void 0;
var g_defaultClothesNames = [];
var g_characterBones = new map_default.a();
var g_clothesModels = [];
var m_defaultClothMesh = [];
var eyeBlindWaitCount = 60 * 3; //60fps*3秒
var WIDTH = 1080;
var HEIGHT = 1920;
var cameraPosition = [0, 1.4, 3];
var cameraCutImgPosition = [0, 1.4, 2.4];
//创建时钟
var clock = new three_module["n" /* Clock */]();
// 设置渲染频率为30FBS，也就是每秒调用渲染器render方法大约30次
var FPS = 60;
var renderT = 1 / FPS; //单位秒  间隔多长时间渲染渲染一次
// 声明一个变量表示render()函数被多次调用累积时间
// 如果执行一次renderer.render，timeS重新置0
var timeS = 0;
var myConsole = function myConsole() {
    var _console;

    return;
    (_console = console).log.apply(_console, arguments);
};

var WebGlLoader_WebGlLoader = function () {
    function WebGlLoader(documentContainer, backColor, secretConfig, isDev) {
        classCallCheck_default()(this, WebGlLoader);

        this.config = S51Config[isDev ? "dev" : "pro"];
        this.isDev = isDev ? isDev : false;
        this.g_removeDefaultFlag = false;
        this.loader = new GLTFLoader["a" /* GLTFLoader */]();
        this.g_model = undefined;
        this.audioPlayer = new audioPlayer_AudioPlayer();
        this.appID = secretConfig.appID;
        this.token = secretConfig.token;
        this.animationID = undefined;
        this.clothSet = new map_default.a();
        this.actionMgr = undefined;
        this.mainModelMap = new map_default.a();
        //眨眼参数
        this.lidMove = 0.08;
        this.lidSpeed = 0.08;
        this.lidWait = 1;

        this.cutImgCallBack = null;
        this.cutState = 0;
        //初始化 threejs
        // myConsole('container ', documentContainer)

        this.container = documentContainer;
        // 加载左上角进度
        if (isDev) {
            this.stats = new stats_module["a" /* default */]();
            this.stats.showPanel(2);
            this.container.appendChild(this.stats.dom);
            this.stats.dom.style.display = 'none'; //默认隐藏
        }

        renderer = new three_module["_44" /* WebGLRenderer */]({
            antialias: true,
            alpha: true //背景透明
        });
        myConsole('windows size', window.innerWidth, window.innerHeight);

        renderer.setPixelRatio(window.devicePixelRatio);
        // renderer.setSize(window.innerWidth, window.innerHeight);
        this.widht = window.innerWidth;
        this.height = HEIGHT / WIDTH * window.innerWidth;

        renderer.setSize(this.widht, this.height);
        renderer.outputEncoding = three_module["_45" /* sRGBEncoding */]; //材质
        renderer.shadowMap.enabled = true;
        renderer.getContext().canvas.addEventListener('webglcontextlost', function (event) {
            myConsole('webglcontext lost');
        }, false);

        this.container.appendChild(renderer.domElement);
        this.pmremGenerator = new three_module["_16" /* PMREMGenerator */](renderer);
        mainScene = new three_module["_27" /* Scene */]();
        // mainScene.background = new THREE.Color(backColor);
        // mainScene.environment = this.pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture;


        this.dirLight = new three_module["s" /* DirectionalLight */](0xffffff, 0.4);
        this.dirLight.position.set(5, 10, 10);
        mainScene.add(this.dirLight);

        var light = new three_module["a" /* AmbientLight */](0xffffff); // 创建一个环境光
        mainScene.add(light);

        mainCamera = new three_module["_17" /* PerspectiveCamera */](45, this.widht / this.height, 1, 1000);
        // camera.position.set( 15, 12, 18 );
        mainCamera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);

        // 添加坐标轴辅助器
        // this.axesHelper = new THREE.AxesHelper(5);
        // mainScene.add(this.axesHelper);
        window.onresize = function () {
            this.width = window.innerWidth; //canvas画布高度
            this.height = HEIGHT / WIDTH * window.innerWidth; //canvas画布宽度
            renderer.setSize(this.width, this.height);
            mainCamera.aspect = this.width / this.height;
            mainCamera.updateProjectionMatrix();
        };
        this.controls = new OrbitControls["a" /* OrbitControls */](mainCamera, renderer.domElement);
        this.controls.target.set(0, 0.8, 0);
        this.controls.update();
        this.controls.enableDamping = true;
        // 限制 放大缩小
        this.controls.maxDistance = 8;
        this.controls.minDistance = 2.5;
        // 平移
        this.controls.listenToKeyEvents(window); // optional
        this.controls.enablePan = true; //开启右键拖拽
        this.controls.enableKeys = true;
        this.controls.touches = {
            ONE: three_module["_33" /* TOUCH */].ROTATE,
            TWO: three_module["_33" /* TOUCH */].DOLLY_ROTATE
        };

        this.controls.minPolarAngle = 0; //上下翻转最小角度
        this.controls.maxPolarAngle = 2.2; //上下翻转最大角度


        if (secretConfig.helper) {
            var dirHelper = new three_module["t" /* DirectionalLightHelper */](this.dirLight, 1);
            mainScene.add(dirHelper);

            var axesHelper = new three_module["e" /* AxesHelper */](5);
            mainScene.add(axesHelper);

            //正交投影照相机
            // const camera2 = new THREE.OrthographicCamera(-1, 1, 1, -1, 5, 10);

            // camera2.position.set(cameraPosition[0],cameraPosition[1],cameraPosition[2],);
            // camera2.lookAt(new THREE.Vector3(0, 0, 0));

            // //照相机帮助线
            // const cameraHelper = new THREE.CameraHelper(camera2);
            // mainScene.add(cameraHelper);
        }

        //canvas居中
        renderer.domElement.style.position = 'absolute';
        renderer.domElement.style.top = '0';
        renderer.domElement.style.left = '0';
        renderer.domElement.style.top = '0';
        renderer.domElement.style.bottom = '0';
        renderer.domElement.style.margin = 'auto';
        this.animate();
    }
    /**
     * 重置一些参数
     */


    createClass_default()(WebGlLoader, [{
        key: "reset",
        value: function reset() {
            this.morphControl = undefined;
            this.morphDict = undefined;
            this.eyeBlinkChange = EYE_BLINK_STEP; //默认先一步步闭眼睛
        }
    }, {
        key: "enableControl",
        value: function enableControl(enable) {
            this.controls.enabled = enable;
        }
    }, {
        key: "resetAppID",
        value: function resetAppID(appId) {
            this.appID = appId;
        }
    }, {
        key: "updateClothesBone2CharacterBone",
        value: function updateClothesBone2CharacterBone() {

            g_clothesModels.forEach(function (obj) {
                var obj_ = obj.scene;
                if (!obj_) return;

                obj_ = obj_.getObjectByName("Armature");
                if (!obj_) return;

                obj_ = obj_.getObjectByName("RootNode");
                if (!obj_) return;

                obj_ = obj_.getObjectByName("Hips");
                //获取衣服的骨骼
                var objRootBone = obj_;
                if (!objRootBone) {
                    //没有找到根骨骼，怀疑是骨骼父节点名字错误，尝试遍历查找跟骨骼
                    obj.scene.traverse(function (obj) {
                        if (obj.isBone && obj.name == "Hips") {
                            objRootBone = obj;
                        }
                    });
                }
                if (objRootBone) {
                    objRootBone.traverse(function (bone) {
                        var matchingBone = g_characterBones.get(bone.name);
                        if (matchingBone) {
                            // bone.position.copy(matchingBone.position);
                            // bone.quaternion.copy(matchingBone.quaternion);
                            bone.position.copy(matchingBone.position);
                            bone.quaternion.copy(matchingBone.quaternion);
                            bone.scale.copy(matchingBone.scale);
                        }
                    });
                }
            });
        }
        //在渲染循环中更新动画 

    }, {
        key: "animate",
        value: function animate() {
            var self = this;
            this.animationID = requestAnimationFrame(function () {
                self.animate();
            });

            var deltaTime = clock.getDelta();
            if (this.actionMgr) this.actionMgr.updateMixerDelate(deltaTime);
            //绑定衣服与人物动作一致
            this.updateClothesBone2CharacterBone();
            if (this.audioPlayer) {
                this.audioPlayer.updateAudioDelta();
            }
            //眼睛动作
            this.eyeBlinkUpdate();

            //截图
            if (this.cutImgCallBack && this.cutState == 0 //需要截图，并且未在截图状态
            && this.morphControl && this.morphDict && this.morphControl[this.morphDict[EYE_BLINK_LEFT]] <= 0) {
                try {
                    this.cutImag();
                } catch (e) {
                    console.error(e);
                }
            }

            if (this.stats) {
                this.stats.update();
            }
            renderer.render(mainScene, mainCamera);
        }
    }, {
        key: "loadHdrModel",
        value: function loadHdrModel(hdrModel) {
            return new promise_default.a(function (resolve, reject) {
                return resolve(); //暂时不使用hdr环境光
                // 加载场景灯光
                var rgbeLoader = new exrloader["a" /* EXRLoader */]();
                // myConsole('load hdr:', hdrModel)
                rgbeLoader.load(hdrModel, function (texture) {
                    texture.mapping = three_module["v" /* EquirectangularReflectionMapping */];
                    mainScene.environment = texture; // 加了纹理，默认衣服显示有问题
                    return resolve();
                }, function (process) {}, function (err) {
                    console.error(err);
                    reject();
                });
            });
        }
    }, {
        key: "loadMainGLTF",
        value: function loadMainGLTF(mainUrl, success, processCall, error) {
            // myConsole('加载模型:', this.mainModelMap)
            var urlMd5 = crypto_js_default.a.MD5(mainUrl).toString();
            if (this.mainModelMap.has(urlMd5)) {
                myConsole('模型已加载，直接返回 ', urlMd5);
                success && success(this.mainModelMap.get(urlMd5));
                return;
            }
            if (this.mainLoader) {
                delete this.mainLoader;
                this.mainLoader = null;
            }
            this.mainLoader = new GLTFLoader["a" /* GLTFLoader */]();
            var self = this;
            this.mainLoader.load(mainUrl,
            //loader.load('http://xcx.download.studio51.com/Female_V2.glb',
            function (gltf) {

                self.mainLoader = null;
                // self.mainModelMap.set(urlMd5, gltf) //因为ios内存限制暂时去掉模型缓存
                success && success(gltf);
            }, function (process) {
                processCall && processCall(process);
            }, function (err) {
                error && error(err);
            });
        }
        /**
         * 加载人物模型
         * mainUrl: 任务模型
         * defaultClothMeshName: 人物自带服装
         * hdrUrl 
         * changeCloth 默认更换服装
         */

    }, {
        key: "loadMainModel",
        value: function loadMainModel(mainUrl, defaultClothMeshName, hdrUrl, changeCloth, actions, defaultAction, config, processCallback, resultCallback) {

            myConsole('init main model---------', mainUrl);
            //保存默认服装名称
            g_defaultClothesNames.length = 0;
            if (defaultClothMeshName && defaultClothMeshName.length > 0) {
                g_defaultClothesNames.push.apply(g_defaultClothesNames, toConsumableArray_default()(defaultClothMeshName));
            }

            //加载人物模型      
            if (this.g_model) {
                //删除旧模型
                mainScene.remove(this.g_model.scene);
                this.g_model.scene.traverse(function (child) {
                    if (child.material) {
                        child.material.dispose();
                    }
                    if (child.geometry) {
                        child.geometry.dispose();
                    }
                    child = null;
                });

                this.g_model = null;
            }

            if (this.audioPlayer) {
                this.audioPlayer.stopNowVoice();
            }
            var self = this;
            // myConsole('mainScene', mainScene)
            this.loadMainGLTF(mainUrl,
            //loader.load('http://xcx.download.studio51.com/Female_V2.glb',
            function () {
                var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(gltf) {
                    var _m_defaultClothMesh;

                    return regenerator_default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    self.reset();
                                    // myConsole("人物模型 ：", gltf.scene)
                                    // myConsole('默认服装 ', g_defaultClothesNames)

                                    //删除服装
                                    m_defaultClothMesh && m_defaultClothMesh.length > 0 && m_defaultClothMesh.forEach(function (child) {
                                        child.material.dispose && child.material.dispose();
                                    });
                                    m_defaultClothMesh.length = 0;

                                    self.clothSet && self.clothSet.size > 0 && self.clothSet.forEach(function (child) {
                                        // myConsole('---child',child)
                                        child.scene && child.scene.material && child.scene.material.dispose && child.material.dispose();
                                    });
                                    g_clothesModels = [];
                                    g_characterBones.clear();
                                    m_defaultClothMesh = [];
                                    self.clothSet.clear();

                                    three_module["l" /* Cache */].clear();
                                    if (self.actionMgr) {
                                        self.actionMgr.release();
                                        delete self.actionMgr;
                                        self.actionMgr = null;
                                    }
                                    self.actionMgr = new actionMgr(gltf.scene);

                                    g_removeDefaultFlag = false;
                                    m_defaultClothMesh.length = 0;
                                    (_m_defaultClothMesh = m_defaultClothMesh).push.apply(_m_defaultClothMesh, toConsumableArray_default()(self.getDefaultClotheObjs(gltf.scene, g_defaultClothesNames)));
                                    self.g_model = gltf;
                                    // myConsole("人物模型加载完成",mainScene);
                                    _context.next = 17;
                                    return self.loadHdrModel(hdrUrl);

                                case 17:
                                    if (!(changeCloth && changeCloth.length > 0)) {
                                        _context.next = 27;
                                        break;
                                    }

                                    _context.prev = 18;
                                    _context.next = 21;
                                    return self.loadAndCloth(changeCloth, function (process) {
                                        processCallback && processCallback({
                                            finished: false,
                                            percent: 80 + process.percent * 0.1
                                        });
                                    });

                                case 21:
                                    _context.next = 27;
                                    break;

                                case 23:
                                    _context.prev = 23;
                                    _context.t0 = _context["catch"](18);

                                    console.error(_context.t0);
                                    processCallback && processCallback({
                                        finished: false,
                                        percent: 90
                                    });

                                case 27:
                                    if (!actions) {
                                        actions = [];
                                    }
                                    if (actions && actions.length > 0 && actions.indexOf(defaultAction) < 0) {
                                        //动作列表中没有空闲动作，手动添加
                                        actions.push(defaultAction);
                                    }

                                    if (!(actions && actions.length > 0)) {
                                        _context.next = 39;
                                        break;
                                    }

                                    _context.prev = 30;
                                    _context.next = 33;
                                    return self.actionMgr.loadFileToAction(actions, defaultAction, function (process) {
                                        processCallback && processCallback({
                                            finished: process.finished,
                                            percent: 90 + process.percent * 0.1
                                        });
                                    });

                                case 33:
                                    _context.next = 39;
                                    break;

                                case 35:
                                    _context.prev = 35;
                                    _context.t1 = _context["catch"](30);

                                    console.error(_context.t1);
                                    processCallback && processCallback({
                                        finished: true,
                                        percent: 100
                                    });

                                case 39:

                                    // gltf.scene.translateY(-0.03)
                                    mainScene.add(gltf.scene);
                                    // var helper = new THREE.SkeletonHelper( gltf.scene );
                                    // mainScene.add( helper );

                                    resultCallback && resultCallback(null, '人物加载成功');
                                    // if(config.gender ==2){ //女士因为眼睛向上看，暂时按照x轴旋转
                                    //     gltf.scene.rotation.x += 0.1;    

                                    // }
                                    self.audioPlayer.initAudioDict(self.g_model);

                                    self.controls.saveState();
                                    //眨眼动作
                                    self.initEyeBlinkMorph();

                                    //设置动作
                                    // self.actionMgr.playAction('https://xcx.studio51.com/glb/M_ChaShou_V1.fbx')
                                    // self.actionMgr.loadFileToAction([
                                    //     'https://xcx.studio51.com/glb/M_ChaShou_V1.fbx',
                                    //     'https://xcx.studio51.com/glb/fbx/M_HuXi_V4.fbx' //https://xcx.studio51.com/glb/fbx/M_HuXi_V4.fbx
                                    // ],
                                    //     'https://xcx.studio51.com/glb/fbx/M_HuXi_V4.fbx').then(()=>{

                                    //         renderer.domElement.addEventListener(
                                    //             "click",
                                    //             event => {
                                    //                 myConsole('---------click')   
                                    //                 self.actionMgr.fadeToAction('https://xcx.studio51.com/glb/M_ChaShou_V1.fbx',0.5)
                                    //             }
                                    //         )
                                    //     })


                                case 44:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[18, 23], [30, 35]]);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }(), function (process) {
                // myConsole("加载中", process);
                if (processCallback) {
                    if (changeCloth && changeCloth.length > 0) {
                        //有默认要替换的衣服，需要将进度前90%作为模型加载进度 剩余10%作为衣服加载进度
                        if (process.total > 0) {
                            var loadPercent = process.loaded / process.total * 0.8;
                            process.percent = loadPercent * 100;
                        } else {
                            //未获取到大小
                            process.percent = 1;
                        }
                    } else if (actions && actions.length > 0) {
                        process.percent = process.loaded / process.total * 0.9;
                    } else {
                        process.percent = process.loaded / process.total * 100;
                    }
                    processCallback(process);
                }
            }, function (error) {
                console.error(error);
                if (resultCallback) {
                    resultCallback(error, '加载失败');
                }
            });
        }
        /**
         * 重置虚拟人位置
         */

    }, {
        key: "resetHumanPosition",
        value: function resetHumanPosition() {
            this.controls.reset();
        }
        /**
        * 查询默认服装
        * @param {} bodyScene 
        */

    }, {
        key: "getDefaultClotheObjs",
        value: function getDefaultClotheObjs(bodyScene, defaultMeshNames) {
            var defaultClothesObj = [];
            if (!defaultMeshNames) {
                return defaultClothesObj;
            }
            //去掉版本号进行比较
            var _defaultMeshNames = [];
            for (var i = 0; i < defaultMeshNames.length; ++i) {
                _defaultMeshNames.push(utils["a" /* utils */].getModelNameRemoveVersion(defaultMeshNames[i]));
            }
            // myConsole(_defaultMeshNames)
            bodyScene.traverse(function (obj) {
                obj.isMesh && myConsole('===', utils["a" /* utils */].getModelNameRemoveVersion(obj.name));
                if (obj.isMesh && _defaultMeshNames && _defaultMeshNames.indexOf(utils["a" /* utils */].getModelNameRemoveVersion(obj.name)) >= 0) {

                    defaultClothesObj.push(obj);
                }
            });
            // myConsole('------- 查询到默认服装', defaultClothesObj)
            return defaultClothesObj;
        }

        //加载单个服装

    }, {
        key: "loadClothScene",
        value: function () {
            var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(loader, url, index, clotheCount, processCallback) {
                var _this = this;

                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt("return", new promise_default.a(function (resolve, reject) {
                                    var clothUrlMd5 = crypto_js_default.a.MD5(url).toString();
                                    if (_this.clothSet.get(clothUrlMd5)) {
                                        var percent = void 0;
                                        if (index == clotheCount - 1) {
                                            percent = 100;
                                        } else {
                                            var itemProcess = 100; //将多个衣服的进度组成一个整体进度
                                            var loadedProcess = ((1 / clotheCount * itemProcess + index / clotheCount) * 100).toFixed(2);
                                            percent = loadedProcess;
                                        }
                                        if (processCallback) {
                                            processCallback({
                                                finished: percent == '100' ? true : false,
                                                percent: percent
                                            });
                                        }
                                        return resolve(_this.clothSet.get(clothUrlMd5));
                                    } else {
                                        loader.load( //加载服装
                                        url, //领带
                                        function (top) {
                                            //body.scene.add(top.scene)
                                            _this.clothSet.set(clothUrlMd5, top);
                                            return resolve(top);
                                        }, function (process) {

                                            var percent = void 0;
                                            if (process.loaded >= process.total && index == clotheCount - 1) {
                                                percent = 100;
                                            } else {
                                                var _itemProcess = process.loaded / process.total; //将多个衣服的进度组成一个整体进度
                                                var _loadedProcess = ((1 / clotheCount * _itemProcess + index / clotheCount) * 100).toFixed(2);
                                                percent = _loadedProcess;
                                            }
                                            if (processCallback) {
                                                processCallback({
                                                    finished: percent == '100' ? true : false,
                                                    percent: percent
                                                });
                                            }
                                        }, function (err) {
                                            console.error('load error', err);
                                            return reject();
                                        });
                                    }
                                }));

                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function loadClothScene(_x2, _x3, _x4, _x5, _x6) {
                return _ref2.apply(this, arguments);
            }

            return loadClothScene;
        }()
        //加载多个服装

    }, {
        key: "loadClothing",
        value: function () {
            var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(loader, urls, processCallback) {
                var clothesObjs, i;
                return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                //改为一个个加载
                                clothesObjs = [];
                                i = 0;

                            case 2:
                                if (!(i < urls.length)) {
                                    _context3.next = 18;
                                    break;
                                }

                                _context3.prev = 3;
                                _context3.t0 = clothesObjs;
                                _context3.next = 7;
                                return this.loadClothScene(loader, urls[i], i, urls.length, processCallback);

                            case 7:
                                _context3.t1 = _context3.sent;

                                _context3.t0.push.call(_context3.t0, _context3.t1);

                                _context3.next = 15;
                                break;

                            case 11:
                                _context3.prev = 11;
                                _context3.t2 = _context3["catch"](3);

                                console.error(_context3.t2);
                                throw "服装加载失败";

                            case 15:
                                ++i;
                                _context3.next = 2;
                                break;

                            case 18:
                                return _context3.abrupt("return", clothesObjs);

                            case 19:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[3, 11]]);
            }));

            function loadClothing(_x7, _x8, _x9) {
                return _ref3.apply(this, arguments);
            }

            return loadClothing;
        }()
    }, {
        key: "clothing",
        value: function clothing(loader, bodyScene, clothesurl, processCallback) {
            var _this2 = this;

            //获取人物模型的骨骼
            var rootBone = bodyScene.getObjectByName("Armature").getObjectByName("RootNode").getObjectByName("Hips");
            g_characterBones.clear();
            rootBone.traverse(function (bone) {
                // myConsole('character bone', bone)
                g_characterBones.set(bone.name, bone);
            });
            // myConsole('character bones count', g_characterBones.size)
            //渲染服装
            return new promise_default.a(function (resolve, reject) {
                _this2.loadClothing(loader, clothesurl, processCallback).then(function (objs) {
                    var _g_clothesModels;

                    // myConsole('-----groups', objs)
                    var modelArmature = bodyScene.getObjectByName("Armature");
                    if (!modelArmature) {
                        return reject('渲染服装失败');
                    }
                    //添加衣服
                    if (g_clothesModels.length) {
                        _this2.moveCloth(_this2.g_model.scene, g_clothesModels);
                    }

                    g_clothesModels.length = 0;
                    (_g_clothesModels = g_clothesModels).push.apply(_g_clothesModels, toConsumableArray_default()(objs));
                    _this2.updateClothesBone2CharacterBone();
                    objs.forEach(function (obj) {
                        modelArmature.add(obj.scene);
                    });

                    return resolve(objs);
                });
            });
        }
    }, {
        key: "moveCloth",
        value: function moveCloth(bodyScene, clothGroup) {
            clothGroup.forEach(function (cloth) {
                cloth.scene.removeFromParent();
            });
        }
        /**
         * 移除默认服装
         * @param {} bodyScene 
         */

    }, {
        key: "removeDefaultClothe",
        value: function removeDefaultClothe(defaultMeshObjs) {

            defaultMeshObjs.forEach(function (skin) {
                skin.traverse(function (child) {
                    if (child.material) {
                        child.material.dispose();
                    }
                    if (child.geometry) {
                        child.geometry.dispose();
                    }
                    child.clear();
                    child = null;
                });
                skin.clear();
                skin.removeFromParent();
                skin = null;
            });
        }

        /**
         * 加载并穿上服装
         * @param {*} clothes 
         */

    }, {
        key: "loadAndCloth",
        value: function loadAndCloth(clothes, processCallback, resultCallback) {
            var _this3 = this;

            return new promise_default.a(function (resolve, reject) {
                if (!_this3.g_model) {
                    resolve();
                    if (resultCallback) resultCallback('人物模型还未加载');

                    return;
                }
                if (!clothes || clothes.length == 0) {
                    resolve();
                    processCallback && processCallback({ finished: true, percent: 100 });
                    resultCallback && resultCallback(null, '未指定服装');

                    return;
                }
                // 加载衣服之前先保存之前的衣服
                // let _curClothGroup = this.curClothGroup
                var loader = new GLTFLoader["a" /* GLTFLoader */]();
                _this3.clothing(loader, _this3.g_model.scene, clothes, processCallback).then(function (res) {
                    // this.curClothGroup = res
                    loader = null;
                    myConsole('cloth load success');
                    //第一次加载去除旧衣服
                    if (!g_removeDefaultFlag) {
                        //第一次加载，去掉默认服饰
                        // myConsole('----remove default clothe', m_defaultClothMesh)
                        _this3.removeDefaultClothe(m_defaultClothMesh);
                        m_defaultClothMesh.forEach(function (child) {
                            child.material.dispose && child.material.dispose();
                        });
                        g_removeDefaultFlag = true;
                    }
                    // //衣服加载之后，删除旧衣服
                    // if (_curClothGroup) {
                    //     this.moveCloth(this.g_model.scene, _curClothGroup)
                    // }
                    resolve();
                    if (resultCallback) resultCallback(null, '换装成功');
                }, function (e) {
                    loader = null;
                    console.error(e);
                    resolve();
                    if (resultCallback) resultCallback('服装加载失败', e);
                });
            });
        }

        /**
         * 向虚拟人发送聊天消息
         * @param {*} message 
         * @param {*} resultCallback 
         */
        // @deprecated //方法已经启用，请在sdk外部调用聊天接口 

    }, {
        key: "chat2MetaHuman",
        value: function chat2MetaHuman(message, messageType, resultCallback, eventHandler) {
            var _this4 = this;

            myConsole('blob message', message);
            if (!message || message.length == 0) {
                return;
            }
            var url = "" + this.config.HUMAN_URL;
            var body = {
                app_id: this.appID,
                sign: this.config.HUMAN_SIGN,
                access_token: this.token
            };

            if (messageType == define["b" /* CHAT_MSG_TYPE */].VOICE_STREAM) {
                body['voice'] = message;
            } else {
                body['word'] = "" + message;
            }
            myConsole('请求聊天:', url, body);
            utils["a" /* utils */].postData(url, 'applet/webview/dialog', body).then(function (res) {
                myConsole('聊天回答:', res);
                if (res.code != 200) {
                    if (resultCallback) resultCallback(res.msg, '发送聊天消息失败');
                    return;
                }
                _this4.say(res.data.resp, res.data.url, res.data.viseme, resultCallback, eventHandler);
            }, function (err) {
                resultCallback('聊天接口调用失败:' + err, '聊天接口调用失败');
            });
        }
    }, {
        key: "stopNowVoice",
        value: function stopNowVoice() {
            if (this.audioPlayer) {
                this.audioPlayer.stopNowVoice();
            }
        }
    }, {
        key: "initEyeBlinkMorph",
        value: function initEyeBlinkMorph() {
            var _this5 = this;

            if (!this.g_model) {
                return;
            }
            this.g_model.scene.getObjectByName("Armature") && this.g_model.scene.getObjectByName("Armature").traverse(function (o) {
                if (o.morphTargetInfluences) {
                    _this5.morphControl = o.morphTargetInfluences;
                    _this5.morphDict = o.morphTargetDictionary;
                    // myConsole('找到形态键：', o.name, o.morphTargetDictionary)
                }
            });
        }
        /**
         * 自动眨眼
         */

    }, {
        key: "eyeBlinkUpdate",
        value: function eyeBlinkUpdate() {

            if (!this.morphControl || !this.morphDict || this.cutState) {
                return;
            }
            if (this.morphDict[EYE_BLINK_LEFT] == undefined || this.morphControl[this.morphDict[EYE_BLINK_RIGHT]] == undefined) {
                return;
            }
            if (this.morphControl[this.morphDict[EYE_BLINK_LEFT]] <= 0) {
                if (this.lidWait > eyeBlindWaitCount) {
                    this.lidMove = this.lidSpeed;
                    this.lidWait = 0;
                } else {
                    this.lidMove = 0;
                }
                this.lidWait += 1;
            } else if (this.morphControl[this.morphDict[EYE_BLINK_LEFT]] > 1) {
                this.lidMove = -this.lidMove;
            }

            this.morphControl[this.morphDict[EYE_BLINK_LEFT]] += this.lidMove;
            this.morphControl[this.morphDict[EYE_BLINK_RIGHT]] += this.lidMove;
        }

        /**
         * 清除缓存
         */

    }, {
        key: "clearThreeCatch",
        value: function clearThreeCatch() {
            if (this.animationID) {
                cancelAnimationFrame(this.animationID);
            }
            if (this.g_model) {
                //删除模型
                this.g_model.scene.traverse(function (child) {
                    if (child.material) {
                        child.material.dispose();
                    }
                    if (child.geometry) {
                        child.geometry.dispose();
                    }
                    child = null;
                });

                this.g_model && this.g_model.scene.removeFromParent();
                this.g_model = null;
            }
            renderer.dispose();
            renderer.forceContextLoss();
            renderer.content = null;
            var gl = renderer.domElement.getContext("webgl");
            gl && gl.getExtension("WEBGL_lose_context") && gl.getExtension("WEBGL_lose_context").loseContext();
            renderer = null;
            mainCamera = null;
            mainScene = null;
            // THREE.Cache.clear()
            myConsole('清除 缓存');
        }
    }, {
        key: "showStats",
        value: function showStats(show) {
            myConsole('show stats', show, this.stats.dom.style);

            if (show) {
                this.stats && (this.stats.dom.style.display = 'block');
            } else {
                this.stats && (this.stats.dom.style.display = 'none');
            }
        }
        /**
         * 播报并播放动作
         * @param {*} audio 
         * @param {*} audioVisem 
         * @param {*} action  动作文件，可以为空，代表没有动作
         * @param {*} resultCallback(err,res)
         * @param {*} eventHandler
         */

    }, {
        key: "say",
        value: function say(audio, audioVisem, duration, conf, resultCallback, eventHandler) {
            if (!this.g_model) {
                return resultCallback && resultCallback('模型还未加载');
            }
            var lastTime = 0;
            if (audioVisem && audioVisem.length > 0) {
                //最后一个音素的时间代表音频文件的总时长
                lastTime = audioVisem[audioVisem.length - 1].time;
            }
            if (this.audioPlayer) {
                if (eventHandler) this.audioPlayer.setEventListener(eventHandler);
                this.audioPlayer.playAudio(this.g_model, audio, audioVisem, '', //播放文字，暂时保留
                duration, conf);
            }

            if (resultCallback) {
                resultCallback(null, {
                    voiceDuration: lastTime
                });
            }
        }
    }, {
        key: "playAction",
        value: function playAction(action, fadeDuration) {
            this.actionMgr.fadeToAction(action, fadeDuration || 1);
        }
    }, {
        key: "playIdleAction",
        value: function playIdleAction() {
            myConsole('播放空闲动作');
            this.actionMgr.actionFinished();
        }
    }, {
        key: "cutImag",
        value: function cutImag() {
            this.cutState = 1;

            var divID = 'webgl_tmp_img';
            try {
                // 在图片加载完成后，将其添加到div中
                var reset = function reset() {
                    setTimeout(function () {
                        mainCamera.position.z = cameraPosition[2];
                        document.getElementById(divID) && document.getElementById(divID).remove();
                    }, 1000);
                    self.cutState = 0;
                    self.cutImgCallBack = null;
                };

                //使用当前的渲染数据生成一张图片并盖住模型
                // 创建一个div元素，并将其添加到DOM中
                var canvas = renderer.domElement;
                var rect = canvas.getBoundingClientRect();
                // myConsole('cavas rect', rect)
                var div = document.createElement('div');
                div.id = divID;
                div.style.position = 'absolute';
                div.style.top = rect.top + "px";
                div.style.left = rect.left + "px";
                div.style.width = rect.width + "px";
                div.style.height = rect.height + "px";
                div.style.margin = 'auto';
                div.style.zIndex = '0';
                this.container.appendChild(div);
                // myConsole('cavas div', div.style)
                // 创建一个Image对象，并加载图片
                mainScene.background = new three_module["o" /* Color */](0x616e75);
                renderer.render(mainScene, mainCamera);
                var srcPre = renderer.domElement.toDataURL("image/jpeg");
                var img = new Image();
                img.src = srcPre;
                var self = this;
                img.onerror = function () {
                    reset();
                };
                img.onload = function () {
                    // 创建一个img元素，并将其添加到div中
                    var imgElement = document.createElement('img');
                    imgElement.src = srcPre;
                    imgElement.style.width = '100%';
                    imgElement.style.height = '100%';
                    div.appendChild(imgElement);

                    setTimeout(function () {
                        //延时1秒，避免div还未刷新导致屏幕闪动
                        //开始截取真正的屏幕    
                        self.resetHumanPosition();
                        mainCamera.position.z = cameraCutImgPosition[2];
                        mainScene.background = null;
                        renderer.render(mainScene, mainCamera);
                        var src = renderer.domElement.toDataURL(); //将选中的canvas转换为base64编码
                        // let a = document.createElement("a"); // 生成一个a元素
                        // let event = new MouseEvent("click"); // 创建一个单击事件
                        // a.download = "photo"; // 设置图片名称
                        // a.href = src; // 将生成的URL设置为a.href属性
                        // a.dispatchEvent(event); // 触发a的单击事件 将图片下载下来
                        //将数据转为form data 用于上传
                        //去除 data URL 中的头部说明

                        self.cutImgCallBack && self.cutImgCallBack(null, utils["a" /* utils */].dataURLToBlob(src));

                        reset();
                    }, 1000);
                };
            } catch (e) {
                console.error(e);
                document.getElementById(divID) && document.getElementById(divID).remove();
                this.cutState = 0;
                this.cutImgCallBack = null;
            }
        }
    }, {
        key: "downloadCanvasImg",
        value: function downloadCanvasImg(callback) {
            //截屏的时候，需要等眼睛全部睁开
            if (this.cutState) {
                return callback('正在处理，稍后再试');
            }
            this.cutImgCallBack = callback;
        }
    }, {
        key: "setAudioMuted",
        value: function setAudioMuted(muted) {
            this.audioPlayer.setAudioMuted(muted);
        }
    }, {
        key: "setJWAOpenValue",
        value: function setJWAOpenValue(value) {
            this.audioPlayer.setJWAOpenValue(value);
        }
    }]);

    return WebGlLoader;
}();

/* harmony default export */ var S51WebGLSDK_WebGlLoader = (WebGlLoader_WebGlLoader);
// CONCATENATED MODULE: ./src/S51WebGLSDK/index.js







var S51WebGLSDK_WebGlSDK = function () {
    function WebGlSDK() {
        classCallCheck_default()(this, WebGlSDK);

        this.isDev = false;
        this.webGlLoader = undefined;
    }

    createClass_default()(WebGlSDK, [{
        key: 'initSDK',
        value: function initSDK(documentContainer, backColor, secretConfig, isDev) {
            // let naviInfo = utils.getNavicatObj()
            // if(naviInfo && naviInfo.os && naviInfo.os.name.toLowerCase()=='ios'
            //  && naviInfo.os.version && naviInfo.os.version.original=='16.4'){
            //     alert(`抱歉，您当前的系统 ${naviInfo.os.name}:${naviInfo.os.version.original} 存在兼容性问题`)
            // }
            this.isDev = isDev;
            this.webGlLoader = new S51WebGLSDK_WebGlLoader(documentContainer, backColor, secretConfig, isDev);
            return [null];
        }
    }, {
        key: 'resetAppID',
        value: function resetAppID(appId) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.resetAppID(appId);
        }
    }, {
        key: 'enableControl',
        value: function enableControl(enable) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.enableControl(enable);
        }
    }, {
        key: 'loadHuman',
        value: function loadHuman(url, defaultClothName, hdrUrl, changeCloth, actions, defaultAction, config, processCallback, resultCallback) {
            if (!this.webGlLoader) {
                if (resultCallback) resultCallback("sdk还未初始化");
                return;
            }
            return this.webGlLoader.loadMainModel(url, defaultClothName, hdrUrl, changeCloth, actions, defaultAction, config, processCallback, resultCallback);
        }

        /**
         * 加载音素文件（OVR格式） 并且驱动口型播放音频
         * @param {*} visemeUrl 
         * @param {*} audioUrl 
         * @param {*} eventHandler 'error','start','ended'
         */
        // loadVisemeAndPlay(visemeUrl, audioUrl, eventHandler) {
        //     if (!this.webGlLoader) {
        //         if (eventHandler) eventHandler("error",'加载音素文件失败')
        //         return
        //     }
        //     this.webGlLoader.loadVisemeAndPlay(visemeUrl,audioUrl,eventHandler)
        // }

        /**
         * 虚拟人坐标复位
         */

    }, {
        key: 'resetHumanPosition',
        value: function resetHumanPosition() {
            if (!this.webGlLoader) {
                return ['sdk未初始化'];
            }
            this.webGlLoader.resetHumanPosition();
            return [null, '重置成功'];
        }
        /**
         * 加载服装并换装（自动将默认或者上一件服装删除）
         * @param {*} clothes 
         * @param {*} processCallback 
         * @param {*} resultCallback 
         */

    }, {
        key: 'loadAndCLoth',
        value: function loadAndCLoth(clothes, processCallback, resultCallback) {
            if (!this.webGlLoader) {
                if (resultCallback) resultCallback("sdk还未初始化", '服装文件失败');
                return;
            }
            this.webGlLoader.loadAndCloth(clothes, processCallback, resultCallback);
        }

        /** @deprecated */ //方法已经启用，请在sdk外部调用聊天接口 

    }, {
        key: 'chat2MetaHumanWord',
        value: function chat2MetaHumanWord(message, resultCallback, eventHandler) {
            if (!this.webGlLoader) {
                if (resultCallback) resultCallback("sdk还未初始化", '聊天失败');
                return;
            }
            this.webGlLoader.chat2MetaHuman(message, define["b" /* CHAT_MSG_TYPE */].WORD, resultCallback, eventHandler);
        }
        /** @deprecated */ //方法已经启用，请在sdk外部调用聊天接口 

    }, {
        key: 'chat2MetaHumanVoice',
        value: function chat2MetaHumanVoice(voiceBase64Stream, resultCallback, eventHandler) {
            if (!this.webGlLoader) {
                if (resultCallback) resultCallback("sdk还未初始化", '聊天失败');
                return;
            }
            this.webGlLoader.chat2MetaHuman(voiceBase64Stream, define["b" /* CHAT_MSG_TYPE */].VOICE_STREAM, resultCallback, eventHandler);
        }
    }, {
        key: 'stopNowVoice',
        value: function stopNowVoice() {
            if (!this.webGlLoader) {
                console.error('sdk还未初始化');
                return;
            }
            this.webGlLoader.stopNowVoice();
        }
    }, {
        key: 'clearCache',
        value: function clearCache() {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.clearThreeCatch();
        }
    }, {
        key: 'showStats',
        value: function showStats(show) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.showStats(show);
        }
        /**
        * 播报并播放动作
        * @param {*} audio 
        * @param {*} audioVisem 
        * @param {*} resultCallback(err,res)
        * @param {*} eventHandler
        */

    }, {
        key: 'say',
        value: function say(audio, audioVisem, duration, conf, resultCallback, eventHandler) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.say(audio, audioVisem, duration, conf, resultCallback, eventHandler);
        }
    }, {
        key: 'setAudioMuted',
        value: function setAudioMuted(muted) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.setAudioMuted(muted);
        }
        /**
         * 播放动作
         * @param {*} action 
         * @param {*} fadeDuration 
         * @returns 
         */

    }, {
        key: 'playAction',
        value: function playAction(action, fadeDuration) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.playAction(action, fadeDuration);
        }
    }, {
        key: 'playIdleAction',
        value: function playIdleAction() {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.playIdleAction();
        }
    }, {
        key: 'downloadCanvasImg',
        value: function downloadCanvasImg(callback) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.downloadCanvasImg(callback);
        }
    }, {
        key: 'setJWAOpenValue',
        value: function setJWAOpenValue(value) {
            if (!this.webGlLoader) {
                return;
            }
            this.webGlLoader.setJWAOpenValue(value);
        }
    }]);

    return WebGlSDK;
}();

/* harmony default export */ var S51WebGLSDK = __webpack_exports__["a"] = (new S51WebGLSDK_WebGlSDK());

/***/ }),

/***/ "XZOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YcHL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f37d428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("M5Ib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aXSi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cJYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dr2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHAT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHAT_ROLE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chatframe__ = __webpack_require__("t5lu");



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Chatframe__["a" /* default */]);
var CHAT_TYPE = {
    TEXT: 1,
    VOICE: 2,
    IMG: 3,
    FILE: 4,
    LINK: 5,
    VIDEO: 6
};
var CHAT_ROLE = {
    ROBOT: 1,
    USER: 2
};

/***/ }),

/***/ "dv6J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eXW6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f+wq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fT5a":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gnaN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gsj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h9JT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hZpC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hnPy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jTD2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jijt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var components_inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1426a676","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"weui-loading"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("6ReU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_loading,
  src_components_inline_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k3w1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l71h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lT9M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lU6p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "liEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n4IK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oAV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVuxUrlQuery */
/* harmony export (immutable) */ __webpack_exports__["c"] = getUrlParams;
/* unused harmony export postData */
/* harmony export (immutable) */ __webpack_exports__["a"] = createRequest;
/* unused harmony export makeBase64 */
/* harmony export (immutable) */ __webpack_exports__["d"] = paseBase64;
/* harmony export (immutable) */ __webpack_exports__["b"] = getChatFileType;
/* unused harmony export base64ToBlob */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__define__ = __webpack_require__("++TJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__myComponents_Chatframe__ = __webpack_require__("dr2p");



function getVuxUrlQuery(url) {
    //获取当前url
    var dz_url = url.split('#')[0]; //获取#/之前的字符串
    var cs = dz_url.split('?')[1]; //获取?之后的参数字符串
    var cs_arr = cs.split('&'); //参数字符串分割为数组
    var cs = {};
    for (var i = 0; i < cs_arr.length; i++) {
        //遍历数组，拿到json对象
        cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
    }
    console.log('url query', cs);
    return cs;
}
function getUrlParams(url) {
    console.log('get url param', url);
    var result = {};
    var arr_ = url.split('?');
    if (arr_.length <= 1) {
        return result;
    }
    var paramArr = arr_[1].split('&');
    for (var i = 0; i < paramArr.length; ++i) {
        var _arr = paramArr[i].split('=');
        if (_arr.length == 2) {
            result[_arr[0]] = _arr[1];
        }
    }
    return result;
}
// 请求数据
function postData(type, url, data, callback) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: type,
        url: url,
        data: data,
        success: function success(res) {
            callback(res);
        }
    });
}

function createRequest(method, api, data, callback) {
    var token = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__define__["a" /* STORAGE_KEY */].TOKEN);
    if (!data) {
        data = {};
    }
    data.access_token = token;
    var tokenData = data;
    // console.log('process',process.env)
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: method,
        url: "https://wxcx.studio51.com" + '/' + api,
        data: tokenData,
        success: function success(res) {
            callback(res);
        },

        error: function error(errorMsg) {
            //请求失败时执行该函数
            console.log(errorMsg, '请求数据失败');
            // alert("请求数据失败!",errorMsg);
            callback({
                code: errorMsg.status,
                msg: errorMsg.statusText
            });
        }
    });
}

function makeBase64(url) {
    return window.btoa(window.encodeURIComponent(url));
}

function paseBase64(base64) {
    return window.decodeURIComponent(window.atob(base64));
}

/**
 * 获取聊天附件的类型
 */
function getChatFileType(url) {
    if (!url) {
        return;
    }
    var ex = url.substring(url.lastIndexOf('.') + 1);
    ex = ex.toLowerCase();
    if (['png', 'jpg', 'jpeg'].indexOf(ex) >= 0) {
        return __WEBPACK_IMPORTED_MODULE_2__myComponents_Chatframe__["b" /* CHAT_TYPE */].IMG;
    } else if (['mp4'].indexOf(ex) >= 0) {
        return __WEBPACK_IMPORTED_MODULE_2__myComponents_Chatframe__["b" /* CHAT_TYPE */].VIDEO;
    } else if (['pdf'].indexOf(ex) >= 0) {
        return __WEBPACK_IMPORTED_MODULE_2__myComponents_Chatframe__["b" /* CHAT_TYPE */].FILE;
    }
    return;
}

function base64ToBlob(base64, fileType) {
    var typeHeader = 'data:application/' + fileType + ';base64,'; // 定义base64 头部文件类型
    var audioSrc = typeHeader + base64; // 拼接最终的base64
    var arr = audioSrc.split(',');
    var array = arr[0].match(/:(.*?);/);
    var mime = (array && array.length > 1 ? array[1] : type) || type;
    // 去掉url的头，并转化为byte
    var bytes = window.atob(arr[1]);
    // 处理异常,将ascii码小于0的转换为大于0
    var ab = new ArrayBuffer(bytes.length);
    // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    var ia = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
        type: mime
    });
}

/***/ }),

/***/ "pDNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("5VbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c8891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"touchstart":function($event){return _vm.clear.apply(null, arguments)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("+LB2")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = __webpack_exports__["a"] = (x_input_Component.exports);


/***/ }),

/***/ "qGz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-loading/index.vue + 3 modules
var inline_loading = __webpack_require__("jijt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/myVideo/myVideo.vue




/* harmony default export */ var myVideo = ({
  name: "myVideo",
  components: {
    XDialog: x_dialog["a" /* default */],
    InlineLoading: inline_loading["a" /* default */]
  },
  props: {
    videoUrl: String
  },
  data: function data() {
    return {
      activeUrl: this.videoUrl,
      showHideOnBlur: true,
      loaded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log("myvideo mouted");

    this.$refs.videoPlayer.load();
    this.$refs.videoPlayer.addEventListener('canplay', function () {
      console.log('player can play');
      _this.loaded = true;

      _this.$refs.videoPlayer.play();
    });
    this.$refs.videoPlayer.addEventListener('webkitendfullscreen', function () {
      _this.$emit("onHideMyVideo");
    });
    this.$refs.videoPlayer.addEventListener('x5videoexitfullscreen', function () {

      _this.$emit("onHideMyVideo");
    });
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onHide: function onHide() {
      console.log("隐藏视频窗口");
      this.$emit("onHideMyVideo");
    },
    screenChange: function screenChange() {}
  },
  watch: {
    videoUrl: function videoUrl(url) {
      this.activeUrl = url;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/myVideo/myVideo.vue




/* harmony default export */ var myVideo_myVideo = ({
  name: "myVideo",
  components: {
    XDialog: x_dialog["a" /* default */],
    InlineLoading: inline_loading["a" /* default */]
  },
  props: {
    videoUrl: String
  },
  data: function data() {
    return {
      activeUrl: this.videoUrl,
      showHideOnBlur: true,
      loaded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log("myvideo mouted");

    this.$refs.videoPlayer.load();
    this.$refs.videoPlayer.addEventListener('canplay', function () {
      console.log('player can play');
      _this.loaded = true;

      _this.$refs.videoPlayer.play();
    });
    this.$refs.videoPlayer.addEventListener('webkitendfullscreen', function () {
      _this.$emit("onHideMyVideo");
    });
    this.$refs.videoPlayer.addEventListener('x5videoexitfullscreen', function () {

      _this.$emit("onHideMyVideo");
    });
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onHide: function onHide() {
      console.log("隐藏视频窗口");
      this.$emit("onHideMyVideo");
    },
    screenChange: function screenChange() {}
  },
  watch: {
    videoUrl: function videoUrl(url) {
      this.activeUrl = url;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90b15994","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/myVideo/myVideo.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myVideo"},[_c('x-dialog',{staticClass:"dialog-demo",attrs:{"hide-on-blur":""},on:{"on-hide":_vm.onHide},model:{value:(_vm.showHideOnBlur),callback:function ($$v) {_vm.showHideOnBlur=$$v},expression:"showHideOnBlur"}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}],staticStyle:{"text-align":"center"}},[_c('inline-loading'),_vm._v(" "),_c('span',{staticStyle:{"color":"white"}},[_vm._v("视频加载")])],1),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],ref:"videoPlayer",attrs:{"bindfullscreenchange":"screenChange","controls":"","src":_vm.activeUrl,"width":"100%","poster":_vm.activeUrl+'?vframe/jpg/offset/2/w/480',"preload":"auto"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var myComponents_myVideo_myVideo = (esExports);
// CONCATENATED MODULE: ./src/myComponents/myVideo/myVideo.vue
function injectStyle (ssrContext) {
  __webpack_require__("V+Qo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90b15994"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  myVideo_myVideo,
  myComponents_myVideo_myVideo,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_myComponents_myVideo_myVideo = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qhUK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uWE6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sc21":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./src/utils/audioText.js
var audioText_audio = new Audio();
// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-loading/index.vue + 3 modules
var inline_loading = __webpack_require__("jijt");

// EXTERNAL MODULE: ./src/myComponents/Chatframe/index.js
var Chatframe = __webpack_require__("dr2p");

// EXTERNAL MODULE: ./src/myComponents/myImage/myImage.vue + 3 modules
var myImage = __webpack_require__("SRZQ");

// EXTERNAL MODULE: ./src/myComponents/myVideo/myVideo.vue + 3 modules
var myVideo = __webpack_require__("qGz8");

// EXTERNAL MODULE: ./src/S51WebGLSDK/utils/utils.js + 1 modules
var utils = __webpack_require__("U3F8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/TypeMessage/TypeMessage.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TypeMessage = ({
  name: "robotchatmessage",
  components: {},
  props: {
    stringText: String, //显示聊天内容
    speed: Number, //显示速度 毫秒/字
    playState: Boolean, //播放文本按钮状态
    itemID: String
  },
  data: function data() {
    return {
      displayMessage: "",
      totalMessage: this.stringText || "",
      intervalHandler: undefined,
      displayIndex: 0,
      disSpeed: this.speed,
      playTextVoiceSatate: this.playState
    };
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      if (this.disSpeed <= 0) {
        this.displayMessage = this.totalMessage;
        this.displayIndex = this.totalMessage.length;
        this.$emit('onTextShowAccomplish', { itemID: this.itemID });
        return;
      }
      if (this.intervalHandler) clearInterval(this.intervalHandler);
      this.displayIndex = 0;
      this.displayMessage = "";
      this.intervalHandler = setInterval(function () {
        if (_this.displayIndex >= _this.totalMessage.length) {
          clearInterval(_this.intervalHandler);
          _this.disSpeed = 0;
          _this.$emit('onTextShowAccomplish', { itemID: _this.itemID });
          return;
        }
        _this.displayMessage += _this.totalMessage[_this.displayIndex++];
      }, this.disSpeed);
    },
    getCurShowLength: function getCurShowLength() {
      return this.displayMessage.length;
    },

    //播放文字语音
    onPlayTextVoice: function onPlayTextVoice() {

      // let url = '/static/img/蓝心羽 - 好想爱这个世界啊 (片段).mp3'  //播放地址
      this.$emit('onPlayText');
    }
  },
  watch: {
    speed: function speed(value) {
      console.log('----------change speed', value);
      this.disSpeed = value;
    },
    playState: function playState(value) {
      this.playTextVoiceSatate = value;
    },
    stringText: function stringText(value) {
      this.totalMessage = value;
    }
  },
  expose: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/TypeMessage/TypeMessage.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TypeMessage_TypeMessage = ({
  name: "robotchatmessage",
  components: {},
  props: {
    stringText: String, //显示聊天内容
    speed: Number, //显示速度 毫秒/字
    playState: Boolean, //播放文本按钮状态
    itemID: String
  },
  data: function data() {
    return {
      displayMessage: "",
      totalMessage: this.stringText || "",
      intervalHandler: undefined,
      displayIndex: 0,
      disSpeed: this.speed,
      playTextVoiceSatate: this.playState
    };
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      if (this.disSpeed <= 0) {
        this.displayMessage = this.totalMessage;
        this.displayIndex = this.totalMessage.length;
        this.$emit('onTextShowAccomplish', { itemID: this.itemID });
        return;
      }
      if (this.intervalHandler) clearInterval(this.intervalHandler);
      this.displayIndex = 0;
      this.displayMessage = "";
      this.intervalHandler = setInterval(function () {
        if (_this.displayIndex >= _this.totalMessage.length) {
          clearInterval(_this.intervalHandler);
          _this.disSpeed = 0;
          _this.$emit('onTextShowAccomplish', { itemID: _this.itemID });
          return;
        }
        _this.displayMessage += _this.totalMessage[_this.displayIndex++];
      }, this.disSpeed);
    },
    getCurShowLength: function getCurShowLength() {
      return this.displayMessage.length;
    },

    //播放文字语音
    onPlayTextVoice: function onPlayTextVoice() {

      // let url = '/static/img/蓝心羽 - 好想爱这个世界啊 (片段).mp3'  //播放地址
      this.$emit('onPlayText');
    }
  },
  watch: {
    speed: function speed(value) {
      console.log('----------change speed', value);
      this.disSpeed = value;
    },
    playState: function playState(value) {
      this.playTextVoiceSatate = value;
    },
    stringText: function stringText(value) {
      this.totalMessage = value;
    }
  },
  expose: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bcd937f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/TypeMessage/TypeMessage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticStyle:{"width":"100%","display":"block"}},[_vm._v(_vm._s(_vm.disSpeed<=0?_vm.totalMessage:_vm.displayMessage))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var myComponents_TypeMessage_TypeMessage = (esExports);
// CONCATENATED MODULE: ./src/myComponents/TypeMessage/TypeMessage.vue
function injectStyle (ssrContext) {
  __webpack_require__("Uh5A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bcd937f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  TypeMessage_TypeMessage,
  myComponents_TypeMessage_TypeMessage,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_myComponents_TypeMessage_TypeMessage = (Component.exports);

// EXTERNAL MODULE: ./src/eventBus/index.js
var eventBus = __webpack_require__("Kw3Y");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/TypeFlowMessage/TypeFlowMessage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var TypeFlowMessage = ({
  name: "TypeFlowMessage",
  components: {},
  props: {
    stringText: String, //显示聊天内容
    speed: Number, //显示速度 毫秒/字
    playState: Boolean, //播放文本按钮状态
    itemID: String,
    msgQueue: Array
  },
  data: function data() {
    return {
      displayMessage: "",
      totalMessage: this.stringText || "",
      intervalHandler: undefined,
      displayIndex: 0,
      disSpeed: 200,
      playTextVoiceSatate: this.playState,
      questionList: []
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.init();
    this.addQAState = false; //正在添加qa
    this.curQaIndex = 0; //qa添加索引
    this.tempChar = '';
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onAsk: function onAsk(question) {
      this.$emit('onClickQuestion', question);
    },

    /**
     * 处理下一帧文字
     * 返回： true:所有消息结束 false:消息未结束
     */
    nextAudio: function nextAudio() {
      if (this.audioRead >= this.msgQueue.length) {
        return;
      }
      if (!this.msgQueue[this.audioRead].audioState || this.msgQueue[this.audioRead].audioState == 0) {
        //0-还未开始 1-播放中 2-播放结束

        if (this.msgQueue[this.audioRead].audio) {

          if (audioText_audio) {
            audioText_audio.pause();
            audioText_audio.autoplay = false;
            audioText_audio.src = this.msgQueue[this.audioRead].audio;
            audioText_audio.muted = false;

            audioText_audio.play().then(function () {}, function (err) {
              //  alert(err)
              console.error(err);
            });
            this.msgQueue[this.audioRead].audioState = 1;
            console.log('开始播放语音:', this.msgQueue[this.audioRead].audio);
          }
        } else {
          this.msgQueue[this.audioRead].audioState = 2;
          this.audioRead++;
          this.nextAudio();
        }
      }
    },
    nextMessage: function nextMessage() {
      if (this.msgQueue.length == 0) {
        return false;
      }

      if (this.ptrRead.index < this.msgQueue.length) {
        if (this.msgQueue[this.ptrRead.index].flag == 'start') {
          this.ptrRead.index = this.ptrRead.index + 1;
          this.ptrRead.subIndex = 0;
          eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: false });
        } else if (this.msgQueue[this.ptrRead.index].flag == 'ing') {
          if (this.ptrRead.subIndex < this.msgQueue[this.ptrRead.index].txt.length) {
            var txt = this.msgQueue[this.ptrRead.index].txt;
            if (this.addQAState == false && txt[this.ptrRead.subIndex] == '<' && txt[this.ptrRead.subIndex + 1] == 'a' && txt[this.ptrRead.subIndex + 2] == '>') //匹配到开头
              {
                this.addQAState = true;
                this.ptrRead.subIndex += 2;
              } else if (this.addQAState) {

              if (txt[this.ptrRead.subIndex] == '<' && txt[this.ptrRead.subIndex + 1] == '/' && txt[this.ptrRead.subIndex + 2] == 'a' && txt[this.ptrRead.subIndex + 3] == '>') {
                //匹配到结尾
                this.curQaIndex++;
                this.addQAState = false;
                this.ptrRead.subIndex += 3;
              } else {
                if (this.curQaIndex >= this.questionList.length) {
                  this.questionList.push(txt[this.ptrRead.subIndex]);
                } else {
                  this.questionList[this.curQaIndex] += txt[this.ptrRead.subIndex];
                }
                this.$forceUpdate();
              }
            } else {
              this.displayMessage += this.msgQueue[this.ptrRead.index].txt[this.ptrRead.subIndex];
            }

            this.ptrRead.subIndex++;
          } else {
            //跳转下一个
            this.ptrRead.index = this.ptrRead.index + 1;
            this.ptrRead.subIndex = 0;
            this.nextMessage();
          }
        } else if (this.msgQueue[this.ptrRead.index].flag == 'end') {
          this.ptrRead.index = this.ptrRead.index + 1;
          this.ptrRead.subIndex = 0;
        }
      } else {
        var lastItem = this.msgQueue[this.msgQueue.length - 1];
        if (lastItem.flag == 'end') {
          //播放结束
          console.log('----------------------end');

          return true;
        }
      }
      return false;
    },
    init: function init() {
      var _this = this;

      console.log('type init ');
      this.ptrRead = {
        index: 0,
        subIndex: 0
      };
      this.audioRead = 0;
      if (this.intervalHandler) clearInterval(this.intervalHandler);

      this.displayMessage = "";
      this.intervalHandler = setInterval(function () {
        var isEnd = _this.nextMessage();
        // this.nextAudio()
        if (isEnd) {
          _this.disSpeed = 0;
          _this.totalMessage = _this.displayMessage;
          clearInterval(_this.intervalHandler);
          _this.$emit('onTextShowAccomplish', { itemID: _this.itemID });
          eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: true });
        }
      }, 200);
      // audioText.addEventListener('ended',()=>{
      //   console.log('-=-=-=-=-=-= end')
      //   if(this.audioRead<this.msgQueue.length){
      //       this.msgQueue[this.audioRead].audioState = 2 //播放结束，开始下一个 
      //       this.audioRead++
      //       this.nextAudio()
      //       console.log('语音播放结束，播放下一个语音:')
      //   }

      // })
    },
    getCurShowLength: function getCurShowLength() {
      return this.displayMessage.length;
    },

    //播放文字语音
    onPlayTextVoice: function onPlayTextVoice() {

      // let url = '/static/img/蓝心羽 - 好想爱这个世界啊 (片段).mp3'  //播放地址
      this.$emit('onPlayText');
    }
  },
  watch: {
    playState: function playState(value) {
      this.playTextVoiceSatate = value;
    },
    stringText: function stringText(value) {
      this.totalMessage = value;
    }
  },
  expose: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/TypeFlowMessage/TypeFlowMessage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var TypeFlowMessage_TypeFlowMessage = ({
  name: "TypeFlowMessage",
  components: {},
  props: {
    stringText: String, //显示聊天内容
    speed: Number, //显示速度 毫秒/字
    playState: Boolean, //播放文本按钮状态
    itemID: String,
    msgQueue: Array
  },
  data: function data() {
    return {
      displayMessage: "",
      totalMessage: this.stringText || "",
      intervalHandler: undefined,
      displayIndex: 0,
      disSpeed: 200,
      playTextVoiceSatate: this.playState,
      questionList: []
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.init();
    this.addQAState = false; //正在添加qa
    this.curQaIndex = 0; //qa添加索引
    this.tempChar = '';
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    onAsk: function onAsk(question) {
      this.$emit('onClickQuestion', question);
    },

    /**
     * 处理下一帧文字
     * 返回： true:所有消息结束 false:消息未结束
     */
    nextAudio: function nextAudio() {
      if (this.audioRead >= this.msgQueue.length) {
        return;
      }
      if (!this.msgQueue[this.audioRead].audioState || this.msgQueue[this.audioRead].audioState == 0) {
        //0-还未开始 1-播放中 2-播放结束

        if (this.msgQueue[this.audioRead].audio) {

          if (audioText_audio) {
            audioText_audio.pause();
            audioText_audio.autoplay = false;
            audioText_audio.src = this.msgQueue[this.audioRead].audio;
            audioText_audio.muted = false;

            audioText_audio.play().then(function () {}, function (err) {
              //  alert(err)
              console.error(err);
            });
            this.msgQueue[this.audioRead].audioState = 1;
            console.log('开始播放语音:', this.msgQueue[this.audioRead].audio);
          }
        } else {
          this.msgQueue[this.audioRead].audioState = 2;
          this.audioRead++;
          this.nextAudio();
        }
      }
    },
    nextMessage: function nextMessage() {
      if (this.msgQueue.length == 0) {
        return false;
      }

      if (this.ptrRead.index < this.msgQueue.length) {
        if (this.msgQueue[this.ptrRead.index].flag == 'start') {
          this.ptrRead.index = this.ptrRead.index + 1;
          this.ptrRead.subIndex = 0;
          eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: false });
        } else if (this.msgQueue[this.ptrRead.index].flag == 'ing') {
          if (this.ptrRead.subIndex < this.msgQueue[this.ptrRead.index].txt.length) {
            var txt = this.msgQueue[this.ptrRead.index].txt;
            if (this.addQAState == false && txt[this.ptrRead.subIndex] == '<' && txt[this.ptrRead.subIndex + 1] == 'a' && txt[this.ptrRead.subIndex + 2] == '>') //匹配到开头
              {
                this.addQAState = true;
                this.ptrRead.subIndex += 2;
              } else if (this.addQAState) {

              if (txt[this.ptrRead.subIndex] == '<' && txt[this.ptrRead.subIndex + 1] == '/' && txt[this.ptrRead.subIndex + 2] == 'a' && txt[this.ptrRead.subIndex + 3] == '>') {
                //匹配到结尾
                this.curQaIndex++;
                this.addQAState = false;
                this.ptrRead.subIndex += 3;
              } else {
                if (this.curQaIndex >= this.questionList.length) {
                  this.questionList.push(txt[this.ptrRead.subIndex]);
                } else {
                  this.questionList[this.curQaIndex] += txt[this.ptrRead.subIndex];
                }
                this.$forceUpdate();
              }
            } else {
              this.displayMessage += this.msgQueue[this.ptrRead.index].txt[this.ptrRead.subIndex];
            }

            this.ptrRead.subIndex++;
          } else {
            //跳转下一个
            this.ptrRead.index = this.ptrRead.index + 1;
            this.ptrRead.subIndex = 0;
            this.nextMessage();
          }
        } else if (this.msgQueue[this.ptrRead.index].flag == 'end') {
          this.ptrRead.index = this.ptrRead.index + 1;
          this.ptrRead.subIndex = 0;
        }
      } else {
        var lastItem = this.msgQueue[this.msgQueue.length - 1];
        if (lastItem.flag == 'end') {
          //播放结束
          console.log('----------------------end');

          return true;
        }
      }
      return false;
    },
    init: function init() {
      var _this = this;

      console.log('type init ');
      this.ptrRead = {
        index: 0,
        subIndex: 0
      };
      this.audioRead = 0;
      if (this.intervalHandler) clearInterval(this.intervalHandler);

      this.displayMessage = "";
      this.intervalHandler = setInterval(function () {
        var isEnd = _this.nextMessage();
        // this.nextAudio()
        if (isEnd) {
          _this.disSpeed = 0;
          _this.totalMessage = _this.displayMessage;
          clearInterval(_this.intervalHandler);
          _this.$emit('onTextShowAccomplish', { itemID: _this.itemID });
          eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: true });
        }
      }, 200);
      // audioText.addEventListener('ended',()=>{
      //   console.log('-=-=-=-=-=-= end')
      //   if(this.audioRead<this.msgQueue.length){
      //       this.msgQueue[this.audioRead].audioState = 2 //播放结束，开始下一个 
      //       this.audioRead++
      //       this.nextAudio()
      //       console.log('语音播放结束，播放下一个语音:')
      //   }

      // })
    },
    getCurShowLength: function getCurShowLength() {
      return this.displayMessage.length;
    },

    //播放文字语音
    onPlayTextVoice: function onPlayTextVoice() {

      // let url = '/static/img/蓝心羽 - 好想爱这个世界啊 (片段).mp3'  //播放地址
      this.$emit('onPlayText');
    }
  },
  watch: {
    playState: function playState(value) {
      this.playTextVoiceSatate = value;
    },
    stringText: function stringText(value) {
      this.totalMessage = value;
    }
  },
  expose: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f24dc30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/TypeFlowMessage/TypeFlowMessage.vue
var TypeFlowMessage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('span',{staticStyle:{"width":"100%","display":"block","padding-right":"3px"}},[_vm._v(_vm._s(_vm.disSpeed<=0?_vm.totalMessage:_vm.displayMessage)+"\n    "),_c('div',{staticClass:"question"},_vm._l((_vm.questionList),function(item){return _c('li',[_c('a',{staticClass:"question-sub",attrs:{"href":"#"},on:{"click":function($event){return _vm.onAsk(item)}}},[_vm._v(_vm._s(item))])])}),0)])])}
var TypeFlowMessage_staticRenderFns = []
var TypeFlowMessage_esExports = { render: TypeFlowMessage_render, staticRenderFns: TypeFlowMessage_staticRenderFns }
/* harmony default export */ var myComponents_TypeFlowMessage_TypeFlowMessage = (TypeFlowMessage_esExports);
// CONCATENATED MODULE: ./src/myComponents/TypeFlowMessage/TypeFlowMessage.vue
function TypeFlowMessage_injectStyle (ssrContext) {
  __webpack_require__("LYDH")
}
var TypeFlowMessage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TypeFlowMessage___vue_template_functional__ = false
/* styles */
var TypeFlowMessage___vue_styles__ = TypeFlowMessage_injectStyle
/* scopeId */
var TypeFlowMessage___vue_scopeId__ = "data-v-2f24dc30"
/* moduleIdentifier (server only) */
var TypeFlowMessage___vue_module_identifier__ = null
var TypeFlowMessage_Component = TypeFlowMessage_normalizeComponent(
  TypeFlowMessage_TypeFlowMessage,
  myComponents_TypeFlowMessage_TypeFlowMessage,
  TypeFlowMessage___vue_template_functional__,
  TypeFlowMessage___vue_styles__,
  TypeFlowMessage___vue_scopeId__,
  TypeFlowMessage___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_TypeFlowMessage_TypeFlowMessage = (TypeFlowMessage_Component.exports);

// EXTERNAL MODULE: ./node_modules/element-resize-detector/src/element-resize-detector.js
var element_resize_detector = __webpack_require__("uk2G");
var element_resize_detector_default = /*#__PURE__*/__webpack_require__.n(element_resize_detector);

// EXTERNAL MODULE: ./src/api/api.js
var api = __webpack_require__("P9l9");

// EXTERNAL MODULE: ./src/S51WebGLSDK/define.js
var define = __webpack_require__("1/Ha");

// EXTERNAL MODULE: ./node_modules/vux/src/components/loading/index.vue + 3 modules
var loading = __webpack_require__("Bfwr");

// EXTERNAL MODULE: ./src/S51WebGLSDK/index.js + 5 modules
var S51WebGLSDK = __webpack_require__("WzIO");

// EXTERNAL MODULE: ./src/utils/utils.js
var utils_utils = __webpack_require__("oAV5");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/utils/chatService.js





/**
 * 流式聊天服务
 */
var chatService_ChatService = function () {
    function ChatService(appId, token) {
        classCallCheck_default()(this, ChatService);

        this.appId = appId;
        this.token = token;
        this.state = 0; //0-未连接  1-连接中  2-连接成功  3-连接失败
    }

    createClass_default()(ChatService, [{
        key: 'disconnect',
        value: function disconnect() {
            this.websocket && this.websocket.close();
        }
        /**
         * 连接
         */

    }, {
        key: 'connect',
        value: function connect(callback) {
            var _this = this;

            console.log('----------连接websocket');
            if (this.state == 1) {
                console.log('已经正在连接中');
                return;
            }
            this.state = 1;
            this.websocket = new WebSocket("wss://wschatpro.studio51.com/api/chat" + '/' + ('' + this.token));
            this.websocket.onopen = function () {
                console.log('websocket connect success');
                _this.state = 2;
                callback && callback(null, '连接成功');
                if (_this.heartHandle) {
                    clearInterval(_this.heartHandle);
                }
                _this.heartHandle = setInterval(function () {
                    if (_this.state == 2) {
                        _this.websocket.send(stringify_default()({
                            'heart': Date.now()
                        }));
                    }
                }, 15000);
            };
            this.websocket.onerror = function (err) {
                console.error('websocket connect error', err);
                callback && callback('连接失败');
            };
            this.websocket.onmessage = function (msg) {
                // console.log('websocket message', msg.data)
                if (_this.respCallback) {
                    _this.respCallback(JSON.parse(msg.data));
                }
            };
            this.websocket.onclose = function (reason) {
                console.log('websocket close', reason);
                _this.state = 0;
                //尝试重连
                setTimeout(function () {
                    _this.connect(function (msg) {});
                }, 5000);
            };
            setInterval(function () {}, 5000);
            return this;
        }
        /**
         * 询问
         * @param {*} question 
         * @param {*} openViseme 
         * type:1-文字  2-语音
         */

    }, {
        key: 'ask',
        value: function ask(questionID, question, type, param, callback) {
            if (this.state == 0 || this.state == 3) {
                return callback('服务器还未连接');
            }
            console.log('-----token', this.token);
            var askData = {
                h: [],
                q: '',
                qu: ''
            };
            if (type == Chatframe["b" /* CHAT_TYPE */].TEXT) {
                askData.q = question;
            } else if (type == Chatframe["b" /* CHAT_TYPE */].VOICE) {
                askData.qu = question;
            }
            this.websocket.send(stringify_default()(askData));
            this.respCallback = callback;
        }
    }]);

    return ChatService;
}();
// CONCATENATED MODULE: ./src/S51AudioPlayer/index.js






var S51AudioPlayer_AudioQueue = function () {
    function AudioQueue() {
        classCallCheck_default()(this, AudioQueue);

        this.audioText = new Audio();
        this.audioList = [];
        this.audioRead = 0;
        this.type = 0; //0-2D 1-3D需要驱动口型
        this.start = 0;
        this.muted = true; //默认静音
        this.audioID = 0;
        this.audioPlaying = false;
        var _this = this;
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        var playEndHandler = function playEndHandler() {
            console.log('-=-=-=-=-=-= end');
            if (_this.audioRead < _this.audioList.length) {
                if (_this.audioList[_this.audioRead].endFlag) {
                    _this.callback && _this.callback('endPlay', { id: _this.audioID });
                    _this.type == AudioDriveType.TYPE_3D && S51WebGLSDK["a" /* default */].setJWAOpenValue(0);
                    _this.audioPlaying = false;
                }
                _this.audioList[_this.audioRead].audioState = 2; //播放结束，开始下一个 
                _this.audioRead++;
                _this.nextAudio();
                console.log('语音播放结束，播放下一个语音:');
            }
        };
        this.audioText.addEventListener('ended', playEndHandler);
    }

    createClass_default()(AudioQueue, [{
        key: "setEventListener",
        value: function setEventListener(callback) {
            this.callback = callback;
        }
    }, {
        key: "setMuted",
        value: function setMuted(muted) {
            var _this2 = this;

            if (!muted && this.muted) {
                //取消静音，并且之前是静音状态开始播放
                this.audioCtx && this.audioCtx.resume(); //激活audioctx
                this.audioText.muted = false;
                this.nextAudio();
                if (this.timeHandler) clearInterval(this.timeHandler);
                this.timeHandler = setInterval(function () {
                    _this2.nextAudio();
                }, 200);
            }
            this.muted = muted;
        }
    }, {
        key: "reset",
        value: function reset(type) {
            var _this3 = this;

            if (type) {
                this.type = type;
            }
            if (this.audioPlaying) {
                this.pause();
            }

            this.audioList = [];
            this.audioRead = 0;
            console.log('muted state', this.muted);
            if (!this.muted) {
                //非静音状态，开始播放列表
                if (this.timeHandler) clearInterval(this.timeHandler);
                this.timeHandler = setInterval(function () {
                    _this3.nextAudio();
                }, 200);
                this.audioCtx && this.audioCtx.resume(); //激活audioctx
            } else {//当前静音状态

                }
        }
    }, {
        key: "addAudio",
        value: function addAudio(url, uniID, endFlag) {
            console.log('add url', url);
            this.audioList.push({
                audio: url,
                audioState: 0,
                endFlag: endFlag ? true : false
            });
            if (this.audioList.length == 1) {
                //第一条记录 记录开始时间
                this.start = Date.now();
                this.audioID = uniID;
                this.callback && this.callback('startLoading', { id: this.audioID });
            }
        }
    }, {
        key: "pause",
        value: function pause() {

            this.audioText.pause();
            this.audioCtxPlaying = false;
            S51WebGLSDK["a" /* default */].setJWAOpenValue(0);
            this.audioCtx && this.audioCtx.suspend();
            this._source && (this._source.onended = null);
            this._source = null;
            console.log('播放结束 pause');
        }
        /**
           * 处理下一帧文字
           * 返回： true:所有消息结束 false:消息未结束
           */

    }, {
        key: "nextAudio",
        value: function nextAudio() {
            if (this.audioRead >= this.audioList.length) {
                return;
            }

            if (!this.audioList[this.audioRead].audioState || this.audioList[this.audioRead].audioState == 0) {
                //0-还未开始 1-播放中 2-播放结束
                if (this.audioList[this.audioRead].audio) {

                    this.audioText.autoplay = false;
                    this.audioText.src = this.audioList[this.audioRead].audio;
                    this.audioText.muted = false;
                    this.audioPlaying = true;
                    var _this = this;

                    if (this.audioRead == 0) {
                        //第一个音频 如果当前时间-开始时间没有超过第一个音频的时长，则使用seek到指定位置
                        var startPlayHandler = function startPlayHandler() {

                            _this.audioText.removeEventListener('canplaythrough', startPlayHandler);
                            var curTime = (Date.now() - _this.start - 200) * 1.0 / 1000;
                            console.log('start play handler', _this.audioText.duration, curTime);
                            if (curTime < 1) {
                                curTime = 0; //1秒以内不seek
                            }
                            if (_this.audioText.duration <= curTime) {
                                //已经超时 播放结束
                                _this.audioText.pause();
                                return;
                            }
                            _this.audioText.currentTime = curTime;

                            var seeked = function seeked() {
                                console.log('seeked handler');
                                _this.audioText.removeEventListener('seeked', seeked);
                                _this.audioText.muted = false;
                                _this.audioText.play().then(function () {
                                    _this.callback && _this.callback('startPlay', { id: _this.audioID });
                                }, function (err) {
                                    //  alert(err)
                                    console.error(err);
                                });
                            };
                            _this.audioText.addEventListener('seeked', seeked);
                            // console.log('type',_this.type)
                            _this.type == AudioDriveType.TYPE_3D && _this.initAudioCtx(_this.audioList[_this.audioRead].audio, _this.audioText.currentTime + 0.1);
                        };
                        this.audioText.addEventListener('canplaythrough', startPlayHandler);
                        this.audioText.muted = true; //开始播放前静音，等加载完成后再开始播放声音
                        this.audioText.load();
                        console.log('load audio');
                    } else {
                        this.audioText.play().then(function () {}, function (err) {
                            //  alert(err)
                            console.error(err);
                        });
                        this.type == AudioDriveType.TYPE_3D && this.initAudioCtx(this.audioList[this.audioRead].audio, 0.1);
                    }

                    this.audioList[this.audioRead].audioState = 1;
                    console.log('开始播放语音:', this.audioList[this.audioRead].audio);
                } else {
                    console.log('没有语音文件', this.audioList[this.audioRead]);
                    this.audioList[this.audioRead].audioState = 2;
                    if (this.audioList[this.audioRead].endFlag) {
                        //最后一个语音 
                        this.callback && this.callback('endPlay', { id: this.audioID });
                        this.type == AudioDriveType.TYPE_3D && S51WebGLSDK["a" /* default */].setJWAOpenValue(0);
                        this.audioPlaying = false;
                    }
                    this.audioRead++;
                    this.nextAudio();
                }
            }
        }
        /**
        * 根据音频波形控制口行张合
        */

    }, {
        key: "initAudioCtx",
        value: function initAudioCtx(audioUrl, startSec) {
            // console.log('init audio ctx',audioUrl,startSec)
            var _sensitivityThreshold = .5;
            var samplingFrequency = 44100;
            var _voiceBoundingFrequencies = [0, 500, 700, 3000, 6000];
            var _audioSampleCount = { low: 256, med: 512, high: 1024 };
            var _smoothing = 0.5;
            var getstPSD = function getstPSD(spectrum) {

                var stPSD = new Float32Array(spectrum.length);

                for (var i = 0; i < spectrum.length; i++) {
                    stPSD[i] = _sensitivityThreshold + (spectrum[i] + 20) / 140;
                }

                return stPSD;
            };

            var _getData = function _getData(url) {
                var request = new XMLHttpRequest();

                request.open('GET', url, true);
                request.responseType = 'arraybuffer';

                return new promise_default.a(function (resolve, reject) {
                    request.onload = function () {
                        var audioData = request.response;
                        resolve(audioData);
                        console.log('audioData', audioData);
                    };

                    request.send();
                });
            };

            var _sampleCount = _audioSampleCount.high;
            var _indicesFrequencyMale = [];
            var _analyser = this.audioCtx.createAnalyser();
            this.audioCtxPlaying = false;
            var _this = this;
            _getData(audioUrl).then(function (audioData) {
                _this.audioCtx.decodeAudioData(audioData, function (_buffer) {
                    console.log('Buffer ready to play.');
                    for (var m = 0; m < _voiceBoundingFrequencies.length; m++) {
                        _indicesFrequencyMale[m] = Math.round(2 * _sampleCount / samplingFrequency * _voiceBoundingFrequencies[m]);
                        //console.log("IndicesFrequencyMale[",m,"]",_indicesFrequencyMale[m]);
                    }
                    _analyser.minDecibels = -160;
                    _analyser.maxDecibels = -25;
                    _analyser.smoothingTimeConstant = _smoothing;
                    _analyser.fftSize = _sampleCount;

                    _this._source = _this.audioCtx.createBufferSource();
                    _this._source.buffer = _buffer;
                    _this._source.connect(_analyser);
                    var gainNode = _this.audioCtx.createGain();
                    gainNode.connect(_this.audioCtx.destination);
                    gainNode.gain.value = 0; // 设置音量为0
                    _this._source.connect(gainNode);
                    if (_this._node) {
                        _this._node.onaudioprocess = null;
                        _this._node = null;
                    }
                    _this._node = _this.audioCtx.createScriptProcessor(_sampleCount * 2, 1, 1);
                    _analyser.connect(_this._node);
                    _this._node.onaudioprocess = function (_) {
                        if (!_this.audioCtxPlaying) return;
                        // console.log('=============== process')
                        var _spectrum = new Float32Array(_analyser.frequencyBinCount);
                        _analyser.getFloatFrequencyData(_spectrum);
                        var _stPSD = getstPSD(_spectrum);

                        var _blendShapeKiss = 0;
                        var _blendShapeLips = 0;
                        var _blendShapeMouth = 0;

                        var energyBinMale = new Float32Array(_voiceBoundingFrequencies.length);

                        for (var _m = 0; _m < _voiceBoundingFrequencies.length - 1; _m++) {
                            for (var j = _indicesFrequencyMale[_m]; j <= _indicesFrequencyMale[_m + 1]; j++) {
                                if (_stPSD[j] > 0) {
                                    energyBinMale[_m] += _stPSD[j];
                                }
                            }

                            energyBinMale[_m] /= _indicesFrequencyMale[_m + 1] - _indicesFrequencyMale[_m];
                        }

                        if (energyBinMale[1] > 0.2) {
                            _blendShapeKiss = 1 - 2 * energyBinMale[2];
                        } else {
                            _blendShapeKiss = (1 - 2 * energyBinMale[2]) * 5 * energyBinMale[1];
                        }

                        _blendShapeLips = 3 * energyBinMale[3];
                        _blendShapeMouth = 0.85 * (energyBinMale[1] - energyBinMale[3]);

                        var _blendShapes = {
                            blendShapeKiss: _blendShapeKiss,
                            blendShapeLips: _blendShapeLips,
                            blendShapeMouth: _blendShapeMouth
                            //    console.log('process ',_blendShapeMouth)
                        };S51WebGLSDK["a" /* default */].setJWAOpenValue(_blendShapeMouth);
                        //    EventBus.$emit(BUS_EVENT.ADD_LOG,_blendShapeMouth)
                    };

                    _this._node.connect(_this.audioCtx.destination);
                    _this.audioCtxPlaying = true;
                    _this._source.start(0, startSec ? startSec : 0);
                    _this._source.onended = function () {
                        console.log('播放结束 111');
                        _this.audioCtxPlaying = false;
                        _this._node.onaudioprocess = null;
                    };
                }, function (err) {
                    console.log("Error with decoding audio data:" + err);
                    reject(err);
                });
            }, function (err) {
                console.log("Error with decoding audio data:" + err);
                reject(err);
            });
        }
    }]);

    return AudioQueue;
}();

/* harmony default export */ var S51AudioPlayer = (new S51AudioPlayer_AudioQueue());
var AudioDriveType = {
    TYPE_2D: 0,
    TYPE_3D: 1
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/Chatframe/Chatframe.vue

























/* harmony default export */ var Chatframe_Chatframe = ({
  name: "chatframe",
  components: {
    InlineLoading: inline_loading["a" /* default */],
    TypeMessageVue: src_myComponents_TypeMessage_TypeMessage,
    TypeFlowMessageVue: src_myComponents_TypeFlowMessage_TypeFlowMessage,
    MyVideo: myVideo["a" /* default */],
    MyImage: myImage["a" /* default */],
    Loading: loading["a" /* default */]
  },
  props: {
    voiceContentList: Array,
    appId: String,
    imageType: Number, //类型 0：2D  1：3D
    actionMap: {},
    defaultChatAction: String

  },
  data: function data() {
    return {
      list: [],
      chatType: Chatframe["b" /* CHAT_TYPE */],
      chatRole: Chatframe["a" /* CHAT_ROLE */],
      showVideo: false,
      videoUrl: "",
      showImage: false,
      imageUrl: "",
      currentPlayID: 0,
      clickPlay: false,
      playShow: true,
      id: 0,
      greetContent: {
        id: 0,
        playState: 0
      },
      audioMuted: true,
      audioPlayers: {},
      longPressTimer: null,
      pressedItem: null
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log('------------mouted appid', this.appId);
    this.enableInput = true;
    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, function (param) {
      _this2.enableInput = param.enable;
    });
    this.initChatService(this.appId);
    document.addEventListener('click', function () {
      if (_this2.audioMuted) {
        if (_this2.greetContent.id > 0 && !_this2.greetContent.typeFinish) {//打招呼还没打印完成


        }
        _this2.audioMuted = false;
        audioText_audio.muted = false;
        S51AudioPlayer.setMuted(false);
      }
    });
    console.log("%c⧭", "color: #ffa280", this.imageType);
    var param = utils["a" /* utils */].getUrlParams(window.location.href);
    if (param.type == "GPT") {
      this.playShow = false;
    }
    S51AudioPlayer.reset(param.type == '3d' ? AudioDriveType.TYPE_3D : AudioDriveType.TYPE_2D);

    var erd = element_resize_detector_default()();

    var _this = this;
    console.log("chatList", document.getElementById("chatList"));
    erd.listenTo(document.getElementById("chatList"), function (element) {
      _this.$nextTick(function () {
        var scrollEl = _this.$refs.mianscroll;
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: "smooth" });
        scrollEl.addEventListener("scroll", function (e) {

          var chatContainer = document.getElementById("chatContainer");
          var containerTop = chatContainer.getBoundingClientRect().top;

          var greet = document.getElementById('greet');
          if (greet) {

            if (greet.getBoundingClientRect().bottom - containerTop < 20) {
              greet.style.visibility = "hidden";
            } else {
              greet.style.visibility = "visible";
            }
          }

          _this.list.forEach(function (item) {
            var chat = document.getElementById("itemref" + item.id);
            if (chat) {

              if (chat.getBoundingClientRect().bottom - containerTop < 20) {
                chat.style.visibility = "hidden";
              } else {
                chat.style.visibility = "visible";
              }
            }
          });
        });
      });
      S51AudioPlayer.setEventListener(function (event, data) {
        if (event == 'startLoading') {
          console.log('开始加载', data);
          if (data.id == _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.loadingVoice = true;
            _this2.greetContent.playTextVoiceSatate = false;
          }
          for (var i = 0; i < _this2.list.length; ++i) {
            if (_this2.list[i].id == data.id) {
              _this2.list[i].playTextVoiceSatate = false;
              _this2.list[i].clickPlay = true;
            }
          }
          _this2.$forceUpdate();
        } else if (event == 'startPlay') {
          console.log('开始播放', data);

          if (data.id != _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.playTextVoiceSatate = false;
          }
          for (var _i = 0; _i < _this2.list.length; ++_i) {
            if (_this2.list[_i].id != data.id) {
              _this2.list[_i].playTextVoiceSatate = false;
            }
          }

          if (data.id == _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.playTextVoiceSatate = true;
            _this2.greetContent.loadingVoice = false;
          } else {
            for (var _i2 = 0; _i2 < _this2.list.length; ++_i2) {
              if (_this2.list[_i2].id == data.id) {
                _this2.list[_i2].playTextVoiceSatate = true;
                _this2.list[_i2].clickPlay = false;
              }
            }
          }
          _this2.$forceUpdate();
        } else if (event == 'endPlay') {
          console.log('播放结束', data);
          if (data.id == _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.playTextVoiceSatate = false;
            _this2.greetContent.loadingVoice = false;
          } else {
            for (var _i3 = 0; _i3 < _this2.list.length; ++_i3) {
              if (_this2.list[_i3].id == data.id) {
                _this2.list[_i3].playTextVoiceSatate = false;
              }
            }
          }
          _this2.$forceUpdate();
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    startLongPress: function startLongPress(event, item) {
      var _this3 = this;

      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
      }

      this.pressedItem = item;

      var longPressDuration = 500;

      this.longPressTimer = setTimeout(function () {

        _this3.$set(item, 'showTranslateBtn', true);
      }, longPressDuration);
    },
    cancelLongPress: function cancelLongPress() {

      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
      this.pressedItem = null;
    },
    translateVoice: function translateVoice(item) {
      var _this4 = this;

      this.$set(item, 'showTranslateBtn', false);
      if (item.translateText != '') {
        if (item.translateShowStatus) {
          this.$set(item, 'translateShowStatus', false);
        } else {
          this.$set(item, 'translateShowStatus', true);
        }
      } else {
        this.$vux.loading.show({
          text: '转换中...',
          position: 'absolute'
        });
        var options = {
          voice: item.voiceHttpUrl,
          app_id: this.appId
        };
        Object(api["y" /* translateVoiceToText */])(options).then(function (res) {
          _this4.$vux.loading.hide();
          if (res.code == 200) {
            _this4.$set(item, 'translateShowStatus', true);
            _this4.$set(item, 'translateText', res.data.word);
          }
        }).finally(function () {
          _this4.$vux.loading.hide();
        });
      }
    },
    playAudio: function playAudio(id, item) {
      var _this5 = this;

      if (!this.audioPlayers) {
        this.audioPlayers = {};
      }

      if (!this.audioPlayers[id]) {
        this.audioPlayers[id] = new Audio();

        this.audioPlayers[id].addEventListener('ended', function () {
          console.log('音频播放完成');

          _this5.audioPlayers[id].currentTime = 0;
          _this5.$set(item, 'rightPlayStatus', false);
        });
      }

      var audio = this.audioPlayers[id];

      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
        this.$set(item, 'rightPlayStatus', false);
        console.log('音频已暂停并重置');
        return;
      }

      if (item.voiceHttpUrl && audio.src !== item.voiceHttpUrl) {
        audio.src = item.voiceHttpUrl;
      }
      this.$set(item, 'rightPlayStatus', true);
      audio.play();
    },
    onClickQuestion: function onClickQuestion(data) {
      console.log('点击了问题:', data);
      this.flowChat(Chatframe["b" /* CHAT_TYPE */].TEXT, data, 0);
    },

    /**
    * 流式聊天
    */
    initChatService: function initChatService(appId) {
      var _this6 = this;

      console.log('init chat service', appId);
      if (appId && appId.length) {
        if (!this.lastAppId || this.lastAppId != appId) {
          console.log('appid change', appId);
          this.lastAppId = appId;
          Object(api["f" /* chatToken */])({
            app_id: appId,
            type: this.imageType
          }).then(function (d) {
            if (_this6.chatService) {
              _this6.chatService.disconnect();
              _this6.chatService = null;
            }
            _this6.chatServiceToken = d.data.token;
            _this6.chatService = new chatService_ChatService(appId, d.data.token).connect();
          }, function (e) {
            console.error('获取长连接token失败');
          });
        }
      }
    },

    /**
    * 播放打招呼
    */
    onPlayGreetVoice: function onPlayGreetVoice() {
      var _this7 = this;

      if (!this.enableInput) {
        return;
      }
      if (this.greetContent.playTextVoiceSatate) {
        S51AudioPlayer.pause();
        this.greetContent.playTextVoiceSatate = false;
        this.$forceUpdate();
        return;
      }
      if (this.greetContent.helloAudio && (!this.greetContent.preName || this.greetContent.name == this.greetContent.preName)) {
        S51AudioPlayer.reset();
        S51AudioPlayer.addAudio(this.greetContent.helloAudio, this.greetContent.id, true);
      } else {
        this.greetContent.preName = this.greetContent.name;
        var name = this.greetContent.name;
        this.$set(this.greetContent, 'loadingVoice', true);
        Object(api["g" /* chatWordToVoice */])(name, this.appId).then(function (res) {
          if (res.code == 200) {
            _this7.greetContent.helloAudio = res.data.audio;
            _this7.greetContent.viseme = res.data.viseme;
            _this7.greetContent.duration = res.data.duration;
            S51AudioPlayer.reset();
            S51AudioPlayer.addAudio(_this7.greetContent.helloAudio, _this7.greetContent.id, true);
          }
        }).finally(function () {
          _this7.$set(_this7.greetContent, 'loadingVoice', false);
        });
      }
    },
    onEditText: function onEditText() {
      this.$emit("informEditModal", { open: true, text: this.greetContent.name });
    },
    onPlayTextVoice: function onPlayTextVoice(item) {
      if (this.clickPlay) return;
      if (!this.enableInput) {
        //流式聊天正在接受数据
        return;
      }
      if (item.playTextVoiceSatate) {
        S51AudioPlayer.pause();
        item.playTextVoiceSatate = false;
        this.$forceUpdate();

        return;
      }
      this.id = item.id;
      this.stopAllTyping();
      if (item.msgQueue.length) {
        S51AudioPlayer.reset();
        for (var i = 0; i < item.msgQueue.length; ++i) {
          if (item.msgQueue[i].flag == 'ing' && item.msgQueue[i].audio && item.msgQueue[i].audio.length > 0) {
            S51AudioPlayer.addAudio(item.msgQueue[i].audio, item.id);
          } else if (item.msgQueue[i].flag == 'end') {
            S51AudioPlayer.addAudio(null, item.id, true);
          }
        }
      }
    },
    onTextShowAccomplish: function onTextShowAccomplish(e) {
      var _this8 = this;

      console.log("%c⧭", "color: #00bf00", e);
      console.log('0000000');
      this.list.forEach(function (item) {
        console.log('11111111');
        if (item.id == e.itemID) {
          item.disPlay = true;
          console.log('------打字结束', item);

          if (item.extFile) {
            _this8.addExtFileMsg(item.extFile);
          }
        }
      });

      S51WebGLSDK["a" /* default */].playIdleAction();
      this.stopedAcion = Date.now();
      this.$forceUpdate();
      console.log("%c⧭", "color: #0088cc", this.list);
    },
    stopNowVoice: function stopNowVoice() {
      S51WebGLSDK["a" /* default */].stopNowVoice();
      audioText_audio.pause();
      if (this.greetContent.speed > 0) {
        this.greetContent.speed = 0;
        this.greetContent.typeFinish = true;
        this.greetContent.disPlay = true;
      }
    },
    openFile: function openFile(url) {
      console.log("打开文档", url);
      this.$wechat.miniProgram.navigateTo({
        url: "../documentView/documentView?url=" + encodeURIComponent(url),
        success: function success() {
          console.log("跳转成功");
        }
      });
    },
    onLookVideo: function onLookVideo(url) {
      this.videoUrl = url;
      this.showVideo = true;
      this.stopNowVoice();
    },
    onLookImage: function onLookImage(url) {
      this.imageUrl = url;
      this.showImage = true;
    },
    addExtFileMsg: function addExtFileMsg(annex) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var type, size, fileName, arr;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('添加文件:', annex);

                type = Object(utils_utils["b" /* getChatFileType */])(annex);

                if (!type) {
                  _context.next = 26;
                  break;
                }

                if (!(type == Chatframe["b" /* CHAT_TYPE */].IMG)) {
                  _context.next = 7;
                  break;
                }

                _this9.list.push({
                  type: type,
                  differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
                  id: "ext_" + Date.now(),
                  app_id: _this9.appId,
                  imageUrl: annex
                });
                _context.next = 26;
                break;

              case 7:
                if (!(type == Chatframe["b" /* CHAT_TYPE */].VIDEO)) {
                  _context.next = 11;
                  break;
                }

                _this9.list.push({
                  type: type,
                  differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
                  id: "ext_" + Date.now(),
                  app_id: _this9.appId,
                  videoUrl: annex,
                  videoCover: annex + "?vframe/jpg/offset/2/w/480" //获取封面图
                });
                _context.next = 26;
                break;

              case 11:
                if (!(type == Chatframe["b" /* CHAT_TYPE */].FILE)) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 12;
                _context.next = 15;
                return Object(api["r" /* headInfoSize */])(annex);

              case 15:
                size = _context.sent;

                size = (size / (1024 * 1024)).toFixed(2);
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](12);

                console.log(_context.t0);

              case 22:
                fileName = "附件";
                arr = annex.split("/");

                if (arr.length > 0) {
                  fileName = arr[arr.length - 1];
                }
                _this9.list.push({
                  type: type,
                  differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
                  id: "ext_" + Date.now(),
                  app_id: _this9.appId,
                  name: fileName,
                  size: size || 0,
                  fileUrl: annex
                });

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this9, [[12, 19]]);
      }))();
    },
    chat: function chat(type, message, cardID) {
      console.log("聊天:", type, message);
      return this.flowChat(type, message, cardID);
    },
    addRobotMessage: function addRobotMessage(helloWorld, voiceUrl, voiceViseme, action) {

      var chatInfo = {
        differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
        id: Date.now(),
        app_id: this.appId,
        playAction: action
      };

      chatInfo.type = Chatframe["b" /* CHAT_TYPE */].TEXT;
      chatInfo.name = helloWorld, chatInfo.speed = 100;
      this.list.push(chatInfo);
      console.log("say hello ", chatInfo, this.list);
      if (this.imageType == 1 && action && action.length > 0) {

        S51WebGLSDK["a" /* default */].playAction(action);
      }
      this.$emit("onChatListChange", this.list);
    },
    stopAllTyping: function stopAllTyping() {

      this.greetContent.speed = 0;
      for (var i = 0; i < this.list.length; ++i) {
        if (this.list[i].differentiate == Chatframe["a" /* CHAT_ROLE */].ROBOT && this.list[i].type == Chatframe["b" /* CHAT_TYPE */].TEXT) {
          this.list[i].speed = 0;
          this.list[i].disPlay = true;
        }
      }
    },
    clearChat: function clearChat() {
      this.list = [];
      this.greetContent = {
        id: 0
      };
      this.stopAllTyping();
      this.stopNowVoice();
    },
    onTextShowGreetFinish: function onTextShowGreetFinish(e) {
      //打招呼文字显示结束
      console.log('greet type finish', e.itemID, this.greetContent.id);
      if (e.itemID == this.greetContent.id) {
        this.greetContent.disPlay = true;

        if (this.greetContent.extFile) {
          this.addExtFileMsg(this.greetContent.extFile);
        }
        this.$set(this.greetContent, 'typeFinish', true);
      }
      S51WebGLSDK["a" /* default */].playIdleAction();
    },
    playHello: function playHello() {
      var _this10 = this;

      if (this.greetContent.id == 0) {
        return;
      }

      if (this.imageType == 1) {

        S51WebGLSDK["a" /* default */].setAudioMuted(false);
      } else {
        console.log('开始播放语音', this.greetContent.helloAudio);
        audioText_audio.src = this.greetContent.helloAudio;
        audioText_audio.autoplay = false;
        audioText_audio.preload = 'none';
        var startPlay = function startPlay() {
          audioText_audio.removeEventListener('canplaythrough', startPlay);
          audioText_audio.currentTime = _this10.$refs.greetMessage.getCurShowLength() * _this10.greetContent.speed / 1000;
          console.log('可以完整播放音频了', audioText_audio.currentTime);
          audioText_audio.addEventListener('seeked', function () {
            audioText_audio.muted = false;
            audioText_audio.play();
          });
        };
        audioText_audio.addEventListener('canplaythrough', startPlay);
        audioText_audio.muted = true;
        audioText_audio.load();
      }
    },

    /**
    * 打招呼
    */
    sayHello: function sayHello(helloWord, helloAudio, helloVisem, action, duration, isMyself) {
      console.log('say hello', helloWord, this.imageType);

      S51AudioPlayer.addAudio(helloAudio, this.greetContent.id, true);
      if (this.imageType == 1) {
        //3D
        this.greetContent.playAction && this.greetContent.playAction.length > 0 && S51WebGLSDK["a" /* default */].playAction(this.greetContent.playAction);
      }
      this.greetContent = {
        name: helloWord,
        id: Date.now(),
        speed: duration > 0 ? duration * 1000 / helloWord.length : 0,
        isMyself: isMyself,
        helloAudio: helloAudio,
        helloVisem: helloVisem,
        playAction: action,
        duration: duration
      };
    },
    updateHelloWord: function updateHelloWord(hellWord) {
      console.log('更新打招呼内容', hellWord);
      this.greetContent.preName = this.greetContent.name;
      this.$set(this.greetContent, 'name', hellWord);
    },
    flowChat: function flowChat(type, message, cardID) {
      var _this11 = this;

      console.log('message', message);

      return new promise_default.a(function (resolve, reject) {
        resolve({
          data: {}
        });
        var messageText = null;
        var messageVoice = null;
        _this11.stopAllTyping();
        _this11.stopNowVoice();

        for (var i = 0; i < _this11.list.length; ++i) {
          _this11.list[i].playTextVoiceSatate = false;
        }
        eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: false });
        switch (type) {
          case Chatframe["b" /* CHAT_TYPE */].TEXT:
            messageText = message;
            _this11.list.push({
              type: Chatframe["b" /* CHAT_TYPE */].TEXT,
              differentiate: Chatframe["a" /* CHAT_ROLE */].USER,
              id: Date.now(),
              name: message,
              app_id: _this11.appId
            });
            break;
          case Chatframe["b" /* CHAT_TYPE */].VOICE:
            messageVoice = message;
            _this11.list.push({
              type: Chatframe["b" /* CHAT_TYPE */].VOICE,
              differentiate: Chatframe["a" /* CHAT_ROLE */].USER,
              id: Date.now(),
              voiceUrl: messageVoice.voiceUrl,
              voiceHttpUrl: messageVoice.voiceHttpUrl,
              app_id: _this11.appId,
              duration: Math.floor(messageVoice.duration),
              rightPlayStatus: false,
              showTranslateBtn: false,
              translateText: '',
              translateShowStatus: false
            });
            break;
        }
        _this11.$emit("onChatListChange", _this11.list);
        var self = _this11;
        _this11.chatService.ask(1, type == Chatframe["b" /* CHAT_TYPE */].VOICE ? messageVoice.voiceHttpUrl : messageText, type, null, function (msg) {
          console.log('flow chat', msg);
          if (msg.m && msg.m.length > 0) {
            console.error('聊天失败：', msg.m);

            eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: true });
            return;
          }
          if (msg.f == 'start') {
            var chatInfo = {
              differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
              id: Date.now(),
              app_id: self.appId,
              flowText: true,
              type: Chatframe["b" /* CHAT_TYPE */].TEXT,
              audioText: audioText_audio,
              name: '',
              msgQueue: [{
                txt: '',
                file: '',
                audio: '',
                viseme: '',
                flag: 'start'
              }]
            };
            self.currentChatInfo = chatInfo;
            self.list.push(chatInfo);

            console.log(' answer start input');
            self.$emit("onChatListChange", self.list);
            S51AudioPlayer.reset();
          } else if (msg.f == 'ing' && self.currentChatInfo) {
            var audio = '';
            if (msg.a && msg.a.length > 0) {
              audio = msg.a[0];
              if (audio.indexOf('http') == 0) {//http直接按照http文件播放

              } else {
                audio = 'data:audio/mpeg;base64,' + audio;
              }
            }
            if (msg.r.data.f && msg.r.data.f.length) {
              self.currentChatInfo.extFile = msg.r.data.f;
            }
            self.currentChatInfo.msgQueue.push({
              txt: msg.r.data.r,
              file: msg.r.data.f,
              audio: audio != '' ? audio : null,
              viseme: msg.v,
              flag: 'ing'
            });
            S51AudioPlayer.addAudio(audio, self.currentChatInfo.id);
            if (self.currentChatInfo.msgQueue.length == 2) {
              //第一个ing 开始播放动作


              var actionUrl = self.defaultChatAction && self.defaultChatAction.length > 0 ? self.actionMap[self.defaultChatAction] : "";
              if (self.actionMap && msg.r.data.ba && self.actionMap[msg.r.data.ba]) {
                actionUrl = self.actionMap[msg.r.data.ba];
                console.log("使用指定动作", actionUrl);
              }
              console.log('------------查询动作', actionUrl, self.actionMap, msg.r.data.ba);
              if (self.imageType == 1) {

                actionUrl && actionUrl.length > 0 && S51WebGLSDK["a" /* default */].playAction(actionUrl);
              }
              self.currentChatInfo.playAction = actionUrl;
            }
          } else if (msg.f == 'end' && self.currentChatInfo) {
            //消息结束
            self.currentChatInfo.name = msg.r;
            self.currentChatInfo.msgQueue.push({
              txt: '',
              file: '',
              audio: '',
              viseme: '',
              flag: 'end'
            });
            S51AudioPlayer.addAudio(null, self.currentChatInfo.id, true);
            self.currentChatInfo.flag = 'end';
            self.currentChatInfo = null;
          }
        });
      });
    }
  },
  watch: {
    appId: function appId(app_id) {
      this.initChatService(app_id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/myComponents/Chatframe/Chatframe.vue

























/* harmony default export */ var myComponents_Chatframe_Chatframe = ({
  name: "chatframe",
  components: {
    InlineLoading: inline_loading["a" /* default */],
    TypeMessageVue: src_myComponents_TypeMessage_TypeMessage,
    TypeFlowMessageVue: src_myComponents_TypeFlowMessage_TypeFlowMessage,
    MyVideo: myVideo["a" /* default */],
    MyImage: myImage["a" /* default */],
    Loading: loading["a" /* default */]
  },
  props: {
    voiceContentList: Array,
    appId: String,
    imageType: Number, //类型 0：2D  1：3D
    actionMap: {},
    defaultChatAction: String

  },
  data: function data() {
    return {
      list: [],
      chatType: Chatframe["b" /* CHAT_TYPE */],
      chatRole: Chatframe["a" /* CHAT_ROLE */],
      showVideo: false,
      videoUrl: "",
      showImage: false,
      imageUrl: "",
      currentPlayID: 0,
      clickPlay: false,
      playShow: true,
      id: 0,
      greetContent: {
        id: 0,
        playState: 0
      },
      audioMuted: true,
      audioPlayers: {},
      longPressTimer: null,
      pressedItem: null
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log('------------mouted appid', this.appId);
    this.enableInput = true;
    eventBus["b" /* EventBus */].$on(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, function (param) {
      _this2.enableInput = param.enable;
    });
    this.initChatService(this.appId);
    document.addEventListener('click', function () {
      if (_this2.audioMuted) {
        if (_this2.greetContent.id > 0 && !_this2.greetContent.typeFinish) {//打招呼还没打印完成


        }
        _this2.audioMuted = false;
        audioText_audio.muted = false;
        S51AudioPlayer.setMuted(false);
      }
    });
    console.log("%c⧭", "color: #ffa280", this.imageType);
    var param = utils["a" /* utils */].getUrlParams(window.location.href);
    if (param.type == "GPT") {
      this.playShow = false;
    }
    S51AudioPlayer.reset(param.type == '3d' ? AudioDriveType.TYPE_3D : AudioDriveType.TYPE_2D);

    var erd = element_resize_detector_default()();

    var _this = this;
    console.log("chatList", document.getElementById("chatList"));
    erd.listenTo(document.getElementById("chatList"), function (element) {
      _this.$nextTick(function () {
        var scrollEl = _this.$refs.mianscroll;
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: "smooth" });
        scrollEl.addEventListener("scroll", function (e) {

          var chatContainer = document.getElementById("chatContainer");
          var containerTop = chatContainer.getBoundingClientRect().top;

          var greet = document.getElementById('greet');
          if (greet) {

            if (greet.getBoundingClientRect().bottom - containerTop < 20) {
              greet.style.visibility = "hidden";
            } else {
              greet.style.visibility = "visible";
            }
          }

          _this.list.forEach(function (item) {
            var chat = document.getElementById("itemref" + item.id);
            if (chat) {

              if (chat.getBoundingClientRect().bottom - containerTop < 20) {
                chat.style.visibility = "hidden";
              } else {
                chat.style.visibility = "visible";
              }
            }
          });
        });
      });
      S51AudioPlayer.setEventListener(function (event, data) {
        if (event == 'startLoading') {
          console.log('开始加载', data);
          if (data.id == _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.loadingVoice = true;
            _this2.greetContent.playTextVoiceSatate = false;
          }
          for (var i = 0; i < _this2.list.length; ++i) {
            if (_this2.list[i].id == data.id) {
              _this2.list[i].playTextVoiceSatate = false;
              _this2.list[i].clickPlay = true;
            }
          }
          _this2.$forceUpdate();
        } else if (event == 'startPlay') {
          console.log('开始播放', data);

          if (data.id != _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.playTextVoiceSatate = false;
          }
          for (var _i = 0; _i < _this2.list.length; ++_i) {
            if (_this2.list[_i].id != data.id) {
              _this2.list[_i].playTextVoiceSatate = false;
            }
          }

          if (data.id == _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.playTextVoiceSatate = true;
            _this2.greetContent.loadingVoice = false;
          } else {
            for (var _i2 = 0; _i2 < _this2.list.length; ++_i2) {
              if (_this2.list[_i2].id == data.id) {
                _this2.list[_i2].playTextVoiceSatate = true;
                _this2.list[_i2].clickPlay = false;
              }
            }
          }
          _this2.$forceUpdate();
        } else if (event == 'endPlay') {
          console.log('播放结束', data);
          if (data.id == _this2.greetContent.id) {
            //打招呼开始播放
            _this2.greetContent.playTextVoiceSatate = false;
            _this2.greetContent.loadingVoice = false;
          } else {
            for (var _i3 = 0; _i3 < _this2.list.length; ++_i3) {
              if (_this2.list[_i3].id == data.id) {
                _this2.list[_i3].playTextVoiceSatate = false;
              }
            }
          }
          _this2.$forceUpdate();
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    startLongPress: function startLongPress(event, item) {
      var _this3 = this;

      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
      }

      this.pressedItem = item;

      var longPressDuration = 500;

      this.longPressTimer = setTimeout(function () {

        _this3.$set(item, 'showTranslateBtn', true);
      }, longPressDuration);
    },
    cancelLongPress: function cancelLongPress() {

      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
      this.pressedItem = null;
    },
    translateVoice: function translateVoice(item) {
      var _this4 = this;

      this.$set(item, 'showTranslateBtn', false);
      if (item.translateText != '') {
        if (item.translateShowStatus) {
          this.$set(item, 'translateShowStatus', false);
        } else {
          this.$set(item, 'translateShowStatus', true);
        }
      } else {
        this.$vux.loading.show({
          text: '转换中...',
          position: 'absolute'
        });
        var options = {
          voice: item.voiceHttpUrl,
          app_id: this.appId
        };
        Object(api["y" /* translateVoiceToText */])(options).then(function (res) {
          _this4.$vux.loading.hide();
          if (res.code == 200) {
            _this4.$set(item, 'translateShowStatus', true);
            _this4.$set(item, 'translateText', res.data.word);
          }
        }).finally(function () {
          _this4.$vux.loading.hide();
        });
      }
    },
    playAudio: function playAudio(id, item) {
      var _this5 = this;

      if (!this.audioPlayers) {
        this.audioPlayers = {};
      }

      if (!this.audioPlayers[id]) {
        this.audioPlayers[id] = new Audio();

        this.audioPlayers[id].addEventListener('ended', function () {
          console.log('音频播放完成');

          _this5.audioPlayers[id].currentTime = 0;
          _this5.$set(item, 'rightPlayStatus', false);
        });
      }

      var audio = this.audioPlayers[id];

      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
        this.$set(item, 'rightPlayStatus', false);
        console.log('音频已暂停并重置');
        return;
      }

      if (item.voiceHttpUrl && audio.src !== item.voiceHttpUrl) {
        audio.src = item.voiceHttpUrl;
      }
      this.$set(item, 'rightPlayStatus', true);
      audio.play();
    },
    onClickQuestion: function onClickQuestion(data) {
      console.log('点击了问题:', data);
      this.flowChat(Chatframe["b" /* CHAT_TYPE */].TEXT, data, 0);
    },

    /**
    * 流式聊天
    */
    initChatService: function initChatService(appId) {
      var _this6 = this;

      console.log('init chat service', appId);
      if (appId && appId.length) {
        if (!this.lastAppId || this.lastAppId != appId) {
          console.log('appid change', appId);
          this.lastAppId = appId;
          Object(api["f" /* chatToken */])({
            app_id: appId,
            type: this.imageType
          }).then(function (d) {
            if (_this6.chatService) {
              _this6.chatService.disconnect();
              _this6.chatService = null;
            }
            _this6.chatServiceToken = d.data.token;
            _this6.chatService = new chatService_ChatService(appId, d.data.token).connect();
          }, function (e) {
            console.error('获取长连接token失败');
          });
        }
      }
    },

    /**
    * 播放打招呼
    */
    onPlayGreetVoice: function onPlayGreetVoice() {
      var _this7 = this;

      if (!this.enableInput) {
        return;
      }
      if (this.greetContent.playTextVoiceSatate) {
        S51AudioPlayer.pause();
        this.greetContent.playTextVoiceSatate = false;
        this.$forceUpdate();
        return;
      }
      if (this.greetContent.helloAudio && (!this.greetContent.preName || this.greetContent.name == this.greetContent.preName)) {
        S51AudioPlayer.reset();
        S51AudioPlayer.addAudio(this.greetContent.helloAudio, this.greetContent.id, true);
      } else {
        this.greetContent.preName = this.greetContent.name;
        var name = this.greetContent.name;
        this.$set(this.greetContent, 'loadingVoice', true);
        Object(api["g" /* chatWordToVoice */])(name, this.appId).then(function (res) {
          if (res.code == 200) {
            _this7.greetContent.helloAudio = res.data.audio;
            _this7.greetContent.viseme = res.data.viseme;
            _this7.greetContent.duration = res.data.duration;
            S51AudioPlayer.reset();
            S51AudioPlayer.addAudio(_this7.greetContent.helloAudio, _this7.greetContent.id, true);
          }
        }).finally(function () {
          _this7.$set(_this7.greetContent, 'loadingVoice', false);
        });
      }
    },
    onEditText: function onEditText() {
      this.$emit("informEditModal", { open: true, text: this.greetContent.name });
    },
    onPlayTextVoice: function onPlayTextVoice(item) {
      if (this.clickPlay) return;
      if (!this.enableInput) {
        //流式聊天正在接受数据
        return;
      }
      if (item.playTextVoiceSatate) {
        S51AudioPlayer.pause();
        item.playTextVoiceSatate = false;
        this.$forceUpdate();

        return;
      }
      this.id = item.id;
      this.stopAllTyping();
      if (item.msgQueue.length) {
        S51AudioPlayer.reset();
        for (var i = 0; i < item.msgQueue.length; ++i) {
          if (item.msgQueue[i].flag == 'ing' && item.msgQueue[i].audio && item.msgQueue[i].audio.length > 0) {
            S51AudioPlayer.addAudio(item.msgQueue[i].audio, item.id);
          } else if (item.msgQueue[i].flag == 'end') {
            S51AudioPlayer.addAudio(null, item.id, true);
          }
        }
      }
    },
    onTextShowAccomplish: function onTextShowAccomplish(e) {
      var _this8 = this;

      console.log("%c⧭", "color: #00bf00", e);
      console.log('0000000');
      this.list.forEach(function (item) {
        console.log('11111111');
        if (item.id == e.itemID) {
          item.disPlay = true;
          console.log('------打字结束', item);

          if (item.extFile) {
            _this8.addExtFileMsg(item.extFile);
          }
        }
      });

      S51WebGLSDK["a" /* default */].playIdleAction();
      this.stopedAcion = Date.now();
      this.$forceUpdate();
      console.log("%c⧭", "color: #0088cc", this.list);
    },
    stopNowVoice: function stopNowVoice() {
      S51WebGLSDK["a" /* default */].stopNowVoice();
      audioText_audio.pause();
      if (this.greetContent.speed > 0) {
        this.greetContent.speed = 0;
        this.greetContent.typeFinish = true;
        this.greetContent.disPlay = true;
      }
    },
    openFile: function openFile(url) {
      console.log("打开文档", url);
      this.$wechat.miniProgram.navigateTo({
        url: "../documentView/documentView?url=" + encodeURIComponent(url),
        success: function success() {
          console.log("跳转成功");
        }
      });
    },
    onLookVideo: function onLookVideo(url) {
      this.videoUrl = url;
      this.showVideo = true;
      this.stopNowVoice();
    },
    onLookImage: function onLookImage(url) {
      this.imageUrl = url;
      this.showImage = true;
    },
    addExtFileMsg: function addExtFileMsg(annex) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var type, size, fileName, arr;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('添加文件:', annex);

                type = Object(utils_utils["b" /* getChatFileType */])(annex);

                if (!type) {
                  _context.next = 26;
                  break;
                }

                if (!(type == Chatframe["b" /* CHAT_TYPE */].IMG)) {
                  _context.next = 7;
                  break;
                }

                _this9.list.push({
                  type: type,
                  differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
                  id: "ext_" + Date.now(),
                  app_id: _this9.appId,
                  imageUrl: annex
                });
                _context.next = 26;
                break;

              case 7:
                if (!(type == Chatframe["b" /* CHAT_TYPE */].VIDEO)) {
                  _context.next = 11;
                  break;
                }

                _this9.list.push({
                  type: type,
                  differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
                  id: "ext_" + Date.now(),
                  app_id: _this9.appId,
                  videoUrl: annex,
                  videoCover: annex + "?vframe/jpg/offset/2/w/480" //获取封面图
                });
                _context.next = 26;
                break;

              case 11:
                if (!(type == Chatframe["b" /* CHAT_TYPE */].FILE)) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 12;
                _context.next = 15;
                return Object(api["r" /* headInfoSize */])(annex);

              case 15:
                size = _context.sent;

                size = (size / (1024 * 1024)).toFixed(2);
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](12);

                console.log(_context.t0);

              case 22:
                fileName = "附件";
                arr = annex.split("/");

                if (arr.length > 0) {
                  fileName = arr[arr.length - 1];
                }
                _this9.list.push({
                  type: type,
                  differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
                  id: "ext_" + Date.now(),
                  app_id: _this9.appId,
                  name: fileName,
                  size: size || 0,
                  fileUrl: annex
                });

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this9, [[12, 19]]);
      }))();
    },
    chat: function chat(type, message, cardID) {
      console.log("聊天:", type, message);
      return this.flowChat(type, message, cardID);
    },
    addRobotMessage: function addRobotMessage(helloWorld, voiceUrl, voiceViseme, action) {

      var chatInfo = {
        differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
        id: Date.now(),
        app_id: this.appId,
        playAction: action
      };

      chatInfo.type = Chatframe["b" /* CHAT_TYPE */].TEXT;
      chatInfo.name = helloWorld, chatInfo.speed = 100;
      this.list.push(chatInfo);
      console.log("say hello ", chatInfo, this.list);
      if (this.imageType == 1 && action && action.length > 0) {

        S51WebGLSDK["a" /* default */].playAction(action);
      }
      this.$emit("onChatListChange", this.list);
    },
    stopAllTyping: function stopAllTyping() {

      this.greetContent.speed = 0;
      for (var i = 0; i < this.list.length; ++i) {
        if (this.list[i].differentiate == Chatframe["a" /* CHAT_ROLE */].ROBOT && this.list[i].type == Chatframe["b" /* CHAT_TYPE */].TEXT) {
          this.list[i].speed = 0;
          this.list[i].disPlay = true;
        }
      }
    },
    clearChat: function clearChat() {
      this.list = [];
      this.greetContent = {
        id: 0
      };
      this.stopAllTyping();
      this.stopNowVoice();
    },
    onTextShowGreetFinish: function onTextShowGreetFinish(e) {
      //打招呼文字显示结束
      console.log('greet type finish', e.itemID, this.greetContent.id);
      if (e.itemID == this.greetContent.id) {
        this.greetContent.disPlay = true;

        if (this.greetContent.extFile) {
          this.addExtFileMsg(this.greetContent.extFile);
        }
        this.$set(this.greetContent, 'typeFinish', true);
      }
      S51WebGLSDK["a" /* default */].playIdleAction();
    },
    playHello: function playHello() {
      var _this10 = this;

      if (this.greetContent.id == 0) {
        return;
      }

      if (this.imageType == 1) {

        S51WebGLSDK["a" /* default */].setAudioMuted(false);
      } else {
        console.log('开始播放语音', this.greetContent.helloAudio);
        audioText_audio.src = this.greetContent.helloAudio;
        audioText_audio.autoplay = false;
        audioText_audio.preload = 'none';
        var startPlay = function startPlay() {
          audioText_audio.removeEventListener('canplaythrough', startPlay);
          audioText_audio.currentTime = _this10.$refs.greetMessage.getCurShowLength() * _this10.greetContent.speed / 1000;
          console.log('可以完整播放音频了', audioText_audio.currentTime);
          audioText_audio.addEventListener('seeked', function () {
            audioText_audio.muted = false;
            audioText_audio.play();
          });
        };
        audioText_audio.addEventListener('canplaythrough', startPlay);
        audioText_audio.muted = true;
        audioText_audio.load();
      }
    },

    /**
    * 打招呼
    */
    sayHello: function sayHello(helloWord, helloAudio, helloVisem, action, duration, isMyself) {
      console.log('say hello', helloWord, this.imageType);

      S51AudioPlayer.addAudio(helloAudio, this.greetContent.id, true);
      if (this.imageType == 1) {
        //3D
        this.greetContent.playAction && this.greetContent.playAction.length > 0 && S51WebGLSDK["a" /* default */].playAction(this.greetContent.playAction);
      }
      this.greetContent = {
        name: helloWord,
        id: Date.now(),
        speed: duration > 0 ? duration * 1000 / helloWord.length : 0,
        isMyself: isMyself,
        helloAudio: helloAudio,
        helloVisem: helloVisem,
        playAction: action,
        duration: duration
      };
    },
    updateHelloWord: function updateHelloWord(hellWord) {
      console.log('更新打招呼内容', hellWord);
      this.greetContent.preName = this.greetContent.name;
      this.$set(this.greetContent, 'name', hellWord);
    },
    flowChat: function flowChat(type, message, cardID) {
      var _this11 = this;

      console.log('message', message);

      return new promise_default.a(function (resolve, reject) {
        resolve({
          data: {}
        });
        var messageText = null;
        var messageVoice = null;
        _this11.stopAllTyping();
        _this11.stopNowVoice();

        for (var i = 0; i < _this11.list.length; ++i) {
          _this11.list[i].playTextVoiceSatate = false;
        }
        eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: false });
        switch (type) {
          case Chatframe["b" /* CHAT_TYPE */].TEXT:
            messageText = message;
            _this11.list.push({
              type: Chatframe["b" /* CHAT_TYPE */].TEXT,
              differentiate: Chatframe["a" /* CHAT_ROLE */].USER,
              id: Date.now(),
              name: message,
              app_id: _this11.appId
            });
            break;
          case Chatframe["b" /* CHAT_TYPE */].VOICE:
            messageVoice = message;
            _this11.list.push({
              type: Chatframe["b" /* CHAT_TYPE */].VOICE,
              differentiate: Chatframe["a" /* CHAT_ROLE */].USER,
              id: Date.now(),
              voiceUrl: messageVoice.voiceUrl,
              voiceHttpUrl: messageVoice.voiceHttpUrl,
              app_id: _this11.appId,
              duration: Math.floor(messageVoice.duration),
              rightPlayStatus: false,
              showTranslateBtn: false,
              translateText: '',
              translateShowStatus: false
            });
            break;
        }
        _this11.$emit("onChatListChange", _this11.list);
        var self = _this11;
        _this11.chatService.ask(1, type == Chatframe["b" /* CHAT_TYPE */].VOICE ? messageVoice.voiceHttpUrl : messageText, type, null, function (msg) {
          console.log('flow chat', msg);
          if (msg.m && msg.m.length > 0) {
            console.error('聊天失败：', msg.m);

            eventBus["b" /* EventBus */].$emit(eventBus["a" /* BUS_EVENT */].ENABLE_INPUT, { enable: true });
            return;
          }
          if (msg.f == 'start') {
            var chatInfo = {
              differentiate: Chatframe["a" /* CHAT_ROLE */].ROBOT,
              id: Date.now(),
              app_id: self.appId,
              flowText: true,
              type: Chatframe["b" /* CHAT_TYPE */].TEXT,
              audioText: audioText_audio,
              name: '',
              msgQueue: [{
                txt: '',
                file: '',
                audio: '',
                viseme: '',
                flag: 'start'
              }]
            };
            self.currentChatInfo = chatInfo;
            self.list.push(chatInfo);

            console.log(' answer start input');
            self.$emit("onChatListChange", self.list);
            S51AudioPlayer.reset();
          } else if (msg.f == 'ing' && self.currentChatInfo) {
            var audio = '';
            if (msg.a && msg.a.length > 0) {
              audio = msg.a[0];
              if (audio.indexOf('http') == 0) {//http直接按照http文件播放

              } else {
                audio = 'data:audio/mpeg;base64,' + audio;
              }
            }
            if (msg.r.data.f && msg.r.data.f.length) {
              self.currentChatInfo.extFile = msg.r.data.f;
            }
            self.currentChatInfo.msgQueue.push({
              txt: msg.r.data.r,
              file: msg.r.data.f,
              audio: audio != '' ? audio : null,
              viseme: msg.v,
              flag: 'ing'
            });
            S51AudioPlayer.addAudio(audio, self.currentChatInfo.id);
            if (self.currentChatInfo.msgQueue.length == 2) {
              //第一个ing 开始播放动作


              var actionUrl = self.defaultChatAction && self.defaultChatAction.length > 0 ? self.actionMap[self.defaultChatAction] : "";
              if (self.actionMap && msg.r.data.ba && self.actionMap[msg.r.data.ba]) {
                actionUrl = self.actionMap[msg.r.data.ba];
                console.log("使用指定动作", actionUrl);
              }
              console.log('------------查询动作', actionUrl, self.actionMap, msg.r.data.ba);
              if (self.imageType == 1) {

                actionUrl && actionUrl.length > 0 && S51WebGLSDK["a" /* default */].playAction(actionUrl);
              }
              self.currentChatInfo.playAction = actionUrl;
            }
          } else if (msg.f == 'end' && self.currentChatInfo) {
            //消息结束
            self.currentChatInfo.name = msg.r;
            self.currentChatInfo.msgQueue.push({
              txt: '',
              file: '',
              audio: '',
              viseme: '',
              flag: 'end'
            });
            S51AudioPlayer.addAudio(null, self.currentChatInfo.id, true);
            self.currentChatInfo.flag = 'end';
            self.currentChatInfo = null;
          }
        });
      });
    }
  },
  watch: {
    appId: function appId(app_id) {
      this.initChatService(app_id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d52be8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/myComponents/Chatframe/Chatframe.vue
var Chatframe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mianscroll",staticClass:"chat-container",staticStyle:{"height":"100%"},attrs:{"id":"chatContainer"}},[(_vm.showVideo)?_c('my-video',{attrs:{"videoUrl":_vm.videoUrl},on:{"onHideMyVideo":function($event){_vm.showVideo = false}}}):_vm._e(),_vm._v(" "),(_vm.showImage)?_c('my-image',{attrs:{"imageUrl":_vm.imageUrl},on:{"onHideMyImage":function($event){_vm.showImage = false}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-list",staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"id":"chatList"}},[(_vm.greetContent.id > 0)?_c('div',{staticClass:"leftd",staticStyle:{"max-width":"84%"}},[_c('div',[_c('div',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"id":"greet"}},[_c('div',{staticClass:"speech left",staticStyle:{"max-width":"100%"},attrs:{"ng-class":"speech left"}},[_c('TypeMessageVue',{ref:"greetMessage",attrs:{"stringText":_vm.greetContent.name,"itemID":String(_vm.greetContent.id),"speed":_vm.greetContent.speed || 0,"playState":_vm.currentPlayID == _vm.greetContent.id},on:{"onTextShowAccomplish":_vm.onTextShowGreetFinish}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.greetContent.disPlay),expression:"greetContent.disPlay"}],staticClass:"play_text"},[_c('img',{class:_vm.greetContent.loadingVoice?'animated_swing_infinite':'',attrs:{"src":_vm.greetContent.loadingVoice?'/static/img/loading_icon.png':
                    _vm.greetContent.playTextVoiceSatate?'/static/img/robot_paly_icon_active.png':'/static/img/robot_paly_icon.png'},on:{"click":_vm.onPlayGreetVoice}})])]),_vm._v(" "),(_vm.greetContent.isMyself)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.greetContent.typeFinish),expression:"greetContent.typeFinish"}],staticStyle:{"font-size":"12px","font-weight":"bold","color":"#00edb4","margin-top":"5px","margin-left":"5px","text-decoration":"underline"},on:{"click":_vm.onEditText}},[_vm._v("\n          修改默认打招呼\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"id":'itemref' + item.id}},[(item.differentiate == _vm.chatRole.ROBOT)?_c('div',{staticClass:"leftd"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.TEXT),expression:"item.type == chatType.TEXT"}]},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"speech left"},[(item.flowText)?_c('TypeFlowMessageVue',{attrs:{"stringText":item.name,"itemID":String(item.id),"playState":_vm.currentPlayID == item.id,"msgQueue":item.msgQueue},on:{"onTextShowAccomplish":_vm.onTextShowAccomplish,"onClickQuestion":_vm.onClickQuestion}}):_c('TypeMessageVue',{attrs:{"stringText":item.name,"itemID":String(item.id),"speed":item.speed || 0,"playState":_vm.currentPlayID == item.id},on:{"onTextShowAccomplish":_vm.onTextShowAccomplish}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.TEXT && item.disPlay && _vm.playShow),expression:"item.type == chatType.TEXT && item.disPlay && playShow"}],key:item.playTextVoiceSatate,staticClass:"play_text"},[_c('div',[_c('img',{class:(item.playTextVoiceSatate == false ||
                    item.playTextVoiceSatate == null ||
                    item.playTextVoiceSatate == undefined) &&
                    _vm.clickPlay == true &&
                    _vm.id == item.id
                    ? 'animated_swing_infinite'
                    : '',attrs:{"src":(item.playTextVoiceSatate == false ||
                        item.playTextVoiceSatate == null ||
                        item.playTextVoiceSatate == undefined) &&
                        _vm.clickPlay == false
                        ? '/static/img/robot_paly_icon.png'
                        : (item.playTextVoiceSatate == false ||
                          item.playTextVoiceSatate == null ||
                          item.playTextVoiceSatate == undefined) &&
                          _vm.clickPlay == true &&
                          _vm.id == item.id
                          ? '/static/img/loading_icon.png'
                          : (item.playTextVoiceSatate != false ||
                            item.playTextVoiceSatate != null ||
                            item.playTextVoiceSatate != undefined) &&
                            _vm.clickPlay != true
                            ? '/static/img/robot_paly_icon_active.png'
                            : 'static/img/robot_paly_icon.png',"alt":""},on:{"click":function($event){return _vm.onPlayTextVoice(item)}}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.IMG),expression:"item.type == chatType.IMG"}],staticClass:"speech left image-container",attrs:{"ng-class":"speech left"},on:{"click":function($event){return _vm.onLookImage(item.imageUrl)}}},[_c('img',{attrs:{"src":item.imageUrl,"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.VOICE),expression:"item.type == chatType.VOICE"}],staticClass:"speech left",attrs:{"ng-class":"speech left"}},[_vm._v("\n          语音消息\n          "),_c('img',{attrs:{"src":"","alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.LINK),expression:"item.type == chatType.LINK"}],staticClass:"speech left",attrs:{"ng-class":"speech left"}},[_c('a',{attrs:{"target":"_Self","href":item.linkUrl}},[_vm._v(_vm._s(item.linkUrl))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.VIDEO),expression:"item.type == chatType.VIDEO"}],staticClass:"speech left video-container",attrs:{"ng-class":"speech left"},on:{"click":function($event){return _vm.onLookVideo(item.videoUrl)}}},[_c('img',{staticClass:"video",attrs:{"src":item.videoCover,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"video-play"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.FILE),expression:"item.type == chatType.FILE"}],staticClass:"speech left file",attrs:{"ng-class":"speech left"},on:{"click":function($event){return _vm.openFile(item.fileUrl)}}},[_c('div',{staticClass:"file-icon"},[_c('div',{staticClass:"left-name-size"},[_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(item.size)+"MB")])]),_vm._v(" "),_vm._m(0,true)])])]):_vm._e(),_vm._v(" "),(item.differentiate == _vm.chatRole.USER)?_c('div',{staticClass:"rightd"},[_c('div',{staticClass:"effect-button animated rotatein"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.TEXT),expression:"item.type == chatType.TEXT"}],staticClass:"speech right",attrs:{"ng-class":"speech right"}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.IMG),expression:"item.type == chatType.IMG"}],staticClass:"speech right image-container",attrs:{"ng-class":"speech right"},on:{"click":function($event){return _vm.onLookImage(item.imageUrl)}}},[_c('img',{attrs:{"src":item.imageUrl,"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.VOICE),expression:"item.type == chatType.VOICE"}]},[_c('div',{staticClass:"no-select-audio",on:{"mousedown":function($event){return _vm.startLongPress($event, item)},"touchstart":function($event){return _vm.startLongPress($event, item)},"mouseup":_vm.cancelLongPress,"touchend":_vm.cancelLongPress}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.VOICE),expression:"item.type == chatType.VOICE"}],staticClass:"play_audio",on:{"click":function($event){$event.stopPropagation();return _vm.playAudio(item.id, item)}}},[_c('img',{attrs:{"src":item.rightPlayStatus ? '/static/img/robot_paly_icon_active.png' : 'static/img/robot_paly_icon.png',"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"speech right",staticStyle:{"display":"flex","justify-content":"flex-end","align-items":"center"},attrs:{"ng-class":"speech right"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_vm._v(_vm._s(item.duration)+"s”\n                "),_c('img',{staticStyle:{"width":"15px","height":"15px","margin-left":"5px"},attrs:{"src":"/static/img/towards_left_icon.png","alt":""}})])]),_vm._v(" "),(item.showTranslateBtn)?_c('div',{staticClass:"translate-wrapper",style:(!item.translateShowStatus ? 'right:30px;' : 'right:18px;'),on:{"click":function($event){$event.stopPropagation();return _vm.translateVoice(item)}}},[_c('div',{staticClass:"translate-btn"},[_c('span',{staticClass:"translate-text"},[_vm._v(_vm._s(!item.translateShowStatus ? '转文字' : '取消转文字'))])])]):_vm._e()]),_vm._v(" "),(item.translateText != '' && item.translateShowStatus)?_c('div',{staticClass:"speech right translate-show-text"},[_vm._v(_vm._s(item.translateText))]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.LINK),expression:"item.type == chatType.LINK"}],staticClass:"speech right",attrs:{"ng-class":"speech right"}},[_c('a',{attrs:{"target":"_Self","href":item.linkUrl}},[_vm._v(_vm._s(item.linkUrl))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.VIDEO),expression:"item.type == chatType.VIDEO"}],staticClass:"speech right video-container",attrs:{"ng-class":"speech right"},on:{"click":function($event){return _vm.onLookVideo(item.videoUrl)}}},[_c('img',{staticClass:"video",attrs:{"src":item.videoCover,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"video-play"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.type == _vm.chatType.FILE),expression:"item.type == chatType.FILE"}],staticClass:"speech right",attrs:{"ng-class":"speech right"},on:{"click":function($event){return _vm.openFile(item.fileUrl)}}},[_c('div',{staticClass:"file-icon"},[_c('div',{staticClass:"left-name-size"},[_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(item.size)+"MB")])]),_vm._v(" "),_vm._m(1,true)])])]):_vm._e()])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.audioMuted),expression:"audioMuted"}],staticClass:"cancel-muted"},[_c('img',{staticStyle:{"margin-right":"5px","width":"15px","height":"15px"},attrs:{"src":"/static/img/mute_icon.jpg","alt":""}}),_vm._v(" 取消静音")])],1)}
var Chatframe_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-icon"},[_c('img',{staticStyle:{"width":"30px","height":"30px"},attrs:{"src":"/static/img/pdf.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-icon"},[_c('img',{staticStyle:{"width":"30px","height":"30px"},attrs:{"src":"/static/img/pdf.png","alt":""}})])}]
var Chatframe_esExports = { render: Chatframe_render, staticRenderFns: Chatframe_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_myComponents_Chatframe_Chatframe = (Chatframe_esExports);
// CONCATENATED MODULE: ./src/myComponents/Chatframe/Chatframe.vue
function Chatframe_injectStyle (ssrContext) {
  __webpack_require__("dv6J")
}
var Chatframe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chatframe___vue_template_functional__ = false
/* styles */
var Chatframe___vue_styles__ = Chatframe_injectStyle
/* scopeId */
var Chatframe___vue_scopeId__ = "data-v-09d52be8"
/* moduleIdentifier (server only) */
var Chatframe___vue_module_identifier__ = null
var Chatframe_Component = Chatframe_normalizeComponent(
  myComponents_Chatframe_Chatframe,
  selectortype_template_index_0_src_myComponents_Chatframe_Chatframe,
  Chatframe___vue_template_functional__,
  Chatframe___vue_styles__,
  Chatframe___vue_scopeId__,
  Chatframe___vue_module_identifier__
)

/* harmony default export */ var src_myComponents_Chatframe_Chatframe = __webpack_exports__["a"] = (Chatframe_Component.exports);


/***/ }),

/***/ "tZYb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vy6r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wwIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0012d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_selector = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("G6U3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_selector,
  src_components_selector,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x/ze":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9a7f7e4d5c81bedc8066.js